export default {
    labels: {
        clear: 'Walang laman',
        refresh: 'Refresh',
        nextStep: 'Susunod na hakka',
        prevStep: 'Naunang hakka',
        closeDriver: 'Lumabas ang Booto',
        complete: 'Taposo',
        viewStatistics: 'Pansin ang Statistics',
        colon: '：',
        splitter: '/',
        remark: 'Mga pahayaga',
        correction: 'Pagwawasto',
        save: 'Pag-save',
        reset: 'Reseta',
        increase: 'Dagdagan',
        preview: 'Preview a',
        unit: 'Artikulo',
        cancel: 'Kansela',
        all: 'Lahat',
        searchPlaceHolder: 'Maglagay ng keyword query',
        greaterThan: 'Malakin',
        lessThan: 'Mas maa',
        second: 'Seconds',
        description: 'Paglalarawan',
        column: 'Kolumn',
        pleaseChoice: 'Pakipilin',
        filter: 'Filtral',
        saveAndSubmit: 'I-save at I-submite',
        submit: 'Submissions',
        appeal: 'Complaint',
        review: 'Review',
        choose: 'Pilit',
        manage: 'Pamamahalan',
        delete: 'Mangalisa',
        add: 'Bago',
        create: 'Bago',
        edit: 'Pag-edita',
        name: 'Pangang',
        describe: 'Paglalarawan',
        next: 'Susunod na hakka',
        percent: '%',
        export: 'Pag-exporto',
        exportAll: 'Pag-export Lahat',
        confirm: 'Determine',
        back: 'Bumalik',
        versionUpdate: 'Natutuwa akong ipaalam sa iyo na ang aming website ay naglabas lamang ng bagong bersyon! Upang matiyak ang iyong normal na paggamit, kailangan naming i-save mo agad ang iyong kasalukuyang trabaho, at pagkatapos i-freesh ang pahina (click ang refresh button ng browser, o pindutin ang F5 key) upang maging epekto ang aming bagong bersyon. Maraming salamat para sa iyong pakikipagtulungan!',
        more: 'Mas maramin',
        selected: 'Pinilin',
        deduct: 'Buckle',
        maxScore: 'Karamihan ay',
        scoreUnit: 'Punts',
        pointUnit: 'Isan',
        comma: '，',
        view: 'Pansing',
        batchingImport: 'Importan',
        deleteContent: 'Sigurado ka bang nais mong tanggalin ito? Hindi mo ito maaaring ibalik pagkatapos ng pagtanggal',
        import: 'Importan',
        uploadFile: 'Upload ang Files',
        downloadFile: 'File ng pag-exporto',
        upload: 'Uploads',
        click: 'Clickt',
        downloadTemplate: 'Download Template',
        fillInTheForm: 'Mula sa pamamagitan ng formato',
        UploadExcelfile: 'Upload Excel upang kumpleto ang pag-import ng batch',
        uploadIdentical: 'Kung ang pangalan ng API ay mayroon, ang mga mayroong data sa sistema ay i-update sa panahon ng pag-import.',
        numOne: '1',
        numTwo: '2',
        numThree: '3',
        apply: 'Appap',
        leftBracket: '(',
        rightBracket: ')',
        question: 'Katanungan',
        answer: 'Sumagot',
        content: 'Nilaon',
        search: 'Paghahanap',
        query: 'Query',
        cancelEdit: 'Kansela ang Edit',
        noValue: 'Walang datas',
        selectAll: 'Pilit',
        changeAGroup: 'Magbago ng grupop',
        arrow: ' ---> ',
        saveReview: 'Review Submissions',
        saveSpotCheck: 'Sampling inspeksyon at submissions',
        rapidSampling: 'Mabilis na sampling',
        file: 'Pag-archive',
        download: 'Download a',
        lastPage: 'Naunang Pahinan',
        nextPage: 'Susunod na Pahinan',
        batchActions: 'Operasyon ng batch',
        cancelDistribution: 'Hindi assign',
        againDistribution: 'Reassign',
        deleteRecord: 'Paglabas ng Recod',
        oneOptionOpertor: 'Opsyonal na inspector',
        allOptionOpertor: 'Lahat ng mga inspektor ng kalida',
        distributionInfoFirstOne: 'Pagkumpirma',
        distributionInfoFirstTwo: 'Gusto mo bang muling magbigay ng mga talaan? Mangyaring pumili ng target sa pagtatalaga.',
        distributionInfoSecondOne: 'OK upang kansela',
        distributionInfoSecondTwo: 'Ang impormasyon ba ang assignor ng record na ito? Pagkatapos ng pagkansela, ito ay magiging isang hindi nakatakdang tala ng pagsusuri.',
        distributionInfoSecondThree: 'Ang impormasyon ba ng assignor ng record na ito, ito ay magiging isang hindi nakatakdang sampling record pagkatapos ng pagkansela.',
        distributionInfoThirdOne: 'Mayroon ang mga piniling talaka',
        distributionInfoThirdTwo: 'Hindi iproseso ang mga reviewed record.',
        distributionInfoThirdThree: 'Hindi maaasahan ang mga talaan na na-sampley.',
        exportError: 'Nabigo ng pag-exporto',
        exportSuccess: 'Nagtagumpay ang pag-exporto',
        deleteRecordInfo: 'Sigurado ka bang nais mong tanggalin ang {0} records? Hindi maaaring mabawi ang data pagkatapos ng pagtanggal',
        pleaseSetFilter: 'Mangyaring piliin ang mga filtra',
        noCountAfterFilter: 'Walang data ng pag-export, mangyaring i-reset ang mga kritera ng filter',
        redo: 'Pagpapatake',
        batchMove: 'Batch Move',
        websiteName: 'Intelligent quality inspeksyo',
        salesEnable: 'Pagbebentas',
        systemName: 'Intelligent quality inspeksyo',
        initSystemError: 'Nabigo sa pagbubukod sa network o page sa inisyalisasyon, mangyaring makipag-ugnay sa serbisyo ng customer',
        day: 'Araw',
        hour: 'Oras',
        minute: 'Punts',
        questionMark: '？',
        personalSettings: 'Personal na Settings',
        logout: 'Isulat-off',
        ok: 'Determine',
        saveAs: 'Pag-save',
        pleaseEnter: 'Mangyaring irekt',
        executeMessage: {
            executeSuccess: '{0} matagumpay na natapos',
            executeError: 'Nabigo ang {0} sa pagpapatakbon',
        },
        field: 'Fields',
        operator: 'Operator',
        value: 'Valuen',
        placeholder: 'Pakipilin',
        pleaseSelect: 'Pakipilin',
        totalScore: 'Total score',
        hyphen: '-',
        semicolon: '；',
        wfm: 'Intelligent schedulm',
        user: 'User',
        none: 'Walan',
        plusSign: '+',
        minusSign: '-',
        saveSuccessAndReload: 'Mag-save nang matagumpay! Epektibo matapos ang pag-refreshes ng may kaugnayan na empleyad',
        saveAsName: '{0}(Kukopa)',
        systemInformation: 'Makikita ang data ng sistema',
        billingCenter: 'Billing Center.',
        financeCenter: 'Pamamahala ng Pananalapi',
        warningMessage: 'Ang natitirang quota ay hindi sapat, mangyaring pag-recarge hangga\'t maa',
        fileTypeHolder: 'Hindi tama ang format ng file. Mangyaring i-upload ng file sa format na {0}.',
        dataNo: 'Walang datas',
        move: 'Lumaw',
        study: 'May mga puntong inspeksyon ng kalidad ng sariling natututun',
        studySuccess: 'Labeling Success',
        studyError: 'Nabigo ang Labeling',
        editType: 'Pag-edit ng Kategory Labels',
        copyed: 'Nakakopya sa Clipbor',
        clickToCopy: 'Click Copy',
        addFilterConditions: 'Dagdag ang Filter Condition:',
        filterConditions: 'Filter Condition:',
        messageTime: 'Oras ng message',
        messageType: 'Type ng message',
        pushType: 'Mensahe Channel',
        messageContent: 'Kabilangan ng message',
        messageName: 'Pangalan ng message',
        messageStatus: 'Status ng message',
        configuration: 'Impormasyon sa pagsasaayos',
        sendTarget: 'Papadala ang Destination',
        guideUrl: 'Bootstrap URL',
        noticeDetail: 'Detalye ng message',
        action: 'Operasyong',
        seeDetail: 'Pansin Detalyas',
        theDay: 'Araw {0}',
        theLastDayOfMonth: 'Ang huling araw ng bawat buwan',
        ignore: 'Ipandiwalan',
        seeNow: 'Tingnan Ngano',
        exportConfirmText: {
            export: 'Isang kabuuan ng {0} na piraso ng data, kumpirman upang mag-export?',
            exportAll: 'Tikumpirma upang i-export ang lahat ng nilalaman?',
        },
        samrTagAdd: 'Dagdag ang Tags',
        deletePopconfirmContent: 'Sigurado ka bang nais mong tanggalin?',
        TheLastThirtyDays: 'Huling 30 araw,',
        addNumber: 'Plus',
        subNumber: 'Minus',
        addStrategy: 'Dagdag ang Patakarang',
        minutes: 'Minuta',
        status: 'Gaan ang Status',
        pushConfig: 'Push Configuration',
        category: 'Classifications',
        and: 'Kasaman',
        interval: 'Intervaly',
        switchOn: 'Buksa',
        switchOff: 'Saray',
        batchDel: 'Batch Deletet',
        exportTxt: 'Pag-export teksto ng TXT',
        playSpeed: 'Doble na bilis',
        messageLogBtn: 'Makikita ang mga notifika/pag-uusap na nagpapahiwatig',
        dataLink: 'Data Link',
        yes: 'Oo,',
        no: 'Hindin',
        sentenceUnit: 'Sentensya',
        appealDetail: 'Detalyas ng Grievance Record',
        detail: 'Detalyo',
        default: 'Defaulta',
        customer: 'Customero',
        agent: 'Servisyo ng Customero',
        sort: 'Sort',
        applyNow: 'Aplikation',
        index: 'Serial numero',
        allColumns: 'Mga kolum na maaaring idagg',
        selectedColumns: 'Dagdag na Columns',
        syn: 'Sinchronization',
        saveAndNext: 'Likha at lumikha ng susunoda',
        viewReference: 'Pansin ang References',
        referenceDetail: 'Mga Detalyas',
        goToQaList: 'Pumunta sa inspeksyon ng kalidado',
        goToCheck: 'Pumunta sa spot check',
        businessCard: 'Business card',
        weapp: 'Maliit na program a',
        redpacket: 'Pulang envelope',
        externalRedpacket: 'Pagbago ng mga red envelop',
        sphfeed: 'Video Number a',
        exportTaskCreated: 'Naging matagumpay ang pag-export ng gawain',
        plzGoTo: 'Mangyaring jump',
        importTaskCreated: 'Naging matagumpay ang pag-import ng gawain',
        taskCreated: 'Matagumpay na nilikha ang gawaan',
        reply: 'Sumugot',
        replied: 'Sumugot',
        release: 'Publish',
        expandMore: 'Lawakin ang iba pang mga sagot {0}',
        comment: 'Mga komento',
    },
    business: {
        notifyMessage: {
            IsNullErrorFormat: 'Mangyaring magkaroon ng hindi bababa sa isang {0}',
            canNotBeEmptyFormat: '{0} hindi maaaring walang laman',
            repeatErrorTipFormat: '{0} ay duplicatet',
            getInformationFailedFormat: 'Hindi makakuha ng {0} impormasyon. Mangyaring suriin ang iyong network koneksyon o subukan muli mamasa',
            deleteSuccessFormat: 'Matagumpay na natanggal ang {0}.',
            deleteFailedFormat: 'Nabigo ang {0} sa pagtanggal. Mangyaring subukan muli mamaya.',
            saveSuccessFormat: '{0} ay nagtagumpay.',
            saveFailedFormat: 'Nabigo ang {0} sa pag-save. Mangyaring subukan muli mamaya.',
            fileSuccessFormat: '{0} ay matagumpay na na-archive.',
            fileFailedFormat: '{0} nabigo ang arkibo. Mangyaring subukan muli mamaya.',
            exportSuccessFormat: '{0} ay nagtagumpay sa pag-exporto',
            exportFailedFormat: 'Bigo ang pag-export ng {0}. Mangyaring subukan muli mamaya.',
            submitSuccessFormat: '{0} ay nagtagumpay.',
            submitFailedFormat: 'Nabigo ang {0} sa pagsumite, mangyaring subukan muli mamaya.',
            confirmSuccessFormat: 'Ang {0} ay matagumpay.',
            confirmFailedFormat: 'Nabigo ang {0} na kumpirmasyon. Mangyaring subukan muli mamaya.',
            pleaseUploadFile: 'Mangyaring i-upload muna ang file!',
            importFileSuccess: 'Tagumpay ang pag-import ng talaksan!',
            importFildFailed: 'Nabigo ang pag-import ng talaksan!',
            deleteSuccess: 'Matagumpay na natanggal!',
            deleteFailed: 'Nabigo ang pagtanggal, mangyaring subukan muli mamaya!',
            illegalTitle: 'Hindi sapat na pahintulot',
            illegalMessage: 'Wala kang ilan o lahat ng pahintulot para sa susunod na hakbang, mangyaring makipag-ugnay sa administrator upang i-configure, click ang OK button ay lumabas sa boot',
            illegalMessageCurrent: 'Wala kang ilan o lahat ng pahintulot para sa kasalukuyang hakbang, mangyaring makipag-ugnay sa administrator upang i-configure, click ang OK button ay lumabas sa boot',
            skipMessage: 'Kung nais mong laktawan ang hakbang na ito, klikt',
            errorMsg500: 'Nabigo ang hiling ng server, mangyaring suriin ang iyong operasyon o represh at subukan mulin',
            errorMsg404: 'Ooops... ang pahina na hinahanap mo ay nawawalan',
            errorMsg400: 'Nabigo ang hiling ng server, mangyaring suriin ang iyong data at subukan mulin',
            pageOverFlow: 'Sa kasalukuyan, 10000 bar lamang ang maaaring ipakita. Mangyaring itakda ang mga kriterya ng filtering upang tingnan ang labis.',
            isHandAddSmartTag: 'Ay isang manu-manong idinagdag na matalinong labela',
            defaultGradeMustAtLast: 'Dapat inilagay ang default rating sa dulo',
            AutomaticAllocationInspectorsIsNull: 'Mangyaring ipalagay ang pangunahing pahina ng impormasyon upang idagdag ang inspector',
            timePickerTips: 'Upang hindi makaapekto sa iyong normal na paggamit, 23:00 ~2:00 ay ang oras ng pagpapanatili ng system, huwag gumawa ng mga nakatakdang gawain.',
            batchDeleteInfo: 'Ang mga entry ng {0} ay tinanggal. Nabigo ang mga entry ng {1} dahil ang data ay ginagamit na.',
            batchDeleteTips: 'Titingnan ang {0} na piraso ng data, kumpirma upang tanggalin?',
            correctionSuccess: 'Tagumpay sa pagwawa ng erros',
        },
        pages: {
            qualityInspectionForm: {
                list: {
                    IsMaxFormNumberError: 'Idagdag sa 10 form ng inspekyon',
                },
                specialProject: {
                    sumOfScoresErrorTip: 'Ang mga item ng metric {0} ay dapat idagdag hanggang 100.',
                    banProjectMaxErrorTip: 'Dagdag hanggang sa 2000 ipinagbabawal na item',
                    deadlyProjectMaxErrorTip: 'Dagdag hanggang sa 500 nakamamatay na item',
                },
            },
        },
        info: {
            creatSuccess: 'Matagumpay na nilika',
            creatError: 'Sawi sa paglikha ng',
            editSuccess: 'Nagtagumpay ang pagbabago',
            editError: 'Nabigo ang pagbabago',
            deleteSuccess: 'Matagumpay na natanggala',
            addSuccess: 'Bagong tagumpa',
            deleteError: 'Bigo ang pagtanggal',
            conditionError: 'Error sa lohikal na expression ng operator',
            customJudgeLogic: 'Pagkamaulit na kumbinasyon ng logical expression error sa kondisya',
            exportError: 'Nabigo ng pag-exporto',
            searchError: 'Nabigo ang filtera',
            loadError: 'Bigo ang {0} sa pag-loadan',
            saveSuccess: 'Ito ang matagumpay',
            saveError: 'Sawi sa pag-save',
            fileSuccess: 'Tagumpay sa arkive',
            fileError: 'Nabigo ang arkivo',
            cannotBeNull: '{0} hindi maaaring walang laman!',
            pleaseSearchAndSelect: 'Mangyaring ipasok ang isang keyword search a',
            clickAndToggle: 'Click upang piliin ang switch',
            deleteWarning: 'Hindi mababawi ang pagtanggal ng {0}, sigurado ka bang nais mong magpatuloy?',
            getOssAuthFailed: 'Hindi makakuha ng awtorisasyon sa OSS. Suriin ang koneksyon sa network o subukan muli mamaya.',
            getInsightAuthFailed: 'Hindi makakuha ng awtorisasyon sa Insight. Suriin ang iyong network koneksyon o subukan muli mamaya.',
            pictureUploadFailed: 'Nabigo ang upload ng larawan',
            pictureUploadFailedSize: 'Lagtas ng laki ng larawan ang limitasyon, bigo ang pag-upload ng imaha',
            wecomTagsSyncInfo: 'Huling update:{0}, syncing {1} messages',
            collectSuccess: 'Tagumpay sa koleksyon.',
        },
    },
    components: {
        common: {
            qcReportEcharts: {
                errorMessage: 'Sawi sa pagkuha ng data ng ulat ng ulat.',
            },
            waveAudio: {
                noWaveMessage: 'Upang mapanatili ang iyong karanasan, hindi ipapakita ang waveform para sa mga recording sa loob ng {0} minuto. Maaari mo silang maglaro.',
            },
            customFilter: {
                del: 'Mangalisa',
                edit: 'Pag-edita',
                new: 'Custom Filter',
                apply: 'Aplikation',
                cancel: 'Kansela',
                onlyApply: 'Makikip',
                ohterSave: 'Pag-save',
                save: 'Pag-save',
                customFilter: 'Karaniwang filtor',
                reset: 'Reseta',
                holderKeyWord: 'Mangyaring ipasok ang keyword a',
                customFilterRule: 'Filter patakaran ng logic:',
                customFilterName: 'Pangalan ng filter:',
                holderCustomFilterName: 'Mangyaring ipasok ang pangalan ng filter',
                manualConfiguration: 'Manual na pagsasaayos',
                holderCustomRule: 'Mangyaring ipasok ang custom na kondisyon ng logic',
                example: 'Halimbawa:',
                dragConfiguration: 'Pag-drag at pagbaga',
                condition: 'Kondisyon',
                operation: 'Operasyong',
                infoDel: 'Ihit ang nilalaman sa lugar upang tanggalan',
                toConfigure: 'Konfigurayo',
                holderCustomFilterNameLength: 'Ang pinakamataas na haba ng pangalan ng filter ay 10',
                customFilterNameNone: 'Hindi maaaring walang laman ang pangalan ng filt',
                and: 'At',
                or: 'O',
                not: 'Hindin',
                delSuccess: 'Matagumpay na natanggala',
                saveSuccess: 'Ito ang matagumpay',
                updateSuccess: 'Nagtagumpay ang pagbabago',
                customFilterCondition: 'Filter Condition:',
                conditionRule: 'Mga Panunungkulan',
                none: 'Walan',
                filterPlaceholder: 'Mangyaring ipasok ang keyword a',
            },
            labelTabs: {
                addThis: 'Dagdag dito',
                goThis: 'Ito',
                saveGo: 'Pag-save at Train',
            },
            datePicker: {
                today: 'Ngayon...',
                yesterday: 'Kahapan',
                theDayBeforeYesterday: 'Ang araw bago kahangan',
                thisWeek: 'Sa linggo na ito',
                lastWeek: 'Nakaraang linggo.',
                thisMonth: 'Ang Buwan nao',
                lastMonth: 'Nakaraang busan',
                lastSevenDay: 'Huling 7 araw...',
                lastThirtyDay: 'Huling 30 araw,',
                thisQuarter: 'Ito',
                lastQuarter: 'Huling Quarter',
                thisYear: 'Ngang taonan',
                lastYear: 'Nakaraan na',
                lastYearFromToday: 'Nakaraan na',
            },
            pagination: {
                page: 'Pahina {1} ng {0}',
            },
            wechatRecord: {
                loadMoreBtn: {
                    top: 'Mag-load ng mga mas maagang mensahes',
                    bottom: 'Higit pang mga messay',
                },
            },
        },
        pages: {
            menuTitleList: {
                tasksManageTitle: 'Gawain sa inspeksyon ng kalida',
                informationCollectTasksManageTitle: 'Mga gawain sa koleksyong',
                customerServiceCenterTitle: 'Customer Service Center',
                informationTitle: 'Data Center.',
                intelligentAnalysisTitle: 'Intelligent analysisa',
                semanticIntelligence: 'Semantic intelligens',
                trainingCenterTitle: 'Training Center.',
                adminTitle: 'System Managements',
            },
            qualityCheckingTask: {
                title: 'Call Quality Inspection',
                index: {
                    tipOne: 'Ginagamit ang inspeksyon ng kalidad ng Call upang suriin ang kalidad ng mga call center trabaho ng mga empleyado. Maaari mong i-set up ang mga naaangkop na inspeksyon ng kalidad na batay sa iyong negosyo.',
                    tipTwo: 'Maaaring itakda ang mga naaangkop na patakaran para sa mga gawaing inspeksyon ng kalidad, kabilang na ang pag-filter at sampling. Matapos ang mga scores ng inspektor ng kalidad, maaaring tingnan ng serbisyo ng customer ang mga resulta ng inspeksyon ng kalidad at karagdagang appeal,',
                    addTaskTitle: 'Pagdagdag ng Quality Inspection Task',
                    deleteTipTitle: 'Ang Gawain sa Inspection ng Quality',
                    deleteTipContent: 'Hindi maaaring ibalik ang mga gawain sa inspeksyon ng kalidad pagkatapos ng pagtanggal. Sigurado ka bang nais mong tanggalin ang mga ito?',
                    checkingTask: 'Gawain sa inspeksyon ng kalida',
                    checkingTaskList: 'Listahan ng Task ng Quality Inspection',
                    formList: 'Form Lista',
                    viewHelpDocuments: 'Makikita ang dokumentasyon ng tulod',
                },
                manage: {
                    taskSetting: {
                        title: 'Mga Setting ng gawain',
                        form: 'Forma',
                        basicInfo: 'Pangunahing impormasyong',
                        visibleRange: 'Makikita ang rangan',
                        visibleRangeTip: 'Ang piniling serbisyo ng customer at serbisyo ng customer ay maaaring tingnan ang gawain sa inspeksyon ng kalidad. Sa karagdagan, ang lider ng grupo ng serbisyo ng customer, serbisyo ng customer at inspector ng kalidad ay maaaring pagsasama sa mga setting ng pahintulot para sa gawaing ito.',
                        automaticSampling: 'Awtomatikong sampling',
                        automaticSamplingTip: 'Maaari mong itakda ang mga patakaran ng awtomatikong sampling, upang ang sistema ay pana-panahon ay magdagdag ng mga gawain sa inspeksyon ng kalidad ayon sa mga patakaran na itinakda mo, tulad ng pagkuha ng 5% ng mga tawag noong nakaraang linggo bawat Lunes.',
                        samplingRate: 'Frekuency ng sampling',
                        samplingTime: 'Oras ng sampling',
                        samplingRange: 'Rang ng sampling',
                        samplingRule: 'Patakaran sa sample',
                        fillterCondition: 'Filter Condition:',
                        workflow: 'Quality Inspection Workflow',
                        appealsTime: 'Pahintulutan ang oras ng appeal',
                        appealsTimeTipOne: 'Matapos ang pagsusuri ng score',
                        appealsTimeTipTwo: 'Sa loob ng mga araw,',
                        appealsTimeTipThree: 'Kung lumagpas ang oras ng appeal, ang rekord ng kalidad ng inspeksyon ay awtomatikong mabago sa Conkummed"',
                        auditTime: 'Oras ng pagproseso ng audit',
                        auditTimeTipOne: 'Matapos mag-file ng reklamo',
                        auditTimeTipTwo: 'Sa loob ng mga araw,',
                        auditTimeTipThree: 'Matapos lumampas ang oras ng pagproseso ng pag-aaral, ang rekord ay nagpapanatili ng orihinal na marka, at ang status ng inspeksyon ng kalidad ay awtomatikong binago sa Conkummed"',
                        noAppealsMode: 'Walang Grievance Mode',
                        appealsMode: 'Pahintulutan ang appeal',
                        noAppealsModeImage: 'no-appeal.png',
                        appealsModeImage: 'appeal.png',
                        customerServices: 'Servisyo ng Customero',
                        customerServicesGroup: 'Grupo ng Servisyo ng Customero',
                        surveyList: 'Listahan',
                        customFields: 'Custom Fields',
                        fieldConfig: 'Field Configuration',
                        from: 'Mula',
                        owner: 'Persona na may singild',
                        inspectorAndReviewerAuthority: 'Awtoridad ng pagsusuri sa kalidad ng inspekyon',
                        inspector: 'Quality inspector',
                        reviewer: 'Reviewer',
                        inspectorTip: 'Maaaring score ng inspector ang gawain',
                        reviewerTip: 'Ang reviewer ay maaaring rate ang gawain',
                        dataStatisticsAuthority: 'Pahintulot sa Statistics ng Data',
                    },
                    samplingRecords: {
                        title: 'Mga tala ng sampling',
                        manualSampling: {
                            title: 'Sampling',
                            fillterCondition: 'Filter Condition:',
                            samplingRule: 'Patakaran sa sample',
                            agent: 'Servisyo ng Customero',
                            type: 'Type',
                            result: 'Resulta',
                            evaluate: 'Evaluation',
                            relayNumber: 'Numero',
                            source: 'Source',
                            task: 'Gawaing',
                            queueState: 'Mga Status ng Queuing',
                            callHanger: 'Taawag hang-up party',
                            queueTime: 'Pagkuha ng oras',
                            talkTime: 'Pangalawan',
                            bellTime: 'Ring Duration',
                            recordCountTipOne: 'Kabuan',
                            recordCountTipTwo: 'Record',
                            customerServices: 'Servisyo ng Customero',
                            customerServicesGroup: 'Grupo ng Servisyo ng Customero',
                            surveyList: 'Listahan',
                            customFields: 'Custom Fields',
                            fieldConfig: 'Field Configuration',
                            defaultFields: 'Mga Default Fields',
                        },
                    },
                    taskList: {
                        title: 'Listahan ng Task',
                        index: {
                            batchDelete: 'Batch Deletet',
                            batchSubmit: 'Batch Submissions',
                            batchConfirm: 'Batch Confirmation',
                            itemFields: 'Grading Item Fields',
                            categoryFields: 'Secondary Classification Field',
                            forbidsAndDeadlies: 'Mga Prohibited at Fatal Items',
                            scoreFieldList: 'Scoring Item Field List.',
                            customerName: 'Pangalan ng Customr',
                            cellphone: 'Telepono',
                            email: 'E-mail',
                            organization: 'Kumpanya',
                            description: 'Paglalarawan',
                            tags: 'Label',
                            taskUserRole: 'Kasalukuyang Role ng User User',
                        },
                        workBench: {
                            title: 'Detalyas',
                            checkForm: 'Form ng Inspection ng kality',
                            waitEvaluate: 'Bilang pagsusuri',
                            alreadyEvaluate: 'Nasayo',
                            waitSubmit: 'Upang ipasa',
                            alreadySubmit: 'Ipinadalan',
                            waitConfirm: 'Upang kumpirman',
                            alreadyConfirm: 'Kinumpirma',
                            waitReview: 'Upang suriin',
                            alreadyReview: 'Reviewe',
                            alreadyDone: 'Kumpleto',
                            comment: 'Mga Remarks',
                            totalScore: 'Total score',
                            score: 'Punts',
                            remark: 'Mga pahayaga',
                            changeRecords: 'Pagbago ng Record',
                            subject: 'Tema',
                            secondLevelScore: 'Grade II',
                            deadlyList: 'Fatal Item',
                            forbidList: 'Mga Prohibited Items',
                            addToCheckTask: 'Dagdag sa Quality Task',
                            submitCheckRemark: 'Ipinadala ang pagsusuri ng inspeksyon ng kalidado',
                            changeCheckRemark: 'Nagbago ang pagsusuri sa inspeksyon ng kalidado',
                            doneCheckRemark: 'Nakumpleto ang pagsusuri ng inspeksyon ng kalidado',
                            submitCheckReview: 'Ipinadala para sa pagsusuri ng kalidad ng inspekyon',
                            submitCheckAppeal: 'Ang appeal sa inspeksyon ng kalidad ay ipinadalasa',
                            saveFlowSuccess: 'Evaluation ang tagumpay.',
                            saveFlowFailed: 'Nabigo ang evaluation, mangyaring subukan muli mamaya.',
                            FormDetail: 'Detalyas',
                            callDetail: 'Mga detalye ng call log',
                            sampleCalllogDetail: 'Detalyas',
                            appealReasonTip: 'Mangyaring ipasok ang isang dahilan para sa appeal (kinakailangan)',
                            appeal: 'Complaint',
                            appealReason: 'Dakila ng reklamo',
                        },
                    },
                },
            },
            qualityInspectionForm: {
                formformat: '{0} Form ng Inspection ng Quality',
                basicInformationTitle: 'Pangunahing impormasyong',
                indicatorsProjectTitle: 'Indicator Item',
                specialProjectTitle: 'Espesyal na Items',
                totalScore: 'Total score',
                indicatorsName: 'Name ng Indicator',
                score: 'Fraction',
                singleScore: 'Single item scor',
                weight: 'Bigaga',
                maxDeductScore: 'Maximum na deduction points',
                add: 'Pagdaraw',
                detail: 'Detalyas',
                list: {
                    title: 'Form ng Inspection ng kality',
                    tipOne: 'Ang pag-configure ng form ng inspeksyon ng kalidad ay ang unang hakbang sa gawaing inspeksyon ng kalidad. Maaari mong i-configure ang pinaka-aangkop na form ng inspeksyon ng kalidad na batay sa negosyo ng iyong kumpanya.',
                    tipTwo: 'Sinusuportahan namin ang iba\'t ibang mga form tulad ng direktang scoring, timbang na scoring, at point deduction systems. Inirerekumenda na itakda mo ang mga patakaran bago idagdag ang mga ito sa sistema.',
                },
                basicInformation: {
                    formTemplate: 'Form template',
                    directScore: 'Direct Rating',
                    weightedScore: 'Timbang Score',
                    deductScore: 'Deductions',
                    directScoreSecondLevel: 'Direct Rating-Level 2',
                    weightedScoreSecondLevel: 'Weght Score-Level 2',
                    deductScoreSecondLevel: 'Points Deduction-Level 2',
                    deductScoreImageFileName: 'deduct-score.png',
                    weightedScoreImageFileName: 'weighted-score.png',
                    directScoreImageFileName: 'direct-score.png',
                    deductScoreSecondLevelImageFileName: 'deduct-score-second-level.png',
                    weightedScoreSecondLevelImageFileName: 'weighted-score-second-level.png',
                    directScoreSecondLevelImageFileName: 'direct-score-second-level.png',
                },
                specialProject: {
                    banProject: 'Mga Prohibited Items',
                    banProjectTip: 'Maaari itong magamit upang suriin sa panahon ng scoring ng kalidad ng inspeksyon. Ito ay maaaring ituring bilang isang paglabag o suplemento sa mga komento nang hindi nakakaapekto sa tunay na marka.',
                    deadlyProject: 'Fatal Item',
                    deadlyProjectTip: 'Maaaring gamitin ang mga nakamamatay na item upang suriin sa panahon ng scoring ng kalidad ng inspeksyon. Kung ang isang nakamamatay na item ay na-check, ang gawain ng inspeksyon ng kalidad ay direktang nakapuntos ng 0 puntos.',
                },
            },
            qualityInspectionStatisticalReports: {
                reports: {
                    title: 'Call Quality Inspection',
                    entiretyReportTitle: 'Pangkalahatang Reporto',
                    serviceGroupReportTitle: 'Mga Report ng Grupo ng Customer Services',
                    serviceReportTitle: 'Report ng Servisyo ng Customero',
                    entiretyReport: {
                        pandect: 'Overviews',
                        contrast: 'Contrast',
                        trend: 'Trend',
                        analyze: 'Analysisya',
                        totalScore: 'Total score',
                        banProject: 'Mga Prohibited Items',
                        deadlyProject: 'Fatal Item',
                    },
                },
            },
            appealChekingTask: {
                list: {
                    title: 'Listahan ng resulta ng inspeksyon ng kalida',
                    taskSelectPlaceholder: 'Pumili ng Quality',
                    agentSelectPlaceholder: 'Magpili ng serbisyo ng customer',
                    refresh: 'Refresh',
                    all: 'Lahat',
                    unread: 'Hindi binasa',
                    inComplaint: 'Sa Complaint',
                    reviewed: 'Reviewe',
                    totalScore: 'Pangkalahatang komento',
                    detail: 'Detalyas ng Inspection ng kality',
                    audioText: 'Nakatala ang teksto',
                    callInfo: 'Impormasyon sa tawag',
                    ticketInfo: 'Impormasyon sa Work Order',
                    wechatInfo: 'Impormasyon sa session',
                    dialogText: 'Teksto sa dialogo',
                    dialogInfo: 'Impormasyon sa dialogo',
                    customer: 'Customero',
                    agent: 'Servisyo ng Customero',
                    none: 'Walang data ng inspekyon',
                    appealSuccess: 'Appeal matagumpay!',
                    appealFailed: 'Nabigo ang apela, mangyaring subukan muli mamaya!',
                    pointListIsNull: 'Ang punto ng inspeksyon ng kalidad ng reklamo ay hindi maaaring walang laman!',
                    pleaseSelectPoint: 'Mangyaring pumili ng punto ng inspeksyon ng kalidad!',
                    unsupportedFormat: 'Hindi suportado ang format na ito.',
                    shardingInformation: 'Ang sumusunod ay shard {0}',
                    smartTags: 'Smart Label',
                    businessRecords: 'Mga tala ng negosyon',
                    selectedPointsWarning: 'Mangyaring suriin ang mga item ng inspeksyon ng kalidad upang mag-aapela, magbigay ng mga nauugnay na pahayag para sa mga appeal item, at pagkatapos mag-click sa Submit.',
                    applyReason: 'Lands of appeal (maximum 50 salita)',
                    chatMessageTypes: {
                        all: 'Lahat',
                        text: 'Tekstos',
                        image: 'Larawn',
                        agree: 'Consent session content',
                        video: 'Videos',
                        voice: 'Voice',
                        file: 'Talaan:',
                        emotion: 'Ekresyon',
                        link: 'Links',
                        chatrecord: 'Chat records',
                        mixed: 'Mixed Messagee',
                        default: 'Hindi suportado ang mensahes',
                        deleteFriend: 'Paglabas ng Kaibigan',
                        redpacket: 'Pulang envelope',
                        card: 'Business card',
                        disAgree: 'Huwag sumasang-ayon sa nilalaman ng session',
                        weapp: 'Maliit na program a',
                        externalRedpacket: 'Pagbago ng mga red envelop',
                        meetingVoicevCall: 'Taawag Mensahe',
                        uRL: 'Web Page',
                        replyTimeout: 'Timeout Repy',
                        sphfeed: 'Video Number a',
                        chatRecordTitle: 'Chat records',
                    },
                },
                components: {
                    qualityCheckScore: {
                        totalScore: 'Total score',
                        actualScore: 'Rating',
                        actualGrade: 'Rating',
                        appeal: 'Complaint',
                        remark: 'Manual remarks',
                        none: 'Walang detalyadong datos para sa inspeksyon ng kalidado',
                        pointEdit: 'Klasipikasyon ng pag-edit ng kalidad na inspekyon',
                    },
                    changeList: {
                        title: 'Pagbago ng Record',
                        user: 'User',
                        point: 'Punto ng inspeksyon ng kalida',
                    },
                    relatedRecord: {
                        title: 'Related Recordss',
                        qualityList: 'Gawain sa inspeksyon ng kalida',
                        none: 'Walan',
                        check: 'Pansing',
                        loadMore: 'Higit pa ang paglog',
                    },
                },
            },
            grade: {
                title: 'Rating ng inspeksyon sa kalida',
                subTitle: 'Ang rating ng inspeksyon ng kalidad ay ginagamit upang mag-grade ang mga bagay sa inspeksyon ng kalidad matapos na nakumpleto ang scoring ng inspeksyon ng kalidad. Halimbawa, maaari itong mai-configure bilang hindi kwalipikado kung ito ay mas mababa sa 60, mabuti kung ito ay mas mataas sa 60, at mahusay kung ito ay mas mataas sa 80.',
                list: {
                    up: 'Paglipat Upa',
                    down: 'Lumang Ibas',
                    del: 'Mangalisa',
                    case: 'Awtomatikong sumali sa library ng kaso',
                    orderCase: 'Default Case Librarya',
                    info: 'Ang default rating ay walang kaugnay na mga kriterya at hindi maaaring tanggalin. Kung ang isa sa mga rating sa itaas ay hindi natutugunan, ang default rating ay makukuha.',
                    add: 'Dagdag ang Rating',
                    save: 'Pag-save',
                    close: 'Kansela',
                    max: 'Ang rating ng inspeksyon ng kalidad ay maaaring mai-configure hanggang 20.',
                    name: 'Walang pangalan',
                    success: 'Ito ang matagumpay',
                },
            },
            qualityInspectionList: {
                title: 'Listahan ng Inspection ng Quality',
                fastFilter: 'Paglabag sa Quality Inspection',
                fastFilterTip: 'Ang isang hit sa minus-point system ay isang paglabag, at ang isang miss sa plus-point system ay isang paglabag.',
                titleWechat: 'Listahan ng analysis',
                titleCollect: 'Listahan ng Acquisition',
                status: 'Status ng analysis',
                reQualityInspectionConfig: 'Mga Opsyon ng Task na Requality',
                pleaseSelectRecheckPoints: 'Mangyaring piliin ang punto ng inspeksyon ng kalidad na binabalikan',
                beginReQualityInspection: 'Sinimulan ang pagpapatakbon',
                cancelReQualityInspection: 'Kansela ng gawaan',
                reQualityInspection: 'Re-inspection',
                reQualityInspectionWechat: 'Re-analysisy',
                reQualityInspectionUnderWay: 'Re-inspection gawain...',
                reQualityInspectionUnderWayTip: 'Ang pag-iwan sa pahina pagkatapos ng pagsasara ng window ay hindi nakakaapekto sa gawain',
                reQualityInspectionDone: 'Nakumpleto ang re-inspecto',
                reQualityInspectionDoneTip: 'Matagumpay na nakumpleto ang re-inspection, mangyaring mag-click ang pindutan ng kumpirmasyon.',
                endReQualityInspection: 'Terminate Task',
                alreadyDoneTip: '{0} natapos',
                totalTip: 'Kabuuan {0}',
                endReInspectionSuccess: 'Muling kalidad na gawain',
                closeWindow: 'Isara ng windows',
                endReInspectionFailed: 'Nabigo ang re-kwality task, mangyaring subukan muli mamaya!',
                detail: {
                    title: 'Detalyas ng Inspection ng kality',
                    wechatTitle: 'Detalyas',
                    titleCollect: 'Detalyas',
                    callIndex: 'Associated Call',
                    textIndex: 'Mga Associated Conversationss',
                    fileConfirm: 'Tikumerima ang pag-file?',
                    fileConfirmDesc: 'Matapos ang arkibo, hindi maaaring i-edit ang score ng inspeksyon ng kalidad. Mangyaring kumpirmahin kung mag-archive.',
                },
                sysCloumnsContal: 'System Column Field Management.',
                personCloumnsContal: 'Personal Column Field Managements',
            },
            spotCheckList: {
                title: 'Listahan ng sampling',
                onlyMyTip: 'Tingnan ang My Sampling Lama',
                plInspector: 'Mangyaring piliin ang staff ng sampling',
                allInspector: 'Tingnan Lata',
                seInspector: 'Tingnan ang itinalagang sampling inspector',
                myInspector: 'Tingnan lamang ang minan',
                noInspector: 'Tingnan ang inspector na hindi nakatakda ng sampling...',
                detail: {
                    title: 'Detalye ng sampling',
                },
            },
            reviewList: {
                title: 'Listahan',
                onlyMyTip: 'Tingnan lamang ang aking review',
                plInspector: 'Mangyaring pumili ng revier',
                allInspector: 'Tingnan Lata',
                seInspector: 'Tingnan ang Designated Reviewer',
                myInspector: 'Tingnan lamang ang minan',
                noInspector: 'Makikita ang hindi nakatakda ng Reviewer',
                detail: {
                    title: 'Detalyas',
                },
            },
            caseBaseList: {
                title: 'Case Librarya',
                del: 'Mangalisa',
                delTitle: 'Lahat ng nilalaman ay hindi mai-save pagkatapos ng pagtanggal',
                cancel: 'Kansela',
                actions: 'Operasyong',
                seeCaseBase: 'Pansin ang Kaso',
                seeDetail: 'Pansin Detalyas',
                edit: 'Pag-edita',
                save: 'Pag-save',
                addCaseBase: 'Bagong Case Librarya',
                export: 'Pag-exporto',
                ok: 'Determine',
                tip: 'Ang karaniwang data ng tawag at pag-uusap sa listahan ng inspeksyon ng kalidad ay maaaring makatipid sa library ng kaso para sa madaling pag-aaral at pagbabahagi.',
                detail: {
                    choiceCaseBase: 'Mangyaring pumili ng kaso',
                    delCaseBase: 'Paglabas ng Kaso',
                    addCaseBase: 'Dagdag ang Kaso',
                    successed: 'Ito ang matagumpay',
                    info: 'Mang-save o kanselan ang nilalaman na unang i-editer',
                    caseType: 'Mangyaring piliin ang isang library ng kaso upang sumali a',
                },
            },
            testSetList: {
                title: 'Set ng Inspection Test ng Quality',
                tip: 'Ang data na sample ng inspektor ng kalidad ay makatipid sa set ng pagsusulit ng inspeksyon ng kalidad, na kumbinyente upang ma-optimize ang pagsasaayos ng mga kondisyon ng inspeksyon ng kalidad at patakaran para sa ilang mga item ng error sa inspeksyon ng makina kumpara pagkatapos ng sampling inspekso .',
                refresh: 'Refresh',
                reQualityInspectionUnderWay: 'Muling susuriin ang misyon...',
                reQualityInspectionUnderWayTip: 'Ang pag-iwan sa pahina pagkatapos ng pagsasara ng window ay hindi nakakaapekto sa gawain',
                reQualityInspectionDone: 'Nakumpleto ang muling pagtatasa',
                reQualityInspectionDoneTip: 'Matagumpay na nakumpleto ang re-valuation, mangyaring mag-click sa Confirm',
                endReQualityInspection: 'Terminate Task',
                alreadyDoneTip: '{0} natapos',
                totalTip: 'Kabuuan {0}',
                endReInspectionSuccess: 'Natapos ang gawain ng muling pagtatasa',
                closeWindow: 'Isara ng windows',
                endReInspectionFailed: 'Nabigo ang task ng muling pagpapahalaga, mangyaring subukan muli mamaya!',
                recheckPoint: 'Mulilkulate ang Quality Inspection Point Scores and Accuracy',
                recheckPointTitle: 'Mga opsyon ng re-valuat',
                delete: {
                    reQualityInspectionUnderWay: 'Batch Delete Tasks...',
                    reQualityInspectionUnderWayTip: 'Ang pag-iwan sa pahina pagkatapos ng pagsasara ng window ay hindi nakakaapekto sa gawain',
                    reQualityInspectionDone: 'Batch Delete Task Complete',
                    reQualityInspectionDoneTip: 'Matagumpay na nakumpleto ang maramihang pagtanggal, mangyaring mag-click sa Confirm',
                    endReQualityInspection: 'Terminate Task',
                    alreadyDoneTip: '{0} natapos',
                    totalTip: 'Kabuuan {0}',
                    endReInspectionSuccess: 'Batch delete task na natapos',
                    closeWindow: 'Isara ng windows',
                    endReInspectionFailed: 'Nabigo ang pagtanggal ng batch, mangyaring subukan muli mamaya!',
                },
                reultList: {
                    assessmentTime: 'Huling Oras ng Evaluation',
                    assessmentAll: 'Total Assessment',
                    strip: 'Artikulo',
                    spot: 'Punt',
                    deviation: 'Deviation',
                    accuracyRate: 'Tukunas',
                    info: 'Walang resulta ng pagsusuri',
                    onlyDeviationInfo: 'Tingnan ang Deviation Records Langy',
                    againAssessment: 'Re-valuasyon',
                    screen: 'Filtral',
                    batchDelete: 'Inalis ang Batch',
                    matching: 'Match',
                    ok: 'Oo,',
                    noCancel: 'Hindin',
                },
            },
            smartWordsLibrary: {
                title: 'Intelihente thesaurus',
                tip1: 'Mga synonyms: ginagamit upang mabawasan ang dami ng pagsasanay ng mga semantic label, Ang mga katulad na pangungusap ng mga synonyms ay hindi kailangang paulit-ulit na pagsasanay.',
                tip2: 'Professional Nouns: Transcribe optimization at natural na wika na pag-unawa ng optimization para sa mga tamang pangngalan tulad ng mga pangalan ng enterprise, Mga pangalan ng produkto at mga salita sa industriya na hindi tumpak na kinikilala upang mapabuti ang katumpakan ng pagkilala at pagsisiyasat.',
                tip3: 'Focus sa mga salita: Pagtuon sa mga salita na nais mong ituon sa pagsusuri sa salita ng cloud upang makatulong sa pag-analise ng mga hotspot ng AI na matugunan ang kasalukuyang negosyo.',
                tip4: 'Block salita: Block salita na hindi mo nais magbigay ng pansin sa salitang pagsusuri ng cloud upang makatulong sa AI na analin ang mga mainit na lugar sa kasalukuyan negosyo.',
                tip5: 'Ang bigat ng salita: ginagamit upang matuwid at optimize ang pagkilala ng mga semantic label. Sa pamamagitan ng pagbabago ng epekto ng mga salita sa mga pangungusap, ang epekto ng pagkilala sa semantiko sa mga tiyak na senaryo ay maaaring ma-optimize bilang kinakailangan.',
                tip6: 'Data ng Corpus: Maglagay ng malalaking paragrapo ng teksto para sa kanilang mga senaryo sa negosyo para sa pagwawasto ng error sa transcoding at pagsasanay sa ASR upang mapabuti ang katuruan ng transcoding ng ASR.',
                upload: {
                    uploadSynonymWords: 'Pag-import ng mga Synonyms',
                    uploadProfessionalWords: 'Importasyon ng propesyonal na termino',
                    uploadAttentionWords: 'Pag-import ng mga salita ng interesa',
                    uploadIgnoreWords: 'Pag-import ng Ignore Words',
                    uploadWordsWeight: 'Pag-import ng mga Salita',
                    uploadTypo: 'Pag-import ng typo',
                    uploadCorpusData: 'Importasyon ng data ng corpus',
                    uploadCorpusContent: 'Importasyon ng datos ng corpus',
                    firstUploadStep: '1. I-download ang template at punan ito ayon sa format ng template',
                    downloadTemplateMessage: 'Download template:',
                    firstUploadJSONButton: 'JSON',
                    firstUploadExcelButton: 'EXCEl',
                    firstUploadTxtButton: 'TXT',
                    secondUploadStep: '2. Click ang button ng Import upang i-upload ang EXCEl file na sumusunod sa format ng template',
                    secondUploadCorpusDataStep: '2. Click the Import button upang i-upload ang TXT file na sumusunod sa format ng template.',
                    postUploadDataFail: 'Nabigo sa pagpapadala at pag-upload ng data.',
                    pleaseUploadTemplate: 'Mangyaring i-upload ang file ng EXCEl/JSON/TXT',
                    templateNeedJSONOrXLSX: 'Ang mga template ng file ay maaari lamang sa format ng JSON o xlsx',
                    templateNeedTxt: 'Ang template ng file ng corpus data ay maaaring maging TXT file lamang',
                    uploadSuccess: 'Nagtagumpay ang pag-importo',
                    uploadFailed: 'Nabigo ang pag-importo',
                    downloadError: 'Nabigo ang pag-downloads',
                    downLoadTxtTitle: 'Corpus Content. txt',
                },
                navTabNames: {
                    synonymWords: 'Mga synonyms',
                    professionalWords: 'Professional Noun',
                    attentionWords: 'Mga salita na nababahalan',
                    ignoreWords: 'Hindi pinapansin ang mga salat',
                    wordsWeight: 'Salitang biga',
                    corpusData: 'Corpus datas',
                    typoLibrary: 'Typos',
                },
                synonymWords: {
                    createSynonymWords: 'Bagong Synonyme',
                    editSynonymWords: 'Pag-edit ng Synonyms',
                    addSynonymWords: 'Dagdag ang Synonyma',
                    pleaseEnterStandardWords: 'Mangyaring ipasok ang isang karaniwang salat',
                    synonymWordsExists: 'Ang synonym ay mayroon na at hindi maaaring idaggga',
                    synonymWordsCanNotNull: 'Hindi maaaring walang laman ang idinagdag na synonyme',
                    pleaseAddSynonymWords: 'Mangyaring magdagdag ng mga synonyms',
                    addSuccess: 'Bagong tagumpa',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                    required: '*',
                },
                professionalWords: {
                    create: 'Mga bagong propesyonal na termino',
                    edit: 'Professional nomen editor,',
                    addTargetWords: 'Dagdag ang salitang kapalita',
                    targetWordsExists: 'Ang salitang kapalit ay mayroon na at hindi maaaring idaggga',
                    targetWordsCanNotNull: 'Ang salitang pagpapalit ay hindi maaaring walang laman',
                    pleaseAddTargetWords: 'Mangyaring magdagdag ng salitang kapalita',
                    pleaseEnter: 'Mangyaring ipasok ang propesyonal na termino',
                    wordsExists: 'Ang termino ay mayroon na.',
                    createSuccess: 'Nagdagdag ng matagumpayan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                    saveError: 'Sawi sa pag-save',
                    addTargetWordsMaxNumberError: 'Maaari kang idagdag hanggang sa 100 salita ng kapalita',
                    addHomophonyWordsMaxNumberError: 'Maaari kang idagdag hanggang sa 100 masked salita...',
                },
                attentionWords: {
                    create: 'Bagong salita ng pag-aalala...',
                    edit: 'Nag-aalala na Word Editor',
                    pleaseEnter: 'Mangyaring ipasok ang isang salita ng interesat',
                    wordsExists: 'Ang salita ng interes ay mayroon na.',
                    createSuccess: 'Nagdagdag ng matagumpayan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                },
                ignoreWords: {
                    create: 'Bagong Ipinabago',
                    edit: 'Ignore Word Editing',
                    pleaseEnter: 'Mangyaring ipalagay ang salita',
                    wordsExists: 'Ang salitang hindi pinapansin ay naiiral na',
                    createSuccess: 'Nagdagdag ng matagumpayan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                },
                wordsWeight: {
                    createWordsWeight: 'Bagong Salita',
                    editWordsWeight: 'I-edit ang Salita',
                    addWordsWeight: 'Dagdag ang Salita',
                    pleaseEnterWeightWords: 'Mangyaring ipasok ang isang bigat na salat',
                    pleaseEnterWeight: 'Mangyaring ipasok ang timbang',
                    weightNeedInZeroToHundred: 'Kailangan ang timbang sa pagitan ng 0 at 100.',
                    synonymWordsExists: 'Ang salita na mayroon na...',
                    weightNeedNumber: 'Ang timbang ay nangangailangan ng integer formato',
                    standardWeightInformation: 'Ang benchmark weight ay 50, at mas malaki ang timbang, mas malakas ang epekto sa pagsusuri.',
                    createSuccess: 'Nagdagdag ng matagumpayan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                },
                corpusData: {
                    createCorpusData: 'Bagong Corpus Data',
                    editCorpusData: 'Edit ang Corpus Data',
                    addCorpusData: 'Dagdag ang Corpus Data',
                    pleaseEnterCorpusDescription: 'Mangyaring ipasok ang corpus na paglalarawan',
                    pleaseEnterCorpusContent: 'Mangyaring ipasok ang nilalaman ng corpus',
                    synonymWordsExists: 'Ang data ng corpus na ito ay mayroon na',
                    CorpusContentWordsOverSetting: 'Ang bilang ng mga salita sa nilalaman ay lumampas sa 20000 salita,',
                    download: 'Download a',
                    upload: 'Uploads',
                    see: 'Pansing',
                    canNotSave: 'Mangyaring gamitin ang function ng import, kung hindi man ito maaaring makatipid',
                    createSuccess: 'Nagdagdag ng matagumpayan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteError: 'Bigo ang pagtanggal',
                    required: '*',
                },
                typoLibrary: {
                    fields: {
                        rightWord: 'Tamang salta',
                        wrongWord: 'Maling salat',
                        wrongWordCount: 'Bilang ng maling salat',
                        wrongWordTip: 'Press Enter upang idagg',
                        status: 'Effectiveness',
                    },
                    create: 'Bagong salita ng typo',
                    edit: 'Pag-edit ng Typo',
                    tip: 'Ang typos word set ay ginagamit upang optimize ang epekto ng "typos detection". Halimbawa, kung ang "refund" ay maling ipinadala bilang "lawak na refund", maaaring maitakda ang mga karaniwang typo at tamang salita sa pamamagitan ng function na ito, at magiging epekto ito sa susunod na araw pagkatapos ng pag-save.',
                    onlyChinese: 'Suporta lamang ang mga salitang Tsino',
                    wrongWordLengthErr: 'Ang haba ng bawat maling salita ay dapat 2 ~10 salat',
                },
            },
            semanticTags: {
                title: 'Semantic label a',
                current: 'Kasalukuyang Semantic Label',
                reference1: 'Gawain sa Inspection: {0} - {1}',
                reference2: 'Smart Label: {0}',
                reference3: 'Preprocessing ng data: {0}',
                reference4: 'Knowledge Base: {0}',
                index: {
                    import: 'Pag-import ng Semantic Labels',
                },
                detail: {
                    new: 'Bagong Semantic Label',
                    edit: 'Edit Semantic Label',
                    name: 'Pangang',
                    standardSentences: 'Karaniwang pangungunan',
                    effectiveness: 'Effectiveness',
                    similarSentences: 'Katulad na pangunguhan',
                    tip: 'Sumusuporta sa paggamit ng # # upang tawagan ang entity API, halimbawa: Ang iyong mobile phone number # sys_phone?',
                    excludeSimilarSentences: 'Paglabas ng mga katulad na pangungunan',
                    intelligentRecommend: 'Smart rekomendasyon ang katulad na nilalamang',
                    fastTraining: 'Mabilis na Training:',
                    qualify: 'Regular,',
                    recallKeyWord: 'Itala ang mga Keywords',
                    excludeKeywords: 'Paglabas ng keywords',
                    excludeKeywordsInfo1: 'Maglalabas ng mga keywords at mga regular na expression ang gumaganap ng una sa lahat ng mga lohika. Kung ang mga ito ay hindi nabubuhay, ang semantic label ay hindi ma-hit.',
                    keyWordInfo1: 'Maaaring punan ang maramihang mga keywords sa bawat linya, na pinaghiwalay ng Ingles commas. Kapag ang maraming mga keywords ay puno, ang lohika ay ang lahat ng mga hits ay hits.',
                    keyWordInfo2: 'Ibinigay ang mga keywords ay maaaring punan sa maraming linya. Kapag napuno ang maraming linya, ang lohika ay maaaring itakda bilang anumang hit.',
                    recallRegular: 'Tandaan ang Regular',
                    excludeRegular: 'Hindi kasal',
                    similaSentences: 'Paglabas ng mga katulad na pangungunan',
                    simim: 'Pagkakatulan',
                    keyWordInfo3: 'Ang hindi kasama ng mga katulad na pangungusap ay tumatagal ng unahan sa lahat ng lohika. Kung ang katulad na pangungusap ay hit, ang semantic label ay hindi mapupunta. Ang default na pagkakatulad ay 80%, at mas malaki ang pagkakatulad, mas katulad nito.',
                    keyWordInfo4: 'Ang patakaran ay katulad ng regular, na may default na pagsisimula at pagtatapos. Hindi kinakailangang ginagamit sa mga brackets, hal. [hindi XXXX]',
                    keyWordInfo5: 'Ang mga function sa advanced module ay karaniwang mga pang-eksperimentong function para sa mga eksperto na pamilyar sa operasyon. Kung hindi ka sigurado kung paano gumana, inirerekumenda na hindi mo baguhin ang seksyon na ito.',
                    keyWordInfo6: 'Ang larawan ng pagpapakita ng cross-sentence ay nagbibigay ng mga semantic tags ng kakayahan na makikita sa mga pangungusap.',
                    keyWordInfo7: 'Sa halos sunud-sunod sa parehong tungkulin',
                    keyWordInfo8: 'Hindi pinapansin ang iba\'t ibang papel na haba ng Sentence ay hindi mas malakin',
                    keyWordInfo9: 'Mga pahintulot ng mga salita para sa pagkilala sa cross',
                    keyWordInfo10: 'Ang haba ng pinakamahabang pangungusap sa cross sentence ay hindi higit',
                    keyWordInfo11: 'Alisin ang katulad na porsyento',
                    keyWordInfo12: 'Hindi mas mababa ang pagkakatulad',
                    keyWordInfo13: '% Ng mga katulad na pangungusap ay magkapareho (default pagkakatulad 80%)',
                    keyWordInfo14: 'Ang katulad na deduplication ay tumutugma sa mga pangungusap na batay sa kanilang pagkakatulad. Inirerekumenda na alisin ang mga pangungusap na katulad upang mapabuti ang epektibo ng pagtuklas.',
                    keyWord: 'Keywords',
                    entity: 'Entity',
                    ruleField: 'Mga salitang konsepto',
                    customRule: 'Disenyo ng Speech Rule',
                    fanhua: 'Katulad na Katanungan',
                    test: 'Testo',
                    testOk: 'Hit teste',
                    senior: 'Mga Advanced Settings',
                    seniorList: 'Pagkakita ng cross-ress',
                    up: 'Mapangita',
                    down: 'Saray',
                    ju: 'Sentensya',
                    oneWord: 'Salita',
                    simimNo: 'Katulad ng timbang',
                    seniorField: 'Pagkakatulad threshold',
                    save: 'Pag-save',
                    cancel: 'Kansela',
                    specialElements: 'Espesyal na elemento',
                    logicRule: 'Mga patakaran ng lohiko',
                    every: 'Maraming tugman',
                    recallOk: 'Hit Recall Word:',
                    recallNo: 'Na-missed Recall Words',
                    ruleOk: 'Hit regular recall',
                    ruleNo: 'Naka-missed Regular',
                    rularOk: 'Hit Rules',
                    rularNo: 'Nawawala ang patakas',
                    infoOk: 'Hit standard pangungusap o katulad na pangungusap:',
                    infoNo: 'Nawawala ang karaniwang pangunguna o katulad na pangungunan',
                    fieldOk: 'Gumawa upang maiwala ang mga katulad na pangungusap:',
                    fieldNo: 'Naliliwanag upang maibukod ang katulad na pangungunan',
                    excludeRuleNo: 'Misses Exclusion Regex',
                    excludeRuleOk: 'Hit na regular na eksklusiyon',
                    excludeKeywordNo: 'Hindi na-iwan ang mga misse keywords',
                    excludeKeywordOk: 'Hit Exclude Keywords',
                    update: 'Nagtagumpay ang pag-update',
                    fanhuaList: 'Ipinadala sa Generalization Tab Similar Sentence List.',
                    wordList: 'Walang laman ang listahan ng pagsasanay at hindi maaaring ipadala sa listahan ng pangkalahatang',
                    start: 'Magsimula',
                    end: 'Endo',
                    keyWordInfo15: 'Ang mga katulad na patlang ay mayroon sa listahan ng generalization (advanced configuration ng katulad na mga restrints ng deduplication)',
                    saveSuccess: 'Ito ang matagumpay',
                    errInfo: 'Ang ilang mga patlang ay hindi puno o puno ng hindi tamang',
                },
                table: {
                    deepTraining: 'Deep Training {0} ikot',
                    fastTraining: 'Mabilis na Traing',
                },
            },
            intelligentCollection: {
                title: 'Intelligent acquisitiso',
                classification: 'Listahan ng grupong',
                new: 'Bagong koleksyong',
                table: {
                    name: 'Name field',
                    props: 'Customer Attributs',
                    type: 'Type ng patlangan',
                    desc: 'Paglalarawan sa field',
                },
                detail: {
                    isCustomerProps: 'Save to Customer Attributs',
                    customerPropsHelper: 'Pagkatapos ng pag-save, ang nakuha na impormasyon ay i-update sa impormasyon ng customer. Kung hindi mo naka-save, hindi ito i-update sa impormasyon ng customer',
                    name: 'Name field',
                    type: 'Type ng patlangan',
                    text: 'Tekstos',
                    desc: 'Paglalarawan sa field',
                    descPlaceHolder: 'Ilarawan ang paggamit ng patlang na ito upang kolektahin ang impormasyong',
                    condition: 'Kondisyon',
                    logic: 'Mga patakan',
                    method: 'Mode ng Acquisition',
                    message: 'Kabilangan ng impormasyong',
                    range: 'Range ng Extraction',
                    entity: 'Extract Entities',
                    base: 'Pangunahing impormasyong',
                    collect: 'Palekta ng impormasyong',
                },
            },
            intelligentTags: {
                title: 'Smart Label',
                sessionLabelTitle: 'Session Scenarios',
                keyEventsTitle: 'Mga pangunahing pangyayarin',
                customerLabelTitle: 'Customer Label',
                addClassification: 'Lumikha ng bagong klasipikasyon ng labela',
                defaultCategoryName: 'Default Classifications',
                index: {
                    createTag: 'Bagong Label',
                    createEvent: 'Bagong kaganapang',
                    editTagClassification: 'Pag-edit ng Label',
                    selectTagClassification: 'Pumili ng Classification ng Label',
                    editTagGrounp: 'Pag-edit ng Grupo',
                    callTimeError: 'Ang piniling oras ng pagtawag/pag-uusap ay hindi maaaring lumampas sa isang buwan (31 araw)',
                    callRecordCountError: 'Ang bilang ng mga talaan ay 0, mangyaring piliin muli ang oras ng tawag/pag-uusap',
                    selectItmeCountError: 'Mangyaring piliin ang matalinong label kung saan nais mong gampanan ang bulk operas',
                    redoSuccess: 'Matagumpay ang muling pagpapatupad, mangyaring pumunta sa task center upang tingnan',
                    redoError: 'Nabigo ang re-executation, mangyaring subukan muli mamaya.',
                    timeError: 'Hindi maaaring lumampas sa isang buwan (31 araw)',
                    categoryName: 'Kategory',
                    categoryColor: 'Kulay ng klassiyon',
                    newTagClassification: 'Bagong Classification ng Label',
                    newEventClassification: 'Bagong Kategorya',
                    tagClassification: 'Label',
                    eventClassification: 'Klasipikasyon ng kaganapan',
                },
                detail: {
                    new: 'Bagong Smart Label',
                    edit: 'Pag-edit ng Smart Label',
                    tagName: 'Pangang',
                    tagDesc: 'Paglalarawan',
                    category: 'Classifications',
                    tagStatus: 'Effectiveness',
                    operator: 'Operator',
                    rule: 'Mga patakan',
                    labelClassAtion: 'Type ng Label',
                    labelClassAtionTip1: 'Callout labels: labeling batay sa mga patakan',
                    labelClassAtionTip2: 'Classification Labeling: Labeling Based on Model Training.',
                    group: 'Pag-grupo',
                    checkLabel: 'Magpili ng kategorya',
                    warn: 'Babalan',
                    warnTips: 'Matapos ang alerto, kapag ang sesyon ay nakakatugon sa pangunahing pangyayari na ito, ang itinalagang tao ay mag-uudyok at maaaring makatanggap ng paalala sa listahan ng paggawa.',
                    warnError: 'Mangyaring piliin ang Alert Specified Personnelel',
                },
                subTitle: {
                    common: 'Smart Session Tags',
                    wecom: 'Enterprise micro label.',
                },
            },
            customerPortrait: {
                title: 'Customer Portraite',
                index: {
                    import: 'Pag-import ng Customer Portrait',
                },
                searchPlaceHolder: 'Customer ID, Nickname, o Phone',
                callCount: 'Bilang ng pag-uusap:',
                callDuration: 'Kabuuang tagal ng tawag:',
                dialogCount: 'Bilang ng mga pag-uusap:',
                keyWordsStatistics: 'Mga pangunahing statistika ng salita (Top 20 & salita ng pag-aalala)',
                keyWordsCount: '({0})',
                businessTag: 'Business Label',
                keyWordsCloudImg: 'Keywords Cloud chart',
                customerEmotionTrend: 'Mga sentiment ng customer trends',
                notFoundCustomer: 'Walang kaugnay na customers na nakuhan',
                noKeyWords: 'Walang mga kaugnay na keyword na nahanap',
                noBusinessTags: 'Hindi nahanap ang mga kaugnay na tag ng negosyon',
                getKeyWordsStatisticsDataError: 'Nabigo sa query ng statistics keywords',
                getBusinessTagsStatisticsDataError: 'Nabigo ang query ng label ng customer',
                personCustome: 'Hindi talaksan',
                notimeInfo: 'Walang natagpuang impormasyon sa emosyon.',
                timeList: 'Date Range',
                operator: 'Smart Label',
                placeHolder: 'Pakipilin',
                placeOperator: 'Mangyaring pumili ng matalinong labela',
                search: 'Query',
                reset: 'Reseta',
                searchHolder: 'Paghahanap',
                call: 'Tawag',
                text: 'Dialog',
            },
            sentimentAnalysis: {
                title: 'Pagtuklas ng opinyon ng publiko',
            },
            saleSentimentAnalysis: {
                title: 'Analysis ng opinyon ng publiko',
            },
            dataPreprocess: {
                title: 'Preprocessing ng datas',
                index: {
                    createData: 'Bagong Data',
                    selectDataSource: 'Pumili ng Source ng Data',
                    selectStatus: 'Pumili ng epektibot',
                    callTimeError: 'Ang piniling oras ng pagtawag/pag-uusap ay hindi maaaring lumampas sa isang buwan (31 araw)',
                    callRecordCountError: 'Ang bilang ng mga talaan ay 0, mangyaring piliin muli ang oras ng tawag/pag-uusap',
                    selectItmeCountError: 'Mangyaring pumili ng data upang gumawa ng bulk operas',
                    redoSuccess: 'Matagumpay ang muling pagpapatupad, mangyaring pumunta sa task center upang tingnan',
                    redoError: 'Nabigo ang re-executation, mangyaring subukan muli mamaya.',
                },
                detail: {
                    new: 'Bagong Data',
                    edit: 'Nag-edit ang Data',
                    name: 'Pangang',
                    desc: 'Paglalarawan',
                    dataSource: 'Source ng Data',
                    status: 'Effectiveness',
                    entity: 'Extract Entities',
                    operator: 'Operator',
                    rule: 'Mga patakan',
                },
            },
            connectedByConversation: {
                title: 'Communication Conversation Association (Communication Conversation Association)',
                list: {
                    title: 'Funksyon ng asosasyon ng dialog ng komunikasyonan',
                    info: 'Ang function ng asosasyon ng pakikipag-usap ay maaaring mag-uugnay sa iba\'t ibang mga tawag at pag-uusap ayon sa mga nakatuon na patakaran.',
                    rule: 'Mga Panunungkulan ng Association',
                    source: 'Mangyaring pumili ng source ng data',
                    classification: 'Mangyaring pumili ng kategory',
                    choose: 'Pakipilin',
                    input: 'Mangyaring irekt',
                    save: 'Pag-save',
                    cancel: 'Kansela',
                    fieldwei: 'Bit',
                    fieldNot: 'May mga hindi napuno na field',
                    fiedldlengthNo: 'Lagi ang haba ng patlang na limitan',
                },
            },
            components: {
                operatorListGather: {
                    conditionTitle: 'CK',
                    keywordTip: 'Maaaring itakda ang maraming keywords, hiwalay sa pamamagitan ng comms',
                    applyRole: 'Detect Role',
                    preOperator: 'Harap operat',
                    applyOperatorScope: 'Range ng detektan',
                    addOperator: 'Magdagdag ng Operator',
                    noPreOperator: 'Walan',
                    from: 'Sekson',
                    to: 'Sentence sa No.',
                    end: 'Sentensya',
                    testRegular: 'Test Regular Expressions',
                    test: 'Testo',
                    matchSuccess: 'Tagumpay sa pagtuto',
                    matchError: 'Nabigo ang Match',
                    querySementicTags: 'Pumili ng Semantic Label',
                    reQuerySementicTags: 'Pagpili ng mga semantic labels',
                    sementicTag: 'Semantic label a',
                    standardSentence: 'Karaniwang pangungunan',
                    similarity: 'Pagkakatulan',
                    actions: 'Operasyong',
                    noFitTag: 'Hindi nahanap ang tamang label,',
                    addSemanticTag: 'Magdagdag ng bagong semantic tag',
                    pleaseEnterRegular: 'Mangyaring ipasok ang isang regular expression',
                    pleaseEnterRegularText: 'Mangyaring ipasok ang nilalaman na verifikan',
                    newAssociateComponentTip: 'Kung ang halaga ay isang numerong uri, gamitin ang legacy feature',
                },
                filterManage: {
                    noValueTip: 'Walang datas',
                    allCall: 'Lahat ng mga tawag',
                    allDialogue: 'Lahat ng mga Dialog',
                    allWechat: 'Lahat ng sesyons',
                    getFiltersListFailed: 'Hindi makakuha ng listahan ng filter, mangyaring subukan muli mamaya!',
                    getFilterDetailFailed: 'Hindi makakuha ng mga detalye ng filter, mangyaring subukan muli mamaya!',
                    getAllCountFailed: 'Hindi makakuha ng kabuuang bilang ng mga tawag/usapan, mangyaring subukan muli mamaya!',
                },
                listManage: {
                    searchPlaceHolder: 'Mangyaring ipasok ang isang keyword search a',
                    filterConditions: 'Filter Condition:',
                    records: 'Record',
                    getRecordsFailed: 'Hindi makakuha ng record, mangyaring subukan muli mamaya!',
                },
                miniListManage: {
                    getRecordsFailed: 'Hindi makakuha ng record, mangyaring subukan muli mamaya!',
                },
                applyTemplates: {
                    title: 'Applicable Quality Inspection Template',
                    collectionTitle: 'Applicable Acquisition Template',
                },
                recordDetail: {
                    showWaveAudio: 'Ipakita ang recording',
                    getDetailFailed: 'Hindi makakuha ng mga detalye, mangyaring subukan muli mamaya!',
                    getSmartTagsFailed: 'Hindi makakuha ng matalinong label, mangyaring subukan muli mamaya!',
                    getTemplatesFailed: 'Hindi makakuha ng applicable template, mangyaring subukan muli mamaya!',
                },
                changeList: {
                    sampleStatus: 'Status ng sampling',
                    sampleAssignInspector: 'Assign Sampling Inspector',
                    reviewAssignInspector: 'Assign reviewer',
                    read: 'Basaan',
                    distributivePerson: 'Lahating Persona',
                    totalScore: 'Total score',
                },
                qualityCheckScore: {
                    totalScore: 'Total score',
                    actualScore: 'Score',
                    actualGrade: 'Rating',
                    appeal: 'Complaint',
                    remark: 'Mga pahayaga',
                    manualRemark: 'Manual remarks',
                    none: 'Walang detalyadong datos para sa inspeksyon ng kalidado',
                    interactiveTip: 'Gumamit ng pagkilala sa pakikipag-ugnay upang makita ang paggamit ng serbisyo ng customer FAQ',
                    interactiveIsEmptyTip: 'Walang nakita na nilalaman ng interactive na pagkilalan',
                },
                semanticMark: {
                    semanticContent: 'Marking pangungusapan',
                    markedSimilarTitel: 'Katulad na Semantic Labels',
                    markedExcludeTitle: 'Marked Exclude Similar Semantic Tags',
                    taskTagTitle: 'Semantic label na may kaugnayan sa task',
                    similarTagTitle: 'Kinilala ang mga katulad na semantic tags (samang> 40%, Top 20)',
                    delete: 'Mangalisa',
                    markSimilar: 'Marka ang katulad',
                    markExclude: 'Hindi magkatulad',
                    none: 'Walan',
                },
                selectCallTime: {
                    callTime: 'Talk Time/Session',
                    callTimeRemind: 'Maaari mong piliin hanggang sa isang buwan (31 araw) ng mga tala ng pag-uusap sa nakaraang taon.',
                    callRecordCount: 'Pinili mo ang kabuuang {0} call/versation records',
                    getCallRecordError: 'Hindi makakuha ng record, mangyaring subukan muli mamaya.',
                },
            },
            informationEntities: {
                title: 'Entity ng impormasyong',
                index: {
                    import: 'Pag-import ng Entities ng Impormasto',
                },
                detail: {
                    new: 'Bagong Entity ng Impormasyon',
                    edit: 'I-edit Entity ng Impormasyon',
                    name: 'Pangang',
                    apiName: 'API',
                    activeFlag: 'Effectiveness',
                    remark: 'Paglalarawan',
                    logicExp: 'Regular entity',
                    sentenceList: 'Entity Contente',
                    tip: 'Ang nilalaman ng Entity ay sumusuporta sa maraming mga entry, na pinaghiwalay ng mga espasyo, na mga synonyms ng parehong entity.',
                    remarkLengthError: 'Hindi maaaring lumampas sa 255',
                    nameLengthError: 'Hindi maaaring lumampas sa 40 ang haba ng pangan',
                    entityDuplicateError: 'Duplicate na nilalaman ng entity',
                },
            },
            interactiveRecognition: {
                title: 'Interaktibo na pagkilalan',
                classify: 'Classifications',
                addClassify: 'Dagdag ang Kategory',
                editClassify: 'Pag-edit ng Kategory',
                index: {
                    import: 'Pag-import ng Interakso',
                },
                detail: {
                    new: 'Bagong Smart Interaksyon',
                    edit: 'Pag-edit ng Smart Interakso',
                    type: 'Type',
                    standardQuestion: 'Standard isyus',
                    similarQList: 'Katulad na probleman',
                    exceptSimilarQList: 'Alisin ang mga katulad na problema...',
                    category: 'Classifications',
                    targetType: 'Target sa Detection ng Problema',
                    status: 'Effectiveness',
                    standardAnswer: 'Standard an sagot',
                    similarAList: 'Katulad na sagot',
                    wrongAList: 'Maling sagot',
                },
            },
            businessAnalysis: {
                title: 'Analysis ng negosyon',
                tip1: 'Analysis ng trend sa negosyo: ang patayong koordinasyon ay bilang ng mga pag-uusap, ako. E. ang kabuuang bilang ng mga pag-uusap na nakakatugon sa mga kondisyon, at ang horizontal na koordinasyon ay ang oras.',
                tip2: 'Analysis ng korrelasyon: analin ang korrelasyon ng maraming mga indikasyon, data ng pagsasaalang-alang ng mouse, dami ng data, korrelasyon, paulit-ulit',
                tip3: 'Pag-analysis: ang pagsusuri ng maraming indikasyon ay maaaring bumuo ng isang relasyon sa pagsasama-sama, ang mga kriterya ng pagbabago para sa parehong tawag/pag-uusap, kung maaari mong hit ang dalawang iba\'t ibang mga indikasyon, maaari mong isaalang-alang na ang dalawang indikasyon ay may kaugnayan sa conversion.',
            },
            knowledgeBase: {
                title: 'Kaalaman Base',
                list: {
                    add: 'Dagdag ang Subcategory',
                    delete: 'Desin ang Classifications',
                    categoryName: 'Kategory',
                    createSuccess: 'Naging matagumpay ang subcategory',
                    keyWord: 'Keywords',
                },
                detail: {
                    type: 'Type',
                    status: 'Status',
                    classification: 'Classifications',
                    standardQuestion: 'Standard isyus',
                    answerDetectionRange: 'Rang ng detection ng sagot',
                    standardAnswer: 'Standard an sagot',
                },
            },
            callManage: {
                title: 'Filter ng Call Recording',
                listTitle: 'Call Management.',
                detailTitle: 'Detalyas',
            },
            dialogueManage: {
                title: 'Text Filter ng Pag-uusal',
                listTitle: 'Pamamahala ng dayalog',
                detailTitle: 'Detalyado sa diyalog',
            },
            weChatManage: {
                title: 'Enterprise WeChat Session Filter',
                listTitle: 'Enterprise WeChat Session Management.',
                detailTitle: 'Mga Detalyado sa Session ng Enterprise WeChat',
            },
            speechRecognition: {
                title: 'Pagkilala sa pagsasabit',
                asr: 'Pagkilala sa pagsasabit',
                asrRemind: 'Ang pagtanggal ng switch na ito ay magiging sanhi ng function ng boses-to-text at ang function ng inspeksyon ng kalidad ng machine.',
                asrConfig: 'ASR Filtration',
                imAsrConfig: 'IMASR',
                imAsrConfigRemind: 'Kapag nakagana, ginagawa ang ASR transcription ng IM',
                asrConfigRemind: 'Kapag pinagana, ang mga talagang tawag lamang ay nagpapatupad ng nilalaman ng ASR',
                correction: 'Intelligent error pagwaro',
                correctionRemind: 'Kapag nakapaggana, ang nilalaman sa "<a href = \'/site/semantic-intelligence/smart-words-library/professional-words s\' target = \'_blank\'> Smart Thesaurus-Professional Nouns </a>" ay gagamitin upang pilitin ang pagbabago ng error sa pagwawad',
                correctionConfig: 'Filter ng pagwawa ng errora',
                advancedSettings: 'Mga Advanced Settings',
                advancedSettingsTip: 'Pinili ang tinukoy na modelo ng ASR para sa mga tinukoy na datos.',
                mandarinASRModel: 'Mandarin ASR modelon',
                cantoneseASRModel: 'Cantonese ASR Modelo',
                englishASRModel: 'Ingles ASR Modelo',
                correctionConfigRemind: 'Kapag pinagana, ang mga tawag lamang na nakakatugon sa mga sumusunod na kondisyon ay maaayos',
                customJudgeLogicIsNull: 'Hindi maaaring walang laman',
                redoCorrection: 'Pagwawast ng error sa re-performa',
                callTime: 'Pumili ng oras ng talk',
                callTimeRemind: 'Maaari mong piliin hanggang sa isang buwan (31 araw) ng mga talaan ng tawag sa nakaraang taon.',
                callRecordCount: 'Nagpili ka ng kabuuang {0} call records',
                redoCorrectionSubmit: 'Ismit para sa pagpapatupad',
                callTimeError: 'Ang piniling oras ng call range ay hindi maaaring lumampas sa isang buwan (31 araw)',
                callRecordCountError: 'Ang bilang ng mga call records ay 0, mangyaring piliin ang oras ng tawag',
                redoCorrectionSuccess: 'Matagumpay ang re-error pagwawasyon, mangyaring pumunta sa task center upang tingin',
                redoCorrectionError: 'Nabigo muli ang error, mangyaring subukan muli mamasa',
            },
            role: {
                title: 'Role Management (Role Management)',
                create: 'Bagong Rol',
                detail: {
                    title: 'Role',
                    new: 'Bagong Rol',
                    view: 'Tingnan ang mga Roles',
                    edit: 'Pag-edit ng Role',
                    navTabNames: {
                        basicInfo: 'Mga pahintulot sa menus',
                        taskPermissions: 'Pahintulot sa gawaing inspekso',
                        dataPermissions: 'Mga pahintulot sa data',
                    },
                    basicInfo: {
                        roleName: 'Pangang',
                        permissions: 'Mga pahintulot',
                    },
                    taskPermissions: {
                        allTask: 'Lahat ng Mga Gawain sa Inspection ng Quality',
                        myCreatedTask: 'Ang gawain sa inspeksyon ng kalidad na nilikha ko',
                    },
                    dataPermissions: {
                        dataPermissionsConfig: 'Konfigurasyon ng pahintulot sa data',
                        tips: 'Ang papel na ito ay maaaring makita ang data sa ilalim ng piniling klassiyas',
                        select: 'Magpili ng kategorya',
                        selectPlaceholder: 'Mangyaring piliin ang isang klassifikasyon na nangangailangan ng pahintulot na nakikita ng data',
                    },
                },
            },
            dataMigration: {
                title: 'Migrasyon ng Data',
                dataUpload: 'Migrasyon ng Data',
                dataDowload: 'Migrasyon ng Data',
                error: 'Mangyaring pumili ng kalidad na gawain upang mag-exporto',
                list: {
                    info: 'Mangyaring piliin ang gawain sa inspeksyon ng kalidad upang lumas',
                    listInfo: 'Mangyaring piliin kung maglipat ng data na may kaugnayan sa gawain ng inspeksyon ng kalidad (tulad ng intelligent thesaurus, semantic tag, entity ng impormasyon, intelligent interaction, atbp.)',
                    noInfo: 'Mangyaring piliin kung aalis ang iba pang datos na hindi QC',
                    ownInfo: 'Lumipat lamang ang mga gawain',
                    everyInfo: 'Gawain na kaugnay',
                    allInfo: 'Lumabas sa lahatan',
                    callFilter: 'Filter ng Call',
                    talkFilter: 'Filter ng dialogo',
                    smartTag: 'Smart Label',
                },
                upload: {
                    info: '1. Click ang upload button upang upload ang isang JSON file na sumusunod sa format.',
                    uploadSuccess: 'Tagumpay ang uploads',
                    uploadError: 'Nabigo ang uploads',
                },
            },
            dataAnalysis: {
                businessStatistics: 'Statistics ng negosyon',
                qualityEffect: 'Kalusugan ng inspeksyon ng kalidado',
                qualityAnalysis: 'Analysis ng inspeksyon ng kalidado',
                generalInspecitionReport: 'Pangkalahatang Reporto',
                fullAmountWork: 'Trabaho ng inspektor ng kalidado',
                intelligentTagsAnalysis: 'Label',
                saleIntelligentTagsAnalysis: 'Smart Label',
                generalInspecitionReportTip: 'Kabuuang data: binibilang ang kabuuang dami ng data ng tawag at pag-uusap sa loob ng kasalukuyang limitasyon ng oras at gawain, kabilang na ang numero at porsyento ng data ng intelihente na inspeksyon ng kalidad, ang numero at porsyento ng data ng manual na sampling, ang bilang ng apela, ang sampling rate at ang time trend chart.',
                groupTest: 'Pangkat na Testo',
            },
            uploadDownloadList: {
                title: 'Mission Center.',
                tabs: {
                    upload: 'Upload Importe',
                    download: 'Download Export a',
                    taskCenter: 'Task Execution',
                },
            },
            uploadDownloadModel: {
                title: 'A-download a',
                list: {
                    clear: 'Walang laman',
                    success: 'Tagumpan',
                    fail: 'Bigo',
                    hand: 'Sa paglaon',
                    noInfo: 'Walang datas',
                },
            },
            financeCenter: {
                title: 'Pamamahala ng Pananalapi',
                unavailable: 'Hindi naka-configure ang billing system sa kasalukuyang environment',
                loadError: 'Nabigo ang pag-load ng billing system. Pakisubukan muli mamaya.',
            },
            billingCenter: {
                title: 'Billing Center.',
                export: 'Pag-exporto',
                limit: 'Limit ng paalagan',
                tips: 'Ang mga resulta ng biling ay magiging biased dahil sa pag-ikot, para sa reference lamang.',
                dashboard: {
                    remainingQuota: 'Kasalukuyang natitirang quota',
                    usedQuota: 'Cumulative Used Quota',
                    voiceQuality: 'Inspeksyon ng kalidad ng Voice:',
                    voice: 'Voice:',
                    textQuality: 'Inspeksyon ng kalidad ng teksto:',
                    text: 'Teksto:',
                    hour: 'Oras',
                    tenThousandHour: 'Milyong oras.',
                    day: 'Araw',
                    cutoff: 'Cutoff',
                    warning: '(Ang natitirang quota ay hindi sapat, mangyaring recharge hangga\'t maaari)',
                    isClosed: '(Sarad na estado)',
                },
                table: {
                    quotaRecord: 'Quota Record',
                    timeFilter: 'Magpili ng petsa:',
                    search: 'Query',
                    reset: 'Reseta',
                    id: 'Serial numero',
                    type: 'Type',
                    qualityType: 'Uri ng inspeksyon sa kalida',
                    quotaChange: 'Pagbago',
                    surplus: 'Balanse',
                    changeTime: 'Oras',
                    voiceQuality: 'Inspeksyon ng Voice Quality',
                    textQuality: 'Inspeksyon ng kalidad ng teksto',
                    sizeChangeText: 'Ipakita sa bawat pahinan',
                    used: 'Gumamit',
                    give: 'Grant',
                    deduction: 'Deduction',
                    callTime: 'Oras ng talk',
                    count: 'Nagproseso ng dami ng data',
                    page: 'Pahina {1} ng {0}',
                },
                limitModal: {
                    call: 'Mas mababa ang quota ng inspeksyon ng boses kalidad.',
                    callFix: 'Oras upang paalalan',
                    dialogue: 'Ang natitirang oras ng inspeksyon ng kalidad ng teksto ay mas maa',
                    dialogueFix: 'Araw na Paalalan',
                },
            },
            messageCenter: {
                replyTitle: 'Sumugot sa ko...',
                answerTitle: '@ Kos',
                shareTitle: 'Magbahagi ng minahan.',
            },
            columnsManage: {
                title: 'Quality Inspection Field Managements',
            },
            recordUpload: {
                list: {
                    task: 'Gawain sa inspeksyon ng kalida',
                    user: 'Operator',
                    uploadTime: 'Upload oras',
                    endTime: 'End Oras',
                    total: 'Total uploads',
                    success: 'Tagumpay sa inspeksyon ng kalidado',
                    failed: 'Nabigo ang inspeksyon ng kalidado',
                    progress: 'Progress ng Inspection ng Quality',
                    inProgress: 'Sa paglaon',
                    finished: 'Kumpleto',
                },
                steps: {
                    uploading: 'Uploading recording files',
                    baseInfo: 'Mula sa pangunahing impormasyong',
                    start: 'Simulan ang inspeksyon ng kalidado',
                },
                uploadComponent: {
                    dragger: 'Drag at bumagsak upang idagdag ang mga files',
                    or: 'O',
                    selectFile: 'Pilit',
                    des: 'Suporta wav, format mp3, sampling rate ng 8000 Hz,16-bit file.',
                    limit1: 'I-upload sa isang beses',
                    limit2: 'Mga file, ang bawat sukat ng file ay hindi lumampas',
                    uploading: 'Uploading',
                    finished: 'Kumpleto',
                    success: 'Tagumpan',
                    failure: 'Bigo',
                },
                baseInfo: {
                    task: 'Pumili ng Quality',
                    type: 'Pumili ng form sa pagrekord',
                    agentSide: 'Ang channel kung saan matatagpuan ang serbisyo ng customer',
                    excel: 'I-upload ang data kasama ang dan',
                    checkFileInfo: 'Pag-aari ng impormasyong talaksan',
                    excelFileError: 'Mangyaring i-upload ang data kasama ang paraa',
                    checking: 'Calibration sa ...',
                    reCheck: 'Re-calibration',
                    success: 'Tagumpay sa pag-verifyo',
                    excelUoloadFail: 'Nabigo sa pag-upload ng data kasama ang ruta.',
                    tips: {
                        tip1: '1. Ang pangalan ng recording file sa ecxel ay dapat na parehong pangalan ng upload na recording, at hindi maaaring maging parehong pangalan.',
                        tip2: '2. Sinusuri ng sistema ang duplicate na may pangalan ng file sa pagrekord at tawag na ID. Ang paulit-ulit na data ay humantong sa pagkabigo ng inspeksyon ng kalidad.',
                        tip3: '3. Para sa naka-download na mahusay na template ng pagrekord, pula ang kulay ng font, na kinakailangang patlang.',
                        tip4: '4. Ang format na patlang ng uri ng oras ay: yyyy-mm-dd hhh:mm:ss, halimbawa, 2021-04-20 17:36:30',
                    },
                },
                title: 'Lokal na pagrekord',
                checkTitle: 'Pagrekord ng inspeksyon ng kalidado',
                start: 'Simulan ang inspeksyon ng kalidado',
                disabledTips: 'Mangyaring i-verify ang recording file bago ang inspeksyon ng kalidado',
                tips: 'Ang recording file na may parehong pangalan ay nagsusulat ng mga resulta ng inspeksyon ng kalidad at pangunahing impormasyon.',
                tips1: 'I-drag at bumagsak dito ang file, o klikk a Upload',
                tips2: 'Suportal',
                tips3: 'Formate',
                type: 'wav、mp3',
                tips4: 'I-upload sa isang beses',
                tips5: 'Mga file, ang bawat sukat ng file ay hindi lumampas',
                tipsOverSize: 'Ang kasalukuyang queue ay puno, mangyaring alisin ang mga file sa queue bago mag-upload.',
                size: '500M',
                count: '20',
                uploaded: 'Naka-upload ang pagrekord ng files',
                uploading: '({0}%)',
                uploadFinished: '(Upload kumpleto)',
                bottomTitle: 'Pagrekord ng koleksyon ng impormasyon:',
                recordType: 'Pumili ang form ng pagrekord:',
                double: 'Dual-channel call recording',
                single: 'Single Channel Call Recording',
                recordBaseInfo: 'Uploading recording ng pangunahing impormasyon:',
                addBtn: 'Dagdag ang talaksan',
                downloadTemplate: 'Template Download. excel',
                checkRecord: 'Pag-aari ng impormasyon sa pagrekord',
                checking: 'Calibration sa ...',
                reCheck: 'Re-calibration',
                checkAll: 'Pilit',
                cancelCheckAll: 'Kansela ang Lahta',
                delete: 'Mangalisa',
                deleteLotSize: 'Batch Deletet',
                agentChannel: 'Channel ng serbisyo ng Customer:',
                left: 'Kaliwa Chanel',
                right: 'Kanang Channel',
                donotKonw: 'Hindi ko alam...',
                mission: 'Pumili ng gawain ng kalidad:',
                uploadFail: 'Nabigo ang uploads',
                repeat: 'Duplicate files',
                overCount: 'Bilang ng mga file ay lumalampas sa limitan',
                overSize: 'Lagi ang laki ng talaksan',
                uoloadFail: 'Sawi sa pag-upload sa cloud',
                formatError: 'Error sa formato',
                seccess: 'Tagumpay sa pag-verifyo',
                fail: 'Nabigo ang pag-verifikas',
                recordChecking: 'Naitala sa inspeksyon ng kalidad, mangyaring mamaya ....',
                recordCheckSuccess: 'Nakumpleto ang inspeksyon ng kalidad sa pagrekord',
                recordCheckFail: 'Nabigo sa pagrekord ng inspeksyon ng kalidad, mangyaring suriin kung ang pagrekord ay duplicate o hindivalid',
                backToIndex: 'Bumalik sa listahan ng uploadd',
                recordCheckIsStarted: 'Isang gawain ng inspeksyon sa kalidad ay kasalukuyang ginagawa. Mangyaring magsimula ng bagong gawain matapos ang kasalukuyang gawain.',
            },
            customerServicePortrait: {
                title: 'Portrait ng Customer Service Portrait',
                tip1: 'Ang batas ng distribusyon ng haba ng pangungusap: ang distribusyon ng haba ng pangungusap ay binibilang sa mga segment ayon sa bilang ng mga salita sa haba ng pangungusap, at ang serbisyo lamang ng customer',
                tip2: 'Batas sa bilis ng distribusyon: ang pagpapamahagi ng bilis, ayon sa bilis (salita/minuto), segment statistics, kalkulahin lamang ang serbisyo ng customer',
                tip3: 'Batas sa pamamahagi ng oras: ang pagpapalagay ng oras ng tugon, ang sitwasyon lamang ng tugon ng serbisyo ng customer ay kinakalkula.',
                tip4: 'Sumunod sa inspeksyon ng kalidad: rate ng pagsunod ng mga punto ng inspeksyon ng kalidado',
                tip5: 'Average Quality Inspection Task Score: average quality inspection task score.',
                contol: {
                    date: 'Magpili ng petsa:',
                    today: 'Ngayon...',
                    thisMonth: 'Ang Buwan nao',
                    lastMonth: 'Nakaraang busan',
                    thisQuarter: 'Ito',
                    lastQuarter: 'Huling Quarter',
                    thisYear: 'Ngang taonan',
                    lastYear: 'Nakaraan na',
                    customer: 'Serbisyo ng customer:',
                    search: 'Query',
                    reset: 'Reseta',
                    export: 'Pag-exporto',
                    indicator: 'Metrics Managements',
                    selectPlaceholder: 'Mangyaring piliin ang serbisyo ng customer na kailangang ihahambin',
                    warning: 'Pumili ng hanggang 5 ahente para sa paghahambin',
                    warning2: 'Mangyaring pumili ng hindi bababa sa 1 agent upang magtanong',
                    dataWarning: 'Magsabi ng data hanggang 366 araw pagkatapos ng simula ng date.',
                    seccuss: 'Nagtagumpay sa pag-record ng pag-exporto',
                },
                echarts: {
                    distributionLaw: 'Batas ng distribusyon',
                    count: 'Bilang ng mga beses',
                    bout: 'Timess',
                },
                portrait: {
                    ability: 'Dimensyon ng kakayahan sa serbisyo ng customer',
                    option: 'Konfigurayo',
                    abilityOption: 'Konfigura ang mga dimensyon ng kakayahan',
                    placeholder: 'Ang kakayahan sa dimensyon ng keyword sa paghahanap',
                    save: 'Pag-save',
                    warning: 'Mangyaring pumili ng hindi bababa sa 3 na indikasyon upang i-configure, at maaari kang piliin hanggang 10 indikatro',
                },
                label: {
                    title: 'Customer Service Label',
                },
            },
            customerServiceRankList: {
                routerTitle: 'RankList',
                title: 'Ranking ng serbisyo ng customer',
                select: {
                    date: 'Magpili ng petsa:',
                    today: 'Ngayon...',
                    thisMonth: 'Ang Buwan nao',
                    lastMonth: 'Nakaraang busan',
                    thisQuarter: 'Ito',
                    lastQuarter: 'Huling Quarter',
                    thisYear: 'Ngang taonan',
                    lastYear: 'Nakaraan na',
                    group: 'Grupo ng Customer Service:',
                    groupPlaceholder: 'Mangyaring pumili ng grupo ng ahento',
                    customer: 'Serbisyo ng customer:',
                    customerPlaceholder: 'Mangyaring piliin ang serbisyo ng customer',
                    search: 'Query',
                    reset: 'Reseta',
                    compared: 'Contrast',
                    export: 'Pag-exporto',
                    column: 'Kolumn',
                    warning: 'Pumili ng hanggang 5 ahente para sa paghahambin',
                    warning2: 'Mangyaring pumili ng hindi bababa sa isang ahent',
                    dataWarning: 'Magsabi ng data hanggang 366 araw pagkatapos ng simula ng date.',
                    selected: 'Piniling agent:',
                    seccuss: 'Nagtagumpay sa pag-record ng pag-exporto',
                },
                compared: {
                    title: 'Magpili ng serbisyo ng customer',
                    return: 'Kansela',
                    compared: 'Contrast',
                    tips: 'Mangyaring piliin ang 2-5 agents para sa paghahambin',
                    warning: '2-5 agents lamang ang suportado para sa paghahambin',
                },
                transfer: {
                    leftTitle: 'List Item',
                    rightTitle: 'Ipakita ang item',
                },
                table: {
                    page: 'Pahina {1} ng {0}',
                    actionTitle: 'Operasyong',
                    action: 'Pansing',
                },
            },
            conceptWord: {
                title: 'Mga salitang konsepto',
                new: 'Bagong Salita ng Concept',
                control: {
                    search: 'Paghahanap:',
                    searchPlaceholder: 'Pangalan o keyword sa paghahanap',
                    commit: 'Query',
                    reset: 'Reseta',
                    import: 'Importan',
                    export: 'Pag-exporto',
                    seccuss: 'Nagtagumpay sa pag-record ng pag-exporto',
                },
                modal: {
                    title: 'Pag-import ng salita ng konsepo',
                },
                table: {
                    sizeChangeText: 'Ipakita sa bawat pahinan',
                    page: 'Pahina {1} ng {0}',
                    edit: 'Pag-edita',
                    delete: 'Mangalisa',
                    request: 'Pagkatapos ng pagtanggal, hindi ito maaaring mabawi. Sigurado ka bang nais mong tanggalin ito?',
                    cancel: 'Kansela',
                    title: {
                        conceptWord: 'Mga salitang konsepto',
                        describeWordsNum: 'Bilang ng mga Discriptive salat',
                        updateTime: 'Pag-update ng oras',
                        status: 'Effectiveness',
                        effective: 'Epektive',
                        invalid: 'Hindi bayad',
                        action: 'Operasyong',
                    },
                },
                detail: {
                    title: {
                        new: 'Bagong Salita ng Concept',
                        edit: 'Edit Concept Words',
                    },
                    name: 'Pangalan ng salitang konsept',
                    namePlaceholder: 'Mangyaring ipasok ang pangalan ng salita ng konsepto',
                    effectiveness: 'Effectiveness',
                    effective: 'Epektive',
                    invalid: 'Hindi bayad',
                    description: 'Mga salita na naglalarawan:',
                    descriptionPlaceholder: 'Mangyaring ipasok ang isang paglalarawar',
                    add: 'Dagdagan',
                    repeat: 'Duplicate Contente',
                    empty: 'Hindi maaaring walang laman',
                    recommendEmpty: 'Wala nang mga rekomendasyon, mangyaring ipasok at idagdag ang mga ito nang manu-mano.',
                    recommend: 'Smart rekomendasyon ng mga Descriptive Words',
                    cancel: 'Kansela',
                    change: 'Magbago ng grupop',
                    descriptionSelected: 'Idagdag na paglalarawan:',
                    save: 'Pag-save',
                    success: 'Matagumpay na nai-save ang mga salitang konsepto',
                    warning: 'Hindi maaaring walang laman ang pangalan ng Concept',
                    warning2: 'Mangyaring magdagdag ng hindi bababa sa 1 paglalarawar',
                    submitBtnHandle: {
                        title: 'Hindi idinagdag ang piniling paglalarawan. Ang pag-save ay tatanggalin ang hindi na-ded na paglalarawan.',
                        content: 'Click OK upang bumalik sa konsepto ng salitang home page, kumpirma upang patuloy?',
                    },
                },
            },
            smartTools: {
                btn: 'Smart Tools',
                title: {
                    similarWords: 'Natagpuat',
                    search: 'Sa pamamagitan ng salat',
                    semanticTags: 'Semantic label a',
                },
                sentenceSearch: {
                    placeholder: 'Mangyaring ipasok ang search keyword, suportahan ang maraming keywords',
                    more: 'Makikita ang buong teksto',
                    pageUp: 'Naunang Pahinan',
                    pageDown: 'Susunod na Pahinan',
                    total: 'Kabuuang {0} records',
                },
                similarDiscover: {
                    placeholder: 'Mangyaring ipasok ang keyword a',
                    copyed: 'Kopyas',
                    none: 'Walang may kaugnayan na salita, mangyaring subukan ang iba pang keywords',
                },
                smartTags: {
                    searchPlaceHolder: 'Mangyaring ipasok ang keywords o pangungusap',
                    createSmartTag: 'Bago',
                    createClusteringSmartTag: 'Bagong may {0} na piraso ng data',
                    addFromKeyword: 'Idagdag ang nilalaman ng paghahanap sa mga katulad na pangungunan',
                    hit: 'Hit',
                    similar: 'Katulad',
                    name: 'Semantic Label',
                    namePlaceHolder: 'Mangyaring ipasok ang isang semantic label name a',
                    recallWords: 'Itala ang Salit',
                    recallWordsPlaceHolder: 'Mangyaring ipasok a recall keyword',
                    recallRegular: 'Tandaan ang Regular',
                    recallRegularPlaceHolder: 'Mangyaring ipasok ang Regular',
                    rules: 'Mga patakan',
                    standardSentences: 'Karaniwang pangungunan',
                    standardSentencesPlaceHolder: 'Mangyaring ipasok ang isang karaniwang pangunguhan',
                    similaSentences: 'Katulad na pangunguhan',
                    similaSentencesPlaceHolder: 'Mangyaring ipasok ang katulad na pangunguhan',
                    notSaveError: 'Mangyaring i-save ang semantic label bago maghanap',
                    add: 'Dagdagan',
                    newPage: 'Buksan sa bagong pahinan',
                    querryError: 'Ang mga katulad na patlang ay mayroon sa listahan ng generalization (advanced configuration ng katulad na mga restrints ng deduplication)',
                    detailTitle: 'Mga Detalya ng Semantic Label',
                },
            },
            trainingCenter: {
                title: 'Training Center.',
                edit: 'Pag-edita',
                delete: 'Mangalisa',
                seleteAll: 'Pilit',
                cancelCheckAll: 'Kansela ang Lahta',
                add: 'Dagdagan',
                remove: 'Alisini',
                save: 'Pag-save',
                cancel: 'Kansela',
                fastTraining: {
                    title: 'Mabilis na Traing',
                    titleDes: 'Ang mabilis na pagsasanay ay disenyo upang makatulong sa mga semantic labels na mabilis na pangkalahatan sa 20 katulad na pangunguhan',
                    semanticTags: 'Semantic label a',
                    semanticTagsPlaceholder: 'Mangyaring ipasok ang proseso ng keyword search a',
                    standardSentence: 'Standard pangungusap:{0}',
                    similarSentencesPlaceholder: 'Maglagay ng katulad na pangungusap upang idagdag o paghahanap',
                    similarSentencesAdd: 'Dagdagan',
                    similarSentencesSearch: 'Paghahanap',
                    similarSentences: 'Idinagdag ang katulad na pangungunan',
                    trainingCount: 'Count ng Training:{0},',
                    similarSentencesRecommend: 'Rekumenda ng katulad na pangungunan',
                    noResp: 'Walang may kaugnayan sa semantic label, mangyaring baguhin ang keyword.',
                    similarSentencesModalTitle: 'Katulad na Paghahanap',
                    moreInfo: 'Makikita ang Context',
                    moreInfoBtn: 'Context',
                    modalSearchType: {
                        all: 'Lahat',
                        customer: 'Servisyo ng Customero',
                        client: 'Customero',
                    },
                    repetWarning: 'Ang parehong katulad na pangungusap ay mayroon na, mangyaring huwag magdagdag ito nang paulit-ulit.',
                    repetRemoveTip: 'May duplicate na nilalaman sa nakaligtas na katulad na pangungusap, na awtomatikong deduplicated.',
                },
                trainingHistory: {
                    title: 'Kasaysayan ng Pagsasanay',
                    select: {
                        date: 'Magpili ng oras:',
                        today: 'Ngayon...',
                        thisMonth: 'Ang Buwan nao',
                        lastMonth: 'Nakaraang busan',
                        thisQuarter: 'Ito',
                        lastQuarter: 'Huling Quarter',
                        thisYear: 'Ngang taonan',
                        lastYear: 'Nakaraan na',
                        search: 'Query',
                        reset: 'Reseta',
                    },
                    table: {
                        time: 'Oras',
                        user: 'Operator',
                        tag: 'Semantic label a',
                        similarCount: 'Bilang ng mga katulad na pangungunan',
                        deleteCount: 'Bilang ng mga pangungusap na tinang',
                        page: 'Pahina {1} ng {0}',
                    },
                },
                classifiedTraining: {
                    title: 'Pagsasanay sa klassiyon',
                    tagsGrounp: 'Label',
                    placeHolder: 'Pakipilin',
                    cellTime: 'Piliin ang oras',
                    search: 'Query',
                    reset: 'Reseta',
                    classifiedFlag: 'Pagsasanay sa Classification',
                    num: 'Numerical',
                    gas: 'Percentage',
                    noData: 'Unclassified Training...',
                    noDataHeight: 'Mataas ang hindi klase na data at kailangan ng pagsasanay.',
                    noDataSmall: 'Ang proporsyon ng hindi klase na data ay medyo mataas, at inirerekumenda ang pagsasanay.',
                    noDataDays: '{0} araw bago ang huling pagpapatupad',
                    training: 'Pagsasayo',
                    start: 'Magsimula',
                    addClass: 'Dagdag ang Classifications',
                    custom: 'Advanced filtering',
                    marked: 'Labeled Data Errata',
                    markedHeight: 'Hindi ginanap ang Errata sa loob ng {0} araw, at inirerekumenda na gawin ito.',
                    markedSmall: 'Hindi ginanap ang Errata para sa {0} araw. Si Errata ay kailangang',
                    mark: 'Errata',
                    dataCheck: 'Klasified Verification ng Data',
                    dataCheckSmall: 'Ang divergence ng K-L ay mas mataas kaysa sa 0.5, inirerekumenda upang magsanay',
                    dataCheckHeight: 'Ang divergence ng K-L ay mas mataas kaysa sa 0.8 at kailangan ng pagsasanay.',
                    check: 'Calibration',
                    history: 'Kasaysayan ng Callout',
                    historyTime: 'Pang-araw-araw na anotasyon at pagbabago ay awtomatikong magsagawa ng pagsasanay sa modelo sa 2:00 ng umaga.',
                    today: 'Tagged ngayon',
                    article: 'Artikulo',
                    none: 'Walan',
                    historyCheck: 'Kasaysayan Total Callout',
                    look: 'Tingnan ang mga talana',
                    historyluate: 'Recalc Historical Data',
                    startluate: 'Crane',
                    classData: 'Classified datas',
                    classStatus: 'Pagsasanay',
                    next: 'Susunod na artikulo...',
                    prev: 'Nakaraang artikulo...',
                    finish: 'Kumpletong pagsasayo',
                    stop: 'End of train',
                    classDetail: 'Detalyas',
                    trainingNone: 'Walang pagsasanay para sa matalinong labela',
                },
                classifiedTrainingHistory: {
                    title: 'Kasaysayan ng Pagsasanay',
                    time: 'Magpili ng oras:',
                    tag: 'Type ng label:',
                    user: 'Operator:',
                    data: 'Magpili ng source ng data:',
                    search: 'Query',
                    searchBar: 'Paghahanap:',
                    searchBarPlaceholder: 'Mangyaring ipasok ang ID/mag-uusap',
                    reset: 'Reseta',
                    export: 'Pag-exporto',
                    all: 'Lahat',
                    select: {
                        today: 'Ngayon...',
                        thisMonth: 'Ang Buwan nao',
                        lastMonth: 'Nakaraang busan',
                        thisQuarter: 'Ito',
                        lastQuarter: 'Huling Quarter',
                        thisYear: 'Ngang taonan',
                        lastYear: 'Nakaraan na',
                        search: 'Query',
                        reset: 'Reseta',
                    },
                    table: {
                        user: 'Operator',
                        date: 'Oras ng operasyong',
                        data: 'Source ng Data',
                        id: 'Call ID/Conversation ID',
                        tagType: 'Smart Label',
                        tagName: 'Label',
                        state: 'Status',
                        sizeChangeText: 'Ipakita sa bawat pahinan',
                        page: 'Pahina {1} ng {0}',
                        call: 'Tawag',
                        dialogue: 'Dialog',
                    },
                },
                clusteringAnnotation: {
                    title: 'Clustering annotations',
                    left: {
                        title: 'Mga resulta ng clustering',
                    },
                    right: {
                        title: 'Mga Clustering Sentences',
                        checkAll: 'Piliin ang Lahat ng Pahina na Ito',
                        tagging: 'Callout',
                        detail: 'Pansing',
                        meaningless: 'Ipandiwalan',
                        meaninglessTips: 'Ang mga hindi pinapansin na resulta ng clustering ay hindi maipakita sa hinaharap. Sigurado ka bang nais mong hindi ba alamin ang mga ito?',
                        cancel: 'Kansela',
                    },
                },
            },
            clientCenter: {
                clientManage: {
                    title: 'Customer Management (Cstomer Management)',
                    tabTitle: 'Customer Service Center Customer',
                },
                wechatClientManage: {
                    title: 'Enterprise micro customer',
                    table: {
                        id: 'Customer ID',
                        name: 'Nickname ng customer',
                        tag: 'Customer Label',
                    },
                },
            },
            collectionRule: {
                title: 'Mga Panunungkulan',
                form: {
                    info: 'Intelligente na koleksyon ng impormasyong',
                    infoPlaceholder: 'Mangyaring pumili ng kategory',
                },
                table: {
                    name: 'Name field',
                    props: 'Customer Attributs',
                    type: 'Type ng patlangan',
                    desc: 'Paglalarawan sa field',
                },
            },
            dataAdd: {
                title: 'Dagdag ang datas',
                types: {
                    auto: 'Awtomatiko ang pagdagsa',
                    manual: 'Magdagdag ng manuki',
                },
            },
            wechatStaff: {
                table: {
                    name: 'Pangang',
                    part: 'Departamento',
                    phone: 'Mobile telepono',
                    email: 'E-mail',
                    wechartId: 'Enterprise WeChat ID',
                    status: 'Sa status sa trabaho',
                },
                info: 'Mangyaring piliin ang departamento na kailangan munang synchronize ang data',
                synSuccess: 'Nagtagumpay ang synchronization',
                init: 'Inisyalisayon',
                syn: 'Sinchronization',
            },
            appealHistory: {
                appealTime: 'Oras ng Appeal',
                cancelTime: 'Oras ng revoko',
                reviewTime: 'Oras ng pagsusuri',
                inspector: 'Quality inspector',
                result: 'Resulta ng reklamo',
                complainResult: 'Isang kabuuan ng {0} kalidad na inspeksyon ay appealed, {1} ay matagumpay na tinatanggihan at {2}',
                reason: 'Dahilan para sa reklamo',
                rejection: 'Dahilan para sa pagtanggik',
                cancel: 'Revokd',
                tip: 'Patunayan na bawiin ang reklamo?',
            },
            appealSdk: {
                time: 'Oras ng dialogo',
                externalIdCall: 'Call log ID',
                externalIdText: 'ID ng record ng pakikipag-usap',
                callCenterCallID: 'ID ng Tawag sa Call Center',
                imDialogRecordID: 'ID ng talaan ng pag-uusap sa IM',
                customerNickName: 'Nickname ng customer',
                readStatus: 'Review Status',
                status: 'Status ng reklamo',
                isManual: 'Manual na inspeksyon ng kalidado',
                complainButtonInfo: 'Pinapayagan ang {0} appeals, {1} appeals na ginawa, natitirang {2} apela. {3} ay maaaring appeal bago',
                submit: 'Magpadala ng reklamo',
                complain: 'Complaint',
                allComplain: 'Lahat',
                pendingSubmit: 'Upang ipasa',
                taskIds: 'Gawain sa inspeksyon ng kalida',
                graded: 'Rating',
                complainSuccess: 'Matagumpay na ipinadala ang paghalal',
                appealSdkIndex: {
                    title: 'Mga resulta ng inteligent quality inspekyon',
                },
            },
        },
        lookupRecords: {
            getFiltersListError: 'Hindi makakuha ng impormasyon sa listahan ng filter, mangyaring suriin ang koneksyon sa network o subukan muli mamaya!',
            columns: 'Kolumn',
            filter: 'Filtral',
            noSearchResult: 'Walang natagpuat',
            pleaseSearch: 'Mangyaring pumili ng filter at subukan ang paghahanap',
            sift: 'Filtral',
            create: 'Bago',
            search: 'Paghahanap',
            createTaskTitle: 'Bagong Gagawa',
            title: 'Title',
            deadline: 'Deadlines',
            principal: 'Persona na may singild',
            enqueueTime: 'Oras ng pagpasokan',
            computeError: 'Nabigo ang kalkulasyon, mangyaring maghintay!',
            sum: 'Sumo',
            max: 'Makikito',
            min: 'Minim',
            avg: 'Average',
            count: 'Bilal',
            maxDate: 'Maximum (pinakabagong)',
            minDate: 'Minimum (pinakaluna)',
        },
        mainMenu: {
            insight: {
                name: 'Insight',
                getInsightUrlError: 'Hindi makakuha ng Insight link address, mangyaring subukan muli mamaya!',
            },
            template: {
                learningReminder: 'Pag-aaral',
                subscriptionDynamics: 'Dynamics ng subscriptions',
            },
        },
        tasks: {
            subMenu: {
                manageHome: {
                    text: 'Task Management (Task Management)',
                    chaneg: 'Switch',
                },
                qualityCheckTemplate: {
                    text: 'Template ng Inspection ng kality',
                    collectText: 'Template ng Acquisition',
                    condition: {
                        text: 'Mga Condisyon ng Inspection ng kality',
                    },
                    checkPoint: {
                        text: 'Rule Configuration',
                    },
                    automaticAdd: {
                        text: 'Automation ng proseso',
                    },
                    manualAdd: {
                        text: 'Magdagdag ng manuki',
                    },
                    roleConfig: {
                        text: 'Role Configuration',
                    },
                    basicInfo: {
                        text: 'Pangunahing impormasyong',
                    },
                    smartWordsLibrary: {
                        text: 'Intelihente thesaurus',
                    },
                    grade: {
                        text: 'Rating ng inspeksyon sa kalida',
                    },
                    collectionRule: {
                        text: 'Mga Panunungkulan',
                    },
                    addData: {
                        text: 'Dagdag ang datas',
                    },
                    collectionList: {
                        text: 'Listahan ng Acquisition',
                    },
                },
                qualityCheckWorkbench: {
                    text: 'Quality Inspection Workbench',
                    wechatText: 'Analysis Workbench',
                    informationCollectText: 'Acquisition Workbench',
                    qualityInspectionList: {
                        text: 'Listahan ng Inspection ng Quality',
                        wechatText: 'Listahan ng analysis',
                        informationCollectText: 'Listahan ng Acquisition',
                    },
                    condition: {
                        text: 'Quality Inspection List (Obsolete)',
                    },
                    reviewList: {
                        text: 'Listahan',
                    },
                    spotCheckList: {
                        text: 'Listahan ng sampling',
                    },
                    caseBaseList: {
                        text: 'Case Librarya',
                    },
                    testSetList: {
                        text: 'Set ng Inspection Test ng Quality',
                    },
                },
                statisticsAndReports: {
                    text: 'Statistics and Reports',
                    wholeReport: {
                        text: 'Pangkalahatang Reporto',
                    },
                    groupReport: {
                        text: 'Mga Report ng Grupo ng Customer Services',
                    },
                    agentReport: {
                        text: 'Report ng Servisyo ng Customero',
                    },
                    customerServiceExecution: {
                        text: 'Analysis ng Customer Services',
                    },
                    analysisOverview: {
                        text: 'Pangkalahatang Analysisy',
                    },
                    inspectionItemsAnalysis: {
                        text: 'Analysis ng Quality Inspection Item',
                    },
                },
                wechatQa: {
                    text: 'Enterprise WeChat Quality Inspection',
                    task: {
                        text: 'Gawain ng analysis',
                    },
                    baseInfo: {
                        text: 'Pangunahing impormasyong',
                    },
                    checkPoint: {
                        text: 'Konfigurasyon ng Analysis Modelo',
                    },
                    setting: {
                        text: 'Enterprise WeChat Analysis Configuration',
                    },
                    automaticAdd: {
                        text: 'Automation ng proseso',
                    },
                    manualAdd: {
                        text: 'Magdagdag ng manuki',
                    },
                },
                clientCenter: {
                    text: 'Customer Service Center',
                },
            },
            conditionDictionaries: {
                title: 'Lahat ng kondisyon',
                searchDefaultText: 'Mangyaring ipasok ang ID o pangalan',
                id: 'ID',
                name: 'Pangang',
                conditionDetailedShow: 'Lawak',
                conditionDetailedHide: 'Stow',
                remark: 'Paglalarawan:',
                checkRole: 'Role:',
                operator: 'Operator:',
                operatorLogic: 'Logic:',
            },
            audioTextView: {
                customer: 'Customero',
                agent: 'Servisyo ng Customero',
                unsupportedFormat: 'Hindi suportado ang format na ito.',
            },
            checkPointClassifications: {
                add: 'Dagdag ang Kategory',
                name: 'Pangang',
                enterToSave: 'Pindutin ang Enter upang i-save',
                highestScore: 'Maximum Score Cap',
                minimumScore: 'Minimum Score Lower Limitt',
                defaultMinScore: 'Ang default ay 0 points',
                minimumScoreTitle: 'Mas mababang limite',
                beginScore: 'Pangkalahatang halaga ng iskore',
                beginScoreTitle: 'Nagsisimulang halaga ng score',
                scoreSetTip: 'Ang pinakamataas na marka ay mas mababa kaysa sa kabuuan ng lahat ng marka. Maaari mong piliin:',
                ignoreExcessSpillover: 'Hindi pinapansin ang labis na overflow',
                automaticWeightCalculation: 'Awtomatikong weight accounting',
            },
        },
        fieldSelect: {
            field: 'Fields',
        },
        checkRange: {
            numberTipOne: 'Sekson',
            numberTipTwo: 'Sentensya',
            numberTipThree: 'Sentence sa No.',
            conditionLimit: 'Mga Conditional Restrictions',
            roleLimit: 'Role Restrictionss',
            contextLimit: 'Mga Restrictions ng pangunguts',
            notZero: 'Hindi suportado ang input 0 para sa paghihigpit ng pangungunan',
            startMustLessThanEnd: 'Ang posisyon ng simula ng pangungusap ay dapat na mas mababa kaysa sa posisyon ng pangungusapan',
        },
        waveAudio: {
            play: 'Maglaro',
            pause: 'Pahinga',
            rateOne: '0.5',
            rateTwo: '1.0',
            rateThree: '1.5',
            rateFour: '2.0',
            rateFive: '1.2',
        },
        operatorListGather: {
            pleaseEnter: 'Mangyaring irekt',
            pleaseEnterRegular: 'Mangyaring ipasok ang isang regular expression',
            pleaseEnterGrammar: 'Mangyaring ipasok ang patakaran sa gramatika',
            pleaseEnterTestText: 'Mangyaring ipasok ang nilalaman na verifikan',
            pleaseEnterLoudness: 'Mangyaring ipasok ang malakas na decibel',
            pleaseEnterRangeAbility: 'Mangyaring ipasok ang saklaw ng pagbabago',
            afterHit: 'Tingnan pagkatapos ng hit...',
            pleaseEnterContext: 'Mangyaring ipasok ang isang reference statement',
            wordNumber: 'Word Gap',
            intervalSecond: 'Noong oras mas malakin',
            minute: 'Tuwing minuto.',
            wordUnit: 'Salita',
            test: 'Testo',
            testRegular: 'Test Regular Expressions',
            testGrammar: 'Test grammar',
            testGrammarError: 'Nabigo ang pagsubok sa grammar',
            regularError: 'Regular na error ng expression, mangyaring ipasok mulin',
            pleaseEnterSemanticSentence: 'Mangyaring ipasok ang isang pangungusap na nangangailangan ng semantiko',
            pleaseEnterAssociate: 'Tinukoy ang mga tagubilin sa kanan upang bumuo ng isang ekspresyon sa data',
            querySemanticTags: 'Pumili ng Semantic Label',
            reQuerySemanticTags: 'Pagpili ng mga semantic labels',
            semanticTags: 'Semantic label a',
            standardSentence: 'Karaniwang pangungunan',
            semanticName: 'Semantic label a',
            sentence: 'Karaniwang pangungunan',
            similarity: 'Pagkakatulan',
            actions: 'Operasyong',
            tipOne: 'Hindi nahanap ang tamang label,',
            tipTwo: 'Magdagdag ng bagong semantic tag',
            notLessThan: 'Hindi mas mabaan',
            notGreaterThan: 'Hindi mas malakin',
            ignoreLessThan: 'Hindi bahala ng mas maa',
            wordUnitSet: 'Ang pangungusap ng salat',
            speedWordNotNull: 'Ang minimum na bilang ng mga salita at ang pinakamataas na bilang ng mga salita sa pagtuklas ng speech speed ay hindi maaaring walang laman.',
            speedWordMinValueLessThanMaxValue: 'Ang minimum na bilang ng mga salita sa pagpapakita ng speech speed ay hindi maaaring mas malaki kaysa sa maximum na bilang ng mga salita.',
            speechGrabbingIntervalTip: 'Interval> =',
            speechLengthTip: 'Mahaba ang pangungusap> ==',
            msUnit: 'ms',
            sUnit: 'Seconds',
            grabIntervalNotNull: 'Ang agwat ng snatch ay hindi maaaring walang laman',
            grabLengthNotNull: 'Hindi maaaring walang laman ang pangungusap.',
            pleaseSelectEntity: 'Mangyaring pumili ng entity ng impormasyong',
            pleaseSelectOperator: 'Mangyaring pumili ng aksyo',
            pleaseSelectBasicInfo: 'Mangyaring pumili ng pangunahing impormasyong',
            pleaseEnterFixedValue: 'Mangyaring ipasok ang isang maayos na halag',
            loudnessUnit: 'db',
            percent: '%',
            matchSuccess: 'Tagumpay sa pagtuto',
            matchError: 'Nabigo ang Match',
            mindetectionStatement: 'Pinakababang pahayag ng detektan',
            conceptWordholder: 'Mangyaring pumili ng salita ng konsepo',
            elementHolder: 'Mangyaring ipasok ang isang elemento',
            associateMedol: {
                tabs: {
                    data: 'Data',
                    operator: 'Operator',
                },
            },
            repet: 'Uulit',
            bout: 'Timess',
            ignore: 'Hindi bahala ng mas maa',
            ignoreAffix: 'Ang pangungusap ng salat',
            associateData: 'Follow-the-road datas',
            pretreatmentData: 'Preprocessing Data',
            reviewTaskData: 'Review data ng gawain',
            taskData: 'Data ng gawain sa inspeksyon ng kality',
            businessData: 'Mga tala ng negosyon',
            functionOperator: 'Operator ng Functions',
            operation: 'Operasyong',
            notAnyMatch: 'Kapag ang anumang isyu ay hindi hit:',
            times: 'Bilang ng mga pangyayarin',
            newAssociateDataTip: 'Kung ang halaga ay isang numerong uri, gamitin ang legacy feature',
        },
        conditionGather: {
            cycle: 'Cycle:',
            rlue: 'Mga patakan',
            delete: 'Alisini',
            sampling: 'Extraction',
            item: 'Artikulo',
            percent: '%',
            samplingSame: 'Parehong bilang ng extraction bawat ahenteno',
            samplingRecheck: 'Pahintulutan ang paulit-ulit na pagkuha ng mga sampled items',
            dateUnit: 'Hindi.',
            samplingTip: 'Ang iba\'t ibang mga patakaran ay sumasaklaw sa parehong tawag ay hindi paulit-ulit, at mga talaan na nakuha ngunit hindi na-checked ay hindi naakit muli.',
            add: 'Bagong Rule',
        },
        ruleGather: {
            title: 'Mga patakan',
            screeningCondition: 'Filter Condition:',
            addRule: 'Bagong Rule',
            inspector: 'Quality inspector',
            ruleTip: 'Ang rule-unang allocation mode, mula sa itaas hanggang sa ibaba, ay hindi paulit-ulit ang allocation, sa loob ng patakaran o hindi tumutugma sa anumang mga item ng patakaran ay randomly allocated.',
            moveUp: 'Paglipat Upa',
            moveDown: 'Lumang Ibas',
            top: 'Itaga',
        },
        pushRulesGather: {
            title: 'Mga patakan',
            delete: 'Alisini',
            newPush: 'Bagong Push',
            newRule: 'Bagong Rule',
            sampling: 'Extraction',
            item: 'Artikulo',
            percent: '%',
            samplingSame: 'Parehong bilang ng extraction bawat ahenteno',
            dateUnit: 'Hindi.',
            screeningCondition: 'Filter Condition:',
            email: 'E-mail',
            emailPlaceholder: 'Maglagay ng mailboxes, pinaghiwalay ng comms',
            updateType: 'Update Type',
            pushDetail: 'Mga Detalyas',
            pushUrl: 'Puksa URL',
            pushWay: 'Puno ng Type',
            pushMethod: 'Modo ng pagpusi',
            pushContentType: 'Format ng Data',
            pushData: 'Gawi ang data',
            additionalData: 'Karagdagang datas',
            inspectionType: 'Uri ng inspeksyon sa kalida',
            all: 'Lahat',
        },
        taskAdditionalData: {
            newData: 'Bagong datas',
            delete: 'Alisini',
            placeholder: 'Mangyaring ipasok ang pangalan',
            dataPlaceholder: 'Mangyaring ipasok ang nilalamang',
        },
        UdeskQaReact: {
            loadSdkError: 'Nabigo sa pag-load ng SDK, mangyaring subukan muli mamaya!',
        },
        gearOptionList: {
            evaluation: 'Evaluation',
        },
        tableComponentTransfer: {
            leftTitle: 'List Item',
            rightTitle: 'Ipakita ang item',
        },
        kmTinymce: {
            link: 'Ignose/Edit Link',
            modalTitle: 'Mag-ugit ng Links',
            href: 'Address',
            text: 'Ipakita ang teksto',
            title: 'Title',
            target: 'Bubuksa mode',
            none: 'Walan',
            newWindow: 'Buksan sa bagong windows',
            buttonStyle: 'Button Estile',
            close: 'Saray',
            open: 'Buksa',
            answerMessage: 'Jump/Send message',
            answerMessageTitle: 'Papadala ang Mensahe Buttons',
            answerMessageText: 'Ipakita ang teksto',
            answerMessageContent: 'Kabilangan ng message',
            answerMessageButtonStyle: 'Button Estile',
            answerMessageTips: 'Tandaan: Sinusuporta lamang ng button ng pagpapadala ng mensahe ang web channel, mangyaring i-configure ito nang maingat.',
            answerSwitchStaff: 'Jump/Turn Manual',
            answerSwitchStaffTitle: 'Bumalik ng manual buttons',
            answerSwitchStaffText: 'Ipakita ang teksto',
            answerSwitchStaffRule: 'Rules ng button',
            answerSwitchStaffButtonStyle: 'Button Estile',
            answerSwitchStaffTips: 'Tandaan: Sinusuportahan lamang ng switch manual button ang web channel, mangyaring i-configure ito nang maingat.',
            textButton: 'Teksto buttons',
            borderButton: 'Framed Button',
            message: 'Papadala ang message',
            switchStaff: 'Pagliko ng manuki',
            messageError: 'Hindi maaaring lumampas sa 10 salita ang nilalaman ng buttons',
            messageIsEmptyError: 'Hindi maaaring walang laman ang nilalaman ng buttons',
            okText: 'Determine',
            cancelText: 'Kansela',
            video: 'Videos',
            uploadVideo: 'Upload Videos',
            uploadText: 'Suporta lamang ang format ng MP4, laki hindi hihigit sa 20M',
            videoEmptyOrUploading: 'Ang video ay walang laman o pag-uploadg',
            customEmoji: 'Ekresyon',
        },
        massageConfiguration: {
            pushTarget: 'Target sa pagpapakitan',
            customizePushTarget: 'Custom Push Destination',
            sysUser: 'Kasalukuyang User ng Sistema',
            sysRole: 'Kasalukuyang Role ng Sistema',
            emailPushTarget: 'Papadala ang Destination',
            targetEmailsPlaceholder: 'Mangyaring ipasok ang mga mailbox na pinaghiwalay ng comms',
            subject: 'Pangalan ng message',
            SDKID: 'SDK ID',
            content: 'Mga nilalaman ng notifikas',
            sdkPushType: 'Push scheme',
            sdkPushURL: 'Puksa URL',
            pushData: 'Gawi ang data',
            sdkPushWay: 'Modo ng pagpusi',
            dataType: 'Format ng Data',
            additionalData: 'Karagdagang datas',
            name: 'Pangalan ng message',
            filter: 'Filter Condition:',
            triggerType: 'Mekanismo ng trigger',
            pushCycle: 'Naayos na frequency ng times',
            pushContent: 'Mga Nilalanan ng ulat',
            qualityList: 'Listahan ng resulta ng inspeksyon ng kalida',
            designated: 'Ang tinatanggap na Personnel',
            messageType: 'Type ng message',
        },
        taskCard: {
            template: {
                flyingBookGroupChat: 'Flying book group chat',
                questionnaire: 'Questionnaires',
                ecommerceSession: 'E-commerce',
                eCommerceReview: 'E-Commerce Review',
                socialMediaComments: 'Mga Komento ng Social MediaName',
                mixing: 'Paghalo',
                video: 'Videos',
                cancelCollection: 'Kansela ang Paboriton',
                collection: 'Kolektas',
            },
        },
        semanticTagsSelect: {
            index: {
                delete: 'Mangalisa',
                standardSentence: 'Standard pangungusap:',
            },
        },
        gong: {
            filesOpen: {
                folderItem: {
                    collection: 'Kolektas',
                    calls: 'Isang tawag',
                    createdBy: 'Nilikha:',
                    createdOn: 'Oras ng paglikha:',
                },
                fileItem: {
                    uIProvidesIcon: 'Nagbibigay ng ui ng icon',
                    minute: 'Minuta',
                    callClip: 'Call Fragment',
                    start: 'Magsimula',
                    End: 'Endo',
                    employees: 'Mga empleyado:',
                    Customer: 'Customer:',
                    sessionTime: 'Oras ng session:',
                    reasonForRecommendation: 'Dahilan para sa rekumenda:',
                    addedBy: 'Dagdag:',
                    addTime: 'Dagdag na oras:',
                },
                modalAddFile: {
                    caseTitle: 'Kaso na Title',
                    addSomeClipsToTheCaseLibrary: 'Magdagdag ng bahagyang snippets sa kaso library',
                    addToCaseBase: 'Dagdag sa Case Librarya',
                    storedIn: 'Nakaligtas s',
                    pleaseSelect: 'Pakipilin',
                    reasonsForRecommendation: 'Mga dahilan para sa rekumenda',
                    pleaseEnter: 'Mangyaring irekt',
                },
            },
            shareModal: {
                index: {
                    customer: 'Customer:',
                    employees: 'Mga empleyado:',
                    timeliness: 'Timeliness:',
                    recordingLinkValidWithinDays: 'Ang pagrekord ng link na makatuwiran sa loob ng araw.',
                    sharingInstructions: 'Paglalarawan:',
                    shareSuccess: 'Nagbabahagi ng tagumpay!',
                    cancel: 'Kansela',
                    share: 'Naghahatid',
                    copySucceeded: 'Kopya ang matagumpay!',
                    copyShareLink: 'Copy Share Link',
                    shareWithColleagues: 'Magbahagi sa mga kasamahang',
                    shareWithCustomers: 'Magbahagi sa mga customers',
                    staff: 'Employa',
                    selectColleagues: 'Pumili ng mga Colleagues',
                    pleaseSelectColleaguesToShare: 'Mangyaring pumili ng kasamahan na ibahagi',
                    pleaseEnterTheSharingDescription: 'Mangyaring ipalagay ang mga instruksyon sa pagbabahagi...',
                    taskName: 'Gawain:',
                    recordingShareValidWithinDays: 'Ang pagbabahagi ng link na makatuwiran sa loob ng araw.',
                },
            },
            waveAudio: {
                index: {
                    theFileCannotBeFound: 'Hindi mahanap ang file!',
                    sale: 'Behe:',
                    customer: 'Customer:',
                    topicDetection: 'Pagkakita ng paksa:',
                    keyEvents: 'Mga pangunahing kaganapan:',
                },
            },
            helpCommentModal: {
                index: {
                    selectColleagues: 'Pumili ng mga Colleagues',
                    helpContent: 'Help content',
                    visibleRange: 'Makikita ang rangan',
                    seekCounseling: 'Paghahanap ng payo',
                },
            },
            commentDispalyItem: {
                index: {
                    seekAdvice: 'Naghahanap ng payo',
                    concatText: 'Tog',
                },
            },
            customerInsight: {
                index: {
                    customerInformation: 'Impormasyon sa Customero',
                    customerInsight: 'Customer Insights',
                    customerLabel: 'Customer Label',
                },
            },
            intelligentRecommend: {
                index: {
                    scriptRecommendation: 'Inirekomenda ng pagsasalitao',
                    objectionHandlingScripts: 'Objection Handling',
                    productSellingPointScripts: 'Mga Punto ng pagbebenta ng produkto',
                    knowledgePointRecommendation: 'Rekumenda ng punto ng kaalaman',
                    relatedKnowledgePoints: 'Mga Associated Knowledge Points',
                    recommendedCases: 'Rekumenda ng mga kaso',
                },
            },
            supervision: {
                index: {
                    scriptRecommendation: 'Inirekomenda ng pagsasalitao',
                    caseRecommendation: 'Inirekomenda ng kaso',
                    hit: 'Hit',
                    miss: 'Nawalan',
                    supervisionItem: 'Supervision Items',
                    implementation: 'Status ng pagpapatupad',
                    reInspection: 'Re-inspection',
                    supervisionItemSettings: 'Supervision Item Setting',
                },
            },
            supervisionClassificationModal: {
                index: {
                    telephoneCall: 'Mga tawag sa telepono',
                    enterpriseWeChatCall: 'Enterprise Micro-Talk',
                    enterpriseMicroConversation: 'Enterprise micro-session',
                    open: 'Buksa',
                    close: 'Saray',
                    conversationScenario: 'Session Scenarios',
                    monitorConversationChannels: 'Pamahalaan ang channel ng pag-uusap',
                    permanentlyValid: 'Permanently Epektive',
                    permanentlyInvalid: 'Permanenteng hindi ayaw',
                    customValidity: 'Personal na saligan',
                    termOfValidity: 'Peryod ng Validity',
                    newRating: 'Bagong rating',
                    whenConversation: 'Kapag ang session',
                    hit: 'Hit',
                    miss: 'Nawalan',
                    time: 'Noong',
                    rated: 'Rated',
                    qualified: 'Kwalipikado',
                    unqualified: 'Unqualifid',
                    modifiedSuccessfully: 'Nagtagumpay ang pagbabago',
                    classificationName: 'Kategory',
                    supervisionObject: 'Object ng superbisyon',
                    entryintoforceTime: 'Epektibong oras',
                    supervisionItemRating: 'Rating ng mga items',
                    pleaseCheckWhetherTheRatingOfSupervisionItemIsCorrect: 'Mangyaring suriin kung tama ang rating ng supervisy',
                    ratingRules: 'Mga Rules ng rating',
                    settingOfRatingRulesForSupervisionItems: 'Supervision Item Rating Rule Setting',
                },
            },
            reInspect: {
                index: {
                    keyEvents: 'Mga pangunahing pangyayarin',
                    supervisionItem: 'Supervision Items',
                    conversationScenario: 'Session Scenarios',
                    customerLabel: 'Customer Label',
                    reDetectionRules: 'Redetect ang mga patakas',
                },
            },
            audioPlayerBar: {
                index: {
                    downloadRecording: 'Downloading recording',
                    downloadText: 'Download teksto',
                },
            },
        },
        imgUpload: {
            index: {
                uploadPictures: 'Upload larawn',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'Mangyaring piliin ang larawan na may sukat na hindi lumampas sa 2048kb',
            },
        },
        chatRecord: {
            chatRecordItem: {
                components: {
                    debugInfo: {
                        or: 'O',
                        and: 'At',
                        wrong: 'Hindin',
                        matchTo: 'Match',
                        rule: 'Mga patakan',
                        satisfactionOperator: 'Nasiyahan ang operat',
                        customerLabel: 'Customer Label',
                        keyEvents: 'Mga pangunahing pangyayarin',
                        knowledgePoints: 'Mga puntos ng kaalaman',
                        sessionLabel: 'Session Label',
                        supervisionItem: 'Supervision Items',
                    },
                    linkExplorer: {
                        linkInTheText: 'Link sa artikulo:',
                    },
                    index: {
                        unsupportedMessageType: 'Hindi suportado ang uri ng mensahes',
                        locationInformation: 'Impormasyon sa lokasyong',
                        businessCard: 'Business card',
                        smallProgram: 'Maliit na program a',
                        videoNumber: 'Video Number a',
                    },
                    translate: {
                        index: {
                            translation: 'Pagsaling',
                        },
                    },
                    imageRecognition: {
                        index: {
                            imageRecognitionSuccessful: 'Matagumpay ang pagkilala sa larawan',
                            imageRecognitionFailed: 'Nabigo ang pagkilala sa imahes',
                        },
                    },
                },
                index: {
                    system: 'Sistema',
                    customerService: 'Servisyo ng Customero',
                    robot: 'Robot',
                    customer: 'Customero',
                    silence: 'Katahimika',
                    theFollowingIsTheBotServiceMessage: 'Ang sumusunod ay ang mensahe ng serbisyo ng boto',
                    theFollowingIsTheHumanServiceMessage: 'Ang sumusunod ay ang mensahe ng serbisyo ng tao',
                },
            },
        },
        createForm: {
            field: {
                customComponentNotFound: 'Hindi nahanap ang personal na bahagi:',
            },
        },
        sdkLoaderBase: {
            component: {
                custom: 'Pasawa',
            },
            dropdownMonit: {
                updateSucceeded: 'Nagtagumpay ang pag-update',
                areYouSureToDelete: 'Sigurado ka bang nais mong tanggalin?',
                custom: 'Pasawa',
            },
            modalMonit: {
                saveCurrentReportConfigurationForm: 'Save Current Report Configuration === Form a',
                saveCurrentReportConfiguration: 'I-save ang kasalukuyang pagsasaayos',
                pleaseEnterTheNameOfCommonSettingsTheMaximumLengthIs: 'Mangyaring ipasok ang karaniwang pangalan ng setting, ang pinakamataas na haba ay 20!',
                preservation: 'Pag-save',
            },
            template: {
                saveCurrentReportConfiguration: 'I-save ang kasalukuyang pagsasaayos',
                updateCurrentReportConfiguration: 'I-update ang kasalukuyang pagsasaayos',
            },
        },
        audioCallBasicInfoV2: {
            template: {
                processingTime: 'Oras ng pagproseso',
                customFields: 'Custom Fields',
                customerInformation: 'Impormasyon sa Customero',
                associatedWorkOrder: 'Associated Work Order',
                workOrderInformation: 'Impormasyon sa Work Order',
                workOrder: 'Work Order',
                triggerScenario: 'Trigger Scenarioo',
                associatedCallConversation: 'Associate call/versation',
            },
        },
        audioCallContentInfoV2: {
            components: {
                testBtn: {
                    testWithCurrentCommunicationDialogueText: 'Subukin sa kasalukuyang teksto ng pass/dialoge',
                },
            },
            index: {
                originalSentence: 'Orihinal na pangungunan',
                clause: 'Clause',
            },
        },
        checkPointOperatorListGather: {
            template: {
                whetherOverlappingStatementsAreIgnored: 'Kung hindi pinapansin ang mga overlapping states',
                overlappingSpeechResponse: 'Overlapping tugon ng pagsasalitas',
                section: 'Sekson',
                day: 'Araw',
            },
            businessSummary: {
                normal: {
                    equalTo: 'Katumbas',
                    notEqualTo: 'Hindi katumbas',
                    contain: 'Naglalando',
                    excluding: 'Hindi naglalaman',
                },
            },
            externalInterfaceCheck: {
                normal: {
                    equalTo: 'Katumbas',
                    contain: 'Naglalando',
                    informationEntity: 'Entity ng impormasyong',
                    followthepathField: 'Follow-the-path field',
                    fixedValue: 'Fixed halaga',
                    pleaseSelectAnOperator: 'Mangyaring pumili ng operat',
                    pleaseSelectADataType: 'Mangyaring pumili ng uri ng data',
                    pleaseSelect: 'Pakipilin',
                    whenNoResultIsReturned: 'Kapag walang resultao',
                    theResultIsYes: 'Ang resulta ay "Oo"',
                    resultIsNo: 'Resulta ay "Hindi"',
                },
            },
            associate: {
                advanced: {
                    valueTemplate: 'Value Template',
                },
                normal: {
                    processingTime: 'Oras ng pagproseso',
                    customFields: 'Custom Fields',
                    customerInformation: 'Impormasyon sa Customero',
                    workOrderInformation: 'Impormasyon sa Work Order',
                    anyWorkOrder: 'Anumang Work Order',
                    allWorkOrders: 'Lahat ng Work Orders',
                },
                index: {
                    operatorHitResultWhenTheDataSourceIsNot: 'Ang operator ay naging resulta kapag hindi ang source ng data',
                    yes: 'Oo,',
                    no: 'Hindin',
                },
            },
            semanticMatching: {
                index: {
                    pleaseEnterALargeModelPrompt: 'Mangyaring ipasok ang malaking prompt',
                },
            },
            multiModal: {
                normal: {
                    pleaseEnterALargeModelPrompt: 'Mangyaring ipasok ang malaking prompt',
                    whenThereIsNoSuchData: 'Kapag walang ganong datas',
                },
            },
        },
        massagePushConfiguration: {
            component: {
                iAmMeItsADifferentFireworksxxxx8827: 'Ako ay kung sino ako, isang iba\'t ibang firework @ 156xxxx8827',
                hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'Hiya, ako ang pagpapakita ng mensahe ng babala ng kalidad ng inspeksyon ng robot, na idinagdag sa grupo noong Oktubre 17.',
            },
            interfacePush: {
                component: {
                    iAmMeItsADifferentFireworksxxxx8827: 'Ako ay kung sino ako, isang iba\'t ibang firework @ 156xxxx8827',
                    hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'Hiya, ako ang pagpapakita ng mensahe ng babala ng kalidad ng inspeksyon ng robot, na idinagdag sa grupo noong Oktubre 17.',
                },
            },
            associateSelect: {
                const: {
                    communicationTheme: 'Mga tema ng komunikasyon',
                    conversationSummary: 'Session',
                    serviceSuggestions: 'Mga rekomendasyon ng serbisyo',
                },
                template: {
                    associatedWorkOrder: 'Associated Work Order',
                    smartTags: 'Smart Label',
                },
            },
            otherPush: {
                template: {
                    customPushDestination: 'Custom Push Destination',
                },
                components: {
                    ticketConfig: {
                        index: {
                            pleaseEnterTheAcceptanceCustomerServiceEmailOnlyOneIsSupported: 'Mangyaring ipasok ang email ng serbisyo ng pagtanggap ng customer, isa lamang ang suportado.',
                            acceptCustomerService: 'Tanggapin ang serbisyo ng customer',
                            customerService: 'Serbisyo ng customer',
                            dontSetUpAcceptCustomerService: 'Huwag tumanggap ng serbisyo ng customer',
                            specifyMailbox: 'Ang Mailbox',
                            workOrderTitle: 'Pangalawan',
                        },
                    },
                    callingRobotConfig: {
                        index: {
                            workingTimeID: 'ID ng oras ng trabaho',
                            taskName: 'Pangalan ng Task',
                            pleaseEnter: 'Mangyaring irekt',
                            outcallTemplateID: 'Outcall template ID',
                            pleaseEnterIntOnly: 'Mangyaring ipasok, int lamang.',
                            outcallRobotDefinitionID: 'ID ng Definisyon ng outcall robot ID',
                            callingNumberType: 'Type ng numero ng tawaga',
                            relayNumber: 'Numero',
                            numberPool: 'Number Pools',
                            pleaseSelect: 'Pakipilin',
                            callingNumberValue: 'Value ng Numero',
                            contactListID: 'ID ng contact List ID',
                            workEventID: 'ID ng Trabaho',
                        },
                    },
                },
            },
        },
        productMatrix: {
            index: {
                clickToLearnMore: 'Click upang malaman ang higit pa...',
            },
            schema: {
                textRobot: 'Teksto robots',
                trainerEscortDocumentQATaskDialogueTableQAAtlasQA: 'Trainer escort, dokumento na tanong at sagot, task-based dialog, talahanayan at sagot, graph tanong at sagot.',
                capitalRetentionRobot: 'Retention robots',
                richInquiryAndRetentionStrategiesHighPersonificationCommunicationEnsuringHighRetentionRateAndEfficientAutomaticConversionOfClues: 'Mayamang estratehiya sa pagpapanatili ng follow-up, mataas na personification communication, upang matiyak ang mataas na rate ng pagpapanatili, mga pahintulot na awtomatikong pagbabago.',
                outboundRobot: 'Outbound call robots',
                workOrderCompletionReturnVisitServiceSatisfactionSurveyOperationAndMaintenanceFaultWarningPromptOrderDeliveryReminderEcommerceActivityNoticeCandidateAppointmentAndHelpBusinessAutomationAndBusinessEfficiencyImprovement: 'Pagbisita sa pagkumpleto ng trabaho, pagsusuri ng kasiyahan sa serbisyo, babala ng pagkabigo sa operasyon at pagpapanatili ng pagpapanatili, pagpapaalala ng order, e-commerce notificationity activity, appintment ng kandidato, tumulong sa automation ng negosyo at pagpapabuti ng epektibo sa negosyo',
                incomingRobot: 'Nagpapasok na robots',
                flexiblyIntegrateWorkOrdersOrdersAndOtherBusinessSystemsToRealizeProcessAutomationCustomizedRecognitionOfSpeechSemanticModelAndTheBusinessEffectIsImmediateEntitymobilePhoneNumberOrderAmountOrderTimeAddressIdentificationToQuicklySupportComplexBusiness: 'Flexible integration ng mga order ng trabaho, orders at iba pang mga sistema ng negosyo upang makamit ang proseso ng awtomatikong modelo ng boses, agad na resulta ng negosyo; entity (mobil number ng telepono, order, order time, address,...) identifisyon, mabilis na suporta para sa kumplikadong negosyon',
                intelligentQualityInspection: 'Intelligent quality inspeksyo',
                fullQualityInspectionTimelyAndEfficientWithAnAccuracyRateOf: 'Buong inspeksyon ng kalidad, sa panahon at epektibo, na may katumpakan na 85%',
                intelligentSessionAnalysis: 'Analysis ng inteligent session',
                insightIntoBusinessWeaknessesListenToTheVoiceOfCustomersAndImproveMarketingTransformation: 'Ang pananaw sa maikling board ng negosyo, makinig sa tinig ng mga customer, pagpapabuti ng pagbabago sa marketing',
                enterpriseWechatConversationAnalysis: 'Enterprise WeChat Session Analysisy',
                effectivelyIdentifyPotentialBusinessOpportunitiesAndRisksAndIncreaseTheMarketingConversionRateBy: 'Epektibong pagkakakilanlan ng mga potensyal na pagkakataon sa negosyo, panganib, marketing rate na pinataas ng 20%',
                assistant: 'Seat Assistant',
                theAgentAssistantCanGuaranteeTheNoviceCustomerServiceToCompleteTheServiceAndImproveTheCallQualityOfTheSkilledCustomerServiceLetEverySeatBeYourTrumpCard: 'Maaaring matiyak ng katulong ng agent ang serbisyo ng serbisyo ng bagong customer at mapabuti ang kalidad ng tawag ng serbisyo ng bihasang customer. Ang bawat upuan ay maging iyong trump card',
                digitalPeople: 'Ang Digital Tao',
                FaceToFaceAnthropomorphicCommunicationSupportVoiceTextVideoTouchMultimodalInteractionAchieveImmersiveCommunicationExperienceAndImproveBrandImageAndUserServiceExperience: '"Face-to-face" anthropomorphic na komunikasyon, pagsuporta sa boses, teksto, video, touch multi-modal interaction, upang makamit ang paglubong na karanasan sa komunikasyon, pagpapabuti ng brand imahe at karanasan sa serbisyo ng gumagamite',
                aIKnowledgeZhongtaiEnterpriseSearch: 'AI Knowledge Middle End Enterprise Search',
                knowledgeSearchKnowledgeSharingDocumentSearchDatabaseDockingSearch: 'Knowledge Search, Knowledge Sharing, Document Search, Database Docking Search',
                aIKnowledgeCenterKCsKnowledgeBase: 'AI Knowledge Middle Desk · KCS Knowledge Base',
                provideFullLifecycleManagementOfKnowledgeUnifiedMaintenanceOfRobotAndImKnowledgeBaseSupportDockingWithThirdpartyKnowledgeBaseKnowledgeTemplateAtomicKnowledgeAndOtherPowerfulFunctionsToBringMoreConvenientKnowledgeManagementExperience: 'Nagbibigay ng buong buhay na pamamahala ng kaalaman, pinag-isang pagpapanatili ng mga robot at mga base ng kaalaman ng IM, sumusuporta sa docking sa mga base ng kaalaman sa ikatlong bahagi, mga template ng kaalaman, atomic na kaalaman at iba pang mga makapangyarihang function upang magdala ng mas maginhawang karanasan sa pamamahala ng kaalaman.',
                aIKnowledgeCenterKnowledgeMap: 'AI Knowledge Platform-Knowledge Map',
                oneStopMapConstructionIntegratesEnterpriseKnowledgeLargescaleMapShowsKnowledgeDetailsDockingAbilityAndCustomizedExperience: 'Ang paggawa ng isang stop mapping ay nag-integrate ng kaalaman sa enterprise, ang malaking larawan ay nagpapakita ng mga detalye ng kaalaman, at mga kakayahan sa pag-docking upang lumikha ng personal na karanasan.',
                modularDevelopmentPlatformOriginalEngineASR: 'Modular Development Platform-Original Heart Engine-ASR',
                theEndtoendAlgorithmIsAdoptedToRealizeTheEffectExperienceOfBusinessCustomizationTheNaturalSceneRecognitionRateExceedsAndThePersonalizedVocabularyRecognitionRateExceeds97: 'I-aayon ang algorithm na end-to-end upang malaman ang personal na karanasan ng serbisyo, na may likas na rate ng pagkilala ng natural na tanawin na lumampas sa 90% at personalized na pagkilala ng salita na higit sa 97%',
                modularDevelopmentPlatformIntelligentMarketing: 'Modular development platform · Intelligent marketing na',
                makeUseOfDeepLearningAlgorithmsAndUserPortraitsToAchieveAccurateRecommendationOfGoodsAndImproveSalesConversion: 'Gumamit ng malalim na algorithms sa pag-aaral, kasama ang mga larawan ng user, upang makamit ang tumpak na rekomendasyon ng mga kalakal at mapabuti ang pagbabago ng pagbebenta.',
                modularDevelopmentPlatformUserPortrait: 'Modular Development Platform · User Portrait',
                accuratelyBuildUserPortraitsBasedOnUserDataAndConversationDataToFullyDescribeCustomerCharacteristics: 'Tumpak na bumuo ng mga profile ng user na batay sa data ng user at diyalogo, na ganap na naglalarawan ng mga karakteristika ng customer',
                modularDevelopmentPlatformIntelligentRecommendation: 'Modular development platform · Inirekomenda ng Intelligent',
                automaticallyRecommendProductsThatUsersMayBeInterestedInAccordingToUserPortraitsAndProductPortraitsAndRealizePersonalizedRecommendationForThousandsOfPeople: 'Awtomatikong inirerekumenda ang mga produkto na maaaring maging interes sa mga gumagamit na batay sa mga larawan ng gumagamit at mga larawan ng produkto, pagbibigay ng personal na rekomendasyon para sa libu-libong tao.',
                modularDevelopmentPlatformNLPPAAS: 'Modular Development Platform · NLP PaaS',
                provideNLPBasicCapabilitiesWithHighAccuracyCoveringTheUnderlyingCapabilitiesOfDifferentGranularitySuchAsWordsSentencesAndArticles: 'Nagbibigay ng mga pangunahing kakayahan ng NLP na may mataas na katumpakan, na sumasaklaw sa mga kakayahan sa mababang antas ng iba\'t ibang granularity tulad ng mga salita, pangungusap, at mga artikulo.',
            },
        },
        qualityScore: {
            index: {
                show: 'Ipakita:',
                displayBySecondaryClassification: 'Ipakita sa pamamagitan ng pangalawang klassiyon',
                showByRule: 'Ipakita sa pamamagitan ng patakan',
                pleaseEnterClassificationruleName: 'Mangyaring ipasok ang pangalan ng klassifikasyon/runo',
                clickCopy: 'Click Copy',
                hitDetailsOfOperatorsInRules: 'Ang operator hit detalye sa patakaran:',
                hit: 'Hit',
                miss: 'Nawalan',
                filter: 'Filter:',
                clickToViewDetails: 'Click upang tingnan ang mga detalya',
            },
            components: {
                flowNodeList: {
                    branch: 'Punts',
                    pleaseSelect: 'Pakipilin',
                    viewTheCompleteProcess: 'Makikita ang buong proseso',
                    thereIsCurrentlyNoProcessAvailable: 'Walang proseso',
                },
                pointItem: {
                    xiangHit: 'Item hit',
                },
                flowNodeListModal: {
                    index: {
                        completeProcess: 'Kumpletong proseso',
                    },
                },
                reviewComponent: {
                    theProcessQualityInspectionTaskHasChangedPleaseAppealAgain: 'Ang gawain ng inspeksyon ng kalidad ng proseso ay nagbago, mangyaring apela muli.',
                    components: {
                        reviewDetail: {
                            index: {
                                reasonsForAdoption: 'Mga dahilan para sa pag-adop:',
                                reasonForRejection: 'Dahilan para sa pagtanggi:',
                                secondaryReview: 'Secondary review',
                                firstlevelReview: 'Unang-level review',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAReason: 'Mangyaring ipasok ang dahilang',
                        reasonsForAdoption: 'Mga dahilan para sa pag-adop:',
                        reasonForRejection: 'Dahilan para sa pagtanggi:',
                        attachments: 'Mga attatments:',
                    },
                },
                annotation: {
                    index: {
                        annotation: 'Anotations',
                        ruleAnnotation: 'Rule Annotations',
                        areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                        preserve: 'Pag-save',
                        cancel: 'Kansela',
                        callout: 'Callout',
                    },
                },
                uplaod: {
                    index: {
                        uploadFile: 'Upload ang Files',
                    },
                },
            },
        },
        recordDetail: {
            template: {
                processingTime: 'Oras ng pagproseso',
                communicationDialogueInformation: 'Impormasyon sa dialog ng komunikasyon',
                problemExtraction: 'Paglabas ng probleman',
                customFields: 'Custom Fields',
                customerInformation: 'Impormasyon sa Customero',
                information: 'Impormasyon',
                associatedWorkOrder: 'Associated Work Order',
                commentInformation: 'Impormasyon sa Komento',
                theDataHasBeenClearedPeriodically: 'Panahon ang data na ito ay purged.',
                subject: 'Paksa:',
                description: 'Paglalarawan:',
            },
            components: {
                addToTask: {
                    index: {
                        addToQualityInspectionTask: 'Dagdag sa Quality Task',
                    },
                },
            },
        },
        relatedDetail: {
            index: {
                associatedCallConversation: 'Associate call/versation',
            },
        },
        samplingTarget: {
            index: {
                time: 'Noong',
                samplingQuantityIsLessThan: 'Mas mababa ang dami ng sampling',
                alertWhen: 'Maagang babalan',
                everyday: 'Araw-araw',
                weekly: 'Linggon',
                monthly: 'Buwanan',
                samplingInspectionTargetSavedSuccessfully: 'Matagumpay na nai-save ang target ng inspeksyon ng sampling',
                personnel: 'Personelo',
                eachCustomerService: 'Bawat serbisyo ng customer',
                cycle: 'Cycle:',
                samplingInspectionTarget: 'Target ng inspeksyon ng sampling',
                strip: 'Artikulo',
                alertSettings: 'Mga Alart Settings',
            },
        },
        samplingTargetBanner: {
            index: {
                customerService: 'Servisyo ng Customero',
                complete: 'Taposo',
                Objective: '/Target',
                everyday: 'Araw-araw',
                weekly: 'Linggon',
                monthly: 'Buwanan',
            },
        },
        sessionInsights: {
            components: {
                groupChatInteractionRate: 'Rate ng interaction ng chat',
                maximumResponseIntervalTime: 'Maximum interval sa pagitan ng mga sagot',
                numberOfPreemptiveCalls: 'Bilang ng mga snatches',
                numberOfMessages: 'Bilang ng mga mensahes',
                strip: 'Artikulo',
                proportionOfMessages: 'Porsyento ng bilang ng mga mensahes',
                speechPercentage: 'Rato ng pagsasalays',
                longestCustomerTalk: 'Pinakahabang nagsasalita ng customer',
                numberOfIndepthDiscussions: 'Bilang ng malalim na talakayan',
                second: 'Timess',
                maximumDurationOfContinuousSpeech: 'Maximum na patuloy na tagal ng pagsasabit',
                questionFrequency: 'Frequency ng tanong',
                customer: 'Customero',
                keyEvents: 'Mga pangunahing kaganapan:',
                opportunity: {
                    index: {
                        generationFailed: 'Bigo ang build',
                        generateOpportunityPoints: 'Bumuha ang mga punto ng pagkakataan',
                    },
                },
                sessionSummary: {
                    index: {
                        generationFailed: 'Bigo ang build',
                        generateSummary: 'Bumuha ng Sumary',
                    },
                },
            },
            index: {
                areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                add: 'Dagdagan',
                opportunityPoints: 'Punto ng pagkakataon',
                conversationSummary: 'Session',
                cancel: 'Kansela',
                determine: 'Determine',
                edit: 'Pag-edita',
                establish: 'Bukhay',
                conversationalInsights: 'Session Insights',
                keyEvents: 'Mga pangunahing pangyayarin',
                numKeyEvents: 'Mga pangunahing pangyayarin',
                questionAnalysis: 'Pagsusuri ng mga katanungan',
                find: 'Nahanap',
                questions: 'Ikalawang tanon',
                conversationAction: 'Session',
                customer: 'Customero',
                sale: 'Behes',
                sessionLabel: 'Session Scenarios',
                employeeQuestions: 'Mga Katanungan ng staff',
                customerQuestions: 'Mga Katanungan sa Customero',
            },
        },
        ticketTextInfo: {
            index: {
                customer: 'Customero',
                customerService: 'Servisyo ng Customero',
                replyTo: 'Sumugot',
                addressee: 'To:',
            },
            components: {
                call: {
                    index: {
                        initiateOutcall: 'Inisimula ang Outcall',
                        callInformation: 'Impormasyon sa tawag:',
                        assignedNumber: 'Itinalagang numero:',
                        assignAgent: 'Assign Agent:',
                        answerDelay: 'Pagantala ng sagot:',
                        answerNumber: 'Numero ng sagot:',
                        callMode: 'Mode ng call:',
                        status: 'Status:',
                        callDuration: 'Pangulo ng tawag:',
                        yourBrowserDoesNotSupportTheAudioElement: 'Hindi suportahan ng iyong browser ang elemento ng audio.',
                    },
                },
                remark: {
                    index: {
                        notesAdded: 'Idinagdag ang mga talaka',
                        recipient: 'Tatanggap',
                    },
                },
                textMessage: {
                    index: {
                        sendSMS: 'Ipinadala ang SMS',
                        basicInformation: 'Pangunahing impormasyon:',
                        mobilePhoneNumber: 'Mobile phone number:',
                        sendObject: 'Papadala ng object:',
                        sMSTemplate: 'SMS template:',
                        sendResults: 'Mga Resulta:',
                        sMSContent: 'Nilalaman ng SMS:',
                    },
                },
                changeRecord: {
                    index: {
                        workOrderCreated: 'Likha ng Work Order',
                        triggeredTheFollowingActions: 'Nagsimula ang mga sumusunod na aksyo',
                    },
                },
            },
        },
        listManage: {
            template: {
                reerrorCorrection: 'Re-error pagwak',
                areYouSureYouWantToRecorrectTheError: 'Sigurado ka bang nais mong i-ayos muli ang error?',
                retranslation: 'Re-translation',
                areYouSureYouWantToRetranslate: 'Sigurado ka bang nais mong renslate?',
                sort: 'Sort',
                theSelectedDataLanguageIsInconsistentAndCannotBeAddedToTheQualityInspectionTask: 'Ang piniling wika ng data ay hindi pare-pareho at hindi maaaring idagdag sa gawain ng inspeksyon ng kalidad.',
                reIdentification: 'Re-identificay',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'Ang re-identification ay kumukuha ng oras ng paglipat, mangyaring mag-ingat.',
                determine: 'Determine',
                executionSuccessful: 'Matagumpay na pagpapatupad',
                addToQualityInspectionTask: 'Dagdag sa Quality Task',
                batchOperation: 'Operasyon ng batch',
            },
        },
        addToTaskModal: {
            index: {
                successfullyAdded: 'Nagdagdag ng matagumpayan',
                addToQualityInspectionTask: 'Dagdag sa Quality Task',
                qualityInspectionTask: 'Gawain sa inspeksyon ng kalida',
            },
        },
        customFilterModal: {
            component: {
                saveSuccessful: 'Ito ang matagumpay',
                detectRoles: 'Detect Role',
                detectionRange: 'Range ng detektan',
                sentence: 'Sentensya',
            },
            template: {
                cancelDefault: 'Kansela defaulta',
                setAsDefault: 'Itinakda bilang Defaulta',
                default: 'Defaulta',
            },
        },
        inspectionDetail: {
            template: {
                theDataHasBeenClearedPeriodically: 'Panahon ang data na ito ay purged.',
            },
        },
        backToSubSystem: {
            index: {
                returnToBusinessSystem: 'Bumalik sa Business System.',
            },
        },
        qualityCheckScoreTalk: {
            template: {
                overallMood: 'Kabuuang mood',
                problemExtraction: 'Paglabas ng probleman',
                businessSummary: 'Buktad sa negosyon',
                keyWord: 'Keywords',
            },
            components: {
                problemExtraction: {
                    personalityIssues: 'Mga isyu sa pagkatao',
                    generalQuestions: 'Pangkalahatang Katanungan',
                    positiveEmotions: 'Positive emosyon',
                    negativeEmotion: 'Negatibong emosyon',
                    neutralEmotion: 'Neutral emosyon',
                    no: 'Hindin',
                    customerServiceDidNotAnswer: 'Hindi sinagot ang serbisyo ng customer',
                    customerServiceHasAnswered: 'Sinagot ang serbisyo ng customer',
                    problemUnresolved: 'Hindi nalutas ang probleman',
                    theProblemHasBeenResolved: 'Nalutas ang probleman',
                    customerIssue: 'Mga Isyu ng Customer:',
                    customerServiceAnswer: 'Ang sagot ng serbisyo ng customer:',
                    reExtractQuestions: 'Problema sa re-extraction',
                    clickToExtractQuestions: 'Click upang kumuha ng mga katanungan',
                },
            },
        },
        coach: {
            customerPortrait: {
                detail: {
                    index: {
                        portraitName: 'Pangalan ng Portraite',
                        backgroundDescription: 'Description',
                        customerLabel: 'Customer Label',
                        labelManagement: 'Label Management (Label Management)',
                    },
                },
                list: {
                    components: {
                        addCustomerPortraitItemBtn: {
                            index: {
                                newlyBuild: 'Bago',
                            },
                        },
                    },
                },
            },
            detailedInquiryConfig: {
                components: {
                    detailedInquiryConfigTitle: {
                        index: {
                            questioningSettings: 'Mga Setting sa pagtatanon',
                        },
                    },
                    detailedInquiryList: {
                        index: {
                            increaseQuestioning: 'Pagpapataas ng tanon',
                            remove: 'Alisini',
                            addQuestioning: 'Dagdag ang mga Katanungan',
                            section: 'Sekson',
                            secondInquiry: 'Ikalawang tanong',
                            questioningScore: 'Nagtatanong markan',
                        },
                    },
                },
                index: {
                    accordingToRules: 'Sa pamamagitan ng Rule',
                    byScore: 'Sa markas',
                    whenMissRule: 'Kapag nawala ang patakas',
                    whenConductingQuestioning: 'Kapag nagtatanon',
                    pleaseSelectARule: 'Mangyaring pumili ng patakas',
                    ruleCannotBeEmpty: 'Hindi maaaring walang laman',
                    currentScriptScore: 'Kapag ang score ng pagsasalita ≤',
                    pleaseEnterTheScore: 'Mangyaring ipasok ang markan',
                    scoreCannotBeEmpty: 'Hindi maaaring walang laman',
                },
            },
            dialogue: {
                components: {
                    narrator: {
                        narrator: 'Narrator:',
                    },
                    pPT: {
                        slide: 'Slide',
                    },
                    realTimeAnalyzer: {
                        index: {
                            scriptReview: 'Mga komento',
                            script: 'Mga salat',
                            semantics: 'Semantic',
                            violatingWords: 'Paglabag sa mga salat',
                            speechSpeed: 'Speed of Speeche',
                            emotion: 'Emosyon',
                        },
                    },
                    scoreDetail: {
                        index: {
                            scriptReview: 'Mga komento',
                            regenerate: 'Regeneratee',
                            generate: 'Generated',
                            hitSituation: 'Hit Case',
                            noSemanticTagsMatched: 'Hindi tugma sa semantic label.',
                            matchToSemanticTags: 'Match to Semantic Label',
                            appealToBeSubmitted: 'Ang paghawa na ipadalas',
                            ratingHasBeenReviewed: 'Review ang rating',
                            ratingAppealInProgress: 'Scoring Grievances',
                            expressionScore: 'Score ng expression',
                            moodParticlesTimes: 'Tone word, {0} beses',
                            changeTheModalParticlesTo: 'Para sa mga modal particles',
                            second: 'Timess',
                            interrogation: 'Pagtanong',
                            questioningWithoutScoring: 'Tanong nang walang scor',
                            branch: 'Punts',
                            matchingRate: 'Pag-aayos',
                            ratingAppeal: 'Pag-aapela',
                            changeTo: 'Pagbago',
                            wordPerMinute: 'Salita bawat minuto',
                            completeScript: 'Kumpletong pagsasabit',
                            incompleteScript: 'Hindi kumpleto',
                            semanticHit: 'Semantic hit',
                            semanticMisses: 'Semantic Misses',
                            scriptViolation: 'Paglabag sa pagsasabit',
                            modified: 'Nagbago',
                            notChanged: 'Hindi nagbabago',
                            keyWord: 'Keywords',
                            semanticLabels: 'Semantic label a',
                            semanticMatchingRate: 'Semantic matching rate',
                            violatingWords: 'Paglabag sa salita "',
                            delete: 'Mangalisa',
                            unmatched: 'Hindi tugman',
                            matching: 'Match',
                            matchTo: 'Match',
                            notMatchedTo: 'Hindi tugman',
                            scriptScore: 'Speech Score',
                            standardScript: 'Standard Speeche',
                            emotionalScore: 'Emosyonal Score',
                            speechSpeedScore: 'Speed Score',
                            viewResolution: 'Pansin ang resolusyong',
                            nodeConfiguration: 'Node',
                        },
                    },
                    userNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'Ang oras ng sagot ng tanong na ito ay overtime, at ang nilalaman ng sagot ay awtomatikong ipinadala.',
                    },
                    knowledgeNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'Ang oras ng sagot ng tanong na ito ay overtime, at ang nilalaman ng sagot ay awtomatikong ipinadala.',
                    },
                    correctBtn: {
                        saveSuccessful: 'Ito ang matagumpay',
                        errorCorrection: 'Pagwawasto',
                        cancel: 'Kansela',
                        preserve: 'Pag-save',
                    },
                },
            },
            scoringRules: {
                components: {
                    drawerTitle: {
                        scoringRules: 'Mga Panununga',
                        cancel: 'Kansela',
                        determine: 'Determine',
                    },
                    scoringRuleItem: {
                        whole: 'Lahat',
                        arbitrarily: 'Arbitrary',
                        pleaseEnterARuleName: 'Mangyaring ipasok ang pangalan ng panuntuan',
                        standardScript: 'Standard Speeche',
                        if: 'Kung',
                        and: 'At',
                        or: 'O',
                        thenScore: 'Pagkatapos score',
                        pleaseEnterAScore: 'Mangyaring ipasok ang markan',
                        bonusPoints: 'Mga bonus points',
                        minusPoints: 'Minus points',
                        hit: 'Hit',
                        misses: 'Nawalan',
                        keyWord: 'Keywords',
                        semantics: 'Semantic',
                    },
                    title: {
                        ruleValidation: 'Pag-verifyo',
                        scoringRulestheTotalScoreOfTheCurrentScriptIs: 'Mga patakaran sa pagmamarka (ang kabuuang marka ng kasalukuyang pagsasalita ay',
                        points: 'Points)',
                        editRules: 'Pag-edit Rule',
                    },
                },
            },
            userTagsSelect: {
                index: {
                    noLabelsCurrentlyAvailable: 'Walang labela',
                },
            },
            aiGenDialogFrame: {
                components: {
                    description: {
                        index: {
                            communicationObjectives: 'Mga layunin ng komunikasyon',
                            scoringCriteria: 'Mga criterio ng markas',
                        },
                    },
                },
                index: {
                    generating: 'Pagbuo',
                    generateDialogueFramework: 'Pagbuo ng framework ng dialogo',
                    theme: 'Tema',
                },
            },
            aiGenPrompt: {
                components: {
                    title: {
                        hintLanguage: 'Prompt',
                        generatePromptLanguage: 'Prompt na binuo',
                    },
                },
            },
            aiGenScore: {
                index: {
                    communicationStage: 'Communication Phases',
                    communicationObjectives: 'Mga layunin ng komunikasyon',
                    scoringCriteria: 'Mga criterio ng markas',
                    suggestionsForImprovement: 'Mga mungkahi ng promosyon',
                },
            },
            score: {
                overview: {
                    index: {
                        processScore: 'Score ng proseso',
                        contentIntegrity: 'Integridad ng nilalaman:',
                        NumberOfCompletedProcesses: '%, Bilang ng mga kumpletong proseso',
                        keyHitPointsTotal: 'Key hits: kabuuang',
                        notReached: 'Hindi naabota',
                        accurateFollowupAccumulationOfStandardScripts: 'Tumpake Follow-up: Standard Speech Accumulations',
                        theTotalNumberOfWordsHitByTheStudentAfterReading: 'Isang salita, ang bilang ng mga salita na hit ng mag-aaral',
                        aWord: 'Salita',
                        languageNormsYes: 'Spesyasyon ng wika: Ooo',
                        emotionsAppearing: 'Emosyon: lumilitaw',
                        speechSpeedSpeakingTooFast: 'Bilis: masyaw',
                        modalParticlesExcessiveOccurrenceOfModalParticles: 'Mga salitang tone: labis na pangyayari ng tone words',
                    },
                },
            },
            randomBranchConfig: {
                index: {
                    nextNodeRandomTrigger: 'Susunod na node random trigger',
                    ifTheUserPortraitIsEnabledTheNodePathWillBeBasedOnTheUserPortraitAndDefaultSpeechAndTheRandomFunctionWillNotTakeEffect: 'Kung ang larawan ng user ay pinagana, ang node path ay batay sa larawan ng user at default na pagsasalita, at ang random function ay hindi magkakaroon ng epekto.',
                    pleaseSelectRandomMode: 'Pakipili ang random mode',
                    completelyRandom: 'Ganap na randoma',
                    pathCoverageRandom: 'Path coverage random random',
                },
            },
        },
        smartTags: {
            template: {
                addToIgnoreTags: 'Dagdag sa Ipanwalaan ng mga Tags',
                areYouSureYouWantToReExecuteTheSmartLabel: 'Sigurado ka bang nais mong muling ipakita ang matalinong label?',
                reExecute: 'Pagpapatake',
            },
            component: {
                successfullyAdded: 'Nagdagdag ng matagumpayan',
            },
        },
        reInspectionResultModal: {
            index: {
                turnOffAllNotifications: 'Patunin ang lahat ng mga notifikas',
                reQualityInspectionTask: 'Re-inspection gako',
                requalityInspection: 'Re-inspection',
                waiting: 'Naghihintay',
                viewDetails: 'Pansin Detalyas',
            },
        },
        checkPointConditionListGather: {
            checkPointCondition: {
                components: {
                    applyTimeType: {
                        index: {
                            detectionTime: 'Oras ng pag-detection:',
                        },
                    },
                    problemDetectionMode: {
                        index: {
                            singleSentenceDetection: 'Solong pagkilala sa pangungutsa',
                            multisentenceDetection: 'Multi-resence detection',
                            crosssentenceDetection: 'Pagkakita ng cross-ress',
                            problemDetectionMethod: 'Paraan ng detection ng problema:',
                            mostAcross: 'Karamihan sa buong.',
                            sentence: 'Sentensya',
                            ignoreNotGreater: 'Hindi pinababahalan',
                            theSentenceOfTheWord: 'Ang pangungusap ng salat',
                            theCrosssentenceLimitIsNotGreater: 'Hindi mas malaki ang limitasyon ng cross-ress',
                            word: 'Salita',
                        },
                    },
                    info: {
                        index: {
                            useLargeModelsForSemanticMatching: 'Gumamit ng malalaking modelo para sa semantiko na tugma.',
                            keywordsUseStrictMatchingOneLineCanEnterMultipleKeywordsKeywordsAreSeparatedByCommas: 'Ang mga keyword ay gumagamit ng mahigpit na tugma, ang isang linya ay maaaring ipasok ang maraming keywords, ang mga keyword ay pinaghiwalay ng kommas.',
                            semanticTagsSupportBothStrictMatchingAndSemanticMatchingWhereSemanticTagsNeedToBeConfiguredInTheSidebarOfSmartToolsOrSemanticIntelligencesemanticTags: 'Ang mga semantic tags ay sumusuporta sa parehong mahigpit na tugma at semantic matching, kung saan ang mga semantic tags ay kailangang mai-configure sa sidebar ng mga matalinong tool o semantic intelligence-semantic tags.',
                            conceptWordsAresemanticLabelsDesignedForWordsWhichCanMatchWordsStrictlyOrSemanticallyWhereConceptWordsAreConfiguredInSemanticIntelligenceconceptWords: 'Ang mga salita ng konsept ay "semantic labels" na disenyo para sa mga salita, na maaaring tumutugma sa mga salita na mahigpit o semantikal, kung saan ang mga salitang konsepto ay naka-configure sa mga salita ng semantic intelligence-concept.',
                            checkWhetherTheCustomerServiceResponseTimedOutWhetherTheCustomerRespondedTimedOutAndWhetherTheCustomerDidNotRespondTheResponseStartSentenceRefersToWhetherTheResponseOfRoleAIsDetectedFromTheFirstSentenceOrTheLastSentenceOfMultipleMessagesSentContinuouslyWhenRoleAContinuouslySendsMessagesAndDetectsTheResponseOfRoleBResponseTimeoutIsAnUpgradedVersionOfSilentDetection: 'Suriin kung ang tugon ng serbisyo ng customer ay umalis, kung ang customer ay tumugon sa oras, at kung hindi tumugon ang customer. Ang pagsisimula ng sagot ay tumutukoy sa kung ang tugon ng papel A ay nakita mula sa unang pangungusap o ang huling pangungusap ng maraming mensahe na ipinadala patuloy kapag patuloy na nagpapadala ang papel A ng mga mensahe at nakikita ang tugon ng papel na B. Ang repons timeout ay isang upgraded bersyon ng tahimik na detection.',
                            theSilenceDurationOfEachCharacterIsDetectedByDefaultTheLastSentenceIsDetected: 'Nakita ang katahimikan ng bawat character. Sa pamamagitan ng default, nakita ang huling pangungusap.',
                            inTheDialogueBetweenTwoDifferentRolesTheEndTimeOfThePreviousSentencetheStartTimeOfTheCurrentSentenceTheSnatchingIntervalAndTheEndTimeOfTheCurrentSentencetheStartTimeOfTheCurrentSentenceTheLengthOfTheSnatchingSentenceIfItIsSatisfiedAtTheSameTimeItWillBeJudgedAsSnatchingWords: 'Sa diyalogo sa pagitan ng dalawang iba\'t ibang papel, ang huling oras ng nakaraang pangungusap-ang oras ng pagsisimula ng kasalukuyang pangungusap> = ang agwat ng pag-aalis; At ang wakas na oras ng kasalukuyang pangungusap-ang oras ng pagsisimula ng kasalukuyang pangungusap> ang haba ng pangungusap; Kung ito ay nasiyahan sa parehong oras, Ito ay huhusgahan bilang mga salita ng pag-agaw.',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsTheOldVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInSemanticIntelligenceInteractiveRecognition: 'Ito ay angkop para sa pagtuklas ng sagot sa negosyo ng isang tanong at isang uri ng sagot. Ang operator ay naglalarawan ng mga problema mula sa mga mensahe ng customer. Kung hindi nakita ang problema, sundin ang pagsasaayos ng item na "Kapag hindi nakita ang problema. Kung nakita ang problema, nakita ang sagot mula sa mensahe ng serbisyo ng customer. Kapag nakita ang isang sagot, tinutukoy na ang solusyon ng kaalaman ng serbisyo ng customer ay tama; kung walang sagot ang nakikita, ito ay tinutukoy na mali ang solusyon ng kaalaman ng serbisyo ng customer. Ang operator na ito ay ang lumang bersyon ng solusyon ng kaalaman, at ang mga katumbas na pagpipilian ay naayos sa Semantic Intelligence-Interactive Recognition.',
                            detectingWhetherThereAreDuplicateMessagesInASessionSupportsBothStrictAndSemanticDuplication: 'Ang pagtuklas kung may mga duplicate mensahe sa isang sesyon ay sumusuporta sa parehong mahigpit at semantic duplication.',
                            itSupportsTheDetectionOfTheIntervalBetweenTwoSemanticsInWhichSemanticLabelsCanBeSetInTheSidebarOfIntelligentToolsOrSemanticIntelligencesemanticLabels: 'Ito ay sumusuporta sa pagtuklas ng interval sa pagitan ng dalawang semantika, kung saan ang mga semantic label ay maaaring itakda sa sidebar ng mga intelligent tool o semantic intelligence-semantic labels.',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsANewVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInTheSemanticIntelligenceknowledgeBase: 'Ito ay angkop para sa pagtuklas ng sagot sa negosyo ng isang tanong at isang uri ng sagot. Ang operator ay naglalarawan ng mga problema mula sa mga mensahe ng customer. Kung hindi nakita ang problema, sundin ang pagsasaayos ng item na "Kapag hindi nakita ang problema. Kung nakita ang problema, nakita ang sagot mula sa mensahe ng serbisyo ng customer. Kapag nakita ang isang sagot, tinutukoy na ang solusyon ng kaalaman ng serbisyo ng customer ay tama; kung walang sagot ang nakikita, ito ay tinutukoy na mali ang solusyon ng kaalaman ng serbisyo ng customer. Ang operator na ito ay isang bagong bersyon ng solusyon ng kaalaman, at ang mga katumbas na pagpipilian ay naka-configure sa base ng semantic intelligence-knowledge.',
                            checkWhetherTheCustomerServiceSentenceIsTooShortOrTooLong: 'Suriin kung ang pangungusap ng serbisyo ng customer ay masyadong maikli o masyadong mahaba.',
                            detectTheEmotionsOfAgentsOrCustomers: 'Detekta ang emosyon ng mga ahente o customer.',
                            onlyApplicableToTextConversationQualityInspectionToDetectWhetherTheSentMessageContainsTyposTheTyposCanBeEnrichedInTheSemanticIntelligenceintelligentThesaurustyposToOptimizeTheDetectionOfTypos: 'Magagamit lamang sa inspeksyon ng kalidad ng pag-uusap sa teksto, upang makita kung ang ipinadala na mensahe ay naglalaman ng mga typo. Ang mga typo ay maaaring mapayaman sa semantic intelligence-intelligent thesaurus-typos upang ma-optimize ang pagtuklas ng mga typo.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherInterrogativeSentencesAppearInTheSession: 'Ito ay naaangkop lamang sa inspeksyon ng kalidad ng tawag sa boses, na nakakakita kung ang mga pangungusap ay lumilitaw sa sesyon.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherTheVolumeOfTheCustomerServiceOrCustomerIsTooHighOrTooLowAndWhetherTheVolumeChangesSuddenly: 'Ito ay naaangkop lamang sa inspeksyon ng kalidad ng boses, na nakikita kung ang dami ng serbisyo ng customer o customer ay masyadong mataas o masyadong mababa, at kung ang dami ay biglaang nagbabago.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionAndDetectsTheSpeechSpeedOfCustomerServiceOrCustomers: 'Ito ay natupad lamang sa inspeksyon ng kalidad ng tawag sa boses at nakita ang bilis ng pagsasalita ng serbisyo ng customer o mga customer.',
                            checkWhetherTheInformationEntityMentionedInTheSessionIsCorrectThatIsJudgeWhetherTheInformationEntityValueIsEqualToACertainPathassociatedDataOrFixedValueTheInformationEntityCanBeConfiguredInTheSemanticIntelligenceinformationEntity: 'Suriin kung tama ang impormasyong entity na nabanggit sa sesyon, iyon ay, hukom kung ang halaga ng entity entity ng impormasyon ay katumbas ng isang tiyak na datos na may kaugnayan sa path o maayos na halaga. Ang entity ng impormasyon ay maaaring mai-configure sa semantic intelligence-information entity.',
                            theNewVersionOfTheAccompanyingFieldDetectsWhetherTheAccompanyingDataIsEqualToAFixedValueOldVersionOfDataWithTheRouteCanDetectWhetherTheDataWithTheRouteMeetsTheRelationshipExpressionWhereTheRelationshipExpressionSupportsUserdefinedYouCanSetTheAdditionSubtractionMultiplicationAndDivisionOperationWhetherToMatchTheSemanticLabelWhetherToContainKeywordsIFJudgmentEtc: 'Ang bagong bersyon ng kasama na patlang: nakikita kung ang kasamang data ay katumbas ng isang nakapirming halaga. Lumang bersyon ng data na may ruta: maaaring makita kung ang data na may ruta ay nakakatugon sa expression ng relasyon, kung saan ang expression ng relasyon ay sumusuporta sa paglalarawan ng user, maaari mong itakda ang pagdaragdag, pagbabawas, multiplication at division operasyon, kung magkatulad sa label ng semantiko, kung maglalaman ng mga keywords, paghatol ng IF, atbp.',
                            determineWhetherTheSummaryContentOfTheSessionIsEqualToOrContainsAFixedValueTheSummaryIsSetInProcessAutomationBusinessSummary: 'Matukoy kung ang nilalaman ng buod ng sesyon ay katumbas o naglalaman ng isang maayos na halaga. Ang buod ay nakatakda sa Process Automation-Business Summary.',
                        },
                    },
                },
                template: {
                    IgnoreLess: ', Hindi pinapansin mas maa',
                    theSentenceOfTheWord: 'Ang pangungusap ng salat',
                    secondsToNo: 'Seconds to No.',
                    seconds: 'Seconds',
                    responseOpeningSentence: 'Pagsisimula ng sagot',
                },
            },
            template: {
                multimodal: 'Multimodal',
                model: 'Modelo',
            },
            component: {
                largeModel: 'Malaking modelon',
            },
        },
        businessSummary: {
            components: {
                fieldItem: {
                    index: {
                        generationFailed: 'Bigo ang build',
                        generate: 'Generated',
                    },
                },
                empty: {
                    index: {
                        thereIsCurrentlyNoDataAvailable: 'Walang datas',
                    },
                },
            },
            index: {
                regenerate: 'Regeneratee',
            },
        },
        applyTemplates: {
            component: {
                areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                operationSuccessful: 'Nagtagumpay ang operasyon',
            },
            template: {
                delete: 'Mangalisa',
            },
        },
        similarQuestionRecommend: {
            index: {
                pleaseSelectAQuestion: 'Mangyaring pumili ng tanong!',
                similarQuestionRecommendation: 'Katulad na Tanong rekumenda',
                selectAllOnPage: 'Kapag pinipili ang lahat ng pahinan',
                cancel: 'Kansela',
                preserve: 'Pag-save',
                changeBatch: 'Magbago ng batche',
            },
        },
        listControl: {
            index: {
                columnControl: 'Column Control',
            },
        },
        loginUserAvatar: {
            index: {
                switch: 'Switch',
            },
        },
        autoAddComponent: {
            index: {
                whenAddingDataInRealTimeTheQualityInspectionTaskStillTakesTimeToExecuteTheSpecificTimeDependsOnTheSizeOfTheQualityInspectionDataRangingFromAFewMinutesToHours: 'Kapag nagdaragdag ng data sa real time, ang gawain ng inspeksyon ng kalidad ay tumatagal pa rin ng oras upang magpatupad. Ang tiyak na oras ay depende sa laki ng data ng inspeksyon ng kalidad, mula sa ilang minuto hanggang 2 oras.',
            },
        },
        bEditor: {
            index: {
                delete: 'Mangalisa',
                cancel: 'Kansela',
                confirm: 'Determine',
                insert: 'Igop',
                width: 'Lawak',
                height: 'Kataasa',
                clearContent: 'Liyas',
                revoked: 'Revokd',
                redo: 'Mula',
                fontSize: 'Laki ng fonte',
                rowHeight: 'Taas ng row',
                wordSpacing: 'Paglipas ng salot',
                paragraphIndent: 'Paragraph Indente',
                increaseIndent: 'Pagpapataas ng Indentd',
                decreaseIndent: 'Pababa ang Indente',
                border: 'Border',
                color: 'Kulay',
                textColor: 'Teksto kulay',
                backgroundColor: 'Background Color',
                temporaryColor: 'Pansamantalang kulay',
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underlined',
                strikethrough: 'Strikethrough',
                font: 'Fonta',
                textAlignment: 'Text Alignment:',
                left: 'Kaliwan',
                centered: 'Sentror',
                right: 'Kanan',
                bothEnds: 'Parehong dulo',
                leftFloat: 'Kaliwa Float',
                rightFloat: 'Kanang Float',
                subrupt: 'Superscripts',
                subscript: 'Subscript',
                clearStyle: 'Lilinaw ang Estil',
                title: 'Title',
                regular: 'Regular',
                orderedList: 'Ordered Lista',
                unorderedList: 'Walang listang',
                reference: 'Reference',
                code: 'Code',
                link: 'Links',
                clearLink: 'Lilinaw ang link',
                horizontalLine: 'Horizontal Linya',
                media: 'Media',
                mediaLibrary: 'Media Librarya',
                smallExpression: 'Maliit na expressiono',
                fullScreen: 'Buong Scren',
                exitFullScreen: 'Lumabas sa Buong Scren',
                enterLinkText: 'Isugot ang teksto ng link',
                enterLinkAddress: 'Isugtan ang adres ng link',
                enterTheLinkAddressAndPressEnter: 'Ipasok ang link address at pindutin ang Enter',
                openInNewWindow: 'Buksan sa bagong windows',
                removeLink: 'Alisin ang Linka',
                playingAudioFiles: 'Play a audio files',
                playVideoFiles: 'Play video files',
                embeddedMedia: 'Embedded Media.',
                image: 'Larawan',
                video: 'Videos',
                audio: 'Audio',
            },
        },
        verifyModal: {
            components: {
                verifyCodeInput: {
                    index: {
                        sentSuccessfully: 'Nagpadala ng matagumpayan',
                        resend: 'Resend (Reend)',
                        sendVerificationCode: 'Papadala ang kode ng verifications',
                    },
                },
            },
            index: {
                cAPTCHA: 'CAPTCHA',
                confirm: 'Determine',
                pleaseEnterTheVerificationCode: 'Mangyaring ipasok ang verifika code',
            },
        },
        languageSelect: {
            const: {
                urdu: 'Urdu',
                kazakh: 'Kazakh',
                americanEnglish: 'American English (American English)',
                canadianEnglish: 'Canadian Englishs',
                africanEnglish: 'Ang Ingles sa African',
                french: 'Pranses',
                spanish: 'Espanyola',
                russian: 'Ruso',
                arabic: 'Arabe',
                turkish: 'Turko',
                vietnamese: 'Vietnameses',
                portuguese: 'Portuguesa',
                german: 'Alemanya',
                italian: 'Italiana',
                polish: 'Polish',
                finnish: 'Finnisha',
                dutch: 'Olandes',
                czech: 'Tseko',
                bengali: 'Bengali',
                greek: 'Greeko',
                hindi: 'Hindin',
                chineseTaiwan: 'Tsina Taiwan,',
                cambodian: 'Cambodian',
                allLanguages: 'Lahat ng Wika',
                chinese: 'Tsino',
                english: 'Inglesa',
                cantonese: 'Cantoneses',
                thai: 'Thai',
                malay: 'Malaya',
                indonesian: 'Indonesian',
                korean: 'Korean',
                filipino: 'Filipino',
                japanese: 'Hapons',
            },
            index: {
                pleaseSelectLanguage: 'Mangyaring pumili ng wika',
            },
        },
        languageSetting: {
            index: {
                aSRModel: 'ASR modelon',
                languageAdaptive: 'Adaptive wika',
                mainLanguage: 'Pangunahing wika',
                paraLanguage: 'Para wikan',
                rules: 'Mga patakan',
                languageType: 'Type ng wika:',
                preserve: 'Pag-save',
                remove: 'Alisini',
                new: 'Bago',
            },
        },
        smartToolBar: {
            smartTags: {
                template: {
                    language: 'Wika',
                },
            },
            aiReport: {
                component: {
                    submittedSuccessfully: 'Matagumpay na ipinadalas',
                },
                template: {
                    selectQualityTask: 'Pumili ng Quality',
                    enterReportGenerationRequirements: 'Maglagay ng mga pangangailangan sa paggawa ng ulat',
                    generateReport: 'Paglikha ng Reporto',
                    historicalReport: 'Makasaysayang Reporto',
                    toBeGenerated: 'Upang mabuo',
                    exporting: 'Nag-exporto',
                    failedToGenerate: 'Sawi sa paglika',
                    complete: 'Kumpleto',
                },
            },
            component: {
                largeModelReport: 'Malaking Model Reporto',
            },
        },
        audioCallContentInfo: {
            components: {
                commentView: {
                    index: {
                        viewDetails: 'Pansin Detalyas',
                    },
                },
            },
            template: {
                all: 'Lahat',
                theFollowingIsTheBotServiceMessage: 'Ang sumusunod ay ang mensahe ng serbisyo ng boto',
                theFollowingIsTheHumanServiceMessage: 'Ang sumusunod ay ang mensahe ng serbisyo ng tao',
            },
        },
        asrStatusModal: {
            index: {
                aSRTrainingStatus: 'Status ng Training ASR',
                chineseASR: 'Chinese ASR',
                aSRModelUpdateTimegeneric: 'ASR model update time (generic):',
                aSRModelUpdateTimeexclusive: 'Oras ng pag-update ng ASR model (eksklusibo):',
                numberOfErrorCorrectionsTrained: 'Bilang ng mga pagsasaayos ng error:',
                trainedErrorCorrectionDuration: 'Karanasan ng Pagwawasto ng Error:',
                minutes: 'Minuta',
                numberOfUntrainedErrors: 'Bilang ng mga hindi nasanay na error:',
                untrainedErrorCorrectionDuration: 'Pangkalahatan ng Pagwawasto ng Error:',
            },
        },
        survey: {
            components: {
                question: {
                    index: {
                        singleTopic: 'Single Topico',
                        multipleChoiceQuestions: 'Maraming tanong ng pagpipilia',
                        questionAndAnswer: 'Katanungan at sagot',
                    },
                },
            },
        },
        soundtrackListManage: {
            component: {
                keyWords: 'Mga susing sala',
            },
        },
        audioStickersTalkV2: {
            index: {
                customerService: 'Servisyo ng Customero',
                customer: 'Customero',
                topic: 'Paksaan',
            },
        },
        infoEntitySelect: {
            index: {
                pleaseSelectAnInformationEntity: 'Mangyaring pumili ng entity ng impormasyong',
            },
        },
        outerApiConfigsResponseSelect: {
            index: {
                pleaseSelectAReturnParameter: 'Mangyaring pumili ng isang parameter buk',
            },
        },
        outerApiConfigsSelect: {
            index: {
                pleaseSelectExternalInterface: 'Mangyaring piliin ang panlabas na interface',
            },
        },
        randomFieldSelect: {
            index: {
                pleaseSelect: 'Pakipilin',
            },
            utils: {
                customerInformation: 'Impormasyon sa Customero',
                followtheroadData: 'Follow-the-road datas',
                preprocessingData: 'Preprocessing Data',
                businessRecords: 'Mga tala ng negosyon',
                workOrderInformation: 'Impormasyon sa Work Order',
            },
        },
        frequency: {
            index: {
                pleaseSelect: 'Pakipilin',
                no: 'Hindi.',
            },
        },
        roleSelect: {
            index: {
                pleaseSelect: 'Pakipilin',
            },
        },
        userSelect: {
            index: {
                pleaseSelect: 'Pakipilin',
            },
        },
        massageConfigurationV2: {
            index: {
                messageName: 'Pangalan ng message',
                dataType: 'Type ng data',
                filterCondition: 'Filter Condition:',
                triggerMechanism: 'Mekanismo ng trigger',
                afterDataAcquisition: 'Matapos ang pagkuha ng datas',
                afterDataAnalysis: 'Matapos ang pagsusuri ng data',
                pushMode: 'Modo ng pagpusi',
            },
        },
        evaluateDrawer: {
            index: {
                courseQuality: 'Kalidad sa kurso',
                higherValuesIndicateBetterCourseQuality: 'Ang mas mataas na halaga ay nagpapahiwatig ng mas mahusay na kalidad ng kurso',
                learningEffect: 'Epekto sa pag-aaral',
                theHigherTheValueTheBetterTheLearningEffect: 'Ang mas mataas na halaga, mas mahusay ang epekto ng pag-aaral.',
                interactiveExperience: 'Interactive Experiens',
                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'Ang mas mataas na halaga, mas mahusay ang interactive na karanasan ng kurso.',
                suggestedFeedback: 'Iminungkahi',
                pleaseEnterAnEvaluationProposalForThisCourse: 'Mangyaring ipalagay ang isang mungkahi sa pagsusuri para sa kurso',
                cancel: 'Kansela',
                submission: 'Submissions',
            },
        },
        filterManage: {
            template: {
                default: 'Defaulta',
            },
        },
        associatedTicket: {
            index: {
                associatedWorkOrder: 'Associated Work Order',
            },
        },
        appealHistory: {
            index: {
                reasonsForPassing: 'Mga dahilan para sa pagpasa',
                reasonForRejection: 'Dahilan para sa pagtanggik',
                secondaryReview: 'Secondary review',
                firstlevelReview: 'Unang-level review',
            },
        },
        customSortModal: {
            component: {
                sorterNameCannotBeEmpty: 'Hindi maaaring walang laman ang pangalan ng sorter',
                ascending: 'Ascend',
                descending: 'Pagbabasa',
            },
            customFilters: {
                ascending: 'Ascend',
                descending: 'Pagbabasa',
            },
            template: {
                sorterName: 'Pangalan ng sorter:',
                pleaseEnterASorterName: 'Mangyaring ipasok ang pangalan ng Sorter',
                customSort: 'Custom Sort',
                commonSort: 'Karaniwang urin',
            },
        },
        waveAudioTalkV2: {
            template: {
                confirmRetranslation: 'Patunayan ang muling pagsasalin?',
                retranslation: 'Re-translation',
            },
        },
        waveAudioTalk: {
            template: {
                confirmRetranslation: 'Patunayan ang muling pagsasalin?',
                retranslation: 'Re-translation',
            },
        },
        variableFieldSelect: {
            const: {
                languageField: 'Field ng wika',
                businessRecords: 'Mga tala ng negosyon',
                smartLabel: 'Smart Label',
                pretreatment: 'Pretreatment:',
                workOrderFields: 'Work Order Fields',
                customerInformation: 'Impormasyon sa Customero',
                associatedWorkOrder: 'Associated Work Order',
            },
            index: {
                pleaseEnterAKeywordQuery: 'Mangyaring ipasok ng keyword query',
            },
        },
        customModelsQaMethod: {
            index: {
                qualityInspectionMethod: 'Paraan ng inspeksyon ng kalidado',
                setTheLargeModelQualityInspectionMethodOfTheCurrentQualityInspectionRule: 'Itakda ang malaking paraan ng inspeksyon ng kalidad ng modelo ng kasalukuyang patakaran ng inspeksyon ng kalidad;',
                batchQualityInspectionAfterTheCurrentRuleIsMergedWithOtherBatchQualityInspectionRulesUnderTheSameTaskTheLargeModelIsCalledToOutputTheQualityInspectionResultsOfMultipleRulesAtOneTimeThisIsApplicableToSimpleRules: 'Batch Quality Inspection: Matapos ang kasalukuyang patakaran ay pinagsama sa iba pang mga patakaran ng inspeksyon ng kalidad ng batch sa ilalim ng parehong gawain, ang malaking modelo ay tinatawag upang maglabas ng mga resulta ng inspeksyon ng kalidad ng maraming patakaran sa isang pagkakataon. Ito ay naaangkop sa mga simpleng patakaran.',
                separateQualityInspectionIndicatesThatTheCurrentRuleIsNotMergedWithOtherRulesAndQualityInspectionIsPerformedSeparatelyThisIsApplicableToComplexRules: 'Separate Quality Inspection: nagpapahiwatig na ang kasalukuyang patakaran ay hindi pinagsama sa iba pang mga patakaran, at hiwalay na ginagawa ang inspeksyon ng kalidad. Ito ay naaangkop sa mga kumplikadong patakaran.',
                noteThatTheConsumptionOfIndividualQualityInspectionTokenIsHigherThanThatOfBatchQualityInspection: 'Tandaan na ang pagkonsumo ng indibidwal na kalidad ng inspeksyon ay mas mataas kaysa sa inspeksyon ng kalidad ng batch.',
                batchQualityInspection: 'Batch Quality Inspection',
                separateQualityInspection: 'Hiwalay na inspeksyon ng kalidado',
            },
        },
        dialogInformation: {
            index: {
                call: 'Tawag',
                dialogue: 'Dialog',
            },
        },
        ticketRelateQa: {
            index: {
                detectionDataCannotBeEmpty: 'Hindi maaaring walang laman ang data ng detection!',
                workOrder: 'Work Order',
                dialogue: 'Dialog',
                detectionData: 'Data ng detektas',
            },
        },
        customerServiceGrounp: {
            component: {
                maximumNameLengthIs: 'Ang pinakamataas na haba ng pangalan ay 20.',
            },
        },
        agentGroupSelect: {
            index: {
                pleaseSelectAnAgentGroup: 'Mangyaring pumili ng grupo ng ahento',
            },
        },
        agentSelect: {
            index: {
                pleaseSelectCustomerService: 'Mangyaring piliin ang serbisyo ng customer',
            },
        },
        ticketTypeSelect: {
            index: {
                customer: 'Customero',
                customerService: 'Servisyo ng Customero',
                internalRemarks: 'Panloob na mga Pahayag',
                sMS: 'SMS',
                call: 'Tawag',
                mail: 'Mail',
                changeRecord: 'Pagbago ng Record',
            },
        },
        agentDepartmentSelect: {
            index: {
                pleaseSelectDepartment: 'Mangyaring piliin ang departamento...',
            },
        },
        aSRModelSelect: {
            index: {
                pleaseSelect: 'Pakipilin',
            },
        },
        exportButton: {
            index: {
                exportTaskCreatedSuccessfully: 'Naging matagumpay ang paggawa ng gawain.',
                taskCreatedSuccessfully: 'Matagumpay na nilikha ang gawaan',
                downloadCenter: 'Download Center.',
                taskCenter: 'Mission Center.',
            },
        },
    },
    fields: {
        qualityInspectionForm: {
            list: {
                name: 'Pangang',
                description: 'Paglalarawan',
                type: 'Type',
                status: 'Status',
                actions: 'Operasyong',
            },
        },
        qualityCheckingTask: {
            index: {
                name: 'Pangalan ng Task',
                description: 'Paglalarawan',
                form: 'Form ng Inspection ng kality',
                actions: 'Operasyong',
                createUser: 'Creater',
            },
            samplingRecords: {
                createTime: 'Oras',
                type: 'Type',
                operateUser: 'Operator',
                number: 'Dagdag ang Quantity',
                filterConditionList: 'Filter Condition:',
                sampleRuleStr: 'Kondisyon ng sampling',
                timeGreaterThan: 'Mas malaki ang oras',
                timeLessThan: 'Mas mababa ang oras',
            },
        },
        customFilters: {
            createdAt: 'Oras ng talk',
            customerId: 'Customero',
            agentId: 'Servisyo ng Customero',
            userGroupId: 'Grupo ng Servisyo ng Customero',
            state: 'Status',
            lastEvaluateUserId: 'Huling Rater',
            submitTime: 'Huling Oras ng Pagpasok',
            totalScore: 'Total score',
            formItemForbidIdList: 'Mga Prohibited Items',
            formItemDeadlyIdList: 'Fatal Item',
        },
        samplingInspection: {
            callTime: 'Oras ng talk',
            dialogTime: 'Oras ng dialogo',
            originator: 'Lahating Persona',
            createTime: 'Oras ng paglika',
            updateTime: 'Pag-update ng oras',
            status: 'Status ng proseso',
            score: 'Fraction',
            actions: 'Operasyong',
            reviewer: 'Reviewer',
            samplingOfficer: 'Sampling inspector',
            id: 'Call log ID',
            time: 'Oras ng talk',
            phone: 'Customer Phone',
            staff: 'Servisyo ng Customero',
            inspectionStatus: 'Status ng Inspection ng kality',
            samplingStatus: 'Status ng sampling',
            inspectionGrade: 'Rating',
        },
        smartWordsLibrary: {
            synonymWords: {
                standardWords: 'Standard na sala',
                synonymWords: 'Mga synonyms',
                synonymWordsNumber: 'Bilang ng mga synonyms',
                useFrequency: 'Frequency ng paggamita',
                effectiveness: 'Effectiveness',
                operation: 'Operasyong',
            },
            common: {
                useFrequency: 'Frequency ng paggamita',
                effectiveness: 'Effectiveness',
                operation: 'Operasyong',
            },
            professionalWords: {
                professionalWords: 'Professional Noun',
                useFrequency: 'Mga statistika ng paggamita',
                homophonic: 'Mga mainit na salita (homophone substitution)',
                target: 'Pagpapalit ng pangalan',
                targetWords: 'Palitan ang mga salat',
                homophonyWords: 'Salitang masking ng homophone',
                operation: 'Operasyong',
            },
            attentionWords: 'Mga salita na nababahalan',
            ignoreWords: 'Hindi pinapansin ang mga salat',
            wordsWeight: {
                selfDefineWeightWords: 'Custom Weight Words',
                weightWords: 'Mga salita',
                weight: 'Bigaga',
                useFrequency: 'Frequency ng paggamita',
                effectiveness: 'Effectiveness',
                operation: 'Operasyong',
            },
            corpusData: {
                corpusDescription: 'Paglalarawan ng corpus',
                updateTime: 'Pag-update ng oras',
                wordsCount: 'Bilang ng mga salat',
                effectiveness: 'Effectiveness',
                operation: 'Operasyong',
                corpusContent: 'Nilaon',
            },
        },
        semanticTags: {
            title: 'Semantic label a',
            tags: 'Karaniwang pangungunan',
            orgName: 'Organisasyong',
            tagCount: 'Bilang ng pagsasanayan',
            usingCount: 'Bilang ng mga references',
            activeFlag: 'Effectiveness',
            suggestion: 'Mga rekomendasyon sa pagsasanay',
            actions: 'Operasyong',
        },
        intelligentTags: {
            tagName: 'Pangang',
            tagDesc: 'Paglalarawan',
            tagRefCnt: 'Bilang ng mga marka',
            categoryName: 'Label',
            eventName: 'Klasipikasyon ng kaganapan',
            tagStatus: 'Effectiveness',
            actions: 'Operasyong',
            tagType: 'Type ng Label',
        },
        dataPreprocess: {
            name: 'Pangang',
            desc: 'Paglalarawan',
            dataSource: 'Limits ng Source Data',
            type: 'Type',
            status: 'Effectiveness',
            actions: 'Operasyong',
        },
        informationEntities: {
            name: 'Pangang',
            apiName: 'API',
            type: 'Type',
            remark: 'Paglalarawan',
            activeFlag: 'Effectiveness',
            actions: 'Operasyong',
        },
        interactiveRecognition: {
            questionAndAnswer: 'Karaniwang Katanungan at sagot',
            type: 'Type',
            status: 'Status',
            actions: 'Operasyong',
            question: 'Katanungan',
        },
        role: {
            id: 'ID',
            name: 'Pangang',
            actions: 'Operasyong',
        },
        uploadDownload: {
            taskName: 'Pangalan ng files',
            createTime: 'Petsan',
            size: 'Lakin',
            createUserName: 'Operator',
            status: 'Status',
            result: 'Resulta',
            actions: 'Operasyong',
        },
        taskCenterList: {
            name: 'Nilalaman ng gawas',
            createTime: 'Oras ng Pagpapalagay',
            startTime: 'Simulan Oras',
            endTime: 'End Oras',
            createUserName: 'Operator',
            status: 'Status',
            result: 'Resulta',
            actions: 'Operasyong',
        },
        customerInformation: {
            title: 'Impormasyon sa Servisyo ng Customero',
            data: 'Tingnan ang Data ng Exception Lama',
            list: {
                agentNo: 'ID ng Job ID/Customer Service ID',
                agentName: 'Servisyo ng Customero',
                agentTel: 'Telepono',
                agentEmail: 'E-mail',
                updateTime: 'Pag-update ng oras',
                actions: 'Operasyong',
            },
            upload: {
                second: '2. Click ang button ng Import upang i-upload ang EXCEl file na sumusunod sa format ng template',
            },
        },
        IndexManagement: {
            title: 'Metrics Managements',
            list: {
                indicatorName: 'Pangang',
                indicatorDesc: 'Paglalarawan',
                activity: 'Effectiveness',
                inspectDataSource: 'Source ng Data',
                sysType: 'Type',
                agentGroups: 'Grupo ng Servisyo ng Customero',
                actions: 'Operasyong',
            },
            detail: {
                nameEmpty: 'Hindi maaaring walang laman ang pangan',
                descript: 'Paglalarawan',
                descriptEmpty: 'Hindi maaaring walang laman ang paglalarawan',
                active: 'Effectiveness',
                activeEmpty: 'Hindi maaaring walang laman',
                dataSource: 'Source ng Data',
                dataSourceEmpty: 'Hindi maaaring walang laman ang source ng data',
                grounp: 'Grupo ng Servisyo ng Customero',
                grounpEmpty: 'Ang grupo ng agent ay hindi maaaring walang laman',
                grounpHolder: 'Mangyaring pumili ng grupo ng ahento',
                type: 'Paraan ng Scoring',
                typeNone: 'Hindi maaaring walang laman',
                base: 'Punto ng pundasy',
                baseNone: 'Ang base score ay hindi maaaring walang laman',
                positive: 'Positive factors',
                positiveNone: 'Ang positibong factor ay hindi maaaring walang laman',
                customAdd: 'Dagdag ang filt',
                negative: 'Negative factors',
                negativeNone: 'Ang mga negatibong kadahilanan ay hindi maaaring walang laman',
                customOK: 'Filter Criteria:',
                judgeStrategy: 'Panuntunan ng kondisyon:',
                other: 'Iba pang mga kadaka',
                otherAdd: 'Dagdag ang factor:',
                agent: 'Raw datas',
                section: 'Bilang ng mga agwata',
                sectionNone: 'Bilang ng mga agwat ay hindi maaaring walang laman',
                step: 'Interval step',
                stepNone: 'Interval step',
                save: 'Pag-save',
                cancel: 'Kansela',
            },
        },
    },
    enums: {
        gongRolesTypes: {
            all: 'Lahat',
            staff: 'Tanging ang aking sarili...',
            department: 'Departamento at ibaba na',
        },
        gongStatisticsDate: {
            week: 'Linggon',
            month: 'Buwana',
            season: 'Season',
        },
        gongCoachTaskStatus: {
            wait: 'Upang mentorer',
            already: 'Coached',
            ignore: 'Hindi pinapansina',
        },
        callRangeStatus: {
            all: 'Lahat ng mga tawag',
            sale: 'Inisimula ang empleyador',
            customer: 'Inisyal ang Customero',
        },
        todoListType: {
            later: 'Pakikinig mamaya',
            help: 'Pareke para sa tulong...',
            contact: 'Pag-ugnay mamaya',
            send: 'Papadala ng datas',
            warn: 'Peligroso maagang babalan',
        },
        frequencyTypes: {
            everyDay: 'Araw-araw',
            everyWeek: 'Linggon',
            everyMonth: 'Buwanan',
        },
        classifiedTraing: {
            trainTypeList: {
                noneDataTrain: 'Unclassified Data Training a',
                markedDataCorrigenda: 'Labeled Data Errata',
                classifiedDataCheck: 'Klasified Verification ng Data',
                markedHistoryRecord: 'Kasaysayan ng Callout',
                historyDataRecalculate: 'Recalc Historical Data',
            },
            dataExtractMode: {
                random: 'Ganap na Randoma',
                intelligentRecommend: 'Intelligent rekomend',
                custom: 'Pasawa',
                specifiedClass: 'Ipinakilala ang Classifications',
            },
            smartRatesList: {
                markRate: 'Rate ng marka',
                corrigendaRate: 'Errata rate',
                kl: 'Divergence ng K-L',
                signalNoiseRate: 'Signal-to-noise ratio',
            },
        },
        visibleRangeTypes: {
            all: 'Lahat',
            customerGroup: 'Grupo ng Servisyo ng Customero',
            userDefined: 'Pasawa',
        },
        samplingRateTypes: {
            everyDay: 'Guhit araw-araw',
            everyWeek: 'Linggo draw',
        },
        taskRemindTypes: {
            confirm: 'Magpadala ng paalala kapag kailangang kumpirmahin ang rekord ng task ng kalidad ng inspeksyon.',
            appeal: 'Kapag nagsisimula ang rekord ng task ng kalidad ng inspeksyon, magpadala ng paalala.',
        },
        weekDays: {
            monday: 'Luneso',
            tuesday: 'Martesday',
            wednesday: 'Miyerkulo',
            thursday: 'Huwebeson',
            friday: 'Biyernest',
            saturday: 'Sabadon',
            sunday: 'Linggoy',
        },
        reportDateTypes: {
            dailyReport: 'Araw-araw-araw',
            weeklyReport: 'Linggo na Reporto',
        },
        samplingRangeDayTypes: {
            today: 'Ngayon...',
            yesterday: 'Kahapan',
        },
        samplingRangeWeekTypes: {
            thisWeek: 'Sa linggo na ito',
            lastWeek: 'Nakaraang linggo.',
        },
        samplingRuleTypes: {
            proportion: 'Proporsyonal na sampling',
            random: 'Random sampling',
        },
        taskStatusTypes: {
            waitEvaluate: 'Bilang pagsusuri',
            waitSubmit: 'Upang ipasa',
            waitConfirm: 'Upang kumpirman',
            waitReview: 'Upang suriin',
            completed: 'Kumpleto',
            all: 'Lahat',
        },
        qualityInspectionForm: {
            formTemplateTypes: {
                directScore: 'Direct Rating',
                weightedScore: 'Timbang Score',
                deductScore: 'Deductions',
                directScoreSecondLevel: 'Direct Rating-Level 2',
                weightedScoreSecondLevel: 'Weght Score-Level 2',
                deductScoreSecondLevel: 'Points Deduction-Level 2',
            },
        },
        fieldOperators: {
            is: 'Katumbas',
            not: 'Hindi katumbas',
            contains: 'Naglalando',
            notContains: 'Hindi naglalaman',
            not_contains: 'Hindi naglalaman',
            containsAny: 'Naglalaman ng anun',
            contains_any: 'Naglalaman ng anun',
            is_any: 'Naglalaman ng anun',
            not_any: 'Walang naglalaman ng anun',
            notContainsAny: 'Walang naglalaman ng anun',
            not_contains_any: 'Walang naglalaman ng anun',
            containsAll: 'Naglalaman ng lahatan',
            contains_all: 'Naglalaman ng lahatan',
            notContainsAll: 'Hindi naglalaman ng lahatan',
            nont_contains_all: 'Hindi naglalaman ng lahatan',
            isNull: 'Walang laman',
            is_null: 'Walang laman',
            isNotNull: 'Hindi lamang',
            is_not_null: 'Hindi lamang',
            greaterThan: 'Malakin',
            greater_than: 'Malakin',
            greaterThanEq: 'Mas malaki kaysa o katumban',
            greater_than_eq: 'Mas malaki kaysa o katumban',
            lessThan: 'Mas maa',
            less_than: 'Mas maa',
            lessThanEq: 'Mas mababa sa o katumbas',
            less_than_eq: 'Mas mababa sa o katumbas',
            between: 'Sa pagitan',
            notBetween: 'Hindi...',
            not_between: 'Hindi...',
            relative: 'Katumbas',
            set: 'Ito',
            belongs: 'Belong',
            notBelongs: 'Hindi nabibilangan',
            not_belongs: 'Hindi katumbas',
            today: 'Ngayon...',
            yesterday: 'Kahapan',
            the_day_before_yesterday: 'Ang araw bago kahangan',
            tomorrow: 'Bukas.',
            next_seven_day: 'Ang susunod na pitong araw...',
            last_seven_day: 'Huling pitong araw...',
            this_week: 'Sa linggo na ito',
            next_week: 'Susunod na lingggo',
            last_week: 'Nakaraang linggo.',
            this_month: 'Ang Buwan nao',
            next_month: 'Susunod na buan',
            last_month: 'Nakaraang busan',
            this_year: 'Ngang taonan',
            next_year: 'Susunod na an',
            last_year: 'Nakaraan na',
            exact_match: 'Eksaktong tugman',
            add_value: 'Bagong halaga na idinagga',
            remove_value: 'Ang Halagan',
            set_null: 'Walang laman',
            isAny: 'Arbitrary katumbas',
            notAny: 'Arbitrary hindi katumbas',
            belongTo: 'Belong',
            notBelongTo: 'Hindi nabibilangan',
            hasAny: 'Naglalaman ng anun',
            notHasAny: 'Walang naglalaman ng anun',
            prefixContains: 'Nagsisimula katumbas',
            prefixNotContains: 'Ang simula ay hindi katumbas',
            suffixContains: 'End na katumban',
            suffixNotContains: 'Hindi katumbas',
            nextSevenDay: 'Susunod na 7 araw...',
            lastSevenDay: 'Huling 7 araw...',
            thisWeek: 'Sa linggo na ito',
            nextWeek: 'Susunod na lingggo',
            lastWeek: 'Nakaraang linggo.',
            thisMonth: 'Ang Buwan nao',
            nextMonth: 'Susunod na buan',
            lastMonth: 'Nakaraang busan',
            thisYear: 'Ngang taonan',
            nextYear: 'Susunod na an',
            lastYear: 'Nakaraan na',
            after: 'Mamaya kaysa (kasama ang kasalukuyang araw)',
            before: 'Mas maaga kaysa sa (kasama ang kasalukuyang araw)',
            allMatching: 'Match Lahat',
            allNotMatching: 'Lahat ay hindi tugman',
            hit: 'Hit',
            not_hit: 'Nawalan',
        },
        fieldsOperators: {
            is: 'Katumbas',
            is_null: 'Walang ding',
            head_equal: 'Nagsisimula katumbas',
            tail_equal: 'End na katumban',
            is_not_null: 'Hindi rin laman',
            not: 'Hindi katumbas',
            diff_equal: 'Ang pagkakaiba ay katumbas',
            diff_greater_than: 'Mas malaki ang pagkakaibang',
            diff_greater_than_eq: 'Ang pagkakaiba na mas malaki sa o katumbas',
            diff_less_than: 'Mas mababa ang pagkakaiban',
            diff_less_than_eq: 'Ang pagkakaiba mas mababa sa o katumbas',
            hour_equal: 'Parehong oras.',
            day_equal: 'Kasamay-araw',
            week_equal: 'Kasama sa Linggon',
            month_equal: 'Same Month',
            year_equal: 'Kasamay-taon',
            day: 'Araw',
            minute: 'Minuta',
            hour: 'Oras',
            part_equal: 'Bahagyang katumbas',
        },
        samplingColumnCaptions: {
            created_at: 'Oras ng talk',
            agent_id: 'Servisyo ng Customero',
            get_direction: 'Type ng tawag',
            call_result: 'Mga Resulta ng tawag',
            survey: 'Evaluation',
            derived_from_id: 'Source',
            quit_queue_why: 'Mga Status ng Queuing',
            queuing_duration: 'Pagkuha ng oras',
            talking_seconds: 'Pangalawan',
            ringing_seconds: 'Oras ng singg',
            hangup_by: 'Taawag hang-up party',
        },
        callTypes: {
            callIn: 'Pumasok na tawag',
            callOut: 'Exhale',
            threeParty: '(Tripartite)',
            consultation: '(Consulting)',
            insert: '(Malakas na pagpasok)',
            monitor: '(Pakinig)',
            transfer: '(Transfer)',
            intercept: '(Intercept)',
            transferOutside: '(Lipaglipat sa labas na linya)',
            threePartyOutside: '(Tripartite panlabas na linya)',
            consultingOutside: '(Consult sa labas)',
        },
        callResults: {
            staffAnswer: 'Sagot ng serbisyo ng customer',
            staffNotAnswer: 'Nawala ang serbisyo ng customer',
            customerAnswer: 'Customer Anssword',
            customerNotAnswer: 'Nawala ang customero',
            phoneBusy: 'Abala ang telepono',
            phoneOffline: 'Telepono Offline',
            customerSpeedHangUp: 'Customer Quick Hanging',
            customerHangUp: 'Kustomer hangs up',
            queueTimeout: 'Queue Timeout',
            queueGiveUp: 'Laban sa queuing',
            outlineAnswer: 'Sa labas ng sagot',
            outlineNotAnswer: 'Hindi konektado sa labas',
            noChooseQueue: 'Walang Queue na pinilin',
        },
        defaultSurveys: {
            noEvaluation: 'Hindi sinurid',
            noNeedToEvaluate: 'Hindi kailangang sumusula',
        },
        queueStates: {
            queueSuccess: 'Tagumpay sa queue',
            queueTimeout: 'Queue Timeout',
            queueGiveUp: 'Laban sa queuing',
            noStaffOnline: 'Walang serbisyo sa online sa customer',
        },
        callHangers: {
            customer: 'Customero',
            staff: 'Servisyo ng Customero',
            outline: 'Sa labas',
        },
        workFlowTypes: {
            noAppealsMode: 'Walang Grievance Mode',
            appealsMode: 'Pahintulutan ang appeal',
        },
        fieldCategories: {
            standardCondition: 'Standard Filter Criterias',
            customerCondition: 'Mga kritera ng filter na tinutukoy ng user',
        },
        sampleTypes: {
            automatic: 'Awtomatikong sampling',
            manual: 'Manual samplings',
        },
        defaultFields: {
            createdAt: 'Oras ng talk',
            agentId: 'Servisyo ng Customero',
            getDirection: 'Type ng tawag',
            callResult: 'Mga Resulta ng tawag',
            survey: 'Evaluation',
            derivedFrom: 'Source',
            quitQueueWhy: 'Mga Status ng Queuing',
            queuingDuration: 'Pagkuha ng oras',
            talkingSeconds: 'Pangalawan',
            ringingSeconds: 'Oras ng singg',
            hangupBy: 'Taawag hang-up party',
        },
        conditionFieldCategories: {
            fixedField: 'Fixed Fields',
            customField: 'Custom Fields',
            secondLevelScore: 'Pangalawan',
            formItemScore: 'Score item',
            forbids: 'Mga Prohibited Items',
            deadlies: 'Fatal Item',
        },
        columnFieldCategories: {
            agent: 'Servisyo ng Customero',
            callLog: 'Pagrekord ng tawag',
            businessFields: 'Impormasyon sa negosyon',
            customer: 'Customero',
            customerCustomFields: 'Customer Customization',
            source: 'Source',
            queue: 'Queue',
            fixed: 'Fixed',
            secondLevelScore: 'Pangalawan',
            formItemScore: 'Score item',
            forbids: 'Mga Prohibited Items',
            deadlies: 'Fatal Item',
        },
        taskListDefaultFields: {
            startTime: 'Oras ng talk',
            name: 'Servisyo ng Customero',
            state: 'Status',
            totalScore: 'Total score',
            formItemForbidList: 'Mga Prohibited Items',
            formItemDeadlyList: 'Fatal Item',
            comment: 'Mga Remarks',
            inspector: 'Ratings',
            review: 'Reviewer',
        },
        evaluationStates: {
            initial: 'Inisyalisayon',
            waitEvaluate: 'Bilang pagsusuri',
            evaluated: 'Upang ipasa',
            waitConfirm: 'Upang kumpirman',
            waitCheck: 'Upang suriin',
            complete: 'Kumpleto',
        },
        workBenchInfoTypes: {
            callInfo: 'Impormasyon sa tawag',
            businessInfo: 'Impormasyon sa negosyon',
            customerInfo: 'Impormasyon sa Customero',
        },
        evaluationEventStates: {
            create: 'Bukhay',
            valuate: 'Evaluation',
            edit: 'Pag-edita',
            submit: 'Submissions',
            confirm: 'Pagkumpirma',
            appeal: 'Complaint',
            checkConfirm: 'Review konfirmon',
            check: 'Review',
        },
        formItemTypes: {
            direct: 'Direct Rating',
            weight: 'Bigaga',
            deduct: 'Deductions',
            forbid: 'Mga Prohibited Items',
            deadly: 'Fatal Item',
        },
        appealCheckCallTypes: {
            callIn: 'Pumasok na tawag',
            callBack: 'Dalawang paraan na callback.',
            callOut: 'Outcall Direct Dial',
            autoCall: 'Awtomatiko na outbound calle',
        },
        appealCheckCallStatus: {
            waitReview: 'Upang suriin',
            reviewed: 'Reviewe',
            filed: 'Archived',
        },
        samplingStatus: {
            all: 'Lahat',
            unchecked: 'Hindi tiniting ang extraction',
            checked: 'Sampling',
        },
        inspectionStatus: {
            all: 'Lahat',
            unread: 'Hindi binasa',
            readed: 'Basaan',
            appeal: 'Complaint',
            review: 'Review',
            filed: 'Archived',
        },
        gradeChooseHits: {
            yes: 'Oo,',
            no: 'Hindin',
        },
        appealCheckStatus: {
            all: 'Lahat ng Status',
            unread: 'Hindi binasa',
            inComplaint: 'Sa Complaint',
            reviewed: 'Reviewe',
            readed: 'Basaan',
            filed: 'Archived',
            spotchecked: 'Sampling',
        },
        flowStatus: {
            unread: 'Hindi binasa',
            alreadyRead: 'Basaan',
            complaining: 'Sa Complaint',
            reviewed: 'Reviewe',
            sampling: 'Hindi tiniting ang extraction',
            samplingCompleted: 'Sampling',
            complainCancel: 'Revokd',
        },
        complainStatus: {
            success: 'Tagumpan',
            fail: 'Bigo',
            default: 'Sa Complaint',
            canceled: 'Revokd',
        },
        reviewInspectionStatus: {
            inComplaint: 'Sa Complaint',
            reviewed: 'Reviewe',
        },
        gradeChangeTypes: {
            edit: 'Pag-edita',
            check: 'Review',
            file: 'Pag-archive',
            remark: 'Mga pahayaga',
            complain: 'Complaint',
            review: 'Review',
            reviewEvaluation: 'Pagsusuri',
            sample: 'Random inspekyon',
            sampleEvaluation: 'Sampling inspeksyon at pagsusuri',
            sampleSubmit: 'Sampling inspeksyon at submissions',
            sampleAssign: 'Pag-alok ng sampling',
            reviewAssign: 'ALLOCATION',
            read: 'Basaan',
            reviewConfirm: 'Review konfirmon',
            sampleConfirm: 'Pagkumpirma ng inspeksyon ng sampling',
            caseBase: 'Idagdag sa Case Group...',
            sampleCancel: 'Sampling Cancel Assignment',
            reviewCancel: 'Review Cancellation',
            sampleAgain: 'Sampling Reallocation',
            reviewAgain: 'Review Reassignment',
            btachDelete: 'Alisin ang mga rekord ng inspekyon',
            rapidSampling: 'Mabilis na sampling',
            reInspection: 'Re-inspection',
            smartTagsChange: 'Smart Label',
            cancelAppeal: 'Pag-alis ng reklamo',
        },
        appealTypes: {
            transliterationError: 'Error sa transcribe',
            discriminationError: 'Erli sa paghuhugan',
            otherError: 'Iba pang mga errora',
        },
        inspectDataSources: {
            voiceCall: 'Tawag ng Voice',
            textDialogue: 'Teksto dialog',
            realTimeVoiceCall: 'Mga tawag ng totoong oras',
            realTimeTextDialogue: 'Mga pag-uusap sa oras ng teksto',
            wechatDialogue: 'Enterprise micro-session',
            taobao: 'E-commerce Text Dialogue',
            ticket: 'Work Order',
            wechatRadio: 'Enterprise Micro Voice',
        },
        inspectTaskType: {
            all: 'Lahat',
            common: 'Regular na inspeksyon ng kalidado',
            relate: 'Associated Quality Inspection',
        },
        inspectApproveType: {
            all: 'Lahat',
            resolve: 'Pinaaprubahan',
            resolving: 'Sa Repaso',
            reject: 'Hindi ipinasa ang audit',
        },
        dataSourceFlags: {
            all: 'Walang mga paghihigpa',
            voiceCall: 'Tawag',
            textDialogue: 'Dialog',
        },
        smartWordsLibrary: {
            hotWords: 'Mga mainit na salat',
            effective: 'Epektive',
            invalid: 'Hindi bayad',
        },
        activeFlags: {
            effiective: 'Epektive',
            invalid: 'Hindi bayad',
        },
        labelTypes: {
            dimensionLabel: 'Callout Labels',
            classificationLabel: 'Kategory',
        },
        pointTypes: {
            automatic: 'Awtomatikong pagsusural',
            manual: 'Manual na pagsusura',
            interactiveDetection: 'Pagkakita ng pakikipag-ugnayan',
            smartRules: 'Smart Rules',
            machineLearning: 'Sariling mode',
            intelligentModel: 'Intelligent modele',
        },
        pointGradeTypes: {
            radio: 'Single Selecto',
            input: 'Input',
            select: 'Pilit',
            all: 'Nakilala ang lahat',
            any: 'Matugunan ang arbitrary',
            customize: 'Pasawa',
        },
        pointNaChecked: {
            check: 'N/A',
        },
        operatorTypes: {
            keyword: 'Keyword tugman',
            question: 'Interrogative pangungunan',
            regular: 'Regular Expressions',
            context: 'Context duplication',
            semantics: 'Semantiko tugman',
            word: 'Katulad na sala',
            dialogue: 'Interval ng dialog',
            speed: 'Pagkakita ng speech speed',
            grabDetection: 'Snatch detection',
            semanticTags: 'Semantic label a',
        },
        applyRoles: {
            all: 'Lahat',
            customer: 'Customero',
            agent: 'Servisyo ng Customero',
            robot: 'Robot',
        },
        saleApplyRoles: {
            all: 'Lahat',
            customer: 'Customero',
            agent: 'Employa',
        },
        applyOperatorScopes: {
            all: 'Buong teksto',
            preCondition: 'Prekondisyong',
            scope: 'Tinukoy na rango',
        },
        keywordScopes: {
            all: 'Tinitik ang lahat ng keywords.',
            any: 'Detekta ang arbitrary keywords',
        },
        preOperatorHitTypes: {
            first: 'Unang Match',
            every: 'Bawat tugman',
            last: 'Huling Match',
            any: 'Anumang tugman',
            none: 'Hindi tugman',
        },
        operatorRuleTypes: {
            all: 'Nakilala ang lahat',
            any: 'Matugunan ang arbitrary',
            custom: 'Custom Logic',
        },
        informationEntityTypes: {
            system: 'Sistema',
            custom: 'Pasawa',
            moduleCompany: 'Module',
        },
        organizationTypes: {
            null: 'Walan',
            moduleCompany: 'Module',
        },
        customType: {
            smartTag: 'Extract Entities',
            scriptTimes: 'Paglalang ng pagsasaka',
            dataCategory: 'Klasipikasyon ng data',
        },
        interactiveQuestionTypes: {
            standard: 'Standard Q & A',
            multiElement: 'Multi-element tanong at sagot',
            guideMultiRound: 'Guided multi-wheel',
        },
        targetTypes: {
            all: 'Lahat',
            customerService: 'Servisyo ng Customero',
            customer: 'Customero',
        },
        interactiveTypes: {
            similarQList: 'Katulad na probleman',
            exceptSimilarQList: 'Alisin ang mga katulad na problema...',
            similarAList: 'Katulad na sagot',
            wrongAList: 'Maling sagot',
        },
        filterTypes: {
            call: 'Pagrekord ng tawag',
            dialogue: 'Teksto sa dialogo',
            wechat: 'Enterprise WeChat',
            wechatAll: 'Enterprise WeChat All Dialogue',
            ticket: 'Session ng Work Order',
            taobao: 'E-commerce',
            wechatRadio: 'Enterprise Micro Voice',
        },
        fieldTypes: {
            keyword: 'Keywords',
            agent: 'Servisyo ng Customero',
            agentGroup: 'Grupo ng Servisyo ng Customero',
            sigleListbox: 'Single Selecto',
            multiListbox: 'Maramihang pagpipilia',
            text: 'Single linya ng teksto',
            textArea: 'Maraming linya ng teksto',
            dateTime: 'Oras',
            number: 'Digitala',
            voice: '',
            customer: 'Customero',
            fieldWithLink: 'Field na may link',
            percentage: 'Percentage',
            intelligentClassification: 'Intelihente na klasis',
            testSetList: 'Test Set Dynamic Fields',
            inspector: 'Quality inspector',
        },
        saveTypes: {
            save: 'Pag-save',
        },
        knowledgeType: {
            oneToOne: 'Isang tanong at isang sagot',
        },
        updateTypes: {
            update: 'Update',
            saveAs: 'Pag-save',
        },
        recommendItemActionTypes: {
            similar: 'Katulad',
            exclude: 'Exclude',
            ignore: 'Ipandiwalan',
        },
        gradeStatus: {
            unread: 'Hindi binasa',
            alreadyReview: 'Reviewe',
            alreadyFiled: 'Archived',
            waitReview: 'Upang suriin',
            alreadyRead: 'Basaan',
        },
        qualityCheckDetailTypes: {
            review: 'Review',
            spotCheck: 'Random inspekyon',
        },
        sampleAndReviewStatus: {
            init: 'Hindi kinuhan',
            unread: 'Hindi binasa',
            alreadyRead: 'Basaan',
            complaining: 'Sa Complaint',
            reviewed: 'Reviewe',
            sampling: 'Hindi tiniting ang extraction',
            samplingCompleted: 'Sampling',
        },
        interactiveAnswerTypes: {
            noAnswer: 'Walang nakita na sagot',
            answer: 'Nakita ang sagot',
            wrongAnswer: 'Natuklasan ang hindi tamang sagot',
        },
        interactiveMatchedQuestionTypes: {
            noQuestion: 'Walang mga problema ang nakita...',
            question: 'Natuklasan ang probleman',
            eliminateQuestion: 'Natuklasan ang Problema sa kaguluhan',
        },
        isManual: {
            yes: 'Manual na inspeksyon ng kalidado',
            no: 'Walang manual na inspeksyon ng kalidado',
        },
        readStatus: {
            yes: 'Basaan',
            no: 'Hindi binasa',
        },
        reInspectionType: {
            recalcScore: 'Mulilkula ang marka lamang (na may ratings)',
            recheckPoint: 'Mulilkulate ang Quality Inspection Points and Scores',
        },
        common: {
            processingTime: 'Oras ng pagproseso',
            noResponseFromCustomerService: 'Walang tugon mula sa serbisyo ng customer',
            businessRecords: 'Mga tala ng negosyon',
            customFields: 'Custom Fields',
            flyingBookGroupChat: 'Flying book group chat',
            associatedWorkOrder: 'Associated Work Order',
            dataSourceManagement: 'Management ng source ng datas',
            qualityInspectionList: 'Listahan ng Inspection ng Quality',
            reviewList: 'Listahan',
            samplingList: 'Listahan ng sampling',
            theRobotAnswers: 'Ang robot ay sumasagot.',
            voiceOfCustomer: 'Voice of Customer',
            questionnaire: 'Questionnaires',
            originalSoundManagement: 'Orihinal na Sound Management.',
            eCommerceReview: 'E-Commerce Review',
            socialMediaComments: 'Mga Komento ng Social MediaName',
            mixedQualityInspection: 'Mixed Quality Inspection',
            videoCall: 'Video tawag',
            customer: 'Customero',
            customerService: 'Servisyo ng Customero',
            robot: 'Robot',
            customerInformation: 'Impormasyon sa Customero',
            workOrderFields: 'Job Fields',
            intelligentConversationAnalysis: 'Analysis ng inteligent session',
            insightIntoBusinessWeaknessesListenToCustomerVoicesAndEnhanceMarketingTransformation: 'Ang pananaw sa maikling board ng negosyo, makinig sa tinig ng mga customer, pagpapabuti ng pagbabago sa marketing',
            intelligentAccompanyingPractice: 'Smart sparrings',
            createImmersiveAIAccompanimentExercisesThatSimulateRealBusinessScenariosEnablingAllEmployeesToMasterGoldMedalScriptsAndQuicklyImproveDialogueSkills: 'Lumikha ng isang paglubos na AI na nagsimula ng mga tunay na tanawin sa negosyo upang makamit ang buong mastery ng mga kakayahan sa pagsasalita ng gintong medalya at mabilis na pagpapabuti ng diyalogo. mga kasanayan.',
            intelligentQualityInspection: 'Intelligent quality inspeksyo',
            fullQualityInspectionTimelyAndEfficientWithAccuracyRateAbove: 'Buong inspeksyon ng kalidad, sa panahon at epektibo, na may katumpakan na higit sa 85%',
            salesEmpowerment: 'Pagbebentas',
            aIReshapesSalesManagementRealizesDigitalAndVisualCommunicationProcessTransparentlyManagesEveryLinkOfSalesIntelligentlyInsightIntoEveryStepOfCommunicationFinelyDiagnosesBusinessProblemsAndPerfectlyReplicatesSalesExperience: 'Ang AI ay nagbabago ng pagbebenta ng pagbebenta, napagtanto ang digitalization at visualization ng proseso ng komunikasyon, transparent na namamahala ang bawat link ng benta, Matalino na nakikita ang bawat hakbang ng komunikasyon, delikadong diagnose ang mga problema sa negosyo, at perpektong muling binabago ang karanasan sa pagbebenta.',
            algorithmPlatform: 'Algorithm platforme',
            basedOnSelfdevelopedOriginalHeartEngineVoiceSemanticsASRAndNLPModelCustomizationGetThroughBusinessScenarioDataRealizeSystemSelflearningAndAchieveTheGoalOfMoreIntelligentAndMoreAccurateWhenUsed: 'Batay sa pagsasalita semantika ng sariling binuo ng orihinal na puso, Ang mga modelo ng ASR at NLP ay naaayos upang makakuha ng data ng senaryo ng negosyo at matanto ang sistema ng sariling pag-aaral, upang makamit ang layunin ng mas matalino at mas tumpak na paggamit.',
            generalSettings: 'Pangkalahatang Settings',
            unifiedSettingAndManagementOfDataPermissionsAndEmployeeRoles: 'Itakda at pamahalaan ang mga pahintulot sa data at mga papel ng empleyado sa isang pinag-isang paraan',
            callLog: 'Pagrekord ng tawag',
            intelligentRules: 'Smart Rules',
            customFilter: {
                call: 'Tawag ng Voice',
                text: 'Teksto dialog',
                smartTags: 'Smart Label',
                pretreatment: 'Pretreatment:',
                smartTagGroup: 'Smart Label',
                currency: 'Pangkalahatang Data',
                wechat: 'Enterprise WeChat',
                spotCheck: 'Random inspekyon',
                personaField: 'Listahan ng Customers',
                ticket: 'Session ng Work Order',
                taobao: 'E-commerce',
                wechatRadio: 'Enterprise Micro Voice',
                reviewList: 'Review',
            },
            talkerRecognitionType: {
                API: 'API Identifies Track Role',
                text: 'Pagkilala sa teksto',
            },
            operatorTypes: {
                keyword: 'Keyword tugman',
                question: 'Interrogative pangungunan',
                regular: 'Regular Expressions',
                context: 'Context duplication',
                semantics: 'Semantiko tugman',
                word: 'Katulad na sala',
                dialogue: 'Interval ng dialog',
                speed: 'Pagkakita ng speech speed',
                grabDetection: 'Snatch detection',
                semanticTags: 'Semantic label a',
                keywordStrict: 'Tumutang sa keyword (strict)',
                link: 'Link Field',
                entityInfoDetection: 'Detekta ng entity entity',
                basicInfoDetection: 'Pangunahing detekta ng impormasyong',
                volume: 'Pagkakita ng volume nume',
                emotion: 'Sentiment analysisa',
                grammar: 'Mga patakaran sa gramatika',
                sentenceLength: 'Pagkakita ng haba ng pangungus',
                conceptWord: 'Mga salitang konsepto',
                questionsAndAnswers: 'Knowledge Base Solution (luma)',
                element: 'Mga Mahalagang Katanungan at sagot',
                silent: 'Timeout ng Respons',
                associate: 'Follow-the-road datas',
                repeat: 'Mulit ang padalhan',
                timeInterval: 'Interval Durasyon',
                typoDetection: 'Typo detection',
                silentOld: 'Katahimika',
                knowledge: 'Solusyon ng kaalamang',
                wecomRemark: 'Mga panghayag sa enterprise ng mga mikrobyo',
                customerAddTime: 'Customer Add Times',
            },
            keywordOperators: {
                all: 'Match Lahat',
                allNot: 'Lahat ay hindi tugman',
                any: 'Anumang tugman',
            },
            applyRoles: {
                all: 'Lahat',
                customer: 'Customero',
                agent: 'Servisyo ng Customero',
            },
            sentenceLength: {
                less: 'Mas maa',
                greater: 'Malakin',
                equal: 'Katumbas',
                greater_or_equal: 'Mas malaki kaysa o katumban',
                less_or_equal: 'Mas mababa sa o katumbas',
            },
            dialogueApplyScopes: {
                differentRoles: 'Sa pagitan ng iba\'t ibang role',
                agent: 'Servisyo ng Customero',
                customer: 'Customero',
                agentResponse: 'Customer Responses',
                customerResponse: 'Customer Responses',
                customerNoResponse: 'Hindi tumutugon ang customer',
            },
            applyConditionHitTypes: {
                first: 'Ang unang hit.',
                every: 'Bawat hit.',
                last: 'Huling Hit',
            },
            applyConditionScopes: {
                current: 'Kasalukuyan',
                before: 'Bago',
                after: 'Pagkatapos',
                beforeAll: 'Lahat bago',
                afterAll: 'Pagkatapos ng lahatan',
                around: 'Malapit',
            },
            voiceDemoTypes: {
                singleChannel: 'Single Channel Call Recording',
                dualChannel: 'Dual-channel call recording',
            },
            sendStatus: {
                sending: 'Nagpapasa',
                arrive: 'Inihatid',
                fail: 'Sawi ang pagpadalas',
                off_sending: 'Offline Magpadala ng Un basat',
                off_arrive: 'Basaan',
                rollback: 'Inalist',
            },
            collectionMethod: {
                assignment: 'Direktang pagtatalagan',
                entity: 'Entity Extraction',
            },
            systemTypes: {
                qa: 'Intelligent quality inspeksyo',
                wfm: 'Intelligent schedulm',
            },
            entityOperators: {
                equals: 'Katumbas ng impormasyong',
                notEquals: 'Hindi katumbas sa impormasyong',
                contains: 'Naglalaman ng impormasyong',
                notContains: 'Walang impormasyong',
                equalsFix: 'Katumbas sa nakapirming halagan',
                notEqualsFix: 'Hindi katumbas sa nakapirming halaga',
                containsFix: 'Naglalaman ng mga nakapirming halaga',
                notContainsFix: 'Hindi naglalaman ng isang nakapirming halag',
            },
            basicInfoOperators: {
                equals: 'Katumbas',
                notEquals: 'Hindi katumbas',
                contains: 'Naglalando',
                notContains: 'Hindi naglalaman',
                isNull: 'Walang laman',
                isNotNull: 'Hindi lamang',
            },
            volumeDetectionWays: {
                loudness: 'Loudness decibel',
                rangeAbilitySelf: 'Range ng pagbabago (sa ginawa ko sa nakaraang pangungusap)',
                rangeAbilityOth: 'Range ng pagbabago (sa paghahambing sa pangungusap sa itaas)',
                rangeAbility3: 'Range ng pagbabago (sa kaysa sa pangungusap na ito)',
            },
            volumeDetectionOperators: {
                is: 'Katumbas',
                not: 'Hindi katumbas',
                greaterThan: 'Malakin',
                greaterThanEq: 'Mas malaki kaysa o katumban',
                lessThan: 'Mas maa',
                lessThanEq: 'Mas mababa sa o katumbas',
            },
            sentimentTypes: {
                positive: 'Positive emosyon',
                negative: 'Mga negatibong emosyon',
                neutral: 'Neutral emosyon',
                thankful: 'Salamata',
                happy: 'Maligaya',
                complaining: 'Complaint',
                angry: 'Galit',
                post: 'Sa haran',
                negat: 'Negative',
                neut: 'Neutral',
            },
            emotionOperators: {
                is: 'Sumusunod',
                not: 'Hindi sumusunod',
            },
            propTypes: {
                system: 'Sistema',
                user: 'Pasawa',
            },
            valueTypes: {
                text: 'Tekstos',
                number: 'Digitala',
            },
        },
        tasks: {
            agent: 'Agente',
            assignToDesignatedPersons: 'Itagal sa mga Tao',
            bigModelRules: 'Big Model Rules',
            topicAnalysis: 'Analysis ng paksa',
            customerService: 'Servisyo ng Customero',
            addAutomatically: 'Awtomatiko ang pagdagsa',
            createAQualitySparringTask: 'Lumikha ng kalidad na sparring gayo',
            forcedCustomerServiceOffline: 'Pinilit na serbisyo ng customer offline',
            allowCustomGrievance: 'Pahintulutan ang pasadya',
            businessSummary: 'Buktad sa negosyon',
            theDayBeforeYesterday: 'Ang araw bago kahangan',
            assessActionTypes: {
                reassess: 'Re-valuasyon',
            },
            scoreType: {
                aiScore: 'Matalinong pagsusuri',
                manualScore: 'Manual na pagsusura',
                interactiveDetection: 'Pagkakita ng pakikipag-ugnayan',
                smartRules: 'Smart Rules',
                machineLearning: 'Sariling mode',
            },
            inspectType: {
                inspectTrue: 'Pagsuri',
                inspectFalse: 'Hindi tinuna',
            },
            operatorType: {
                keyword: 'Keyword tugman',
                notKeyword: 'Pangunahing magkabagay',
            },
            applyRole: {
                all: 'Lahat',
                customer: 'Customero',
                agent: 'Servisyo ng Customero',
            },
            applyScope: {
                all: 'Lahat',
                specific: 'Tinukoy na pangungunan',
                scope: 'Tinukoy na rango',
            },
            judgeStrategy: {
                all: 'Matugunan ang lahat ng kondisyon',
                arbitrarily: 'Matugunan ang anumang kondisyon',
                custom: 'Custom Logic',
            },
            checkPointStatus: {
                waitFor: 'Naghihintay ang pagsusuri',
                notDeductScore: 'Walang deduction',
                deductScore: 'Deductions',
            },
            applyOptions: {
                hit: 'Condition hit',
                notHit: 'Walang mga kondisyon ang natukoy',
            },
            gradeTypes: {
                yesOrNo: 'Sumusunod',
                input: 'Manual input',
                level: 'Pagsusuri',
                multipleFactors: 'Maraming elementos',
            },
            gradeChooseHits: {
                yes: 'Oo,',
                no: 'Hindin',
            },
            gradeChangeTypes: {
                edit: 'Pag-edita',
                check: 'Review',
                file: 'Pag-archive',
                remark: 'Mga pahayaga',
                complain: 'Complaint',
                review: 'Review',
                reviewEvaluation: 'Pagsusuri',
                sample: 'Random inspekyon',
                sampleEvaluation: 'Sampling inspeksyon at pagsusuri',
                sampleSubmit: 'Sampling inspeksyon at submissions',
                sampleAssign: 'Pag-alok ng sampling',
                reviewAssign: 'ALLOCATION',
                read: 'Basaan',
                reviewConfirm: 'Review konfirmon',
                sampleConfirm: 'Pagkumpirma ng inspeksyon ng sampling',
            },
            gradeStatus: {
                unread: 'Hindi binasa',
                alreadyReview: 'Reviewe',
                alreadyFild: 'Archived',
                waitReview: 'Upang suriin',
                alreadyRead: 'Basaan',
            },
            samplingFrequencyTypes: {
                everyDay: 'Araw-araw',
                everyWeek: 'Linggon',
                everyMonth: 'Buwanan',
            },
            samplingEveryDayTimeTypes: {
                yesterday: 'Kahapan',
                today: 'Ngayon...',
            },
            samplingEveryWeekTimeTypes: {
                thisWeek: 'Sa linggo na ito',
                lastWeek: 'Nakaraang linggo.',
            },
            samplingEveryMonthTimeTypes: {
                thisMonth: 'Ang Buwan nao',
                lastMonth: 'Nakaraang busan',
            },
            samplingTypes: {
                random: 'Random sampling',
                proportional: 'Proporsyonal na sampling',
            },
            weekdays: {
                Monday: 'Luneso',
                Tuesday: 'Martesday',
                Wednesday: 'Miyerkulo',
                Thursday: 'Huwebeson',
                Friday: 'Biyernest',
                Saturday: 'Sabadon',
                Sunday: 'Linggoy',
            },
            distributeTypes: {
                rule: 'Pag-alok ng prioritasyo',
                average: 'Average random distribution',
            },
            notMatchAnyRuleTypes: {
                random: 'Random average distribution',
                assign: 'Itagal sa mga Tao',
                ignore: 'Huwag magbigay',
            },
            inspectorTypes: {
                all: 'Lahat ng mga inspektor ng kalida',
                some: 'Tinukoy na inspector ng kalidado',
            },
            pushFrequencyTypes: {
                everyDay: 'Araw-araw',
                everyWeek: 'Linggon',
                everyMonth: 'Buwanan',
                inspectionUpdate: 'Pag-update ng inspeksyon sa kality',
                timelyInspection: 'Inspeksyon ng real-time quality',
            },
            pushObjectTypes: {
                email: 'Ang Mailbox',
                staff: 'Serbisyo ng customer',
            },
            reviewOptions: {
                reviewResult: 'Ipakita ang mga resulta ng inspeksyon sa kalidad sa panahon ng pagsusuri',
                reviewRecord: 'Ipakita ang mga relevante na talaan sa panahon ng pagsusuri',
                reviewAgentHidden: 'Itago ang impormasyon sa ahente sa panahon ng pagsusuri',
                samplingResult: 'Ipakita ang mga resulta ng inspeksyon sa kalidad habang random inspekyon',
                samplingRecord: 'Ipakita ang mga may kaugnayan sa panahon ng random inspekyon',
                sampleAgentHidden: 'Itago ang impormasyon sa serbisyo ng customer sa panahon ng random inspekyon',
                checkExportAddCallInfoIphone: 'Alkayin ang mga log ng call kapag nag-export ng lista',
                sampleExportAddCallInfoIphone: 'Alkayin ang mga log ng call kapag nag-export ng lista',
                checkExportAddCallInfoText: 'Gamit ang mga tala ng pag-uusap kapag nag-export ng listang',
                sampleExportAddCallInfoText: 'Gamit ang mga tala ng pag-uusap kapag nag-export ng listang',
                inspectionExportAddCallInfoIphone: 'Alkayin ang mga talaan ng tawag kapag ang mga listahan ng pag-export (sa hanggang 10000 ay maaaring i-export sa isang oras)',
                inspectionExportAddCallInfoText: 'Dapat ang mga tala ng pag-uusap kapag nag-export ng listahan (hanggang 10000 ay maaaring i-export sa isang oras)',
            },
            fastSampleInDetailList: {
                fastSampleInInspectDetail: 'Pinapayagan na mabilis na gumawa ng mga check ng spot sa mga detalye ng inspeksyon ng kalidado',
                fastSampleInSampleDetail: 'Pahintulutan ang mabilis na pagpapatupad ng random inspeksyon sa mga detalye ng random inspekso',
                fastSampleInReviewDetail: 'Pinapayagan ang mabilis na pagpapatupad ng mga check ng spot sa mga detalye ng pagsusuri',
            },
            permitCustomReasonList: {
                permitCustomReason: 'Hayaan ang mga custom dahilan para sa mga claims',
            },
            autoMateTasks: {
                autoLoad: 'Awtomatiko ang pagdagsa',
                sample: 'Awtomatikong inspeksyon sa sampling',
                assign: 'Awtomatikong allocations',
                pushes: 'Awtomatiko na push',
                assess: 'Awtomatikong pagtatasa',
                check: 'Pagsusuri ng grievance',
                case: 'Synchronization ng kas library',
            },
            qualityCheckDetailTypes: {
                review: 'Review',
                spotCheck: 'Random inspekyon',
            },
            appealTypes: {
                transliterationError: 'Error sa transcribe',
                discriminationError: 'Erli sa paghuhugan',
                otherError: 'Iba pang mga errora',
            },
            inspectDataSources: {
                voiceCall: 'Tawag ng Voice',
                textDialogue: 'Teksto dialog',
                realTimeVoiceCall: 'Mga tawag ng totoong oras',
                realTimeTextDialogue: 'Mga pag-uusap sa oras ng teksto',
            },
            pointTypes: {
                automatic: 'Awtomatikong pagsusural',
                manual: 'Manual na pagsusura',
                interactiveDetection: 'Pagkakita ng pakikipag-ugnayan',
            },
            pointGradeTypes: {
                radio: 'Single Selecto',
                input: 'Input',
                select: 'Pilit',
            },
            sampleAndReviewStatus: {
                init: 'Hindi kinuhan',
                unread: 'Hindi binasa',
                alreadyRead: 'Basaan',
                complaining: 'Sa Complaint',
                reviewed: 'Reviewe',
                sampling: 'Hindi tiniting ang extraction',
                samplingCompleted: 'Sampling',
            },
            wayOverUpperLimits: {
                ignoreExcessSpillover: 'Hindi pinapansin ang labis na overflow',
                automaticWeightCalculation: 'Awtomatikong weight accounting',
            },
            calculateScoreTypes: {
                add: 'Mga bonus points',
                sub: 'Minus points',
            },
            naChecked: {
                check: 'Ang item na ito ay hindi kasangkot sa pagpapahintulot',
            },
            pointNaChecked: {
                check: 'N/A',
            },
            interactiveRules: {
                proportional: 'Percentage points',
                allRight: 'Lahat ng tamang points',
                anyRight: 'Anumang tamang markan',
            },
            noHitQuestionResults: {
                true: 'Ang resulta ay "Oo"',
                false: 'Resulta ay "Hindi"',
            },
            repetRules: {
                same: 'Ang nilalaman ay eksakto',
                similar: 'Pagkatulad ng semantic',
            },
            relateConditions: {
                highlightQuestion: 'Ang Problema',
                highlightAnswer: 'Ang sagot',
                hightlightFoctors: 'Ang Elemento',
            },
            interactiveQuestionTypes: {
                question: 'Natuklasan ang probleman',
                eliminateQuestion: 'Natuklasan ang Problema sa kaguluhan',
            },
            interactiveAnswerTypes: {
                noAnswer: 'Walang nakita na sagot',
                answer: 'Nakita ang sagot',
                wrongAnswer: 'Natuklasan ang hindi tamang sagot',
            },
            inspectionUpdateTypes: {
                autoInspection: 'Awtomatikong inspeksyon ng kalidado',
                autoInspectionWechat: 'Awtomatikong pagsusuri',
                artificialSampling: 'Manual samplings',
                artificialReview: 'Manual review',
                manualModification: 'Mabilis na sampling',
                timelyInspection: 'Inspeksyon ng real-time quality',
                samplingAssign: 'Pag-alok ng sampling',
                artificialComplain: 'Pagpapatibay ng Grievances',
                fastSampling: 'Quick Sampling Inspection and Submissions',
                recheckInspection: 'Re-inspection',
                recheckInspectionWechat: 'Re-analysisy',
            },
            timelyInspectionTypes: {
                timelyInspection: 'Inspeksyon ng real-time quality',
            },
            pushActionTypes: {
                email: 'Mail',
                interfacePush: 'Interface Push',
            },
            pushDetailWays: {
                riskAlert: 'Alart ng Risk',
                subscribe: 'Subscribe sa mga mensahes',
            },
            riskAlertPushDataTypes: {
                dialogueMessage: 'Mensahe ng call/Conversation messages',
                inspectionResults: 'Mga resulta ng inspeksyon sa kalida',
            },
            subscribePushDataTypes: {
                dialogueMessage: 'Mensahe ng call/Conversation messages',
                textContent: 'Ang nilalaman ng teksto ng mga tawag/pag-uusap',
                inspectionResults: 'Mga resulta ng inspeksyon sa kalida',
            },
            pushRequestMethods: {
                post: 'POST',
            },
            pushContentTypes: {
                json: 'JSON',
            },
            notMatchPreRule: {
                average: 'Average score sa loob ng grupop',
                addOrSubtract: 'Direct plus o minus points',
                noChange: 'Walang plus o minus points',
            },
            defaultScore: {
                empty: 'Walang laman',
                add: 'Mga bonus points',
                notAdd: 'Walang karagdagang points',
                sub: 'Minus points',
                notSub: 'Walang mababa ang points',
                na: 'N/A',
                input: 'Manual input',
                choose: 'Pilit',
            },
            strategyTypes: {
                hitAdd: 'Hit Bonus',
                hitNotAdd: 'Walang mga puntos para sa pag-hitt',
                hitSub: 'Hit minus points',
                hitNotSub: 'Hindi mababawasan ang mga punto ng Hit...',
            },
        },
        download: {
            exportStatus: {
                prepare: 'Sa paghahandan',
                process: 'Sa paglaon',
                faild: 'Nabigo ng pag-exporto',
                success: 'Tagumpan',
            },
        },
        messageType: {
            all: 'Lahat',
            monitor: 'Agad na pagsunod',
            trigger: 'Trigger Notifications',
            timing: 'Report ng times',
        },
        messagePushType: {
            all: 'Lahat',
            system: 'Mga Mensahe ng Sistema',
            sdk: 'SDK',
            push: 'Interface Push',
            email: 'Mail',
            udesk: 'Mga pabaliko',
            udeskWhite: 'Pagbabasa ng sistema ng serbisyo ng Customero',
            weChat: 'Enterprise micro-message',
        },
        autoAddPushTarget: {
            sampleAssignInspector: 'Assign Sampling Inspector',
            sampleInspector: 'Sampling inspector',
            assignReviewer: 'Assign reviewer',
            reviewer: 'Reviewer',
            taskInspector: 'Task Inspector',
        },
        sdkPushType: {
            webHook: 'Standard webhook',
            dingDing: 'DingTalk robots',
            weChat: 'Enterprise WeChat Robot',
            customer: 'Custom Json Contente',
        },
        inspectionRemarksType: {
            inspection: 'Quality Inspection',
            check: 'Random inspekyon',
            review: 'Review',
        },
        segmentationStrategyType: {
            count: 'Bilang ng mga mensahes',
            spacing: 'Interval ng message',
        },
        segmentationStrategy: {
            byTime: 'Segmentasyon ng oras',
            customize: 'Kombinasyon slicing',
        },
        inspectType: {
            commonInspect: 'Regular na inspeksyon ng kalidado',
            associateInspect: 'Associated Quality Inspection',
        },
        typoDetectionOperators: {
            less: 'Mas maa',
            greater: 'Malakin',
        },
        autoAddTypes: {
            realTimeAdd: 'Idagdag sa totoong oras',
            timingAdd: 'Pagdagdag ng oras',
        },
        messageTypes: {
            text: 'Text Messae',
            markdown: 'Markdown Mensahe',
        },
        inServiceStatus: {
            activated: 'Aktibon',
            disabled: 'Naka-disabled',
            inactivated: 'Hindi Aktibon',
            resigned: 'Lumabas mula sa enterprise',
        },
        roles: {
            agent: 'Employa',
            customer: 'Customero',
        },
        commentVisibleAuthority: {
            all: 'Makikita sa lahat',
            self: 'Makikita lamang sa sarilin',
            designation: 'Pinakakitang Persona',
        },
        appealCheckingTask: {
            agent: 'Agente',
            flyingBookGroupChat: 'Flying book group chat',
            finalAppeal: 'Final Appeal',
            largeModel: 'Malaking modelon',
            overdueReview: 'Labis na pagsusuri',
            questionnaire: 'Questionnaires',
            eCommerceReview: 'E-Commerce Review',
            socialMediaComments: 'Mga Komento ng Social MediaName',
            mixedType: 'Mixed types',
            videoCall: 'Video tawag',
            customModel: 'Custom Modelo',
            universalModel: 'Generic modele',
            enterpriseWeChatText: 'Enterprise micro-text',
            generalQualityInspection: 'Pangkalahatang inspeksyon ng kalidado',
            processQualityInspection: 'Proseso ng Quality Inspection',
            voiceCopy: 'Voice double disk',
            beEqualTo: 'Katumbas',
            notEqualTo: 'Hindi katumbas',
            canAppeal: 'Maaaring apela',
            noAppeal: 'Walang apelal',
        },
        wechat: {
            redEnvelopes: 'Pulang envelope',
            text: 'Tekstos',
            picture: 'Larawn',
            voice: 'Voice',
            voiceCall: 'Tawag ng Voice',
            video: 'Videos',
            businessCard: 'Business card',
            position: 'Lokasyong',
            expression: 'Ekresyon',
            link: 'Links',
            applet: 'Maliit na program a',
            chatRecord: 'Chat records',
            mixedMessage: 'Mixed Messagee',
            file: 'Talaan:',
        },
        gong: {
            sessionActivity: 'Session Activity',
            conversationAction: 'Session',
            riskSemantics: 'Peligro semantics',
            daysNotFollowedUp: 'Mga Araw Hindi Sumusunod',
            waysideData: 'Follow-the-road datas',
            notStarted: 'Hindi Nagsimula',
            completed: 'Kumpleto',
            haveInHand: 'Sa paglaon',
            unpublished: 'Hindi inilathalan',
            published: 'Inilathalan',
            knowledgePoints: 'Mga puntos ng kaalaman',
            technologicalProcess: 'Prosos',
            notMarked: 'Hindi Labeled',
            inAnnotation: 'Sa callout',
            annotated: 'Labeled',
        },
        qualityChecingTask: {
            appealCanceled: 'Nakansela ang apelal',
            complaintExpired: 'Nagwawak',
            incomingCall: 'Pumasok na tawag',
            exhale: 'Exhale',
            incomingCallthirdParty: 'Pagdating call (tatlo-way)',
            incomingCallconsultation: 'Inoming call (Consulting)',
            incomingCallforcedInsertion: 'Nagpapasok na tawag (malakas)',
            incomingCallmonitoring: 'Nagpapasok na tawag (pakinig)',
            incomingCalltransfer: 'Inoming call (Transfer)',
            incomingCallinterception: 'Nagpapasok na tawag (intercept)',
            incomingCalltransferToExternalLine: 'Nagpapasok na tawag (paglilipat sa labas ng linya)',
            incomingCallthirdPartyExternalLine: 'Ang papasok na tawag (tatlong daanan sa labas ng linya)',
            incomingCallexternalLine: 'Nagpapasok na tawag (consulting sa labas ng linya)',
            outgoingCallthirdParty: 'Paglabas (tatlong daan)',
            outgoingCalltransfer: 'Outcoming (Transfer)',
            outgoingCallforcedInsertion: 'Paglabas (pilitan)',
            outgoingCallmonitoring: 'Outcoming (pakinig)',
            outgoingCallinterception: 'Lalabas na tawag (intercept)',
            outgoingCalltransferToExternalLine: 'Outbound (paglipat sa labas ng linya)',
            outgoingCallthreePartyExternalLine: 'Lalabas na tawag (tatlong daanan sa labas ng linya)',
            customerServiceAnswer: 'Sagot ng serbisyo ng customer',
            customerServiceMissed: 'Nawala ang serbisyo ng customer',
            customerAnswer: 'Customer Anssword',
            customerMissed: 'Nawala ang customero',
            theTelephoneIsBusy: 'Abala ang telepono',
            phoneOffline: 'Telepono Offline',
            customerQuickHanging: 'Customer Quick Hanging',
            clientHangsUp: 'Kustomer hangs up',
            queueTimeout: 'Queue Timeout',
            giveUpQueuing: 'Laban sa queuing',
            outsideLineAnswering: 'Sa labas ng sagot',
            externalLineIsNotConnected: 'Hindi konektado sa labas',
            noQueueSelected: 'Walang Queue na pinilin',
            notEvaluated: 'Hindi sinurid',
            noEvaluationRequired: 'Hindi kailangang sumusula',
            queuingSucceeded: 'Tagumpay sa queue',
            noCustomerServiceOnline: 'Walang serbisyo sa online sa customer',
            customer: 'Customero',
            customerService: 'Servisyo ng Customero',
            outsideLines: 'Sa labas',
        },
        sessionActivity: {
            single: 'Average na oras ng solong tawag',
            all: 'Kabuuang tawag',
            allTime: 'Kabuuang tagal',
        },
        sessionAction: {
            salesProportion: 'Percentage ng Sales Talk',
            salesLongest: 'Average ang pinakamahabang pahayag ng pagbebent',
            customerLongest: 'Average ang pinakamahabang pagsasalita ng customer',
            discussNumber: 'Bilang ng malalim na talakayan',
            frequency: 'Frequency ng tanong',
        },
        monitorCriteria: {
            all: 'Bago at pagkatapos',
            before: 'Bago',
            after: 'Pagkatapos',
        },
        monitorTimeCycle: {
            day: 'Araw',
            week: 'Linggon',
            month: 'Buwana',
        },
        monitorGroupTestType: {
            ab: 'Paghahambing ng dalawang grupos',
            a: 'Grupo A',
            b: 'Grupo B',
        },
        fields: {
            customerServiceDepartment: 'Departamento ng Servisyo ng Customero',
            belongToDepartment: 'Nabibilang sa departamento...',
            doesNotBelongToTheDepartment: 'Ay hindi nabibilang sa departamento...',
            department: 'Departamento',
            customerTags: 'Customer Label',
            member: 'Mga miyel',
            time: 'Oras',
            cascade: 'Cascade',
            anyMatch: 'Anumang tugman',
            keyWord: 'Keywords',
            keyEvents: 'Mga pangunahing pangyayarin',
        },
        semanticIntelligence: {
            staff: 'Employa',
            customer: 'Customero',
            employeesAndCustomers: 'Mga empleyado at Customers',
            notStarted: 'Hindi Nagsimula',
            haveInHand: 'Sa paglaon',
            completed: 'Kumpleto',
            callRecording: 'Pagrekord ng tawag',
            enterpriseWeChatCall: 'Enterprise Micro-Talk',
            enterpriseWeChatText: 'Enterprise micro-text',
            discourseMiningForObjectionHandling: 'Objection Handling Speech Mining',
            productSellingPointScriptsMining: 'Pagbebenta ng produkt',
            conversationScenario: 'Session Scenarios',
            topicOfConversation: 'Paksaan',
            keyEvents: 'Mga pangunahing pangyayarin',
            customerLabel: 'Customer Label',
            includeAny: 'Naglalaman ng anun',
            includeAll: 'Isipin ang Lahta',
            and: 'At',
            or: 'O',
            question: 'Interrogative pangungunan',
            nonInterrogativeSentence: 'Hindi interrogative na pangungunan',
        },
        coach: {
            comprehensiveScore: 'Comprehensive score',
            comprehensiveScoreCourseQuality05LearningEffect02InteractiveExperience: 'Komprehensibong score = 0.3 * kalidad ng kurso 0.5 * epekto sa pag-aaral 0.2 * interactive na karanasang',
            courseQuality: 'Kalidad sa kurso',
            learningEffect: 'Epekto sa pag-aaral',
            interactiveExperience: 'Interactive Experiens',
            greaterThanOrEqual: 'Mas malaki kaysa o katumban',
            lessThanOrEqual: 'Mas mababa sa o katumbas',
            equal: 'Katumbas',
            smartSparring: 'Smart sparrings',
            intelligentQualityInspection: 'Intelligent quality inspeksyo',
            notPassed: 'Hindi lumipasa',
            analogTelephone: 'Analog Telepono',
            enterScenarioInformation: 'Magbigay ng impormasyon sa scenario',
            generateDialogueFramework: 'Pagbuo ng framework ng dialogo',
            generatePromptLanguage: 'Prompt na binuo',
            aIGeneratedDialogue: 'AI Generated Dialogog',
            system: 'Sistema',
            custom: 'Pasawa',
            flow: 'Prosos',
            script: 'Mga salat',
            express: 'Ekresyon',
            emotion: 'Emosyon',
            rateAccordingToCourseConfiguration: 'Score sa pamamagitan ng kurso',
            intelligentModelRating: 'Smart Model Scoring (Smart Model Scoring)',
            allData: 'Lahat ng datas',
            dataFromThisDepartment: 'Data ng Departamento',
            multidepartmentalData: 'Multi-sector',
            underReview: 'Sa Repaso',
            no: 'Hindin',
            yes: 'Oo,',
            automaticRating: 'Awtomatiko na Scoring',
            auditRating: 'Audit Score',
            reRating: 'Re-scoring',
            inAppeal: 'Sa Complaint',
            reviewed: 'Reviewe',
            notViewed: 'Hindi Tinas',
            viewed: 'Tinawan',
            uncorrected: 'Hindi nababago',
            corrected: 'Naayos',
            practice: 'Ehersisyon',
            examination: 'Examinasyon',
            other: 'Iba',
            notMeetingStandards: 'Hindi hanggang sa karaniwang',
            meetingStandards: 'Standard na',
            excellent: 'Mahusay',
            invalid: 'Nabio',
            notStarted: 'Hindi Nagsimula',
            haveInHand: 'Sa paglaon',
            ended: 'Endad',
            completed: 'Kumpleto',
            hangInTheAir: 'Hindi tapo',
            passed: 'Pasad',
            voiceConversation: 'Dialog ng Voice',
            textDialogue: 'Teksto dialog',
            slidePresentation: 'Slide presentasyong',
            unpublished: 'Hindi inilathalan',
            published: 'Inilathalan',
            narration: 'Narrator',
            studentSpeaking: 'Pagsasalita ng Cadeta',
            robotTalk: 'Robots ay nagsasalita.',
            knowledgeBaseQA: 'Knowledge Base Q & A',
            slide: 'Slide',
            negativeEmotions: 'Negatibong emosyon',
            emotionallyNormal: 'Normal na mood',
            incompleteScript: 'Hindi kumpleto',
            completeScript: 'Kumpletong pagsasabit',
            normalSpeechSpeed: 'Normal bilis',
            speakTooFast: 'Masyadong mabilis ang pagsasalita...',
            speakTooSlowly: 'Masyadong mabagal',
            whole: 'Lahat',
            singlePage: 'Single Paer',
            qA: 'Isang tanong at isang sagot',
            situationalDialogue: 'Sitwasyonal dialog',
            misses: 'Nawalan',
            hit: 'Hit',
            sequentialQA: 'Sequential Q & A',
            randomQA: 'Mga Katanungan',
            mastered: 'Mastering',
            notMastered: 'Hindi mastered',
        },
        algorithm: {
            salesEmpowerment: 'Pagbebentas',
            enterpriseWeChatVoice: 'Enterprise WeChat Voice',
            enterpriseWeChatText: 'Enterprise WeChat Text',
            waiting: 'Naghihintay',
            extracting: 'Sa extractions',
            success: 'Tagumpan',
            fail: 'Bigo',
            intelligentQualityInspection: 'Intelligent quality inspeksyo',
            textDialogue: 'Teksto dialog',
            voiceCall: 'Tawag ng Voice',
            smartTags: 'Smart Label',
            satisfactionEvaluation: 'Pagsusuri ng kasiyahang',
            score: 'Rating',
            grade: 'Rating',
            customerServiceTeam: 'Grupo ng Servisyo ng Customero',
            conversationAnalysis: 'Pag-uusal',
        },
        operatorListGather: {
            falseClosing: 'Maling pagsarad',
            largeModelSemanticMatching: 'Malaking modelo ng semantiko',
            system: 'Sistema',
            customerInformation: 'Impormasyon sa Customero',
            audio: 'Audio',
            videoSound: 'Video Sounds',
            videoScreen: 'Video scren',
            videoFile: 'Video File',
            voiceMessage: 'Voice Messages',
            picture: 'Larawn',
            documentation: 'Dokumentasyon',
            workOrderInformation: 'Impormasyon sa Work Order',
            semanticMatching: 'Semantiko tugman',
            specifiedTime: 'Tinukoy na oras',
            externalInterfaceDetection: 'Panlabas na detection ng interfaces',
            robot: 'Robot',
            intelligentModel: 'Intelligent modele',
            businessSummary: 'Buktad sa negosyon',
            firstSentence: 'Unang pangungunan',
            lastSentence: 'Huling pangungunan',
            allTime: 'Lahat ng Oras',
            nonBusinessWorkingHours: 'Mga oras na hindi negosyon',
            businessWorkingHours: 'Oras ng trabaho sa negosyon',
        },
        callDialogueManage: {
            flyingBookGroupChat: 'Flying book group chat',
            videoCall: 'Video tawag',
            questionnaire: 'Questionnaires',
            originalSoundManagement: 'Orihinal na Sound Management.',
            eCommerceReview: 'E-Commerce Review',
            socialMediaComments: 'Mga Komento ng Social MediaName',
        },
        user: {
            voiceRobotOutcall: 'Voice Robot Outcall',
            workOrder: 'Work Order',
        },
        dataPreprocess: {
            ecommerceSessionQualityInspection: 'E-commerce',
        },
        connectedByConversation: {
            workOrder: 'Work Order',
        },
    },
    pages: {
        auth: {
            welcome: '',
            copyRight: '',
            login: {
                name: 'Login',
                email: 'E-mail',
                password: 'Password',
                forgetPwd: 'Nakakalimutan ang Password',
                emailCannotBeEmpty: 'Ang mailbox ay hindi dapat walang laman.',
                passwordCannotByEmpty: 'Hindi dapat walang laman ang password.',
                mustChangeLogin: 'Pasensya, dapat i-reset ang iyong password, mangyaring makipag-ugnay sa iyong administrator upang i-reset ang iyong password.',
                dismissionLogin: 'Pahihina ako, ngunit iniwan mo ang iyong trabaho.',
                forbiddenLogin: 'Paumanhin, hindi pinagana ang iyong account.',
                loginError: 'Nabigo ang Login, mailbox o error ng password.',
                loginPrompt: 'Login sa sistema',
                rememberMe: 'Tandaan mo ako...',
            },
            logout: {
                logoutError: 'Nabigo ang paglabas. Suriin ang iyong network koneksyon o subukan muli mamaya.',
            },
            resetPassword: {
                forgetPwd: 'Nakakalimutan ang Password',
                inputEmailPrompt: 'Ilagay ang iyong account email sa ibaba at magpapadala kami sa iyo ng email at tagubilin upang i-reset ang iyong password.',
                sendEmailSuccess: 'Matagumpay na ipinadala ang titik ng pagkumpirma ng password sa email na iyong napuno, mangyaring suriin ito sa oras.',
                sendEmailFailed: 'Nabigo ang mailbox sa pagpadala. Suriin ang iyong network koneksyon o subukan muli mamaya.',
                setNewPassword: 'Itakda ang iyong bagong password',
                passwordCannotEmpty: 'Hindi dapat walang laman ang password',
                passwordFormWrong: 'Maling format ng password',
                confirmPasswordWrong: 'Ang dalawang passwords na ipinasok ay hindi katumbas.',
                passwordResetSuccess: 'Nagtagumpay ang password reset.',
                passwordResetFailed: 'Bigo ang pag-reset ng password. Suriin ang iyong network koneksyon o subukan muli mamaya.',
                linkTimeover: 'Nag-expire ang pag-reset ng password link, mangyaring subukan mulin',
            },
            form: {
                title: 'CASE Form Display',
            },
        },
        public: {
            auth: {
                forgotPassword: {
                    email: 'E-mail',
                    emailFormatError: 'Error sa pag-format ng Mailbox, mangyaring pumasok muli!',
                    forgotPassword: 'Nakalimutan ang iyong password?',
                    describe: 'Ilagay ang iyong account email sa ibaba at magpapadala kami sa iyo ng email at tagubilin upang i-reset ang iyong password.',
                    send: 'Dalan',
                    emailCannotBeEmpty: 'Ang Mailbox ay hindi maaaring walang laman',
                    resetPasswordExpire: 'Nag-expire ang pag-reset ng password link, mangyaring subukan mulin',
                },
                resetPassword: {
                    setPassword: 'Itakda ang iyong bagong password',
                    newPassword: 'Bagong password',
                    repeatPassword: 'Duplicate Password',
                    resetPassword: 'Reset ang Password',
                    passwordCannotBeEmpty: 'Ang bagong password ay hindi maaaring walang laman.',
                    confirmPasswordCannotBeEmpty: 'Hindi maaaring walang laman ang duplicate password.',
                    passwordsNotMatch: 'Dalawang password ay hindi pare-pareho!',
                    passwordFormWrong: 'Ang password ay hindi maaaring sa Tsina, at ang numero ay 6-14!',
                    linkExpiration: 'Nag-expire ang pag-reset ng password link, mangyaring subukan mulin',
                },
            },
            errors: {
                haveNoPermissionWarningText: 'Wala kang pahintulot upang tingnan ang pahina sa',
            },
        },
        downloadCenter: {
            name: 'Download Center.',
            saveTime: '(30 araw sa pamamagitan ng default)',
            headerTitle: 'Download ang Files',
            download: 'Download a',
            downloadPromp: 'Ang gawain ay ipinadala, mangyari pumunt',
            viewProgress: 'Makikita ang Progress',
        },
        uploadCenter: {
            name: 'Upload Center.',
        },
        tasks: {
            index: {
                name: 'Pangang',
                remark: 'Paglalarawan',
                qualityCheckTasksTitle: 'Workbench',
                informationCollection: 'Mga gawain sa koleksyong',
                qualityCheckTasks: 'Gawain sa inspeksyon ng kalida',
                wechatQaTasks: 'Gawain ng analysis',
                moduleName: 'Gumamit ng Template Bago',
                creatNewQualityCheckTask: 'Bagong Gagawa',
                generalInspectionList: 'Pangkalahatang Inspection Report ng Quality',
                editQualityCheckTask: 'I-edit ang kalidad ng inspekyon',
                creatNewQualityCheckTaskError: 'Hindi lumikha ng bagong gawain sa inspeksyon ng kalidad.',
                editQualityCheckTaskError: 'Nabigo sa pag-edit ng gawain sa inspeksyon ng kalidad.',
                type: 'Type ng formo',
                singleScore: 'Single Score',
                singleScoreNullError: 'Hindi maaaring walang laman',
                inspector: 'Quality inspector',
                inspectDataSource: 'Source ng Data',
                taskName: 'Pangalan ng Task',
                inspectionType: 'Uri ng inspeksyon sa kalida',
            },
            manage: {
                screeningCondition: 'Filter Condition:',
                template: {
                    condition: {
                        index: {
                            name: 'Kondisyon',
                            existingConditions: 'Mayroong mga kondisyon',
                        },
                        detail: {
                            id: 'ID',
                            name: 'Pangalan ng ConditionName',
                            remark: 'Paglalarawan',
                            checkRange: 'Range ng detektan',
                            operator: 'Operator',
                            operatorLogic: 'Operator logic',
                        },
                    },
                    checkPointTest: {
                        title: 'Rule Test',
                        running: 'Patakaran sa pagsubok, mangyari mamaya ...',
                        clearSuccess: 'Matagumpay na nawala ang diyalogo ng simulal',
                        mock: 'Simulated dialogue',
                        save: 'I-save ang piniling dialogo',
                        saveAll: 'Ang Lahat ng Pag-uusap',
                        saveSuccess: 'Matagumpay na nai-save ang pag-uusap',
                        close: 'Lumabas',
                        delete: 'Tanggal ang pinilin',
                        clear: 'Walang laman',
                        customer: 'Customero',
                        agent: 'Servisyo ng Customero',
                        test: 'Testo',
                        request: 'Matapos ang simulation dialog ay malinis, hindi ito maaaring ibalik. Sigurado ka bang malinis ito?',
                        deletePopconfirmContent: 'Sigurado mo bang nais mong tanggalin ang piniling dialog?',
                    },
                    checkPoint: {
                        index: {
                            name: 'Rule Configuration',
                            wechatTitle: 'Konfigurasyon ng Analysis Modelo',
                            existingCheckPoints: 'Mga patakaran sa inspeksyon ng kalidado',
                            currentCheckPointScore: 'Ang kasalukuyang marka ng panuntunan sa inspeksyon ng kalidad ay',
                            currentCheckPointScoreWechat: 'Ang kasalukuyang marka ng modelo ng pagsusuri ay',
                            currentCheckPointWeight: 'Ang kabuuang timbang ng kasalukuyang patakaran ng inspeksyon ng kalidad ay',
                            weightTotalScoreAndItemScore: 'Kabuuang marka: 100, iisang marka:',
                            template: 'Template ng Inspection Rule ng kality',
                            import: 'Importasyon ng Quality Inspection Rule Template',
                            getTemplateError: 'Hindi makakuha ng template ng patakaran ng inspeksyon ng kalidad.',
                            tabs: {
                                template: 'Template',
                                demo: 'Samples',
                            },
                            customize: 'Blank Template',
                            move: 'Drag at bumagsak upang ayusin ang klassifikasyon at pag-uuri',
                            classification: 'Klasipikasyon ng inspeksyon ng kalidado',
                            classificationWeChat: 'Klasipikasyon ng Modelo',
                            first: 'Antas 1',
                            second: 'Pangalawan',
                            new: 'Bagong Rule ng Inspection ng Quality',
                            weChatNew: 'Dagdag ang Analysis Modelo',
                            createWeChat: 'Bagong Modelo ng Analysis',
                            empty: 'Walang mga patakaran sa inspeksyon sa kalidad para sa panahong,',
                            wechatEmpty: 'Walang modelo ng pagsusuri,',
                            newSecond: 'Bagong Secondary Classifications',
                            newFirst: 'Bagong klasipikasyon sa unang ansa',
                            checkPoint: 'Mga Panunungkulan sa Inspection ng kality',
                            checkPointWeChat: 'Modelo ng analysis',
                        },
                        detail: {
                            name: 'Pangang',
                            remark: 'Paglalarawan',
                            type: 'Type',
                            deduction: 'Deductions',
                            rule: 'Mga patakan',
                            highlighted: 'Lumilipat',
                            gradeType: 'Paraan ng Scoring',
                            interactiveCategory: 'Klasipikasyon ng pakikipag-ugnayan',
                            predeterminedScore: 'Score',
                            weight: 'Bigaga',
                            na: 'N/A',
                            default: 'Default Score',
                            preRule: 'Patakaran bago',
                            analysisHighlighted: 'Pagpapasa ng mga patakarang',
                            categorySelectPrompt: 'Mangyaring pumili ng kategory',
                            checkHighlightArrayError: 'Ang patakaran ay hindi tumutugma sa highlight, mangyaring mag-click muli ang parse rule button.',
                            foctorsHolder: 'Mangyaring pumili ng elemento',
                            foctorsErrorNone: 'Ang patakaran ng multi-element ay walang laman, mangyaring magdagdag ng multi-element type.',
                            naError: 'Hindi maisara ang item kapag ang default score ay N/A',
                            templateNew: {
                                theLargeModelRulesHaveBeenIntegratedIntoTheIntelligentRulesAndTheSubsequentIterationWillNotBeContinuedForBetterExperienceItIsRecommendedToSwitchToTheIntelligentRules: 'Ang malalaking patakaran ng modelo ay integrated sa mga matalinong patakaran, at ang susunod na iterasyon ay hindi magpapatuloy. Para sa mas mahusay na karanasan, inirerekumenda na lumipat sa matalinong patakaran.',
                                agent: 'Agente',
                                convertToLargeModelRules: 'Pagbabago sa malalaking patakaran ng modelon',
                                bigModelRules: 'Big Model Rules',
                                language: 'Wika',
                                nAIsTheNotApplicableWhichSetsPreconditionsForTheQualityInspectionRuleIfTheConditionIsMetTheRuleIsNotApplicableIfTheConditionIsNotMetTheRuleIsNotDetectedDescriptionOfPreconditionsMeansandMeansorIndicatesNOTFillInTheExampleRR2R3: 'Ang N/A ay ang hindi Applicable, na nagtatakda ng mga precondition para sa patakaran ng inspeksyon ng kalidad. Kung ang kondisyon ay natutugunan, ang patakaran ay hindi naaangkop. Kung hindi natutugunan ang kondisyon, hindi nakita ang patakaran;\nPaglalarawan ng mga preconditions: "&" ibig sabihin ng "at", "| |" ibig sabihin ng "o", "!" Ipinapahiwatig ng "NOT", punan ang halimbawa "(R1 | | R2) & & R3"',
                                applicationMessageType: 'Type ng Mensahe ng Aplikation',
                                selectAll: 'Pilit',
                                highlightTags: 'Mga Laban:',
                                ruleType: 'Type ng panuntaro',
                                dataSource: 'Source ng Data',
                                whole: 'Lahat',
                                enterpriseMicroConversation: 'Enterprise micro-session',
                                enterpriseAndMicroCommunication: 'Enterprise Micro-Talk',
                            },
                            components: {
                                flow: {
                                    flow: {
                                        determineNodes: 'Node ng paghukoma',
                                        dialogueNode: 'Node ng dayalog',
                                        editNodes: 'Pag-edit ng Node',
                                    },
                                    nodeConfig: {
                                        smartRules: 'Smart Rules',
                                        bigModelRules: 'Big Model Rules',
                                        nodeName: 'Node',
                                        nodeRules: 'Node',
                                        scoringLogic: 'Scoring logic',
                                        score: 'Score:',
                                        rule: 'Mga patakan',
                                        multiBranchLogic: 'Multi-branch logic',
                                        highlight: 'Lumilipat',
                                        submit: 'Submissions',
                                    },
                                    ruleList: {
                                        manualConfiguration: 'Manual na pagsasaayos',
                                        dragAndDropConfiguration: 'Pag-drag at pagbaga',
                                        branch: 'Sangaya',
                                        branchName: 'Pangalan ng sangay:',
                                        addRules: 'Dagdag ang Rule',
                                    },
                                    sidebar: {
                                        node: 'Node',
                                    },
                                    hooks: {
                                        useControlButtons: {
                                            automaticOrganization: 'Awtomatikong Pagtatap',
                                            canvasAdaptation: 'Canvas adaptive',
                                            copy: 'Kopyahay',
                                            delete: 'Mangalisa',
                                        },
                                        useFlow: {
                                            determineThatTheChildNodesOfANodeCannotBeUsedAsConnectionTargets: 'Ang bata na node ng paghukom ay hindi maaaring gamitin bilang target ng koneksyon.',
                                            theStartingNodeCannotBeUsedAsAConnectionTarget: 'Ang simula node ay hindi maaaring maging target ng koneksyon',
                                            startingNodeCannotConnectMultipleNodes: 'Hindi maaaring magsimula ang node ng higit sa isang node',
                                            nodeCannotBeConnectedToItself: 'Hindi maaaring koneksyon sa node sa kanyang sarilin',
                                            startNode: 'Simula ang Node',
                                        },
                                    },
                                },
                                msgTypesSelect: {
                                    index: {
                                        cancelSelectAll: 'Kansela ang Lahta',
                                        selectAll: 'Pilit',
                                    },
                                },
                                customModelsSelect: {
                                    index: {
                                        whetherItMeetsTheRequirements: 'Sumusunod',
                                        gradedEvaluation: 'Pagsusuri',
                                    },
                                },
                            },
                        },
                        configuration: {
                            title: 'Mga Panunungkulan sa Inspection ng kality',
                            wechatTitle: 'Modelo ng analysis',
                            neme: 'Pangang',
                            errorMessage: 'Nabigo ang pagtanggal sa hindi bababa sa isang kondisyon',
                            desc: 'Paglalarawan',
                            status: 'Status',
                            yes: 'Epektive',
                            no: 'Hindi bayad',
                            namePlaceHolder: 'Mangyaring ipasok ang pangalan ng label a',
                            desPlaceHolder: 'Mangyaring ipasok ang isang paglalarawan',
                            nameEmpty: 'Hindi maaaring walang laman ang pangan',
                            desEmpty: 'Hindi maaaring walang laman ang paglalarawan',
                            type: 'Type',
                            ruler: 'Smart Rules',
                            machineLearning: 'Sariling mode',
                            autoScore: 'Smart Scoring (luma)',
                            manualScore: 'Manual scorings',
                            interaction: 'Interaction detection (luma)',
                            typeTips: {
                                model: 'Matalinong modelo: Ito ay isang preset quality inspection system, na maaaring mabilis na suriin ang mga problemang mayroon sa serbisyo nang walang pagsasaayos at pagpapanatili. Ang modelo na ito ay mas pangkalahatan, kung hindi mo matugunan ang mga pangangailangan sa negosyo, mangyaring gamitin ang "matalinong patakaran" o "manual scoring."',
                                rule: 'Matalinong patakaran: awtomatikong scoring batay sa panuntunan AI',
                                manual: 'Manual scoring: manual quality inspection, manual scoring sa pamamagitan ng manual',
                            },
                            model: 'Modelo:',
                            ruleType: {
                                words: 'Mga salat',
                                interaction: 'Interaksyon',
                                feature: 'Mga tampokan',
                                information: 'Impormasyon',
                            },
                            testingMode: {
                                all: 'Tinitik ang lahat ng keywords.',
                                any: 'Detekta ang arbitrary keywords',
                            },
                            operatorTypesOfInteraction: {
                                question: 'Isang tanong at isang sagot',
                                element: 'Sagot ng mga elementos',
                                repet: 'Context duplication',
                                snatch: 'Snatch salat',
                                silent: 'Katahimika',
                            },
                            role: 'Papel ng deteksyon:',
                            preposition: 'Pre-operator:',
                            range: 'Range ng detekta:',
                            from: 'Sekson',
                            to: 'Sentence sa No.',
                            end: 'Sentensya',
                            hasOldSilentTip: 'Hello, upang mapabuti ang katumpakan, Ang "Intelligent Rules-Interaction-Silence" ay na-upgrade sa "Response Timeout". Inirerekumenda na i-update ang mga patakaran sa paggamit!',
                            changeToOld: 'Paglipat sa Legacy',
                            changeToNew: 'Paglipat sa bagong bersya',
                            logic: {
                                logic: 'Scoring logic',
                                naTip: 'Ang N/A ay ang hindi Applicable, na nagtatakda ng mga precondition para sa patakaran ng inspeksyon ng kalidad. Kung ang mga kondisyon ay natutugunan, ang patakaran ay hindi naaangkop. Kung hindi natutugunan ang mga kondisyon, hindi nakita ang patakaran.',
                                score: 'Score:',
                                na: 'N/A：',
                                naDes: 'Ang item na ito ay hindi kasangkot sa pagpapahintulot',
                                preRule: 'Mga patakaran sa precondition:',
                                notCatchPreRule: 'Kapag hindi natutugunan ang mga precondition:',
                                naChecked: 'Kapag nag-hit ng N/A:',
                                preRuleEmpty: 'Hindi maaaring walang laman',
                                operatorEmpty: 'Ang kinakailangang kondisyon ay hindi maaaring walang laman sa operat',
                                multipleEmpty: 'Hindi maaaring walang laman ang kinakailangang kondisyon sa maraming score ng logik',
                                average: 'Average score sa loob ng grupop',
                                addOrSubtract: 'Direct plus o minus points',
                                noChange: 'Walang plus o minus points',
                                rule: 'Mga patakaran:',
                                all: 'Nasiyahan ang lahat ng operators',
                                any: 'Nasiyahan ang arbitraryong operatoro',
                                customize: 'Custom Operator Logic',
                                multiple: 'Maraming Logic Score',
                                heightLight: 'Nakaliliwanag:',
                                machineLearningTip: 'Sa kasalukuyan, ang sariling mode ay gumagana lamang para sa pagsasalita ng solong pangyayari. Para sa kumplikadong pagsasalita, mangyaring gumamit ng matalinong patakaran.',
                                strategy: 'Stratehiya:',
                            },
                        },
                        component: {
                            approvalSubmittedSuccessfully: 'Matagumpay na ipinadala ang Approval',
                        },
                        components: {
                            pageHeaderExtra: {
                                test: 'Testo',
                                formal: 'Formal',
                                submit: 'Submissions',
                            },
                            createModal: {
                                index: {
                                    pleaseEnterARuleDescription: 'Mangyaring ipasok ang isang paglalarawan sa patakan',
                                    ruleGeneratedSuccessfully: 'Matagumpay na binuo',
                                    failedToGenerateRule: 'Sawi sa paglikha ng patakaran:',
                                    aIGeneration: 'AI henerasyong',
                                    pleaseEnterTheRuleDescriptionTheContentIsGeneratedByAIForReferenceOnly: 'Mangyaring ipasok ang paglalarawan ng panuntunan. Ang nilalaman ay ginawa ng AI para lamang reference.',
                                    generateRules: 'Bukha ng mga Rula',
                                    myRules: 'Ang aking patakarang',
                                },
                            },
                        },
                    },
                    automaticAdd: {
                        index: {
                            name: 'Automation ng proseso',
                            screeningCondition: 'Filter Condition:',
                            aiScreeningCondition: 'Intelligent Filter Condition',
                            rule: 'Mga patakan',
                            automaticAddition: 'Awtomatiko ang pagdagsa',
                            automaticAdditionTip: 'Awtomatikong idinagdag ang data sa mga gawain sa real time o sa regular na agwat para sa AI inspeksyon ng kalidad.',
                            autoAdd: {
                                autoAddType: 'Awtomatikong pagdagdag ng paraang',
                                addFrequency: 'Dagdag ang frequensy',
                                add: 'Dagdagan',
                            },
                            automaticSamplingInspection: 'Awtomatikong inspeksyon sa sampling',
                            automaticSamplingInspectionTip: 'Awtomatikong pagkuha ng data na nangangailangan ng inspeksyon ng kalidad ng manual, halimbawa, gumawa ng 10% ng random data ng kahapon araw-araw para sa manual na sampling.',
                            everyAgentCheckLimit: 'Maximum draw bawat ahenteno',
                            automaticAllocation: 'Awtomatikong allocations',
                            automaticAllocationTip: 'Ang allocation ng inspeksyon ng sampling: awtomatikong inilalaan ang mga inspektor ng kalidad. Halimbawa, 10% ng mga random data ng kahapon ay nakakuha araw-araw para sa inspeksyon ng manual na sampling, at 2 inspektor ng kalidad ay randomly allocated sa gawaing ito sa average.',
                            automaticAllocationTip2: 'Ang allocation ng pagsusuri: ang data ng appeal ay awtomatikong inilalaan sa inspector ng kalidad para sa pagsusuri, halimbawa, ang pang-araw-araw na data ng appeal ay pantay na nakalaan sa 2 inspektor ng kalidad ng gawain na ito para sa pagsusuri.',
                            automaticPush: 'Awtomatiko na push',
                            automaticPushTip: 'Pagbabasa: notification/alarm sa panahon ng inspeksyon ng kalidad, halimbawa, kapag ang isang nakamamatay na error ay nangyayari sa serbisyo ng customer, isang mensahe ng pagpapakita ay ipinadala sa grupo ng micro na enterprise.',
                            automaticPushTip2: 'Ipinadala ang oras na ulat: Halimbawa, ipadala ang mga resulta ng inspeksyon ng manual na sampling ng kahapon sa mailbox ng supervisor ng serbisyo ng customer sa 9:00 araw-araw.',
                            automaticAssess: 'Awtomatikong pagtatasa',
                            automaticAssessTip: 'Ang mga resulta ng manual na sampling ay regular na kumpara sa mga resulta ng inspeksyon ng kalidad ng AI para sa pagsusuri ng katumpakan. Halimbawa, ang rate ng katumpakan ng data ng sampling ng kahapon ay sinusuri sa 8:00 araw-araw.',
                            reexaminationComplaint: 'Pagsusuri ng grievance',
                            spoktReviewDetail: 'Konfigurasyon ng negosyon',
                            spoktReviewDetailTip: 'Configure ang mga function tulad ng kalidad na listahan ng inspeksyon, listahan ng random inspeksyon, negosyo ng reklamo, listahan ng pagsusuri, at komento',
                            qaDetailAction: 'Configuration ng Quality Inspection Configuration',
                            spoktDetailAction: 'Sampling configuration',
                            reviewDetailAction: 'Review configuration',
                            appealAction: 'Grievance Configuration',
                            remarkTemplate: 'Note Template',
                            automaticArchiving: 'Awtomatikong arkive',
                            conditionalRules: 'Mga Panunungkulan',
                            qualityInspectionConditions: 'Mga Condisyon ng Inspection ng kality',
                            unopened: 'Hindi pa bukas',
                            sampleInspectionDistributionModel: 'Pag-alok ng sampling',
                            reviewAllocationModel: 'ALLOCATION',
                            distributionModelTitle: 'Patakaran sa pag-aalok:',
                            pushRules: 'Path Rules',
                            push: 'Pumpa',
                            assessRules: 'Mga Panunungkulan',
                            on: 'on',
                            off: 'off',
                            updateStatusSuccess: 'Nagbabago ang status!',
                            updateStatusFailed: 'Nabigo ang pagbabago ng status, mangyaring subukan muli mamaya!',
                            sampleNumberOrPercent: 'Number o proporsyon ng sampling',
                            inspectorList: 'Tinukoy na inspector ng kalidado',
                            numberOfSubmission: 'Bilang ng mga representasyon na pinapayagan na ipasugot',
                            rewivewDays: 'Araw',
                            TimeOfSubmission: 'Petsa ng Validity of Submission of Representasyon',
                            rewivewSecond: 'Timess',
                            switchOn: 'Buksa',
                            switchOff: 'Saray',
                            notMatchAnyRule: 'Kapag walang patakaran ay tumutugma:',
                            appealOptionsList: {
                                hiddenInspector: 'Nakatago na impormasyon sa inspector',
                                hiddenHit: 'Ang pahina ng appeal ay sumusuporta sa pagpapakita at pagpoposisyon ng mga hit.',
                            },
                            caseLibrary: 'Synchronization ng kas library',
                            caseLibrarySyncTip: 'Synchronize ang mga kaso na idinagdag ng sistema ng QA sa sistema ng serbisyo ng customer',
                            addCase: 'Pagpapataas ng synchronization',
                            caseLibraryId: 'Case Librarya',
                            caseLibraryIdTip: 'Pag-grupo ng base ng kaso ng sistema ng QA',
                            udeskCaseLibraryIdTip: 'Kaso ng grupo ng sistema ng serbisyo ng customer',
                            syncHis: 'Kaso ng kasaysayan ng synchronos',
                            otherSettings: 'Iba pang mga Settings',
                            udeskCaseLibraryId: 'Push Case Group',
                            url: 'Puksa URL',
                            urlTip: 'Mangyaring ipalagay ang interface address na nagsisimula sa http:// o https://',
                        },
                        templateNew: {
                            resultsView: 'Mga Resulta',
                            afterTheStartOfTheSupportConfigurationResultsAreAvailableAndTheTimingCanBeViewedInRealTimeOrAccordingToTheRegularRules: 'Pagkatapos ng pagbubukas, maaari mong i-configure ang oras ng anunsyo ng pagganap at pagtingin, na maaaring tingnan sa real time o sa pamamagitan ng mga patakaran ng timeing.',
                            topicAnalysis: 'Analysis ng paksa',
                            identifyTheTopicInTheConversationAndCustomizeTheTopicDimensionAccordingToTheBusinessSituation: 'Ipakilala ang paksa sa pag-uusap at ipag-aayos ang dimensyon ng paksa ayon sa sitwasyon ng negosyon',
                            detailDisplayConfiguration: 'Detail Display Configuration:',
                            silenceOver: 'Katahimikan sa buo',
                            displayAtSeconds: 'Ipakita sa segundos',
                            secondaryReview: 'Secondary review',
                            numberOfAppealsAllowedToBeSubmitted: 'Bilang ng mga apela na pinapayagan na ipasmite',
                            validityOfSubmissionOfAppeal: 'Valididad ng pagpapadala ng apelal',
                            validityOfAppealReview: 'Validity of appeal',
                            hours: 'Oras',
                            businessSummary: 'Buktad sa negosyon',
                            eachCustomerServiceRepresentativeCanSelectALowerLimit: 'Mas mababang limitasyon ng extraction bawat ahenteno',
                            automaticallyGenerateBusinessSummariesFromLargeModelsAndCustomizeDimensionsBasedOnBusinessSituations: 'Ang buod ng negosyo ay awtomatikong binuo ng malaking modelo, at ang dimensyon ay maaaring maaga ayon sa sitwasyon ng negosyo.',
                            onlyTheFirstLevelReviewerAllocationStrategy: 'Level 1',
                            secondaryCompounding: 'Pangalawang komposisyon:',
                            secondLevelReviewersOnlySupportAverageDistribution: 'Ang mga pangalawang reviewer ay sumusuporta lamang sa katumbas na distribuy',
                            secondLevelReviewer: 'Pangalawang antas:',
                            samplingInspectionTarget: 'Target ng inspeksyon ng sampling',
                            setTheTargetToBeCompletedByManualSamplingInspectionWhenTheTargetIsNotReachedOrExceededAPromptWillBeGivenForExampleEveryCustomerServiceShouldCompleteSamplingInspectionsEveryMonthWhenTheNumberIsLessThan80APromptWillBeGivenOnTheQualityInspectionAndSamplingInspectionPage: 'Itakda ang target na makumpleto sa pamamagitan ng inspeksyon ng manual na sampling, at magbigay ng agad kapag hindi naabot o lumampas ang layunin. Halimbawa, ang bawat serbisyo ng customer ay dapat kumpletuhin ang inspeksyon ng sampling ng 100 items bawat buwan, at kapag ang target ay mas mababa sa 80 item, ang inspeksyon ng kalidad at page ng inspeksyon ng sampling ay magbibigay kaagad.',
                        },
                        component: {
                            pleaseImproveTheSamplingDeadlineConfiguration: 'Mangyaring pagpapabuti ang pagsasagawa ng deadline ng sampling!',
                            pleaseImproveTheAppealConfiguration: 'Mangyaring mapabuti ang appeal configuration!',
                            displaySilentDuration: 'Ipakita ang Silent Duration',
                            playbarDisplayMood: 'Playbar show mood',
                            playbarDisplaySmartLabel: 'Playbar Display Smart Label',
                            playbarDisplayHitRule: 'Playbar Display Hit Rule',
                            verificationFailed: 'Nabigo ang pag-verifikas',
                            pleaseAddASecondLevelQualityInspector: 'Mangyaring idagdag ang ikalawang antas na inspector',
                        },
                        businessSummary: {
                            components: {
                                field: {
                                    index: {
                                        hintLanguage: 'Prompt',
                                        fieldName: 'Name field',
                                        fieldDescription: 'Paglalarawan sa field',
                                        generateContent: 'Bukha ng nilalamang',
                                        enabled: 'Nakapanggawa',
                                        generationMethod: 'Metod ng henerasyong',
                                        automaticGeneration: 'Awtomatikong binuo',
                                        manualTrigger: 'Manual Trigger',
                                        filterCondition: 'Filter Condition:',
                                        return: 'Bumalik',
                                        preserve: 'Pag-save',
                                    },
                                    components: {
                                        training: {
                                            index: {
                                                generateResults: 'Bukha ng mga Resulta',
                                            },
                                        },
                                    },
                                },
                                contentScope: {
                                    index: {
                                        notQualified: 'Hindi kwalifika',
                                        limitedScope: 'Limited Scope',
                                        add: 'Dagdagan',
                                        thereIsCurrentlyNoDataAvailable: 'Walang datas',
                                    },
                                },
                            },
                            index: {
                                fieldName: 'Name field',
                                fieldDescription: 'Paglalarawan sa field',
                                nothing: 'Walan',
                                generationMethod: 'Metod ng henerasyong',
                                generateManually: 'Bumuha ng manuki',
                                automaticGeneration: 'Awtomatikong binuo',
                                generateContent: 'Bukha ng nilalamang',
                                notQualified: 'Hindi kwalifika',
                                filterCondition: 'Filter Condition:',
                                enabled: 'Nakapanggawa',
                                type: 'Type',
                                system: 'Sistema',
                                custom: 'Pasawa',
                                operation: 'Operasyong',
                                edit: 'Pag-edita',
                                areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                                delete: 'Mangalisa',
                                addField: 'Dagdag ang Fields',
                            },
                        },
                        autoAdd: {
                            index: {
                                addQuestionnaireDataAutomatically: 'Awtomatikong pagdagdag ng datos ng questionnaires',
                                addVideoDataAutomatically: 'Awtomatikong pagdagdag ng video datas',
                                automaticallyAddTextData: 'Awtomatikong pagdagdag ng data ng teksto',
                                addVoiceDataAutomatically: 'Awtomatikong pagdagdag ng datos ng boses',
                                automaticallyAddWorkOrderData: 'Awtomatikong pagdagdag ng data ng order ng trabaho',
                            },
                        },
                        topicAnalysis: {
                            components: {
                                field: {
                                    index: {
                                        topicName: 'Pangalan ng paksan',
                                        topicDescription: 'Paglalarawan ng paksan',
                                        topicTag: 'Topic Tag',
                                    },
                                },
                            },
                            index: {
                                addTopic: 'Dagdag ang paksan',
                                topicName: 'Pangalan ng paksan',
                                topicDescription: 'Paglalarawan ng paksan',
                                topicTag: 'Topic Tag',
                                pleaseEnterATopicName: 'Mangyaring ipasok ang pangalan ng paksan',
                            },
                        },
                        components: {
                            businessConfig: {
                                index: {
                                    moreThanTheValidityPeriodIsNotChecked: 'Higit pa sa panahon ng validity ay hindi nasuri',
                                    dontSetValidityPeriod: 'Huwag itakda ang validity',
                                    setTheValidityPeriodOfRandomInspection: 'Itinakda ang valididad ng random inspekyon',
                                    setTheDeadlineForRandomInspection: 'Itakda ang deadline para sa mga random inspeksyon.',
                                    validityPeriodOfSamplingInspection: 'Ipinag-isay ng pagsisiyasat ng sampling inspekyon',
                                    day: 'Araw',
                                    samplingDeadline: 'Deadline ng sampling',
                                    caseLibraryConfiguration: 'Konfigurasyon ng library ng kaso:',
                                    allowViewingTheCaseLibraryInTheAppealsSDK: 'Pahintulutan ang pagtingin ng kasong library sa apela SDK',
                                    finalConfiguration: 'Final Configuration:',
                                    allowFinalReviewInQualityDetails: 'Pahintulutan ang huling pagsusuri sa mga detalye ng kalida',
                                    aIQualityInspectionResultsCanBeAppealed: 'Maaaring apela ang mga resulta ng inspeksyon ng kalidad ng AI',
                                    theResultsOfManualSamplingCanBeAppealed: 'Ang mga resulta ng manu-manong sampling ay maaaring appealed.',
                                    setAppealDeadline: 'Itakda ang deadline ng apelal',
                                    complaintDeadline: 'Complaint deadlines',
                                    reviewDeadline: 'Review deadlines',
                                    setAppealValidityPeriod: 'Itakda ang appeal',
                                    refreshTheAppealValidityPeriodDuringRandomInspectionOrReinspection: 'Refresh ang appeal validity period sa panahon ng random inspeksyon o re-inspection.',
                                    numberOfAppealsAllowedToBeSubmitted: 'Bilang ng mga apela na pinapayagan na ipasmite',
                                    second: 'Timess',
                                },
                            },
                            autoAssign: {
                                index: {
                                    whenTheSecondlevelReviewAssignerIsEqualToTheFirstlevelReviewSubmiterTheSecondlevelReviewIsAutomaticallyCompleted: 'Kapag ang pangalawang antas ng pagsusuri ay katumbas ng submiter ng unang antas ng review, awtomatikong nakumpleto ang pangalawang antas.',
                                    firstlevelReview: 'Unang-level review',
                                    triggerPolicy: 'Patakaran ng trigger:',
                                    secondaryReviewOnlyWhenPassing: 'Pangalawang pagsusuri lamang kapag nagpasa',
                                    secondaryReviewOfAllResults: 'Pangalawang pagsusuri ng lahat ng mga resultat',
                                },
                            },
                            viewGrade: {
                                index: {
                                    number: 'Numero',
                                    pushTiming: 'Pagpindot',
                                    realtimeViewing: 'Real-time viewing.',
                                    timingView: 'Temping View',
                                    addFrequency: 'Dagdag ang frequensy',
                                    timeRange: 'Oras Range',
                                    pleaseSelect: 'Pakipilin',
                                    filterCriteria: 'Filter Criteria:',
                                },
                            },
                        },
                    },
                    roleConfig: {
                        index: {
                            name: 'Role Configuration',
                            roleConfigTip: 'Ginagamit upang mai-configure ang mga patakaran sa pagkilala para sa pagproseso ng paghihiwalay ng speaker kapag ang na-import na data ng tawag ay mono. Sumusunod sa mga patakaran para sa papel ng ahento',
                            operator: 'Operator',
                            operatorLogic: 'Operator logic',
                        },
                    },
                    manualAdd: {
                        index: {
                            name: 'Magdagdag ng manuki',
                            tip: 'Ginagamit upang filter ng preview data sa pamamagitan ng manu-manong pag-ayos ng mga kriterya at mabilis na idagdag ito sa kalidad na gawain ng inspekyon',
                            screeningCondition: 'Idagdag sa pamamagitan ng Filter Criterias',
                            aiScreeningCondition: 'Intelligent Filter Condition',
                            rule: 'Mga patakan',
                            createTime: 'Dagdag ang Oras',
                            filterTitle: 'Filter Contents',
                            filterRule: 'Filter Condition:',
                            startTime: 'Simulan Oras',
                            endTime: 'End Oras',
                            records: 'Importasyong',
                            createUserName: 'Operator',
                            successCount: 'Nagdagdag ng matagumpayan',
                            conditionRule: 'Panuntunan ng kondisyon:',
                            preview: 'Preview a',
                            previewData: 'Sa kasalukuyan, may {0} na tumutugma sa mga kriter ng filter, {1} ay idinagdag ang mga gawain, maaaring idagdag ang {2} gawain, at ang {3} na gawain ay hindi maaaring idagdag.',
                            failCount: 'Sawi ang pagdagdag',
                        },
                    },
                    basicInfo: {
                        index: {
                            title: 'Pangunahing impormasyong',
                            name: 'Pangang',
                            taskName: 'Pangalan ng Task',
                            taskNamePlaceholder: 'Mangyaring ipasok ang pangalan ng gawain',
                            requiredName: 'Hindi maaaring walang laman ang pangalan ng task',
                            taskRemarkPlaceholder: 'Mangyaring ipasok ang isang paglalarawan ng gawain',
                            requiredRemark: 'Hindi maaaring walang laman ang paglalarawan ng Task',
                            remark: 'Paglalarawan',
                            taskRemark: 'Description ng Task',
                            source: 'Source ng Data',
                            benchmarkScore: 'Benchmark score',
                            benchmarkScorePlaceholder: 'Mangyaring ipasok ang benchmark score',
                            scoreLowerLimit: 'Minimum Score Lower Limitt',
                            scoreUpperLimit: 'Maximum Score Cap',
                            inspectType: 'Uri ng inspeksyon sa kalida',
                            nlpModel: 'Ang modelo ng NLP',
                            commonInspect: 'Regular na inspeksyon ng kalidado',
                            associateInspect: 'Associated Quality Inspection',
                            associateCycle: 'Panahon ng korrelasyong',
                            associateRegulation: 'Patakaran ng asosok',
                            judgeStrategy: 'Logic sa pagpapataka',
                            rule: 'Mga patakan',
                            commonTip: 'Regular na Inspeksyon ng Quality: natupad sa solong komunikasyon at diyalogo. Ang inspeksyon ng kalidad ay ginagawa sa nilalaman ng iisang komunikasyon.',
                            associateTip: 'Associated quality inspeksyon: naaplikado sa maraming komunikasyon at pag-uusap, na nag-uugnay sa nilalaman ng maraming komunikasyon para sa inspeksyon ng kalidad.',
                            cycleTip: 'Kung may maraming kaugnay na komunikasyon at dialog, ang data sa kaugnay na panahon ay magpapasok sa gawain para sa inspeksyon ng kalidad.',
                            scoreLowerLimitPlaceholder: 'Mangyaring ipasok ang minimum na limitasyon sa scor',
                            scoreUpperLimitPlaceholder: 'Mangyaring ipasok ang maximum score cap.',
                            call: 'Tawag ng Voice',
                            dialogue: 'Teksto dialog',
                            user: 'Quality inspector',
                            wechatUser: 'Operator',
                            noDesignated: 'Huwag ipasa',
                            type: 'Type ng formo',
                            singleScore: 'Single Score',
                            conduct: 'Mangyaring kumpletin muna ang sumusunod na impormasyon, pagkatapos ay klikt',
                            conduct2: 'Mangyaring kumpleto ang pagsasaayos ng mga patakaran ng inspeksyon ng kalidad at mga punto ng inspeksyon ng kalidad. Kung nakumpleto mo ang pagsasaayos, maaari kang mag-click sa Next o Exit Guide',
                            conduct3: 'Ang rating ng inspeksyon ng kalidad ay naayos ayon sa punto ng inspeksyon ng kalidad at rating nito. Maaari mong tukuyin ang iba\'t ibang antas ng resulta ng inspeksyon ng kalidad. Kung hindi mo kailangan ng rating, maaari mong laktawan ang hakbang na ito. Kung nakumpleto mo ang pagsasaayos, maaari kang mag-click sa Next o lumabas sa gabay.',
                            conduct4: 'Maaari mong i-configure ang mga karakteristika ng data na awtomatikong idadag sa gawain ayon sa mga karakteristika ng data na dapat suriin ang gawain sa awtomatikong karagdagan ang posisyon. Kung hindi mo kailangang awtomatikong magdagdag ng data sa panahong ito, maaari kang mag-click Skip. Kung nakumpleto mo ang pagsasaayos, maaari kang mag-click sa Next.',
                            conduct5: 'Kung gumagamit ka ng mono recording, mangyaring tiyak na i-configure ang item na ito at mag-click sa Next. Mangyaring gamitin lamang ang tinig ng serbisyo ng customer upang makatulong sa sistema na makilala ang iba\'t ibang mga track sa pagitan ng serbisyo ng customer at ng customer. Kung gumagamit ka ng dalawang channel recording o nakumpleto ang pagsasaayos, maaari kang mag-click Skip',
                            conduct6: 'Maaari mong gamitin ang manu-manong karagdagang function upang ipakilala ang mga mayroong data ng komunikasyon sa sistema para sa inspeksyon ng kalidad, o nagsumite ka ng manu-manong karagdagang gawain, mangyaring mag-click nang direkta',
                            helper: 'Makikita ang dokumentasyon ng tulod',
                            quit: 'Lumabas ang Booto',
                            next: 'Susunod na hakka',
                            complete: 'Taposo',
                            skip: 'Lagip',
                            cancel: 'Kansela',
                            delete: 'Mangalisa',
                            save: 'Pag-save',
                        },
                        template: {
                            language: 'Wika',
                            samplingInspector: 'Sampling inspector',
                            sessionType: 'Type ng session',
                        },
                    },
                },
                workbench: {
                    qualityCheckList: {
                        index: {
                            name: 'Quality Inspection Workbench',
                            search: 'Filtral',
                            export: 'Pag-exporto',
                            condition: 'Kondisyon',
                            logic: 'Logiko',
                            reQualityInspection: 'Re-inspection',
                            reQualityInspectionUnderWay: 'Re-inspection gawain...',
                            reQualityInspectionUnderWayTip: 'Ang pag-iwan sa pahina pagkatapos ng pagsasara ng window ay hindi nakakaapekto sa gawain',
                            reQualityInspectionDone: 'Nakumpleto ang re-inspecto',
                            reQualityInspectionDoneTip: 'Matagumpay na nakumpleto ang re-inspection, mangyaring mag-click ang pindutan ng kumpirmasyon.',
                            endReQualityInspection: 'Terminate Task',
                            alreadyDoneTip: 'Kumpleto',
                            totalTip: 'Kabuan',
                            unit: 'Artikulo',
                            endReInspectionSuccess: 'Muling kalidad na gawain',
                            closeWindow: 'Isara ng windows',
                            endReInspectionFailed: 'Nabigo ang re-kwality task, mangyaring subukan muli mamaya!',
                        },
                        detail: {
                            name: 'Detalyas ng Inspection ng kality',
                            reviewName: 'Detalyas',
                            spotCheckName: 'Detalye ng sampling',
                            audioText: 'Nakatala ang teksto',
                            callInfo: 'Impormasyon sa tawag',
                            satisfactionEvaluation: 'Pagpapahalaga sa kasiyahan:',
                            queueTime: 'Oras na ginugol sa queuing:',
                            ringingTime: 'Oras ng pag-ring:',
                            callTime: 'Mga kaganapan sa tawag:',
                            hangUpIdentity: 'Call hang-up party:',
                            location: 'Bahay:',
                            source: 'Source:',
                            agent: 'Serbisyo ng customer:',
                            deviceType: 'Type ng aparato:',
                            callType: 'Type ng call:',
                            phoneNumber: 'Relay number:',
                            task: 'Gawain:',
                            commentsTip: 'Mangyaring ipasok ang mga komento ng inspeksyon ng kalida',
                            lastPage: 'Naunang Pahinan',
                            nextPage: 'Susunod na Pahinan',
                            score: 'Score ng inspeksyon sa kalida',
                            review: 'Review',
                            file: 'Pag-archive',
                            changeList: 'Pagbago ng Record',
                            fullMarks: 'Buong markas',
                            most: 'Karamihan ay',
                            saveReview: 'Review Submissions',
                            saveSpotCheck: 'Sampling inspeksyon at submissions',
                            point: 'Punto ng inspeksyon ng kalida',
                            sampleAssignInspector: 'Assign Sampling Inspector',
                            reviewAssignInspector: 'Assign reviewer',
                            sampleStatus: 'Status ng sampling',
                            read: 'Basaan',
                            user: 'User',
                            confirmer: 'Kinumpirma Persona',
                            voiceDownloadError: 'Nabigo ang pag-download ng Voice, mangyaring subukan muli mamaya!',
                            smartTags: 'Smart Label',
                            interactiveTip: 'Gumamit ng pagkilala sa pakikipag-ugnay upang makita ang paggamit ng serbisyo ng customer FAQ',
                            interactiveIsEmptyTip: 'Walang nakita na nilalaman ng interactive na pagkilalan',
                            businessRecords: 'Mga tala ng negosyon',
                        },
                    },
                },
                reports: {
                    groupChatAnalysis: {
                        index: {
                            analysisOfEnterpriseWeChatGroupChat: 'Analysis ng Enterprise WeChat Group Chat',
                        },
                    },
                },
            },
            cards: {
                health: 'Kalusugan ng inspeksyon ng kalidado',
                accuracy: 'Rate ng pag-apruba ng Discovery',
                sessionsTotal: 'Kabuuang Sessions',
                enable: 'Mapangita',
                disable: 'Disabled',
                none: 'Hindin',
                call: 'Tawag',
                dialogue: 'Dialog',
                taobao: 'E-commerce',
                wecom: 'Session',
                ticket: 'Work Order',
            },
            component: {
                language: 'Wika',
                backup: '(Backup)',
                taskSaveAsSucceeded: 'Nakasave ang gawain bilang matagumpayan',
                copyContent: 'Copy Contents',
                essentialInformation: 'Pangunahing impormasyong',
                ruleConfiguration: 'Rule Configuration',
                basicInformationQualityInspector: 'Basic Information-Quality Inspector',
                qualityInspectionRating: 'Rating ng inspeksyon sa kalida',
                roleConfiguration: 'Role Configuration',
                autoAddConfiguration: 'Awtomatikong pagdagdag ng pagsasaayos',
                autoPushConfiguration: 'Automatic push configuration',
                automaticSamplingConfiguration: 'Awtomatiko na pagsasagawan',
                automaticAllocationConfiguration: 'Awtomatiko na pagsasaayos',
                businessConfiguration: 'Konfigurasyon ng negosyon',
                caseBaseConfiguration: 'Case Librarya',
            },
            template: {
                cancel: 'Kansela',
                complete: 'Taposo',
                sort: 'Sort',
                ruleApproval: 'Rule Approvalo',
                enterpriseMicroConversationAnalysisTask: 'Gawain ng analysis ng micro-session sa Enterprise',
                enterpriseAndMicroVoiceAnalysisTask: 'Enterprise Micro Speech Analysis Task',
                saveTaskAs: 'Sarig ang Gawain',
            },
            approve: {
                checkPoint: {
                    index: {
                        ruleDetails: 'Detalyas',
                    },
                },
                components: {
                    autoApproveSwitch: {
                        modificationSucceeded: 'Nagtagumpay ang pagbabago',
                        automaticApproval: 'Awtomatikong Pag-aprubal',
                    },
                    pageHeaderExtra: {
                        modificationSucceeded: 'Nagtagumpay ang pagbabago',
                        test: 'Testo',
                        formal: 'Formal',
                        adopt: 'Sa pamamagitan ng',
                    },
                    rejectButton: {
                        index: {
                            areYouSureToReject: 'Sigurado ka bang tanggik',
                            pleaseEnterTheRejectionReason: 'Mangyaring ipalagay ang dahilan para sa pagtanggik',
                            reject: 'Tinanggik',
                        },
                    },
                    table: {
                        index: {
                            modificationSucceeded: 'Nagtagumpay ang pagbabago',
                            taskName: 'Pangalan ng Task',
                            dataSource: 'Source ng Data',
                            qualityInspectionType: 'Uri ng inspeksyon sa kalida',
                            state: 'Status',
                            updateTime: 'Pag-update ng oras',
                            updatedBy: 'Update ang Persona',
                            approver: 'Approver',
                            reasonForRejection: 'Dahilan para sa pagtanggik',
                            operation: 'Operasyong',
                            details: 'Detalyo',
                            adopt: 'Sa pamamagitan ng',
                            whole: 'Lahat',
                            approvalStatus: 'Status ng Pag-aprubar',
                        },
                    },
                },
            },
        },
        dashboard: {
            title: 'Overviews',
            hi: 'Hi,',
            standardEdition: 'Standard Edisyon',
            call: 'Balance ng Inspection ng Voice Quality',
            text: 'Ipinagsama ng valide ng pagsusuri ng kalidad ng teksto',
            collectionTasks: 'Mga gawaing inspeksyon ng kalidad na koleks',
            noCollection: 'Walang koleksyon ng mga gawaing inspeksyon ng kalidad,',
            goToCollecte: 'Pumunta sa koleksyong',
            yesterdayOverView: 'Kawang estadistika ng negosyon',
            yesterdayAgent: 'Kahon ng listahan ng serbisyo ng customer',
            yesterdayInspWork: 'Kaganap ang sitwasyon ng trabaho ng inspektor ng kalidado',
            operationalStatistics: {
                title: 'Statistics ng negosyon',
                qualityTesting: 'Quality Inspection',
                spotCheck: 'Random inspekyon',
                appeal: 'Complaint',
                chartTitles: {
                    qualityTestingTrend: 'Trend ng volume na inspeksyon ng kalidad...',
                    qualityTestingAnalysis: 'Gawain sa Inspection ng Quality',
                    spotCheckTrend: 'Sampling trend',
                    spotCheckAnalysis: 'Ang sitwasyon ng inspeksyon ng sampling',
                    appealTrend: 'Mga trend ng grievance',
                    appealAnalysis: 'Ang status ng mandato ng apelal',
                },
                titles: {
                    qualityDataTend: 'Distribusyon ng data ng inspeksyon ng kalida',
                    qualityCover: 'Coverage ng inspeksyon ng kalidado',
                    qualityAverageTime: 'Average Quality Inspection Oras ng Paghihintay',
                    qualityCoverTend: 'Trend ng inspeksyon ng kalidad sa pagsasaman',
                    handCover: 'Manual handling',
                    checkCover: 'Sampling coverages',
                    resAverageTime: 'Average Time Processing',
                    handTend: 'Trend ng manu na pagproseso',
                    dataTend: 'Distribusyon ng task',
                },
                qualityAverage: 'Average Quality Inspection Scoree',
                scoreTrend: 'Quality Inspection Scoring Trend',
                qualityAverageTime: 'Average Quality Inspection Oras ng Paghihintay',
                callCoverage: 'Covage ng inspeksyon sa kalidad ng tinig',
                textCoverage: 'Covage ng inspeksyon ng kalidad ng teksto',
                checkCount: 'Sampling data volumes',
                siphonCount: 'Extract volume ng data',
                reviewCount: 'Review na Volume ng Data',
                appealCount: 'Complaint Data Volumo',
                checkRate: 'Porsyento ng random inspekyon',
                reviewRate: 'Porsyento ng Grievance Review',
                PieTitle: {
                    totalCount: 'Bilang ng mga pag-uusap',
                    totalCall: 'Bilang ng mga tawag sa bose',
                    totalIm: 'Bilang ng mga pag-uusap',
                    inspectionCall: 'Karamihan ng inspeksyon ng Voice quality',
                    inspectionIm: 'Karamihan ng inspeksyon ng teksto',
                    checkCall: 'Karamihan ng sampling ng tinig',
                    unCheckCall: 'Hindi sampol na tinig',
                    checkIm: 'Karamihan ng sampling ng teksto',
                    unCheckIm: 'Un sampled dami ng teksto',
                    reviewCall: 'Voice review volumes',
                    reviewIm: 'Karamihan ng pagsusuri ng teksto',
                    unReviewCall: 'Hindi pinagsubukan na dami ng Voices',
                    unReviewIm: 'Hala ng teksto na hindi binasan',
                    unInspectionCall: 'Voice unchecked damit',
                    unInspectionIm: 'Hindi nag-check na dami ng teksto',
                },
                check_rate: 'Sampling coverages',
                voice_check_rate: 'Coverage ng sampling ng Voices',
                text_check_rate: 'Teksta Sampling Coverage',
                sample_execute_time: 'Karaniwang oras ng pagproseso ng sampla',
                review_execute_time: 'Average Grievance Processing Times',
            },
            analysisOverview: {
                tableTitle: {
                    conditions: 'Mga Ruta ng Inspection ng kalidad Kanban',
                    agent: 'List ng Ranking ng Customer Services',
                },
                tableTips: {
                    conditions: '<Div> ang kabuuang bilang ng mga pag-uusap na lumalabag at sumusunod sa mga patakaran ng inspeksyon ng kalidad. <Br />\nQuality Inspection Item: name of the quality inspection point <br />\nBilang ng mga ilegal na pag-uusap: kabuuang bilang ng mga ilegal na pag-uusap sa item ng inspeksyon na ito <br />\nMga porsyento ng paglabag: Mga porsyento ng paglabag = kabuuang bilang ng mga paglabag/kalat na bilang ng mga paglabag </div>',
                    agent: '<Div> Pagsasaayos ng average rating ng mga ahente <br />\nPangalan ng serbisyo ng customer: ang pangalan ng serbisyo ng customer <br />\nGrupo ng serbisyo ng customer: ang grupo ng serbisyo ng customer kung saan matatagpuan ang serbisyo ng customer (ang impormasyon sa organisasyon sa impormasyon ng serbisyo ng customer) <br />\nSa kabuuang bilang ng mga pag-uusap: kabuuang bilang ng mga pag-uusap sa kalidad ng serbisyo ng customer <br />\nAverage Quality Inspection Score: ang pamantayang score ng inspeksyon ng kalidad ng ahente (kaaangkat na score/katuang bilang ng mga pag-uusap) </div>',
                },
                tips: {
                    total: 'Sa kabuuang bilang ng mga pass/pag-uugnay na ipinasok sa kalidad na gawain ng inspekyon',
                    agentTotal: 'Ang kabuuang bilang ng mga agent ng inspeksyon ng kalidad na nagpasok sa kalidad na gawain ng inspekyon',
                    avg: 'Average score ng kalidad na inspekyon',
                    violation: 'Sumusunod ang bilang ng mga oras ng lahat ng mga item ng inspeksyon ng kalidad ng dayalogo ay hit at lumalabag',
                    compliance: 'Sumusunod ang bilang ng beses na ang mga item ng inspeksyon ng kalidad ay hit sa proseso ng inspeksyon ng kalidad sa pamamagitan ng dialogo',
                    check: 'Kabuuang bilang ng manual samplings',
                    appeal: 'Bilang ng mga reklamo na ipinadala sa kabuuang bilang ng mga pag-uusap',
                    review: 'Kabuuang bilang ng mga ipinadala na pagsusuri sa kabuuang bilang ng mga pag-uusap',
                },
                subTips: {
                    violation: 'Rate ng paglabag: kabuuang bilang ng mga paglabag / kabuuang bilang ng mga item ng inspeksyon ng kalidad * 100%',
                    compliance: 'Rate ng pag-aayos: kabuuang bilang ng mga oras ng pagsunod/kalat na bilang ng mga item ng inspeksyon ng kalidad * 100%',
                    check: 'Coverage ng sampling: kabuuang manual sampling/total quality inspeksyon * 100%',
                    appeal: 'Karamihan ng appeal: kabuuang bilang ng appeals/total bilang ng mga inspeksyon ng kalidad * 100%',
                    review: 'Review rate: kabuuang bilang ng mga reviews/katkatong bilang ng mga inspeksyon ng kalidad * 100%',
                },
            },
            components: {
                companyBackground: {
                    index: {
                        cancel: 'Kansela',
                        pleaseEnterTheCompanyBusinessDescriptionUsedToImproveTheAccuracyOfLargeModelQualityInspectionItIsRecommendedToKeepWithinWords: 'Mangyaring ipasok ang paglalarawan ng negosyo ng kumpanya, na ginagamit upang mapabuti ang katumpakan ng malaking inspeksyon ng kalidad ng modelo, inirerekumenda na panatilihin sa loob ng 200 salita.',
                        save: 'Pag-save',
                    },
                },
            },
        },
        admin: {
            system: {
                index: {
                    name: 'System Settings',
                    systemName: 'Pangalan ng Sistema',
                    speakerRecognize: 'Pagkilala sa speaker',
                    massage: 'Pagkilala sa message',
                    evaluate: 'Artipisyal na pagsusuri',
                    evaluateTip: 'Pagkatapos ng pagbubukas, pumili ng mabilis na pagsusuri sa mga detalye ng inspeksyon ng kalidad at mabilis na pagsusuri',
                    speakerRecognizeTip: 'Upang ma-access ang pagtatala ng tatlong partido sa pamamagitan ng API, ito ay kinakailangan upang makilala kung ang kaliwang channel ay isang serbisyo ng customer o isang customer.',
                    speakerRecognizeTip2: 'Ang pagrekord ng solong channel ay naglalarawan ng papel ng ahente sa pamamagitan ng pagkilala sa teksto at pagsasaayos ng papel.',
                    enabledImSendStatusFilter: 'Filter ng Text Quality Inspection Message Filtery',
                    enabledImSendStatusFilterTips: 'Ang nilalaman ng detection ng pagsasalita ng operator sa inspeksyon ng kalidad ay hindi kasama ang mga mensahe sa status ng [Withdrawn], [Failed to Sen] d] at [Offline Message Unread]',
                    lang: 'Mga setting ng wika ng systema',
                    zh: 'Simplified Tsinon',
                    en: 'English',
                    tw: 'Tradisyonal Tsino',
                },
                template: {
                    maskChangeRecord: 'Mask Change Record',
                    singleMailQualityInspection: 'Single Mail Quality Inspection',
                    blockSMS: 'Block SMS',
                    maskInternalRemarks: 'Mask Internal Remarks',
                    workOrderQualityInspectionMessageFiltering: 'Mga Filter ng Mensahe sa Pag-inspeksyon ng Work Order Quality',
                    theMaskedDataIsOnlyDisplayedButDoesNotParticipateInIntelligentQualityInspection: 'Ang mga masked data ay ipinapakita lamang ngunit hindi lumalahok sa inspeksyon ng kalidad.',
                    multimodalQualityInspection: 'Multimodal Quality Inspection',
                    useALargeMultimodalModelToCheckThePicturesAudioAndVideoInTheSession: 'Gumamit ng malaking modelo ng multi-modal upang suriin ang mga larawan, audio at video sa sesyon.',
                    pictureRecognition: 'Pagkilala sa larawn',
                    largeModelLabelSaveFlowMode: 'Malaking model label sa flow mode',
                    whenEnabledLargeModelMarkingIsPerformedOnlyForSmartTagsRelatedToSessionContent: 'Kapag naka-able, ang malaking pagmamarka ng modelo ay ginagawa lamang para sa mga matalinong tag na may kaugnayan sa nilalaman ng session',
                    largeModelQualityInspectionProvincialFlowMode: 'Malaking modelo ng kalidad na inspeksyon ng probinsyal flow mode',
                    afterEnabledLargeModelQualityInspectionIsPerformedOnlyForIntelligentModelRulesRelatedToSessionContent: 'Matapos mapagana, ang malaking inspeksyon ng kalidad ng modelo ay ginagawa lamang para sa mga matalinong patakaran ng modelo na may kaugnayan sa nilalaman ng sesyon.',
                    cambodian: 'Cambodian',
                    cantonese: 'Cantoneses',
                    korean: 'Korean',
                    filipino: 'Filipino',
                    largeModelSettings: 'Malalaking Mga Setting ng Modelo',
                    forcedCustomerServiceOffline: 'Pinilit na serbisyo ng customer offline',
                    afterOpeningWhenTheCustomerFailsToCompleteTheQualityTrainingTaskAccordingToTheTimeRequirementTheCustomerServiceWillBeForcedToGoOffline: 'Pagkatapos ng pagbubukas, kapag nabigo ang customer upang kumpletuhin ang kalidad na gawain sa pagsasanay ayon sa pangangailangan ng oras, ang serbisyo ng customer ay mapilit na magpunta sa offline.',
                    indonesian: 'Indonesian',
                    vietnamese: 'Vietnameses',
                    portuguese: 'Portuguesa',
                    malay: 'Malaya',
                    french: 'Pranses',
                    spanish: 'Espanyola',
                    japanese: 'Hapons',
                    thai: 'Thai',
                    blockSystemSendingMessages: 'Ang Mask System ay nagpadala ng Mensahe',
                    textDataDesensitization: 'Desensitization ng Data',
                    whenTheSwitchIsTurnedOnTheDesensitizationFieldDropdownListWillBeDisplayedmultipleChoicesAreSupportedTheDesensitizationFieldsPersonNameMobileNumberAddress: 'Kapag ang switch ay nakabukas, ipinapakita ang listahan ng pagka-drop-down na patlang (suportahan ang multi-selection). Kasama sa mga patlang ng desensitization ang pangalan ng tao, numero ng mobile phone, at address.',
                    desensitizingField: 'Desensitized field',
                    name: 'Pangalan ng taos',
                    cellphoneNumber: 'Mobile telepono',
                    address: 'Address',
                    dataCleaning: 'Paglilinis ng data',
                    afterSettingTheConversationDataOfQCAndWeChatWillBeCleanedRegularlyAndCannotBeRecoveredPleaseBeCareful: 'Pagkatapos ng setting, ang pag-uusap ng kalidad ng inspeksyon at enterprise na data ng session ng WeChat ay regular na malinis at hindi maaaring mabawi. Mangyaring gumana nang maingat.',
                    newCleaningRules: 'Bagong patakaran sa paglilinis',
                    qualityInspectionRuleApproval: 'Pag-aaprubahan ng mga patakaran sa inspeksyon ng kalidado',
                    afterOpeningTheModificationOfQualityInspectionRulesCanTakeEffectOnlyAfterBeingApproved: 'Pagkatapos ng pagbubukas, dapat na aprubahan ang pagbabago ng kalidad ng inspeksyon bago ito magkaroon ng epekto.',
                    maskOfflineMessageUnread: 'Mask offline message hindi binasa',
                    privacyNumberProtection: 'Proteksyon ng Privacy Numero',
                    afterOpeningDesensitizeThecustomerPhoneFieldInTheCallWhichIsDisplayedAs1881: 'Pagkatapos ng pagbubukas, dessitize ang patlang na "customer phone" sa panahon ng tawag at ipakita ito bilang 1881 * * * * * * * * * *',
                    shieldingWithdrawn: 'Inalis ang mask',
                    maskSendingFailed: 'Nabigo sa pagpapadala ng mask',
                },
                component: {
                    conversation: 'Tawag',
                    dialogue: 'Dialog',
                    weCom: 'Enterprise WeChat',
                    day: 'Araw',
                    week: 'Linggon',
                    month: 'Buwana',
                    year: 'Taong',
                },
                components: {
                    dataDeleteConfigItem: {
                        scopeOfCleaning: 'Lalawigan ng paglilins',
                        dataCleaningTimeSetting: 'Mga settings ng oras ng paglilinis ng datas',
                        afterCleanUpTheData: 'Matapos ang paglilinis ng data',
                        dataAfterComplaintCompletion: 'Data post-Complaint',
                    },
                },
                coachSpeechRecognition: {
                    executionSuccessful: 'Matagumpay na pagpapatupad',
                    saveSuccessful: 'Ito ang matagumpay',
                    speechRecognition: 'Pagkilala sa pagsasabit',
                    reExecuteErrorCorrection: 'Pagwawast ng error sa re-performa',
                    confirmExecution: 'Titiyan ang pagpapatupan',
                    voiceDetection: 'Detection ng boses',
                    noiseDetectionPowerLevel: 'Level ≤',
                    pleaseEnterTheThreshold: 'Mangyaring ipasok ang threshold',
                    volumeDetectionPowerLevel: 'Level ≥',
                    reset: 'Reseta',
                    preserve: 'Pag-save',
                },
                coachTemplate: {
                    french: 'Pranses',
                    spanish: 'Espanyola',
                    japanese: 'Hapons',
                    thai: 'Thai',
                    loginPopupWindow: 'Login pop-up windows',
                    afterActivationAPopupPromptWillAppearWhenEnteringTheIntelligentAccompanimentSystem: 'Pagkatapos ng pagbubukas, ang isang pop-up window ay mag-uudyok kapag ipinasok ang intelligent sparring system.',
                    title: 'Title',
                    text: 'Tekstos',
                    checkBoxContent: 'Pag-check box content',
                    informedConsentForm: 'Informed Consent Formy',
                    toHelpYouImproveYourCommunicationAndCommunicationSkillsAsWellAsTheApplicationOfProfessionalKnowledgeAllowingYouToPracticeAnytimeAnywhereAndReceiveRealtimeFeedbackWeWillCollectTheFollowingInformationFromYouThroughThisPlatform: 'Upang makatulong sa iyo na mapabuti ang iyong mga kasanayan sa komunikasyon at pagsasalita at ang aplikasyon ng propesyonal na kaalaman, na nagpapahintulot sa iyo na magsanay anumang oras at kahit saan at makatanggap ng real-time feedback, makukuha namin ang sumusunod na impormasyon mula sa iyo sa pamamagitan ng platform na ito:',
                    iHaveFullyReadAndFullyUnderstoodThisInformedConsentFormAndSolemnlyDeclareThatIAgreeToProcessMySensitivePersonalInformationInAccordanceWithThePurposesAndMethodsStatedInThisInformedConsentForm: 'Nabasa ko at ganap na naintindihan ko ang Informed Consent Form na ito at solemn na sumasang-ayon na hawakan ang aking sensitibong personal na impormasyon ayon sa o layunin at pamamaraan na ipinahayag sa Informed Consent Form na ito',
                },
                webPlugin: {
                    webPlugin: 'Web Plugin',
                    generateLink: 'Bukha ng Links',
                    link: 'Links',
                    pleaseEnterALink: 'Mangyaring ipasok ang link',
                },
            },
            systemIntegration: {
                title: 'System Settings',
                ccIntegrationTips: 'Intelligent Quality Inspection Docking Udesk Call Center Description Document',
                unauthorized: 'Hindi awtorisado',
                authorized: 'Pinatutunan',
                udeskDomain: 'Pangalan ng domain ng system ng Customer services',
                udeskToken: 'Agent System Key',
                udeskAdminEmail: 'Customer service account ng administrator system.',
                password: 'Password ng administrator',
                applyAuth: 'Awtorisasyon',
                cancelAuth: 'Kansela na awtorisasyonan',
                reApplyAuth: 'Reauthorization',
                keyTips: 'Background management of customer service system-API authentication token sa solong sign-on.',
            },
            customerField: {
                title: 'Customer Field',
                table: {
                    propName: 'Name field',
                    propDesc: 'Paglalarawan sa field',
                    valueType: 'Type ng patlangan',
                    propType: 'Metodo',
                    createTime: 'Oras ng paglika',
                    canNotEdit: 'Hindi suportahan ng mga patlang ng system ang pag-editon',
                },
                edit: 'Edit Fields',
                new: 'Bagong Fields',
            },
            wechatDocking: {
                title: 'Enterprise micro docking',
                formLabels: {
                    companyId: 'Enterprise ID',
                    communicationKey: 'Susi ng komunikasyonan',
                    token: 'Token',
                    encodingAESKey: 'EncodingAESKey',
                    url: 'Event Callback URL',
                    applicationName: 'Pangalan ng application',
                    applicationId: 'Web Application ID',
                    applicationSecret: 'Aplikasyon ng lihim',
                },
                formTitle: {
                    initialForm: 'Unang Pag-aayos',
                    synchronizeForm: 'Pag-synchronization ng Address book',
                    settingForm: 'Mga Sekreta ng Aplikation',
                },
                qrCodeUrlTip: 'Mangyaring hilingin sa administrator na i-scan ang dalawang-dimensional code sa ibaba upang maibigin ang application ng pag-unlad.',
            },
            taobao: {
                formLabels: {
                    name: 'Name Store',
                    account: 'Numero ng Acut',
                    password: 'Password',
                    confirm: 'Pagtunay ng Password',
                    authorization: 'Awtorisasyon',
                    switchOn: 'Buksa',
                    switchOff: 'Saray',
                },
                tableLabels: {
                    name: 'Name Store',
                    account: 'Numero ng Acut',
                    authorization: 'Awtorisasyon',
                    updateUser: 'Kamakailan lamang na update ng taos',
                    updateTime: 'Huling Update Oras',
                },
            },
            weifengDocking: {
                formLabels: {
                    secondaryDomain: 'Weifeng pangalan ng domain',
                    secretKeyTip: 'Ang lihim na key ng tenant ay nakuha sa lugar ng docking ng background system ng Weifeng.',
                },
            },
            user: {
                index: {
                    name: 'Employee Managements',
                    existingUsers: 'May mga empleyado na.',
                    deleteSuccess: 'Matagumpay na natanggala',
                    deleteFailed: 'Bigo ang pagtanggal',
                },
                detail: {
                    accountPrompt: 'Mangyaring ipasok ang E-mail',
                    resetPassword: 'Reset ang Password',
                    passwordPrompt: 'Password (6-14 kombinasyon ng mga titik at numero)',
                    originPasswordPrompt: 'Mangyaring ipasok ang unang password',
                    resumePasswordPrompt: 'Mangyaring ipasok muli ang iyong password',
                    passwordFormWrong: 'Mangyaring ipasok ang kombinasyon ng 6-14 na titik at numero!',
                    resumePasswordWrong: 'Dalawang password ay hindi pare-pareho!',
                    suppertImageType: 'Suporta jpg, gif, png, maximum 500Kb',
                    namePrompt: 'Mangyaring ipasok ang pangalan',
                    nickNamePrompt: 'Mangyaring ipasok ng palayan',
                    telephonePrompt: 'Mangyaring ipasok ang numero ng telepono',
                    roleSelectedPrompt: 'Mangyaring pumili ng role',
                    agentIdPrompt: 'Mangyaring ipasok ang numero ng trabaho',
                    disabled: 'Disabled',
                    enabled: 'Mapangita',
                    reloadBowerInfo: 'Ang mga pagbabago sa impormasyon ng user, kailangang i-freesh ang browser?',
                    saveUserError: 'Hindi sa pag-save ng impormasyon ng gumagamit, mangyari subukan muli mamasa',
                    resetPasswordSuccess: 'Matagumpay ang pag-reset ng password',
                    resetPasswordFailed: 'Nabigo ang pag-reset ng password, mangyari subukan muli mamasa',
                },
            },
            userGroups: {
                index: {
                    name: 'Employee Group Managements',
                    existingUserGroups: 'Ang umiiral na Grupo ng empleyas',
                },
            },
            role: {
                index: {
                    name: 'Role Management (Role Management)',
                    existingRoles: 'Mayroong mga Rok',
                },
                edit: {
                    editRole: 'Pag-edit ng Role',
                    createRole: 'Bukha ng Role',
                    basicInfo: 'Pangunahing impormasyong',
                    taskPermissions: 'Mga pahintulot sa Task',
                    existingTasks: 'Mga Gawain',
                },
            },
            anomalousData: {
                title: 'Hindi normal na datas',
                list: {
                    selectHolder: 'Mangyaring pumili ng source ng data',
                    businessTime: 'Oras ng negosyon',
                    businessId: 'Negos ID',
                    export: 'Pag-exporto',
                },
            },
            templateComponent: {
                list: {
                    title: 'Template Market',
                    name: 'Template',
                    searchHolder: 'Mangyaring ipasok ang nilalaman na query',
                    update: 'Update',
                    sort: 'Sort',
                    moduleType: 'Template Type',
                    moduleSourceType: 'Applicable Type',
                    fetchNum: 'Bilang ng beses na nakuhan',
                    newest: 'Kamakailan lamang na-update',
                    usedMost: 'Pagkuha ng karamin',
                    call: 'Tawag',
                    dialogue: 'Dialog',
                    waiting: 'Upang suriin',
                    cancel: 'Unpublish a',
                    success: 'Aprovado at I-publishe',
                    failed: 'Ang pagtanggi ng audit',
                    no: 'Hindi Upgraded',
                    ok: 'Maaaring i-upgrades',
                    all: 'Lahat',
                    delete: 'Matagumpay na natanggala',
                    downOk: 'Matagumpay na tinang',
                    withdraw: 'Nagtagumpay sa pag-retwaly',
                    updateOk: 'Tagumpay ang pag-upgrades',
                    get: 'Kuhan',
                    width: 'Pag-retwaly',
                    getOk: 'Tagumpay sa pagkuha',
                    orgName: 'Organisasyong',
                    nowVersion: 'Kasalukuy na bersyo',
                    lastedVersion: 'Pinakababang bersya',
                    appStatus: 'Status ng application',
                    actions: 'Operasyong',
                    down: 'Labas sa shelf',
                    updateTop: 'Upgrades',
                    check: 'Pansing',
                    deleteWhen: 'Patunayan ang pagtanggal?',
                    yes: 'Oo,',
                    noo: 'Hindin',
                    deleteOk: 'Mangalisa',
                    permissible: 'Pinapayagan',
                    noPermissible: 'Hindi pinapayan',
                    openUp: 'Buksa',
                    openDown: 'Hindi buksan',
                    task: 'Gawain sa inspeksyon ng kalida',
                    point: 'Punto ng inspeksyon ng kalida',
                    tag: 'Semantic label a',
                    muti: 'Maraming elementos',
                    inter: 'Isang tanong at isang sagot',
                    info: 'Entity ng impormasyong',
                    concept: 'Mga salitang konsepto',
                    detail: 'Detalyas',
                    infomation: 'Pangunahing impormasyong',
                    detailConfig: 'Detalyadong Configurasion',
                    twoEdit: 'Secondary Editing',
                    mustUpdate: 'Upgrade ngayon',
                    descition: 'Template Description',
                    descitionSize: 'Hindi maaaring lumampas sa 250 salita ang paglalarawan ng template',
                    stencilsDetail: 'Detalyas',
                    updatedRecords: 'Update ang Record',
                    version: 'Numero ng bersyong',
                    updateDescription: 'Update ang Paglalarawan',
                    myModule: 'My Template',
                    addModule: 'Bagong Module',
                    publishVersion: 'Paglabas ng bersyong',
                    earliestVersion: 'Ang pinakamaagang bersyo',
                    edit: 'Pag-edita',
                    add: 'Bago',
                    configNo: 'Hindi maaaring walang laman ang mga detalye ng module',
                    updateNo: 'Hindi maaaring walang laman ang paglalarawan',
                    editSuccess: 'Nagtagumpay ang pagbabago',
                    saveSuccess: 'Ito ang matagumpay',
                    newer: 'Update',
                    sumbit: 'Submissions',
                    cancelName: 'Kansela',
                    nameRequired: 'Ang pangalan ng module ay kinakailangang field',
                    nameSize: 'Hindi maaaring lumampas sa 16 karakter ang pangalan ng module',
                    publishStatus: 'Publish Status',
                    submitUpdate: 'Ipadala ang Update',
                    updateVersion: 'Update ang bersyong',
                    updateExplain: 'Update ang Paglalarawan',
                },
            },
            customDataSource: {
                amazonEcommerce: 'Amazon e-commerce',
                youtubeVideo: 'Youtube video',
                amazon: {
                    component: {
                        queuing: 'Sa linya',
                        notStarted: 'Hindi Nagsimula',
                        inProgress: 'Sa paglaon',
                        success: 'Tagumpan',
                        failed: 'Bigo',
                        successfullyCreated: 'Matagumpay na nilika',
                        editedSuccessfully: 'Matagumpay na na-edito',
                        operationSucceeded: 'Nagtagumpay ang operasyon',
                        deletedSuccessfully: 'Matagumpay na natanggala',
                        link: 'Links',
                        grabState: 'Grab states',
                        updateTime: 'Pag-update ng oras',
                        grab: 'Makuhay',
                        edit: 'Pag-edita',
                    },
                    template: {
                        amazonEcommerce: 'Amazon e-commerce',
                        thisProduct: 'Ito',
                        competition: 'Kompetisyong',
                        new: 'Bago',
                        edit: 'Pag-edita',
                        link: 'Links',
                    },
                },
                youtube: {
                    template: {
                        youtubeVideo: 'Youtube video',
                        thisProduct: 'Ito',
                        competition: 'Kompetisyong',
                        new: 'Bago',
                        edit: 'Pag-edita',
                        link: 'Links',
                    },
                    component: {
                        queuing: 'Sa linya',
                        notStarted: 'Hindi Nagsimula',
                        inProgress: 'Sa paglaon',
                        success: 'Tagumpan',
                        failed: 'Bigo',
                        successfullyCreated: 'Matagumpay na nilika',
                        editedSuccessfully: 'Matagumpay na na-edito',
                        operationSucceeded: 'Nagtagumpay ang operasyon',
                        deletedSuccessfully: 'Matagumpay na natanggala',
                        youTubeVideoLink: 'YouTube video link',
                        grabState: 'Grab states',
                        updateTime: 'Pag-update ng oras',
                        grab: 'Makuhay',
                        edit: 'Pag-edita',
                    },
                },
            },
        },
        demo: {
            title: 'Intelligent quality inspeksyo',
            template: 'Pumili ang Quality Inspection Template',
            radio: 'Pumili ng form sa pagrekord',
            uploadAudio: 'Uploading recording',
            uploadAudioTip: 'Ang upload na recording ay sumusuporta lamang sa mga format ng wav at mp3, at ang sukat ay hindi lumampas sa 1G',
            uploadText: 'Upload teksto',
            uploadTextTip: 'Ang naka-upload na teksto ay sumusuporta lamang sa mga format ng srt at txt, at ang sukat ay hindi lumampas sa 10M. Matapos ang pag-upload ng teksto, hindi na gagamitin ang ASR upang i-parse ang file ng pagrekord.',
            uploadSuccess: 'Matagumpay na na-upload ang pagrekord ng files',
            uploadFailed: 'Hindi nabigo ang pagrekord ng file uploads',
            startQualityInspection: 'Simulan ang inspeksyon ng kalidado',
            qualityInspectionStarted: 'Ang inspeksyon ng kalidad ay umusal',
            downloadText: 'Text Downloads',
            checking: 'Progress ng Inspection ng Quality',
            checkingTip: 'Inaasahang tumagal ng ilang minuto, mangyaring maging pasin',
            noCheckContent: 'Walang resulta ng inspeksyon ng kalidad pan',
            noTextDownload: 'Walang teksto ng inspeksyon ng kalidad!',
            pleaseCheckParams: 'Mangyaring suriin kung pumili ng template, uri ng boses at upload ang recording',
            inspectionFailed: 'Nabigo ang inspeksyon ng kalidad, mangyaring subukan muli mamaya!',
        },
        wechatQa: {
            baseInfo: {
                title: 'Pangunahing impormasyong',
            },
            conversationSetting: {
                title: 'Session',
                segmentationStrategy: 'Slicing strategie',
                rule: 'Strateya',
                time: 'Oras ng pag-cut',
                daily: 'Araw-araw',
                passScore: 'Session Eligible Scoree',
                ruleLogic: 'Logic sa pagpapataka',
            },
            message: {
                title: 'Pinuksa',
                table: {
                    index: 'Serial numero',
                    name: 'Pangang',
                    type: 'Modo ng pagpusi',
                    desc: 'Paglalarawan',
                    status: 'Status',
                },
                subTitle: 'Listahan',
            },
            checkPoint: {
                title: 'Modelo ng analysis',
                groups: 'Modelo Grouping',
                newClassification: 'Bagong Grupo',
                editClassification: 'Pag-edit ng Grupo',
                benchmarkScore: 'Benchmark score',
                pointCount: 'Karaniwang modelo ng pagsusuri sa kasalukuyang klasis',
                openPointCount: 'Bilang ng paggawa ay',
                closedPointCount: 'Ang deactivate na dami ay',
                scoreLowerLimit: 'Minimum Score Lower Limitt',
                scoreUpperLimit: 'Maximum Score Cap',
                classificationName: 'Pangalan ng grupon',
                classificationNamePlaceHolder: 'Mangyaring ipasok ang pangalan ng grupo.',
                classificationRemark: 'Paglalarawan ng grupop',
                classificationRemarkPlaceHolder: 'Mangyaring ipasok ang paglalarawan ng grupo.',
            },
            chartRecord: {
                title: 'Enterprise WeChat Session',
                table: {
                    id: 'Session ID',
                    type: 'Type ng session',
                    startTime: 'Oras ng pagsisimula ng session',
                    endTime: 'Session Huling End Oras',
                    groupId: 'Group ID',
                    client: 'Customero',
                    customer: 'Servisyo ng Customero',
                    averageScore: 'Average Quality Inspection Scoree',
                },
                detail: {
                    title: 'Mga Detalyado sa Session ng Enterprise WeChat',
                    inspectionInfo: 'Impormasyon sa analisi',
                    chartInfo: 'Impormasyon sa session',
                    tasks: 'Gawain ng analysis',
                    avgScore: 'Average score ng pagsusuri',
                    qualified: 'Kwalipikado',
                    unqualified: 'Unqualifid',
                    taskTitle: 'Applicable Analysis Template',
                    info: 'Analysis ng Real-time ng impormasyong',
                    today: 'Balita ngayon',
                    history: 'Mga Makasaysayang Mensahes',
                    components: {
                        filter: {
                            index: {
                                pleaseEnterACommentNickname: 'Mangyaring ipasok ang komento/magama',
                                pleaseEnterTheGroupChatName: 'Mangyaring ipasok ang pangalan ng chat ng grupo.',
                            },
                        },
                    },
                    template: {
                        whole: 'Lahat',
                    },
                },
            },
            realTimeAnalysis: {
                title: 'Real-time analysisa',
                table: {
                    name: 'Pangalan ng Scene',
                    count: 'Bilang ng mga modelo ng analysis',
                    baseScore: 'Benchmark score',
                    passScore: 'Qualified score',
                    maxScore: 'Maximum Score Cap',
                    minScore: 'Minimum Score Lower Limitt',
                    status: 'Status',
                    actions: 'Operasyong',
                },
                detail: {
                    title: 'Real-time analysis ng mga scenario',
                    form: {
                        name: 'Pangalan ng Scene',
                        prevCondition: 'Mga kondisyon ng trigger na Scenarioo',
                        prevConditionToolTip: 'Kung ang kondisyon ay walang laman, ang senaryo na ito ay sinusuri sa pamamagitan ng defaulta',
                        prevConditionError: 'Ang mga kondisyon ng scenario trigger ay hindi maaaring magkakasabay sa modelo ng pagsusuri',
                        scoreInputPlaceholder: 'Isugot ang markan',
                        baseScore: 'Benchmark score',
                        status: 'Status',
                        passScore: 'Qualified score',
                        maxScore: 'Makuna sa pinakamataas na limite',
                        minScore: 'Mas mababang limitasyon ng minimum score',
                        analysisModel: 'Modelo ng analysis',
                        message: 'Trigger Notifications',
                        pushType: 'Modo ng pagpusi',
                        createAnalysisModel: 'Dagdag ang Modelo',
                        scoreUpperLimitError: 'Ang mas mababang limitasyon ng minimum na marka ay hindi maaaring mas malaki kaysa sa pinakamataas na limitasyon ng maximum score.',
                        table: {
                            name: 'Name Modelo',
                            rule: 'Mga patakan',
                            score: 'Score',
                        },
                        pushConfigSwitchTip1: 'Kapag lumilitaw ang tanaw',
                        pushConfigSwitchTip2: 'Times at itaas, itulak ang mga notifikas',
                    },
                },
            },
            smartCustomerTag: {
                title: 'Smart Customer Labeling',
                table: {
                    name: 'Pangalan ng Rule',
                    tags: 'Enterprise micro customer labels',
                    status: 'Gaan ang Status',
                    createUser: 'Creater',
                    createTime: 'Oras ng paglika',
                },
                detail: {
                    name: 'Pangalan ng Rule',
                    condition: 'Itakda ang mga patakas',
                    logic: 'Logiko',
                    status: 'Gaan ang Status',
                    tags: 'Pilit',
                },
            },
            setting: {
                wechatQaCustomerLabel: {
                    template: {
                        numberOfCustomerTags: 'Customer Marked Quantity',
                    },
                },
                messageFiltering: {
                    template: {
                        edit: 'Pag-edita',
                        messageContent: 'Kabilangan ng message',
                        messageTypeID: 'Type ID ng message',
                        messageTypeDescription: 'Mga Paglalarawan ng Type ng message',
                        messageFiltering: 'Filter ng message',
                        suitableForFilteringDataWithoutQualityInspection: 'Angkop para sa pag-filter ng data nang walang inspeksyon ng kalida',
                        create: 'Bukhay',
                        messageDescription: 'Paglalarawan ng message',
                    },
                },
            },
            chartAudioRecord: {
                index: {
                    talkTime: 'Oras ng talk',
                    sessionType: 'Type ng session',
                    whole: 'Lahat',
                    staff: 'Employa',
                    customer: 'Customero',
                    callKeywords: 'Call Key Words',
                },
                detail: {
                    template: {
                        enterpriseMicroVoiceCallDetails: 'Mga detalye ng call ng micro voice',
                    },
                },
            },
            wechatQaChartRecordEntry: {
                sessionArchiving: 'Session',
                voiceCall: 'Tawag ng Voice',
                noMoreVoiceCalls: 'Wala nang mga tawag ng bose',
                enterpriseWechatVoiceCall: 'Enterprise WeChat voice calle',
                enterpriseWechatConversationDetails: 'Mga Detalyado sa Session ng Enterprise WeChat',
                previous: 'Nakaraang artikulo...',
                next: 'Susunod na artikulo...',
            },
            dashboard: {
                template: {
                    enterpriseMicroConversationAnalysisTask: 'Gawain ng analysis ng micro-session sa Enterprise',
                    enterpriseAndMicroVoiceAnalysisTask: 'Enterprise Micro Speech Analysis Task',
                },
            },
            wechatQaTaskManagerEntry: {
                analysisOfEnterpriseWeChatGroupChat: 'Analysis ng Enterprise WeChat Group Chat',
            },
            wechatQaSettingEntry: {
                messageFiltering: 'Filter ng message',
            },
        },
        businessAnalysis: {
            keyword: 'Ulat Pangalang',
            createUser: 'Creater',
            createTime: 'Oras ng paglika',
            updateTime: 'Pag-update ng oras',
        },
        semanticIntelligence: {
            agent: 'Agente',
            externalInterface: {
                detail: {
                    components: {
                        interfaceTest: {
                            index: {
                                testInterface: 'Test Interfaces',
                                testPassed: 'Ang pagsubok ay lumipasa',
                                testNotPassed: 'Hindi nagpasa',
                                request: 'Kahiligan',
                                resultReturnedAfterParsing: 'Bumalik ang resulta pagkatapos ng pag-pars',
                                collapseAPIInteraction: 'Collapse interaction API',
                                viewAPIInteractions: 'Tingnan ang mga interaksyon ng API',
                            },
                        },
                        paramsList: {
                            components: {
                                valuePlain: {
                                    index: {
                                        pleaseEnterAPathExpression: 'Mangyaring ipasok ang isang path expression a',
                                    },
                                },
                                valueSpecial1: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                pleaseSelect: 'Pakipilin',
                                                followthepathField: 'Follow-the-path field',
                                            },
                                        },
                                    },
                                    index: {
                                        informationEntity: 'Entity ng impormasyong',
                                        followthepathField: 'Follow-the-path field',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterAParameterName: 'Mangyaring ipasok ang pangalan ng parametro',
                                addInterfaceParameters: 'Dagdag ang Interface Parameters',
                            },
                        },
                    },
                    index: {
                        testNotPassed: 'Hindi nagpasa',
                        saveSuccessful: 'Ito ang matagumpay',
                        interfaceName: 'Interfae',
                        pleaseEnterInterfaceName: 'Mangyaring ipasok ang pangalan ng interfae',
                        interfaceDescription: 'Interface Description',
                        pleaseEnterInterfaceDescription: 'Mangyaring ipasok ang paglalarawan ng interfae',
                        validity: 'Effectiveness',
                        pleaseSelectEffectivity: 'Mangyaring piliin ang epektibot',
                        effective: 'Epektive',
                        invalid: 'Hindi bayad',
                        dataSource: 'Source ng Data',
                        pleaseSelectADataSource: 'Mangyaring pumili ng source ng data',
                        requestMethod: 'Paraan ng Kahilingang',
                        pleaseSelectARequestMethod: 'Mangyaring pumili ng paraan ng hilig',
                        requestAddress: 'Humihingi Address',
                        pleaseEnterTheRequestAddress: 'Mangyaring ipasok ang address ng hilig',
                        requestParameters: 'Mga Parameters',
                        pleaseAddRequestParameters: 'Mangyaring magdagdag ng mga parameter ng hilig',
                        returnParameter: 'Parameter bumalik',
                        pleaseAddAReturnParameter: 'Mangyaring magdagdag ng parameter ng bukin',
                        editExternalInterface: 'Pag-edit ng External Interfae',
                        newExternalInterface: 'Bagong Panlabas na Interfae',
                    },
                },
                index: {
                    operationSuccessful: 'Nagtagumpay ang operasyon',
                    name: 'Pangang',
                    interfaceDescription: 'Interface Description',
                    dataSource: 'Source ng Data',
                    requestMethod: 'Paraan ng Kahilingang',
                    requestAddress: 'Humihingi Address',
                    creationTime: 'Oras ng paglika',
                    validity: 'Effectiveness',
                    externalInterface: 'Panlabas na Interfaces',
                    pleaseEnterAKeyword: 'Mangyaring ipasok ang keyword a',
                },
            },
            applicationMessageType: 'Type ng Mensahe ng Aplikation',
            intelligentModel: {
                components: {
                    promptArea: {
                        index: {
                            qualityInspectionRequirements: 'Mga kinakailangan sa inspeksyon ng kalida',
                            outputSpecification: 'Output Specification',
                            pleaseImproveTheConfiguration: 'Mangyaring perpekto ang pagsasaayos',
                            generatePromptLanguage: 'Prompt na binuo',
                        },
                        components: {
                            optimization: {
                                index: {
                                    failedToOptimizePrompt: 'Nabigo sa pag-optimize ng prompt',
                                    pleaseEnterACommand: 'Mangyaring ipasok ang commando',
                                    pleaseBecomeAPromptWord: 'Mangyaring maging isang maagang salat',
                                    optimizationPrompt: 'Optimization Prompt',
                                    ifThePromptContainsVariablesTheVariablesNeedToBeReinsertedAfterThePromptIsOptimized: 'Kung ang prompt ay naglalaman ng mga variable, ang mga variable ay kailangang muling ipasok matapos ang prompt ay optimized.',
                                    cancel: 'Kansela',
                                    application: 'Aplikation',
                                    instruction: 'Instruksiy',
                                    generate: 'Generated',
                                    promptWordGenerated: 'Prompt salitang binuo',
                                },
                            },
                        },
                    },
                    typeSelect: {
                        index: {
                            whetherItMeetsTheRequirements: 'Sumusunod',
                            gradedEvaluation: 'Pagsusuri',
                        },
                    },
                    training: {
                        index: {
                            pleaseEnter: 'Mangyaring irekt',
                            pleaseGeneratePrompt: 'Mangyaring paglikha ng prompt',
                            pleaseSelectADialogue: 'Mangyaring pumili ng pag-uusap',
                            training: 'Pagsasayo',
                            dataType: 'Type ng data:',
                            voiceCall: 'Tawag ng Voice',
                            textDialogue: 'Teksto dialog',
                            generate: 'Generated',
                            qualityInspectionResults: 'Mga resulta ng inspeksyon ng kalidad:',
                            hit: 'Hit:',
                        },
                    },
                },
                detail: {
                    index: {
                        modelName: 'Name Modelo',
                        pleaseEnterTheModelNameForExampleIsThereASituationWhereCustomerServiceIsInactive: 'Mangyaring ipasok ang pangalan ng modelo, halimbawa, kung walang aksyon ang ahente.',
                        modelDescription: 'Paglalarawan ng Modelo',
                        canYouProvideADetailedDescriptionOfTheContentYouNeedToTestForTheModelsUnderstandingSuchAsWhetherThereIsASituationWhereCustomerServiceIsInactiveThatIsCustomerServiceHasRespondedToCustomerInquiriesButTheCustomersQuestionsHaveNotBeenAddressedThroughoutOrTheResponseContentIsUnrelatedToTheCustomersResponse: 'Maaari mong ilarawan nang detalyado kung ano ang kailangan mong subukan, na madaling maunawaan ng modelo. Halimbawa, kung walang aksyon ang serbisyo ng customer, iyon ay, ang serbisyo ng customer ay tumugon sa tanong ng customer, ngunit ang tanong ng customer ay hindi nakikipag-usap o ang nilalaman ng sagot ay walang kinalaman sa sagot ng customer.',
                        validity: 'Effectiveness',
                        effective: 'Epektive',
                        invalid: 'Hindi bayad',
                        type: 'Type',
                        hintLanguage: 'Prompt',
                        editIntelligentModel: 'Pag-edit ng Smart Modelo',
                        createANewIntelligentModel: 'Bagong Smart Modelo',
                    },
                },
                index: {
                    updateTime: 'Pag-update ng oras',
                    modelName: 'Name Modelo',
                    modelDescription: 'Paglalarawan ng Modelo',
                    type: 'Type',
                    whetherItMeetsTheRequirements: 'Sumusunod',
                    gradedEvaluation: 'Pagsusuri',
                    validity: 'Effectiveness',
                    intelligentModel: 'Intelligent modele',
                    applicableToSubjectiveQualityInspectionsuchAsWhetherTheQualityInspectionServiceAttitudeIsEnthusiasticWhetherTheServiceIsPatientEtc: 'Kaugnay sa inspeksyon ng kalidad (tulad ng kung ang kalidad ng serbisyo sa inspeksyon ay masigasig at kung ang kalidad ang pag-uugali ng kalidad. ang serbisyo ay pasyente)',
                },
            },
            clusterAnalysis: 'Cluster',
            speechMining: 'Mga salita Mining',
            informationEntities: {
                detail: {
                    batchImportOfInformationEntitiesThroughTheAPIInterfaceIsSupportedEditingIsNotSupportedAfterSavingTheAPIName: 'Maaari kang mag-import ng mga entity ng impormasyon sa mga batches sa pamamagitan ng interface ng API. Matapos ang pangalan ng API ay nai-save, hindi ito maaaring i-edit.',
                    template: {
                        language: 'Wika',
                    },
                },
                component: {
                    language: 'Wika',
                    nothing: 'Walan',
                },
                template: {
                    language: 'Wika',
                },
            },
            knowledgeBase: {
                index: {
                    language: 'Wika',
                    classification: 'Classifications',
                    import: 'Importan',
                    importKnowledgeBase: 'Pag-import ng Knowledge Base',
                    moveKnowledgePointsInBatch: 'Paglipat ng batch points',
                    moveTo: 'Lumipat:',
                    pleaseSelectTheKnowledgePointsToBeMovedInBatch: 'Mangyaring piliin ang mga punto ng kaalaman na ilipat sa mga batche',
                },
                detail: {
                    index: {
                        language: 'Wika',
                        intrasentence: 'Sa loob ng pangungunan',
                        afterProblem: 'Matapos ang probleman',
                    },
                },
            },
            semanticTags: {
                component: {
                    numberOfReferences: 'Bilang ng mga references',
                    language: 'Wika',
                    nothing: 'Walan',
                },
                detail: {
                    template: {
                        largeModelAutomaticallyExpandsSimilarSentences: 'Ang malaking modelo ay awtomatikong nagpapalawak ng katulad na pangungusap.',
                        nLPAutoextendedSimilarSentences: 'NLP auto-pinalawak na katulad na pangungunan',
                        automaticExpansionOfSimilarSentences: 'Awtomatikong pagpapalawak ng mga katulad na pangungunan',
                        nLPExtendedSimilarSentences: 'NLP Extended Similar Sentences',
                        largeModelExtendedSimilarSentences: 'Large Model Extended Similar Sentences',
                        oneclickOptimization: 'One-click optimization',
                        excludeRegularExpressionsSupportFillingInMultipleLinesWhenFillingInMultipleLinesTheLogicIsThatAnyHitCanBeEstablished: 'Paglabas ng mga regular expression na sumusuporta sa pagpuno ng maraming linya. Kapag nagpuno ng maraming linya, ang lohika ay ang anumang hit ay maaaring itinatag.',
                        recallRegularTip: 'Tandaan ang regular na suporta upang punan ang maraming linya, punan ang maraming linya ng logic hit ang anumang maaaring itinatag.',
                        language: 'Wika',
                    },
                    component: {
                        pleaseEnterAStandardSentence: 'Mangyaring ipasok ang isang karaniwang pangunguhan',
                    },
                },
                template: {
                    effectiveness: 'Epektibo:',
                    pleaseSelectEffectivity: 'Mangyaring piliin ang epektibot',
                    effective: 'Epektive',
                    invalid: 'Hindi bayad',
                    language: 'Wika',
                },
            },
            smartWordsLibrary: {
                template: {
                    ignoreWordsBlockWordsThatYouDontWantToPayAttentionToInWordCloudAnalysisToHelpAIThatAnalysisHotspotsAreInLineWithCurrentBusiness: 'Hindi pinapansin ang mga salita: Block salitang hindi mo nais magbigay ng pansin sa salita ng cloud analysis upang makatulong sa AI na ang mga hotspot ay nasa line sa kasalukuyang negosyo.',
                    typosWordSetUsedToOptimizeTheEffectOftyposDetectionForExampleIfrefundIsMistakenlySentAsrefundWidthCommonTyposAndCorrectWordsCanBeSetThroughThisFunctionAndItWillTakeEffectTheNextDayAfterSaving: 'Typos word set: ginagamit upang optimize ang epekto ng "typos detection". Halimbawa, kung ang "refund" ay maling ipinadala bilang "refund width", maaaring itakda ang karaniwang typo at tamang salita sa pamamagitan ng function na ito, at ito ay magiging epekto sa susunod na araw pagkatapos ng pag-save.',
                    translationTerminologyUsedToOptimizeTheEffectOfTranslationWhenATermInTheIndustrySuchAsProductNameParameterNameEtcIsNotTranslatedCorrectlyTheTermAndItsCorrectTranslationCanBeAddedAsATranslationTerm: 'Terminolohiya ng pagsasalin: ginagamit upang optimize ang epekto ng pagsasalin. Kapag ang termino sa industriya, tulad ng pangalan ng produkto, pangalan ng parameter, atbp., ay hindi isinalin nang tama, ang termino at ang tamang pagsasalin nito ay maaaring idagdag bilang termino ng pagsasalin.',
                    translationOfTerms: 'Pagsalin ng mga Terms',
                    hotWords: 'Mga mainit na salat',
                    hotWordsUsedToImproveASRTranscriptionAccuracy: 'Ang mga mainit na salita: ginagamit upang mapabuti ang katuruan ng transcription',
                    sensitiveWords: 'Sensitive salat',
                    sensitiveWordsSensitiveWordsCanBeConfiguredWithBusinessFocusWordsForPublicOpinionToDiscoverSensitiveWordClouds: 'Sensitive salita: ang mga sensitibong salita ay maaaring configuro na may mga salitang tungkol sa negosyo, na ginagamit para sa pagtuklas ng opinyon na sensitibong salita ng cloud',
                },
                sensitiveWords: {
                    component: {
                        language: 'Wika',
                        newSensitiveWord: 'Bagong Sensitive Salit',
                        editSensitiveWords: 'Pag-edit ng mga sensitibong salat',
                        sensitiveWords: 'Sensitive salat',
                    },
                    template: {
                        language: 'Wika',
                        sensitiveWords: 'Sensitive salat',
                        sensitiveWordsCannotBeEmpty: 'Hindi maaaring walang laman',
                        pleaseEnterSensitiveWordsSeparatedBy: 'Mangyaring ipasok ang isang sensitibong salita, at hiwalay ng maraming sensitibong salita \',\'',
                    },
                },
                hotWords: {
                    index: {
                        hotWordModel: 'Modelo ng mainit na sala',
                        aSRProject: 'Proyekto ng ASR',
                        updateTime: 'Pag-update ng oras',
                        operation: 'Operasyong',
                        editBasicInformation: 'Pag-edit ng pangunahing impormasyong',
                        managementHotWords: 'Mga mainit na salitang manage',
                        delete: 'Mangalisa',
                        saveSuccessful: 'Ito ang matagumpay',
                        newHotWordModel: 'Bagong Modelo ng Hot Words',
                        editHotWordModel: 'Pag-edit ng modelo ng mainit na sala',
                        hotWordModelName: 'Pangalan ng modelo ng mainit na salita',
                        pleaseEnterHotwordModelName: 'Mangyaring ipasok ang pangalan ng hotword modele',
                        pleaseSelectAnASRProject: 'Mangyaring pumili ng proyekto ng ASR',
                        areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                        deleteSuccessful: 'Matagumpay na natanggala',
                        currentHotWords: 'Kasalukuyang Hot Words',
                        one: 'Isan',
                        pleaseEnterAHotWordMultipleHotWordsAreSeparatedByCommasInChineseOrEnglishTheMaximumLengthIsCharacters: 'Mangyaring ipasok ang isang mainit na salita. Maraming mainit na salita ay pinaghiwalay ng kommas sa Tsino o Ingles. Ang pinakamataas na haba ay 12 character.',
                        submission: 'Submissions',
                    },
                },
                corpusData: {
                    component: {
                        language: 'Wika',
                    },
                    template: {
                        language: 'Wika',
                    },
                },
                professionalWords: {
                    component: {
                        language: 'Wika',
                    },
                    template: {
                        language: 'Wika',
                    },
                },
                smartWordsLibraryCommon: {
                    component: {
                        language: 'Wika',
                    },
                },
                smartWordsLibraryCommonList: {
                    template: {
                        aSRTrainingStatus: 'Status ng Training ASR',
                    },
                },
                translationTerminology: {
                    components: {
                        list: {
                            index: {
                                pleaseEnterATermNameForTheLanguage: 'Mangyaring ipasok ang pangalan ng term para sa wika',
                                addAdditionalLanguages: 'Dagdag ang mga karagdagang wika',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'Pagsalin ng mga Terms',
                        language: 'Wika',
                        effectiveness: 'Effectiveness',
                        yes: 'Oo,',
                        no: 'Hindin',
                        edit: 'Pag-edita',
                        new: 'Bago',
                        editTranslationTerms: 'Pag-edit ng Mga Terms',
                        newTranslationTerm: 'Bagong Term',
                        pleaseAddTermsInAtLeastTwoLanguages: 'Mangyaring magdagdag ng mga termino sa hindi bababa sa dalawang wika',
                    },
                },
            },
            clusteringAnalysis: {
                add: {
                    index: {
                        pleaseSelectAnApplicationScenario: 'Mangyaring pumili ng scenario ng application',
                        keyWord: 'Keywords',
                        pleaseEnterKeywords: 'Mangyaring ipasok ang keyword a',
                        keywordLengthWithinCharacters: 'Lawa ng keyword sa loob ng 40 characters',
                        dataSources: 'Source ng data',
                        pleaseSelectADataSource: 'Mangyaring pumili ng source ng data',
                        theCurrentClusteringHasBeenCompletedReEditingWillGenerateANewClusteringDataAndWillNotOverwriteTheCompletedClusteringDataPleaseConfirm: 'Ang kasalukuyang clustering ay nakumpleto. Ang muling pag-edit ay gumagawa ng bagong piraso ng data ng clustering at hindi magbababalik ng mga nakumpletong data ng clustering. Mangyaring kumpirman',
                        savingSucceeded: 'Ito ang matagumpay',
                        clusteringStart: 'Nagsisimula ang Clustering',
                        clustering: 'Clusteringg',
                        edit: 'Pag-edita',
                        newlyBuild: 'Bago',
                        clusterName: 'Cluster Named',
                        pleaseEnterAName: 'Mangyaring ipasok ang pangalan',
                        withinCharactersOfTheName: 'Ang haba ng pangalan sa loob ng 40 characters',
                        speaker: 'Speaker',
                        pleaseSelectASpeaker: 'Mangyaring pumili ng speaker',
                        sessionDate: 'Session Date',
                        pleaseEnterTheSessionDate: 'Mangyaring ipasok ang petsa ng session',
                        selectUpToMonthOfHistoricalSessionData: 'Magpili ng maximum ng 1 buwan ng data ng kasaysayan ng session',
                        automaticallyClusterDailyNewData: 'Awtomatikong clustering ng araw-araw bagong data',
                        conversationChannel: 'Pakikipag-usap',
                        pleaseSelectAConversationChannel: 'Mangyaring pumili ng session channel',
                        applicationScenario: 'Application Scenarioss',
                        clusteringRules: 'Patakaran ng clustering',
                        incompleteClusteringRuleSettings: 'Ang setting ng patakaran ay hindi kumpleto',
                        startClustering: 'Simula ang Clusteringd',
                    },
                    components: {
                        conditionItem: {
                            pleaseSelectAQualityInspectionTask: 'Mangyaring pumili ng kalidad na gawain',
                            beEqualTo: 'Katumbas',
                        },
                    },
                },
                detail: {
                    index: {
                        theme: 'Tema',
                        numberOfCorpora: 'Bilang ng corpus',
                        corpusCoverage: 'Coverage ng corpus',
                        clusterDetails: 'Mga Detalyas',
                    },
                    ranking: {
                        hotWords: 'Mga mainit na salat',
                        numberOfCorpora: 'Bilang ng corpus',
                        speaker: 'Speaker',
                        sit: 'Upo.',
                        passenger: 'Guesto',
                        hotSentence: 'Mainit na pangungunan',
                        corpusDetails: 'Detalyas',
                    },
                },
                index: {
                    delete: 'Mangalisa',
                    deletionSucceeded: 'Matagumpay na natanggala',
                    clusterName: 'Cluster Named',
                    speaker: 'Speaker',
                    creationTime: 'Oras ng paglika',
                    state: 'Status',
                    operation: 'Operasyong',
                    see: 'Pansing',
                    edit: 'Pag-edita',
                    clusterAnalysis: 'Cluster',
                    newCluster: 'Bagong Cluster',
                    clusteringStatus: 'Clustering Status',
                },
            },
            wordsMining: {
                dissent: {
                    components: {
                        pageLeftTable: {
                            enterKeywordsToSearchForObjections: 'Maglagay ng mga keyword upang maghanap ng mga pagtutol',
                        },
                        pageRightTable: {
                            columnHeader: {
                                scriptLibrary: 'Speech Librarys',
                                recommendedScripts: 'Rekumenda ng Speeche',
                                common: 'Kabuan',
                                strip: 'Artikulo',
                                scriptFavorites: 'Mga Favorites',
                            },
                            conditionPostfix: {
                                detectRoles: 'Detect Role',
                                detectionRange: 'Range ng detektan',
                                sentence: 'Sentensya',
                            },
                            customerFilter: {
                                scriptFiltering: 'Filtering ng pagsasalitao',
                                cancel: 'Kansela',
                            },
                            index: {
                                viewDetails: 'Pansin Detalyas',
                                areYouSureYouWantToDiscardYouCannotRestoreAfterDiscarding: 'Sigurado ka bang nais mong iwanan ito? Hindi mo maaari itong ibalik matapos itong talikuran.',
                                abandonment: 'Itawad',
                                deletionSucceeded: 'Matagumpay na natanggala',
                                passenger: 'Guesto',
                                sit: 'Upo.',
                                adopted: 'Adopp',
                                determine: 'Determine',
                                cancel: 'Kansela',
                                adopt: 'Adoption',
                            },
                            pageRightFrom: {
                                savingSucceeded: 'Ito ang matagumpay',
                                pleaseEnterTheScriptContent: 'Mangyaring ipasok ang nilalaman ng speeche',
                                pleaseSelectAFavoriteGroup: 'Mangyaring pumili ng paboritong grupong',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                objectionHandlingScriptLibrary: 'Objection Handling Speech Libraryan',
                            },
                            pageRightTable: {
                                index: {
                                    pleaseChooseToAdoptScript: 'Mangyaring pumili ng pagsasabit',
                                },
                            },
                        },
                    },
                },
                favoriteView: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'Mga Favorites ng Objection Handling Words',
                        },
                        pageRightTable: {
                            likeCancel: 'Nakansela ang paggalaw',
                            likeSuccessfully: 'Gusto ko ang tagumpay.',
                            adoptScripts: 'Adopt Speeche',
                            operation: 'Operasyong',
                            viewConversationDetails: 'Tingnan ang mga detalye ng pag-uusap',
                        },
                    },
                    sellingPoint: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'Library ng pagbebenta ng produkto',
                            },
                            pageRightTable: {
                                keyPointsOfScript: 'Mga Key Points of Speeche',
                            },
                        },
                    },
                },
                favorite: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'Mga Favorites ng Objection Handling Words',
                            newGroup: 'Bagong Grupo',
                            editGroup: 'Pag-edit ng Grupo',
                            addGroup: 'Dagdag ang Grouping',
                            savingSucceeded: 'Ito ang matagumpay',
                            groupName: 'Pangalan ng grupon',
                            pleaseEnterTheGroupName: 'Mangyaring ipasok ang pangalan ng grupo.',
                            groupNameWithinCharacters: 'Ang haba ng pangalan ng grupo sa loob ng 20 characters',
                            deletionSucceeded: 'Matagumpay na natanggala',
                        },
                        pageRightTable: {
                            configDrawer: {
                                index: {
                                    scriptRecommendationSettings: 'Inirekomenda ng Speech ang mga Settings',
                                },
                                rightForm: {
                                    savingSucceeded: 'Ito ang matagumpay',
                                    intelligentRecommendation: 'Intelligent rekomend',
                                    theAdoptedExcellentScriptsWillBeAutomaticallyDisplayedInTheConversationSidebarOfSimilarObjectionsAndEmployeesCanDirectlyViewTheRecommendedScriptsForLearningOnTheDetailedPageOfConversationReview: 'Ang mga ekselenteng kasanayan sa pagsasalita ay awtomatikong ipinapakita sa sidebar ng mga pag-uusap na may katulad na pagtutol, at ang mga empleyado ay maaaring direktang tingnan ang rekomendasyon ng mga kasanayan sa pagsasalita para sa pag-aaral sa pagpapatuloy ng mga detalye ng session.',
                                    objectionsIncludedByDefault: 'Kasama sa pamamagitan ng default ang pagtutol',
                                    addRecommendationTriggerSemantics: 'Idagdag ang mga trigger semantics',
                                    remindEmployeesToView: 'Paalalahanan ang mga empleyado na tingnan',
                                    shareWithMoreEmployees: 'Magbahagi sa higit pang mga empleyado.',
                                    allHands: 'Lahat ng kawaka',
                                },
                                smartToolbar: {
                                    selectSemanticTag: 'Pumili ng Semantic Label',
                                },
                            },
                            index: {
                                doYouWantToExportAllDataRecordsUnderTheCurrentGroup: 'I-export ang lahat ng mga tala ng data sa kasalukuyang grupo?',
                                newScript: 'Bagong pagsasabit',
                                editingScript: 'Pag-edit ng Speechs',
                                savingSucceeded: 'Ito ang matagumpay',
                                objection: 'Pagbabaliko',
                                pleaseEnterAScriptObjection: 'Mangyaring ipasok ang isang objection ng speeche',
                                speechTechnique: 'Mga salat',
                                pleaseEnterTheScriptContent: 'Mangyaring ipasok ang nilalaman ng speeche',
                                grouping: 'Pag-grupo',
                                pleaseSelectAFavoriteGroup: 'Mangyaring pumili ng paboritong grupong',
                                adoptScripts: 'Adopt Speeche',
                                passenger: 'Guesto',
                                sit: 'Upo.',
                                numberOfViews: 'Bilang ng views',
                                useful: 'Kapaki-pakita',
                                operation: 'Operasyong',
                                edit: 'Pag-edita',
                                delete: 'Mangalisa',
                                deletionSucceeded: 'Matagumpay na natanggala',
                                scriptRecommendationSettings: 'Inirekomenda ng Speech ang mga Settings',
                            },
                        },
                    },
                },
                index: {
                    scriptLibrary: 'Speech Librarys',
                    scriptMining: 'Mga salita Mining',
                    objectionHandlingScripts: 'Objection Handling',
                    productSellingPointScripts: 'Mga Punto ng pagbebenta ng produkto',
                },
                sellingPoint: {
                    index: {
                        newCluster: 'Bagong Cluster',
                    },
                    components: {
                        callDetailModal: {
                            sessionDetails: 'Detalyas',
                            cancel: 'Kansela',
                            determine: 'Determine',
                            choice: 'Pilit',
                        },
                        pageCenterTable: {
                            scriptOverview: 'Overview ng Speech',
                        },
                        pageLeftTable: {
                            enterSearchKeywords: 'Maglagay ng mga keyword ng search keywords',
                            keyWord: 'Keywords',
                        },
                        pageRightTable: {
                            index: {
                                viewDetails: 'Pansin Detalyas',
                                scriptLibrary: 'Speech Librarys',
                                scriptRefinement: 'Pagbabaliko',
                                adoptScript: 'Adopt Speeche',
                            },
                            tagsEdit: {
                                keyPointsOfScript: 'Mga Key Points of Speeche',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'Library ng pagbebenta ng produkto',
                            },
                            pageRightTable: {
                                configDrawer: {
                                    rightForm: {
                                        defaultIncludedSellingPoints: 'Mga puntos sa pagbebenta kasama sa pamamagitan ng defaulta',
                                    },
                                },
                                index: {
                                    keyWord: 'Keywords',
                                    pleaseSelectAKeyword: 'Mangyaring pumili ng keyword',
                                    keyPointsOfScript: 'Mga Key Points of Speeche',
                                    pleaseInputTheKeyPointsOfTheScript: 'Mangyaring ipasok ang mga key point ng pagsasalitao',
                                    viewDetails: 'Pansin Detalyas',
                                    pleaseChooseToAdoptScript: 'Mangyaring pumili ng pagsasabit',
                                },
                            },
                        },
                    },
                },
            },
            conceptWord: {
                detail: {
                    template: {
                        language: 'Wika',
                        matchingLogic: 'Pag-aayos ng lohik',
                        nLPMatching: 'Laban sa NLP',
                        strictlyMatchByWord: 'Strict match sa pamamagitan ng sala',
                    },
                },
                component: {
                    language: 'Wika',
                },
                template: {
                    language: 'Wika',
                },
            },
            applicationMessage: {
                index: {
                    messageTypeName: 'Pangalan ng uri ng message',
                    messageTypeID: 'Type ID ng message',
                    messageTypeDescription: 'Mga Paglalarawan ng Type ng message',
                    applicationMessageType: 'Type ng Mensahe ng Aplikation',
                    itIsApplicableToAccessDataFromDifferentChannelsForQualityInspectionWhichShouldBeClassifiedAccordingToChannelIdentification: 'Ito ay naaangkop upang ma-access ang data mula sa iba\'t ibang mga channel para sa inspeksyon ng kalidad, na dapat na klase ayon sa pagkakakilanlan ng channel.',
                },
                detail: {
                    index: {
                        messageTypeName: 'Pangalan ng uri ng message',
                        pleaseEnterAMessageTypeName: 'Mangyaring ipasok ang pangalan ng uri ng mensahes',
                        messageTypeDescription: 'Mga Paglalarawan ng Type ng message',
                        describeYourMessageTypeInDetail: 'Detalyado ang iyong uri ng mensahes',
                        editMessageType: 'I-edit ang Type ng message',
                        newMessageType: 'Bagong Type ng message',
                    },
                },
            },
            aiAgent: {
                detail: {
                    components: {
                        paramsList: {
                            components: {
                                value: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                preprocessedField: 'Preprocessed field',
                                            },
                                        },
                                    },
                                    index: {
                                        preprocessedField: 'Preprocessed field',
                                        fixedValue: 'Fixed halaga',
                                        pleaseEnterTheField: 'Mangyaring ipasok ang field',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterKey: 'Mangyaring ipasok ang key',
                            },
                        },
                    },
                    index: {
                        pleasePerfectTheVariable: 'Mangyaring perpekto ang variable.',
                        editAgent: 'Edit Agent',
                        newAgent: 'Bagong Agent',
                        agentName: 'Pangalan ng Agent',
                        pleaseEnter: 'Mangyaring irekt',
                        agentDescription: 'Paglalarawan ng agente',
                        effectiveness: 'Effectiveness',
                        source: 'Source',
                        space: 'Space',
                        agent: 'Agente',
                        aPIAddress: 'API Address',
                        userID: 'User ID',
                        type: 'Type',
                        conversationMessages: 'Mga mensahe ng pakikipag-usap',
                        variable: 'Variabel',
                    },
                },
                index: {
                    name: 'Pangang',
                    description: 'Paglalarawan',
                    source: 'Source',
                    statusUpdateSuccessful: 'Matagumpay ang pag-update ng statuss',
                    agent: 'Agente',
                    pleaseEnterAKeyword: 'Mangyaring ipasok ang keyword a',
                },
            },
        },
        gong: {
            common: {
                pleaseSelectATemMember: 'Mangyaring pumili ng miyembro ng koppa',
                existingFilter: 'May mga filter na.',
                pleaseSelect: 'Pakipilin',
                filterCondition: 'Mga kondisyon ng filtraton',
                areYouSureToDeleteTheCurrentFilter: 'Sigurado ka bang nais mong tanggalin ang kasalukuyang filter?',
                sessionDate: 'Session Date',
                staff: 'Employa',
                customer: 'Customero',
                pleaseEnterCustomerName: 'Mangyaring ipasok ang pangalan ng customer',
                keyWord: 'Keywords',
                whole: 'Lahat',
                pleaseEnterSessionKeywords: 'Mangyaring ipasok ang session keywords',
                sessionDuration: 'Session',
                sessionLabel: 'Session Scenarios',
                pleaseSelectASessionLabel: 'Mangyaring pumili ng isang session',
                commentTopic: 'Komento',
                pleaseSelectACommentTopic: 'Mangyaring pumili ng komento',
                areYouSureYouWantToOverwriteTheCurrentFilter: 'Sigurado ka bang nais mong isulat ang kasalukuyang filter?',
                overlayFilter: 'Cover filter',
                NewFilter: 'Bagong filt',
                newFilter: 'Bagong filt',
                filterName: 'Filter Named',
                pleaseEnter: 'Mangyaring irekt',
                allCall: 'Lahat ng mga tawag',
                percentage: 'Percentage',
                filterScreen: {
                    supportSearchingForMultipleKeywordsWithCommasinBothChineseAndEnglishSeparatingTheORRelationshipAndADashSeparatingTheAndRelationshipSuchAs: 'Maaari kang maghanap ng maraming keywords. Gumamit ng kommas (sa Ingles at Tsino) upang hiwalay OR at pauwasan ang hiwalay at OR. Halimbawa:',
                    callRecordID: 'Call log ID',
                    pleaseFillInTheCallRecordID: 'Mangyaring punan ang call record ID',
                    minute: 'Minuta',
                    second: 'Seconds',
                    whole: 'Lahat',
                    callRecording: 'Pagrekord ng tawag',
                    enterpriseWechat: 'Enterprise WeChat',
                    conversationChannel: 'Pakikipag-usap',
                    pleaseSelectASessionChannel: 'Mangyaring pumili ng session channel',
                    learningStatus: 'Estado ng pag-aaral',
                    pleaseSelectLearningStatus: 'Mangyaring piliin ang status sa pag-aaral',
                    notLearned: 'Hindi natutuna',
                    learned: 'Leared',
                    Minutes: 'Minuta',
                    theFilterConditionIsEmptyNewFilterIsNotSupported: 'Walang laman ang kondisyon ng filter, hindi suportado ang bagong filter!',
                    filterAddedSuccessfully: 'Matagumpay na idinagdag ang filter!',
                    failedToAddFilter: 'Sawi sa pagdagdag ng filter!',
                    filterDeletedSuccessfully: 'Matagumpay na natanggal ang filter!',
                    filterDeletionFailed: 'Bigo ang paglabas ng filter!',
                    filterOverwriteSucceeded: 'Tagumpay sa filter!',
                    filterOverwriteFailed: 'Nabigo ang filter override!',
                    theme: 'Tema',
                    pleaseSelectATheme: 'Mangyaring pumili ng tema...',
                    keyEvents: 'Mga pangunahing pangyayarin',
                    pleaseSelectAKeyEvent: 'Mangyaring pumili ng pangyayari sa key',
                },
                filterItem: {
                    startRetesting: 'Magsimula muling pagtukoy',
                    time: 'Oras',
                    talkTime: 'Pangalawan',
                    keyEvents: 'Mga pangunahing pangyayarin',
                    totalImplementationRateOfSupervisionItems: 'Pangkalahatang rate ng pagpapatupad ng mga items',
                    sort: 'Sort:',
                    seeMore: 'Magpakita ng higit pa...',
                },
                filterStatistics: {
                    conversation: 'Tawag',
                    weChat: 'WeChat',
                    quantity: 'Kwantity',
                },
            },
            caseBase: {
                index: {
                    copyTo: 'Kopyahay',
                    pleaseSelectTheLocationToMove: 'Mangyaring pumili ng lokasyon upang ilipat!',
                    folderCopiedSuccessfully: 'Matagumpay na nakopya ang folder!',
                    cancelCollectionSuccessfully: 'Mapagtagumpay sa koleksyon!',
                    collectionSucceeded: 'Tagumpay sa koleksyon!',
                    starCaseBase: 'Star case library',
                    move: 'Lumaw',
                    rename: 'Pangalawan',
                    delete: 'Mangalisa',
                    folderMovedSuccessfully: 'Matagumpay na inilipat ang folder!',
                    fileMovedSuccessfully: 'Matagumpay na inilipat ang talaksan!',
                    fileMoveFailed: 'Nabigo ang paglipat ng talaksan!',
                    folderAddedSuccessfully: 'Tagumpay na idagdag ang folder!',
                    folderRenameSucceeded: 'Naging matagumpay ang pangalan ng Folder!',
                    fileRenameSucceeded: 'Matagumpay ang pangalan ng talaksan!',
                    theFolderCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'Matapos ang pagtanggal ng folder, hindi mo ito makakakuha. Sigurado ka bang tatanggalin ito?',
                    deleteSucceeded: 'Matagumpay na natanggal!',
                    theFileCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'Matapos ang pagtanggal ng file, hindi mo ito makakakuha. Sigurado ka bang tatanggalin ito?',
                    share: 'Kabuan',
                    folders: 'Folder,',
                    calls: 'Isang tawag',
                    newFolder: 'Bagong Fold',
                    modifyFolder: 'Bago ang Fold',
                    title: 'Title',
                    pleaseEnter: 'Mangyaring irekt',
                    selectMoveLocation: 'Pumili ng Paglipat ng Locations',
                },
            },
            msgCenter: {
                index: {
                    learningReminder: 'Pag-aaral',
                    subscriptionDynamics: 'Dynamics ng subscriptions',
                },
                subscription: {
                    index: {
                        theSessionYouSubscribedToID: 'Ang sesyon na ipinaskribe mo sa (ID)',
                        thereAreDynamicUpdates: 'May dynamic update',
                        newCommentsReplies: 'Dagdag ang komento/replies',
                        strip: 'Artikulo',
                        newHelp: 'Dagdag ang Tulong',
                        goAndWatch: 'Pumunta sa mga manonoon',
                    },
                },
                reply: {
                    index: {
                        respondedToMyComments: 'Sumagot sa aking mga komento',
                        replySucceeded: 'Tagumpay ang sagot!',
                    },
                },
                answer: {
                    index: {
                        youMeInTheComments: '@ Sa mga komento.',
                        replySucceeded: 'Tagumpay ang sagot!',
                    },
                },
                share: {
                    index: {
                        shareCallsForYou: 'Tatawagan para sa iyo na ibahagi',
                        shareCasesForYou: 'Magbahagi ng kaso para sa iyo.',
                    },
                },
                study: {
                    index: {
                        learned: 'Leared',
                        ignored: 'Hindi pinapansina',
                        study: 'Pag-aaral',
                        ignore: 'Ipandiwalan',
                    },
                },
            },
            userManage: {
                list: {
                    importSuccessful: 'Nagtagumpay ang pag-importo',
                    account: 'Numero ng Acut',
                    password: 'Password',
                    cover: 'Cover',
                    skip: 'Lagip',
                    import: 'Importan',
                    importEmployees: 'Pag-importay ng empleyad',
                    importPrompt: 'Pag-import ng Tips',
                    confirm: 'Determine',
                    theDataContainsDuplicateAccountsOrNames: 'Duplicate account o pangalan ay mayroon sa entry ng data',
                    allCoverage: 'Cover lahat',
                    skipAll: 'Lahat',
                    headPortrait: 'Avatar',
                    fullName: 'Pangang',
                    nickname: 'Niyangal',
                    excellentStaff: 'Mahusay na tauhana',
                    yes: 'Oo,',
                    no: 'Hindin',
                    department: 'Departamento',
                    accountNumberemail: 'Account Number (Email)',
                    telephone: 'Telepono',
                    jobNumber: 'Work No.',
                    role: 'Role',
                    pleaseEnterANameOrPhoneSearch: 'Mangyaring ipasok ang email, pangalan o search sa telepono',
                    person: 'Mga tao)',
                    AddEmployee: 'Dagdag ang empleyad',
                },
                edit: {
                    jobNo: 'Work No.',
                    udeskCustomerServiceSystemIdentity: 'Udesk service system identity',
                    enterpriseWechatIdentity: 'Enterprise WeChat Identity',
                    inputID: 'Input ID',
                    newIdentityBinding: 'Bagong Binding ng Identity',
                    identityBinding: 'Binding ng identity',
                    avatarGreaterThan500kb: 'Mas malaki sa 500Kb',
                    uploadSuccessful: 'Tagumpay ang uploads',
                    upload: 'Uploads',
                    supportJPGGIFAndPNGUpTo500kb: 'Suporta jpg, gif, png, maximum 500Kb',
                    yes: 'Oo,',
                    no: 'Hindin',
                    accountNumber: 'Numero ng Acut',
                    pleaseEnterTheAccountNumber: 'Mangyaring ipasok ang numero ng account.',
                    initialPassword: 'Unang password',
                    pleaseInputAPassword: 'Mangyaring ipasok ang password',
                    confirmPassword: 'Pagtunay ng Password',
                    thePasswordsEnteredTwiceAreDifferent: 'Ang password na ipinasok ng dalawang beses ay hindi parehong!',
                    headPortrait: 'Avatar',
                    fullName: 'Pangang',
                    pleaseEnterYourName: 'Mangyaring ipasok ang pangalan',
                    nickname: 'Niyangal',
                    department: 'Departamento',
                    excellentStaff: 'Mahusay na tauhana',
                    sessionIdentity: 'Session Identity',
                    markTheSessionRecordAsBelongingToTheEmployee: 'Ang tag session record ay nabibilang sa empleyad',
                    telephone: 'Telepono',
                    jobNumber: 'Work No.',
                    role: 'Role',
                    pleaseSelectARole: 'Mangyaring pumili ng role',
                    preservation: 'Pag-save',
                    cancel: 'Kansela',
                    addedSuccessfully: 'Nagdagdag nang matagumpay!',
                    modificationSucceeded: 'Nagbago nang matagumpay!',
                    newEmployees: 'Bagong empleyad',
                    editEmployee: 'Pag-edit ng empleyas',
                },
                detail: {
                    viewDetails: 'Pansin Detalyas',
                    accountNumber: 'Numero ng Acut',
                    headPortrait: 'Avatar',
                    fullName: 'Pangang',
                    nickname: 'Niyangal',
                    department: 'Departamento',
                    excellentStaff: 'Mahusay na tauhana',
                    yes: 'Oo,',
                    no: 'Hindin',
                    sessionIdentity: 'Session Identity',
                    markTheSessionRecordAsBelongingToTheEmployee: 'Ang tag session record ay nabibilang sa empleyad',
                    telephone: 'Telepono',
                    jobNumber: 'Work No.',
                    role: 'Role',
                },
            },
            roleManage: {
                list: {
                    menu: 'Menu',
                    functionalCategory: 'Functional kategory',
                    functionalSubclass: 'Function Subclass',
                    deletedSuccessfully: 'Matagumpay na natanggala',
                    NewRole: 'Bagong Rol',
                    role: 'Role',
                    dataPermissions: 'Mga pahintulot sa data:',
                    edit: 'Pag-edita',
                    areYouSureYouWantToDeleteTheRole: 'Tiyakin ang pagtanggal ng role',
                    determine: 'Determine',
                    cancel: 'Kansela',
                    delete: 'Mangalisa',
                    applicationPermission: 'Paglalapat ng mga pahinis',
                },
                edit: {
                    youCanOnlySeeYourOwnSessionData: 'Makikita lamang ang iyong sariling data ng session',
                    youCanViewTheSessionDataOfYourDepartmentAndSubordinateDepartments: 'Maaari mong tingnan ang data ng session ng departamento at subordinate na departamentos',
                    menu: 'Menu',
                    functionalCategory: 'Functional kategory',
                    functionalSubclass: 'Function Subclass',
                    successfullyAdded: 'Bagong tagumpa',
                    modifiedSuccessfully: 'Nagtagumpay ang pagbabago',
                    edit: 'Pag-edita',
                    cancel: 'Kansela',
                    confirm: 'Pagkumpirma',
                    roleName: 'Role Name (Role Name)',
                    pleaseEnterTheRoleName: 'Mangyaring ipasok ang pangalan ng role',
                    dataAuthority: 'Mga pahintulot sa data',
                    youCanViewCompanyWideSessionData: 'Maaaring tingnan ang data sa buong sesyon ng kumpanyan',
                    applicationPermission: 'Paglalapat ng mga pahinis',
                },
            },
            callDetail: {
                index: {
                    conversationProcess: 'Session',
                    generateProcess: 'Proseso ng henerasyong',
                    addProcess: 'Dagdag sa proseso',
                    cancel: 'Kansela',
                    complete: 'Taposo',
                    edit: 'Pag-edita',
                    theSettingWillBeSuccessfulLater: 'Ito upang makita ang tagumpay mamaya!',
                    previous: 'Nakaraang artikulo...',
                    next: 'Susunod na artikulo...',
                    debuggingMode: 'Mode ng debug:',
                    afterActivationIfTheMessageMatchesTheRulesOfKeyEventsSupervisionItemsCustomerLabelsOrKnowledgePointRulesTheRuleNameThatTheMessageMatchesAndTheKnowledgePointNameOfTheKnowledgeBaseWillBeDisplayed: 'Matapos ang aktibo ang mensahe, kung ito ay tumutugma sa mga patakaran ng mga pangyayari, pagsubaybay sa mga item, tag ng customer, o mga punto ng kaalaman, ang pangalan ng patakaran kung saan ang mensahe ay tumutugma at ang pangalan ng kaalaman ng base ng kaalaman ay ipinapakita.',
                    seeLater: 'Tingnan mamaya',
                    determine: 'Determine',
                    conversationalInsights: 'Session Insights',
                    customerInsight: 'Customer Insights',
                    knowledgePointRecommendation: 'Rekumenda ng punto ng kaalaman',
                    comment: 'Mga komento',
                    sessionQuality: 'Session Quality',
                    setToListenLaterSuccessfully: 'Itakda upang makinig sa tagumpay mamaya!',
                    listenLater: 'Pakikinig mamaya',
                    seekCounselingSuccess: 'Naghahanap ng tagumpay sa coaching!',
                    altogether: 'Isang kabuuang',
                    appearsAt: '\'',
                    commentsPublishedSuccessfully: 'Matagumpay na napost ang mga komento',
                    callRecording: 'Pagrekord ng tawag',
                    addedSuccessfully: 'Nagdagdag ng matagumpayan',
                    shareWithColleagues: 'Magbahagi sa mga kasamahang',
                    shareWithCustomers: 'Magbahagi sa mga customers',
                    resumptionDetails: 'Detalye ng pagpapatuloy',
                    addToCaseBase: 'Dagdag sa Case Librarya',
                    shareCases: 'Nagbibigay ng mga kaso',
                    seekCounseling: 'Paghahanap ng payo',
                    sessionRecord: 'Session Record',
                    businessRecord: 'Mga tala ng negosyon',
                    keywordSearch: 'Keyword Search',
                    whole: 'Lahat',
                    pleaseEnterACommentEnterToNotifyOthersAndEnterToAddATopic: 'Mangyaring ipasok ang komento, ipasok @ upang bigyan ang iba, ipasok # upang magdagdag ng threade',
                    subscriptionSession: 'Subscribe sa Sessio',
                    afterSubscribingYouWillBeNotifiedWhenThereAreNewHelpCommentsAndReplies: 'Pagkatapos ng subscription, kapag may bagong tulong, komento at sagot, makakatanggap ka ng mga notifikas at paalala.',
                },
            },
            coachTask: {
                index: {
                    employeeName: 'Pangalan ng empleyad',
                    customerName: 'Pangalan ng Customr',
                    source: 'Source',
                    viewSessionRecords: 'Makikita ang mga tala ng session',
                    coachingStatus: 'Status ng Coaching',
                    helpTime: 'Oras para sa tulong...',
                    counselingTime: 'Time counseling',
                    helpContent: 'Help content',
                    coachingOperation: 'Operasyon ng coaching',
                    areYouSureYouWantToIgnoreIt: 'Sigurado ka bang nais mong hindi ba alamin ito?',
                    determine: 'Determine',
                    cancel: 'Kansela',
                    ignoreHelp: 'Ipindiran ang Tulong',
                    coaching: 'Conduct coaching',
                    viewCoaching: 'Tingnan Coaching',
                    areYouSureToReturnToCounseling: 'Sigurado ka bang bumalik sa payo?',
                    returnToPendingCoaching: 'Patuloy sa Counseling',
                    tutor: 'Payor',
                    helpSeekingStatus: 'Status ng tulongon',
                    recentCoachingTime: 'Kamakailan-lamang na Oras ng Counseling',
                    operation: 'Operasyong',
                    ignoreSuccess: 'Hindi bahala ang tagumpay!',
                    recoverySucceeded: 'Matagumpay sa pagbawi!',
                    successfulCoaching: 'Tutoring tagumpay!',
                    myMission: 'Misyon ko...',
                    selectCoachingStatus: 'Pumili ng Status ng Coaching',
                    whole: 'Lahat',
                    iAskedForHelp: 'Humingi ako ng tulong...',
                    signOut: 'Lumabas',
                    submit: 'Submissions',
                    helpPerson: 'Humihingi ng tuloyo',
                    customer: 'Customero',
                    toBeCoached: 'Upang mentorer',
                    counselingSuggestions: 'Payo sa payo',
                    pleaseEnterCoachingSuggestions: 'Mangyaring ipasok ang mga mungkahi sa coaching',
                },
            },
            coachTaskCenter: {
                title: 'Mission Center.',
                list: {
                    taskName: 'Pangalan ng Task',
                    lessonGroup: 'Classification ng kurso',
                    lessonName: 'Kurso',
                    taskType: 'Type ng task',
                    taskStatus: 'Task Status',
                    taskExecutionInfo: 'Status ng pagpapatupad',
                    totalCount: 'Bilang ng mga tao na pataka',
                    executeCount: 'Bilang ng pinataka',
                    executeRate: 'Rate ng pagpapatupad',
                    completeCount: 'Bilang ng kumpleto',
                    completeRate: 'Rate ng pagkumpleto',
                    commitCount: 'Bilang ng Attainment',
                    commitRate: 'Rate ng pagsunod',
                    excellentRate: 'Mahusay na rate',
                    taskTime: 'Oras ng gayo',
                    option: 'Operasyong',
                    edit: 'Pag-edita',
                    taskDetail: 'Task Data',
                    delete: 'Mangalisa',
                    new: 'Bagong Publikasyon',
                    taskTypeAll: 'Lahat',
                    taskTypePractice: 'Ehersisyon',
                    taskTypeTest: 'Examinasyon',
                    taskStatusNotStarted: 'Hindi Nagsimula',
                    taskStatusRunning: 'Sa paglaon',
                    taskStatusEnd: 'Endad',
                    taskStatusInvalid: 'Walang puwersa',
                    unlimitedTime: 'Unlimited times',
                    to: 'Tog',
                    deleteConfirm: 'Matapos ang pagtanggal, ang lahat ng mga tala ng pag-aaral sa ilalim ng gawain na ito ay malilinis. Sigurado ka bang tatanggalin ang mga ito?',
                    deleteSuccess: 'Matagumpay na natanggal ang gawain',
                },
                edit: {
                    addTask: 'Bagong Publish Task',
                    editTask: 'Pag-edit ng Publish Task',
                    publishSuccess: 'Matagumpay na inilathalan',
                    publishFailed: 'Nabigo ang publish',
                    updateSuccess: 'Nagtagumpay ang pag-update',
                    updateFailed: 'Nabigo ang pag-update',
                    cannotBeNull: 'Hindi maaaring walang laman',
                    explain: 'Paglalarawan',
                    taskDescExtra: '(Ang nilalaman dito ay ipapakita sa {0} pasukan)',
                    taskTargetObj: 'Paglathala ng mga Objects',
                    isEnable: 'Efektibong Status',
                    dialogueMode: 'Mode ng dayalog',
                    voice: 'Voice',
                    text: 'Tekstos',
                    userPortrait: 'User Portrait',
                    difficultyLevel: 'Mahirapa',
                    limitDuration: 'Duration Limitt',
                    tipLabel: 'Tips',
                    tipTooltip: 'Pahintulutan ang mga delegate na tingnan ang pagsasalita ng sangguni',
                    limitTimes: 'Bilang ng exams',
                    time: 'Oras',
                    gradingStandart: 'Mga criterio ng markas',
                    gradingStandartDescAffix: '(Ang kasalukuyang proseso ng pag-uusap',
                    gradingStandartDescSuffix: 'Points, kakayahan sa pagsasalita {0} points, mood {1} points, bilis {2} points)',
                    completeStandart: 'Mga kinakailangan sa pagkumpleto ng task',
                    byTimes: 'Sa pamamagitan ng bilang ng oras',
                    byScore: 'Sa markas',
                    completeByTimes: 'Bilang ng Exercise',
                    times: 'Timess',
                    score: 'Punts',
                    anyTimes: 'Anumang beses',
                    getScore: 'Score',
                    offLimitDuration: 'Walang limitasyong tagala',
                    onLimitDuration: 'Limitasyong Oras',
                    commitScore: 'Standard, score',
                    excellentScore: 'Mahusay na standard, score',
                    offLimitTime: 'Unlimited times',
                    onLimitTime: 'Limitadong oras',
                },
            },
            homePage: {
                common: {
                    useMessage: {
                        hi: 'Hi,',
                    },
                    callDynamic: {
                        today: 'Ngayon...',
                        yesterday: 'Kawang.',
                        sessions: 'Isang sesyon',
                    },
                    todoList: {
                        strip: 'Artikulo',
                        theSessionIsAddedTolistenLater: 'Ang sesyon ay sumali sa "Narinig mamaya"',
                        askYouForHelp: 'Humingi sa iyo ng tulo',
                        iHopeToContactYouLater: 'Umaasa sa contact mamaya',
                        lookingForwardToSendingTheInformationLater: 'Inaasahan na ipadala ang materyal mamaya',
                        dialogueRisk: 'Ang pakikipag-usap ay may mga punto ng peligroso',
                        tutored: 'Coached',
                        goToCounseling: 'Pumunta sa payo',
                        contacted: 'Mga contacts',
                        hasBeenSent: 'Ipinadalas',
                        areYouSureYouWantToIgnoreIt: 'Sigurado ka bang nais mong hindi ba alamin ito?',
                        determine: 'Determine',
                        cancel: 'Kansela',
                        ignore: 'Ipandiwalan',
                        checked: 'Tinawan',
                    },
                    callListItem: {
                        strip: 'Artikulo',
                        learned: 'Leared',
                        keyEvents: 'Mga pangunahing pangyayarin',
                        totalImplementationRateOfSupervisionItems: 'Pangkalahatang rate ng pagpapatupad ng mga items',
                    },
                },
                index: {
                    operationSucceeded: 'Matagumpay ang operasyon!',
                    sessionDynamics: 'Session dynamics',
                    my: 'Ak',
                    department: 'Departamento',
                    company: 'Kumpanya',
                    toDoList: 'Listahan',
                },
            },
            teamAnalysis: {
                index: {
                    effectiveCallVolumenumber: 'Effective call volume (unit)',
                    bestPractices: 'Best Practices',
                    averageDurationOfASingleCallminutes: 'Average na tagal ng solong tawag (minuto)',
                    totalCallVolumePCs: 'Kabuuang Calls (unit)',
                    totalTalkTimehours: 'Total Call Duration (Hours)',
                    speakingPercentagepercentage: 'Porsyento ng pagsasalita (percentage)',
                    maximumContinuousSpeakingTimeminutes: 'Maximum patuloy na oras ng pagsasalita (minuto)',
                    numberOfIndepthDiscussionsPCs: 'Bilang ng malalim na talakayan (pcs)',
                    maximumCustomerTalkminutes: 'Maximum na nagsasalita ng customer (minuto)',
                    questionFrequencyPCs: 'Frequency ng katanungan (unit)',
                    averageValue: 'Average',
                    selectDate: 'Piliit ang petsas',
                    personnel: 'Personelo',
                    pleaseSelect: 'Pakipilin',
                    callRange: 'Range ng tawag',
                    conversationActivity: 'Session Activity',
                    conversationAction: 'Session',
                    keyEvents: 'Mga pangunahing pangyayarin',
                    callRecord: 'Pagrekord ng tawag',
                    filter: 'Filter:',
                    conversation: 'Tawag',
                    minute: 'Minuta',
                    sale: 'Employa',
                },
            },
            saleClientCenter: {
                detail: {
                    index: {
                        january: 'Eneror',
                        numberOfCalls: 'Bilang ng mga tawag',
                        accountInformation: 'Impormasyon sa Acut',
                        month: 'Buwana',
                        today: 'Ngayon...',
                        customerDetails: 'Detalyas',
                        searchKeywordsInCommunicationContent: 'Naghahanap ng keywords sa nilalaman ng komunikasyon',
                        allMembers: 'Lahat ng miyel',
                        reset: 'Reseta',
                        query: 'Query',
                        allTrip: 'Full Journey Show',
                        contactOverview: 'Contact Overviews',
                        lastContact: 'Hulang contacta',
                        nextContact: 'Susunod na Contact',
                        previous: 'Nakaraang artikulo...',
                        next: 'Susunod na artikulo...',
                        viewDetails: 'Pansin Detalyas',
                        contactDynamics: 'Dinamika',
                        lastYear: 'Nakaraan na',
                        lastCall: 'Hulang tawag',
                        hotTopicsForDiscussion: 'Mainit na paksa ng talakayan',
                        totalInTheLastYear: 'Sa nakaraang taon sa kabuuan.',
                        callTimes: 'Sekundarya na tawag',
                    },
                },
                list: {
                    index: {
                        risk: 'Pangiba',
                        have: 'Mayroong',
                        nothing: 'Walan',
                        channel: 'Channel',
                        callRecording: 'Pagrekord ng tawag',
                        enterpriseWeChatConversation: 'Enterprise micro-session',
                        enterpriseWeChatCall: 'Enterprise Micro-Talk',
                        followUpSuggestions: 'Mga rekomendasyon sa pagsunod',
                        customer: 'Customer Center',
                        followUp: 'Follow-up',
                        personInCharge: 'Persona na may singild',
                        recentFollowup: 'Kamakailan-lamang na sinusundan.',
                        lastContactTime: 'Hulang oras ng contacte',
                        operation: 'Operasyong',
                        see: 'Pansing',
                        exceed: 'Mas maramin',
                        noActivityForMoreThanDays: 'Araw na walang aktibay',
                        lately: 'Kamakain',
                        risksOccurredInTheLastDays: 'Nangyayari ang mga semantika sa panganib sa loob ng mga araw.',
                        savedSuccessfully: 'Ito ang matagumpay',
                        today: 'Ngayon...',
                        allDepartments: 'Lahat ng Departamento',
                        allMembers: 'Lahat ng miyel',
                        customerName: 'Pangalan ng Customr',
                        reset: 'Reseta',
                        query: 'Query',
                        customers: 'Customero',
                        showTheContactInformationBetweenEmployeesAndCustomersInWhichPinkBubblesAreCustomerMessagesAndBlueOnesAreEmployeeMessagesTheLargerTheProportionOfSpeechesTheLargerTheBubbles: 'Ipakita ang contact sa pagitan ng mga empleyado at mga customer, kung saan ang mga rosas na bubble ay mga mensahe ng customer at mga asul na bubble ay mga mensahe ng empleyado. Mas malaki ang proporsyon ng mga pagsasalita, mas malaki ang mga bubble.',
                        riskAllocation: 'Configuration ng Risk',
                        preservation: 'Pag-save',
                        pleaseEnter: 'Mangyaring irekt',
                        noActivityForDays: 'Araw na walang aktibay',
                        riskSemanticsWithinDays: 'Nangyayari ang mga semantika sa panganib sa loob ng mga araw.',
                        addRiskSemantics: 'Dagdag ang peligro semantics',
                        semanticTags: 'Semantic labels:',
                        standardSentence: 'Standard pangungusap:',
                    },
                    components: {
                        advancedFilter: {
                            components: {
                                list: {
                                    index: {
                                        addNewConditions: 'Dagdag ang Bagong Kondisyon',
                                    },
                                },
                            },
                            index: {
                                meetAllOfTheFollowingConditions: 'Ito ang lahat ng mga sumusunod na kondisyon',
                            },
                        },
                        advancedFilterButton: {
                            index: {
                                screen: 'Filtral',
                                pleaseSelectFilteringCriteria: 'Mangyaring piliin ang mga filtra',
                            },
                        },
                    },
                },
                components: {
                    businessStage: {
                        index: {
                            changeOpportunityStage: 'Pagbabago ng Opportunity Stage',
                            theCurrentStageIs: 'Ang kasalukuyang yugto ay α',
                            ConfirmToChangeItTo: '], Kumpirma upang baguhin ito ′',
                            IsIt: ']?',
                            StageCoStay: '] Sa kabuuang pananatilin',
                            day: 'Araw',
                            start: 'Magsimula',
                            end: 'Endo',
                            orderInput: 'Nawala ang Orde',
                            restart: 'Imalist',
                            pleaseConfigureTheSalesStageInformation: 'Mangyaring konfiguro ang impormasyon sa bentahes',
                            reasonForDocumentInput: 'Dahil sa pagkawala ng order:',
                            completeOrderInput: 'Complete Losing Order',
                            pleaseSelectTheReason: 'Mangyaring pumili ng dahilang',
                        },
                        modal: {
                            customerDynamics: {
                                theManagerSuggests: 'Inirerekumenda ng Management:',
                            },
                            index: {
                                sessionDetails: 'Detalyas',
                                customerDynamics: 'Customer Dynamics',
                                riskPoint: 'Peligroso',
                                followUpSuggestions: 'Mga rekomendasyon sa pagsunod',
                            },
                            sessionDetails: {
                                common: 'Kabuan',
                                currentlyViewingThe: 'Sa kasalukuyang tingnan No.',
                                sessions: 'Isang sesyon',
                            },
                        },
                    },
                    businessTitle: {
                        index: {
                            theCurrentStageHasStayed: 'Tumigil ang kasalukuyang phase',
                            day: 'Araw',
                        },
                    },
                    business: {
                        index: {
                            reEnableOpportunity: 'Maaari muling Opportunity',
                        },
                    },
                    customerTag: {
                        index: {
                            label: 'Label',
                        },
                    },
                    moreCustomer: {
                        index: {
                            essentialInformation: 'Pangunahing impormasyong',
                            cancel: 'Kansela',
                            confirm: 'Pagkumpirma',
                            customer: 'Customero',
                            currentFollowupStage: 'Kasalukuyang phase',
                            telephone: 'Telepono',
                            followUpDays: 'Follow-up Days',
                            day: 'Araw',
                            remarks: 'Mga pahayaga',
                            channelPreference: 'Preference sa channel',
                            hello: 'Hello.',
                            customFields: 'Custom Fields',
                            opportunityAmount: 'Mga Opportunity Amon',
                            focus: 'Mga pag-aalalan',
                            customerInformation: 'Impormasyon sa Customero',
                            viewMoreCustomerInformation: 'Makita ang higit pang impormasyon sa customer',
                        },
                    },
                    table: {
                        components: {
                            row: {
                                row0: {
                                    keyEvents: 'Mga pangunahing kaganapan:',
                                },
                                row1: {
                                    customerDynamics: 'Customer Dynamics',
                                    common: 'Kabuan',
                                    barDynamic: 'Dynamiko',
                                },
                                row2: {
                                    riskPoint: 'Peligroso',
                                    common: 'Kabuan',
                                    risks: 'Artikal na Risk',
                                },
                                row3: {
                                    followUpSuggestions: 'Mga rekomendasyon sa pagsunod',
                                    intelligentRecommendation: 'Intelligent rekomend',
                                    strip: 'Artikulo',
                                    managersSuggestATotalOf: 'Inirekomenda ng manager ang kabuuang',
                                    recommendedByManagers: 'Inirekomenda ng Manager',
                                    creationTime: 'Oras ng paglika',
                                    administratorSuggestions: 'Payo ng administrator',
                                    suggestionsForNewManagers: 'Payo ng bagong manager',
                                },
                            },
                        },
                        index: {
                            typeTime: 'Type/Oras',
                        },
                    },
                    userInfo: {
                        index: {
                            personInCharge: 'Persona na may singild',
                            recentFollower: 'Kamakailan-lamang na sinusundan.',
                            startTime: 'Unang oras ng maabot',
                            followUpDays: 'Follow-up Days',
                            day: 'Araw',
                            remarks: 'Mga pahayaga',
                        },
                    },
                },
            },
            studyAnalysis: {
                index: {
                    teamMembers: 'Miyembro ng kopa',
                    membersLearnTheTotalNumberOfOtherPeoplesConversationsdeDuplicationLookingUpTheDetailsOfTheConversationAndClickingTheRecordingAndPlayingIsRegardedAsLearningOnce: 'Ang kabuuang bilang ng mga sesyon na natutunan ng mga miyembro mula sa iba (de-duplication). Ang paghahanap ng mga detalye ng sesyon at pag-click sa pag-record upang maglaro ay itinuturing na isang beses na pag-aaral.',
                    totalNumberOfStudies: 'Bilang ng pag-aaral',
                    theTotalNumberOfCommentsAndRepliesFromMembersToOtherPeoplesSessionsdeDuplication: 'Ang kabuuang bilang ng mga komento at sagot na pinasimulan ng mga miyembro sa sesyon ng iba pang mga tao (deduplication)',
                    totalNumberOfInteractions: 'Bilang ng pakikipag-ugnayan',
                    learnTheSumOfConversationCallDuration: 'Suma ng kapakanan ng tawag sa session',
                    lengthOfStudy: 'Pag-aaral',
                    totalNumberOfMembersWhoInitiatedTheConversationToOthers: 'Ang kabuuang bilang ng mga kahilingan para sa tulong mula sa mga miyembro hanggang sa sesyon ng iba pang mga tao (de-duplication)',
                    totalNumberOfRequests: 'Kabuuang bilang ng mga hinihingi para sa tulo',
                    totalNumberOfMembersCounselingOthersForHelpdeDuplication: 'Bilang ng mga miyembro na nagpapayo para sa tulong mula sa iba (de-duplication)',
                    totalCounseling: 'Bilang ng tutorials',
                    totalNumberOfMemberSessionsToOthersAddedToTheCaseBasedeDuplication: 'Ang kabuuang bilang ng mga sesyon ng mga miyembro sa iba na idinagdag sa kasong library (de-duplication)',
                    addCase: 'Dagdag ang Kaso',
                    totalNumberOfSubscriptionsMadeByMembersToOtherPeoplesSessionsdeDuplication: 'Ang kabuuang bilang ng mga miyembro sa sesyon ng iba pang mga tao (deduplication)',
                    subscribe: 'Subscription a',
                    totalNumberOfSessionsCommunicatedByMembers: 'Bilang ng mga sesyon na nakikipag-ugnay ng mga miyebo',
                    totalSessions: 'Kabuuang Sessions',
                    theTotalNumberdeDuplicationOfAMembersOwnSessionItIsDeemedToBeAReplayIfTheMemberHasCheckedTheSessionDetailsAndClickedTheRecordingAndPlayback: 'Ang kabuuang bilang ng mga miyembro na nagbabalik ng kanilang mga sesyon (de-duplication), paghahanap ng mga detalye ng session at pag-click sa pag-record upang maglaro bilang replaying isang beses.',
                    totalNumberOfDoubleDisk: 'Kabuuang bilang ng replays',
                    totalNumberOfDuplicateDiskTotalNumberOfSessions: 'Bilang ng redisks/total bilang ng session * 100%',
                    proportionOfDoubleDisk: 'Porsyento ng pagpapatuloy',
                    summationOfConversationCallDurationOfDuplicateDisk: 'Summation ng tagal ng session call para sa double diska',
                    resumptionDuration: 'Pag-ulit',
                    totalNumberOfRequestsForHelpFromMembersForTheirOwnSessionsdeDuplication: 'Ang kabuuang bilang ng mga miyembro na nagsimula ng tulong para sa kanilang sariling sesyon (de-duplication)',
                    theTotalNumberOfCommentsincludingRepliesReceivedByOthersInAMembersSession: 'Ang kabuuang bilang ng mga komento (kabilang na ang mga sagot) na natanggap ng sesyon ng miyebo',
                    theTotalNumberOfSessionsOfMembersAddedToTheCaseBaseByOthersdeDuplication: 'Kabuuang bilang ng mga sesyon ng miyembro na idinagdag sa library ng kaso ng iba (de-duplication)',
                    theTotalNumberOfMemberSessionsSubscribedByOthersdeDuplication: 'Bilang ng mga sesyon ng miyembro na sinusubkribe ng iba (deduplication)',
                    askForHelpInTheLastMonth: 'Nakaraang buwan para sa tulong.',
                    lastTimeForHelp: 'Huling oras upang humingi ng tuloyo',
                    operation: 'Operasyong',
                    viewAllSessionsInTheLastMonth: 'Tingnan ang lahat ng session ng nakaraang buan',
                    allDepartments: 'Lahat ng Departamento',
                    reset: 'Reseta',
                    query: 'Query',
                    altogether: 'Isang kabuuang',
                    secondSession: 'Sekundarya session',
                },
            },
            checkPointTest: {
                components: {
                    testSelectComponent: {
                        currentTestItems: 'Kasalukuyang Proyekto ng Test:',
                        supervisionItem: 'Supervision Items',
                        keyEvents: 'Mga pangunahing pangyayarin',
                    },
                },
                index: {
                    pleaseCheckTheMonitoringItemsOrKeyEventsToBeTestedAndEnsureThatThereAreCallsInTheSimulatedDialogue: 'Mangyaring suriin ang mga item ng monitoring o pangyayaring pangyayari na nais mong subukan at tiyakin na may nilalaman sa pagsasalita sa simulate na pag-uusap',
                },
            },
            executionAnalysis: {
                index: {
                    executiveForceAnalysis: 'Execution Analysisy',
                },
            },
            konwledgeBase: {
                detail: {
                    components: {
                        richTextList: {
                            process: 'Proseso 1',
                            technologicalProcess: 'Prosos',
                            newProcess: 'Bagong proseso',
                        },
                    },
                    index: {
                        upload: 'Uploads',
                        preservation: 'Pag-save',
                        newlyBuild: 'Bago',
                        cancel: 'Kansela',
                        name: 'Pangang',
                        describe: 'Paglalarawan',
                        type: 'Type',
                        classification: 'Classifications',
                        content: 'Nilaon',
                        enclosure: 'Annex',
                        knowledgePointAssociation: 'Asosasyon ng point ng kaalaman',
                        open: 'Buksa',
                        close: 'Saray',
                        operator: 'Operator',
                        logic: 'Logiko',
                        see: 'Pansing',
                        edit: 'Pag-edita',
                    },
                },
                index: {
                    name: 'Pangang',
                    describe: 'Paglalarawan',
                    createdBy: 'Creater',
                    type: 'Type',
                    lastUpdated: 'Huling Update Oras',
                    numberOfReferences: 'Bilang ng mga references',
                    operation: 'Operasyong',
                    see: 'Pansing',
                    edit: 'Pag-edita',
                    delete: 'Mangalisa',
                    categoryDeletedSuccessfully: 'Matagumpay na natanggal ang kategorya',
                    classificationOfKnowledgePoints: 'Klasipikasyon ng mga punto ng kaalaman',
                    newlyBuild: 'Bago',
                    knowledgeBase: 'Kaalaman Base',
                    knowledgePoints: 'Mga puntos ng kaalaman',
                    technologicalProcess: 'Prosos',
                    keyword: 'Keywords',
                    batchExport: 'Batch Exporto',
                    batchDelete: 'Batch Deletet',
                    importProcess: 'Proseso',
                    importKnowledgePoints: 'Pag-import ng mga punto ng kaalaman',
                    ifTheKnowledgePointDoesNotExistInTheKnowledgeBaseAddTheKnowledgePointDirectlyIfItExistsSkipAndDoNotUpdate: 'Kung ang punto ng kaalaman ay hindi umiiral sa base ng kaalaman, idagdag ang punto ng kaalaman nang direkta; kung ito ay mayroon, laktawan ito at huwag i-update ito.',
                    editKnowledgePointClassification: 'Pag-edit ng klassifikasyon ng kaalaman',
                    newKnowledgePointClassification: 'Bagong Klassifikasyon ng Kaalamang',
                    categoryEditingSucceeded: 'Tagumpay sa pag-edit ng kategorya',
                    newClassificationSucceeded: 'Bagong Kategory',
                    classificationName: 'Kategory',
                },
            },
            monitoringReport: {
                index: {
                    executiveSupervision: 'Pangangasiwa ng puwersa',
                },
            },
            topicCallout: {
                index: {
                    whole: 'Lahat',
                    date: 'Petsan',
                    dimensionStatus: 'Status ng Callout',
                    callRecordID: 'Call log ID',
                    callRecordIDMustBeNumeric: 'Dapat na numero ng call log ID',
                    strip: 'Artikulo',
                    topicAnnotation: 'Topic Callout',
                    annotated: 'Labeled',
                    stripNotMarked: 'Bar, hindi nakalaba',
                    barInDimension: 'Bars, sa callout',
                    customer: 'Customero',
                    sale: 'Behes',
                    common: 'Kabuan',
                    sessions: 'Session',
                    currentTopic: 'Kasalukuyang Topic:',
                    staff: 'Employa',
                    topicOfConversation: 'Paksaan',
                    theOperationIsSuccessfulAndTheDimensionHasBeenReset: 'Nagtagumpay ang operasyon, binago ang callout',
                    afterResetAllTheAnnotationRecordsOfThisCommunicationSessionWillBeClearedPleaseConfirm: 'Pagkatapos ng i-resettin, ang lahat ng mga record ng labeling ng session na ito ay malilinis. Mangyaring kumpirman',
                    resetAll: 'Reset Laht',
                    pleaseSelectTheTopicToBeMarked: 'Mangyaring pumili ng paksa sa label a',
                    pleaseTickTheSentenceToBeMarked: 'Mangyaring suriin ang pangungusap na markan',
                    theOperationIsSuccessfulAndTheAnnotationHasTakenEffect: 'Nagtagumpay ang operasyon, naging epekto ang label',
                    theScopeOfThisAnnotationIncludesMessagesOfOtherTopicsClickOKToCoverThem: 'Kasama sa saklaw ng anotasyon na ito ang mga mensahe mula sa iba pang mga paksa. Click OK upang magsulat ang mga ito.',
                    confirmDimensions: 'Pagtunay',
                    talkTime: 'Oras ng talk',
                    callID: 'Call id',
                },
            },
            topicList: {
                index: {
                    callID: 'Call ID',
                    latestMarkedTime: 'Pinakababang oras ng pagmamaka',
                    topicOfConversation: 'Paksaan',
                    numberOfSentences: 'Bilang ng pangungusapan',
                    sentence: 'Sentensya',
                    operation: 'Operasyong',
                    see: 'Pansing',
                    delete: 'Mangalisa',
                    edit: 'Pag-edita',
                    newSubTopic: 'Bagong Sub Topic',
                    move: 'Lumaw',
                    whole: 'Lahat',
                    topicDeletedSuccessfully: 'Matagumpay na natanggal ang topic',
                    newlyBuild: 'Bago',
                    topicList: 'Listahan ng paksan',
                    callIDMustBeNumeric: 'Dapat na numero ang ID ng tawag',
                    leadInTopic: 'Importante ng paksan',
                    whenTheCategoryNameIsRepeatedTheOriginalTopicCategoryWillNotBeOverwrittenThisItemWillBeSkippedDirectlyAndWillNotBeImported: 'Kung ang pangalan ng kategorya ay duplicate, ang orihinal na kategorya ng paksa ay hindi masusulat, at ang item ay maaalis at hindi mag-import.',
                    mobileClassification: 'Mobile klasifikasyong',
                    editTopic: 'Pag-edit ng paksan',
                    newTopic: 'Bagong paksan',
                    topicName: 'Pangalan ng paksan',
                },
            },
            groupTest: {
                detail: {
                    template: {
                        modificationSucceeded: 'Nagtagumpay ang pagbabago',
                        createdSuccessfully: 'Matagumpay na nilika',
                        modificationFailed: 'Nabigo ang pagbabago',
                        creationFailed: 'Sawi sa paglikha ng',
                        monitoringName: 'Pangalan ng monitoring',
                        upToCharacters: 'Hanggang 40 characters',
                        pleaseEnterAName: 'Mangyaring ipasok ang pangalan',
                        monitoringIndicators: 'Monitoring index',
                        sessionActivity: 'Session Activity',
                        conversationAction: 'Session',
                        keyEvents: 'Mga pangunahing pangyayarin',
                        supervisionItems: 'Supervision Items',
                        monitoringMembers: 'Mga miyembro ng monitora',
                        groupReceivingGuidanceTrainingOrManagementIntervention: 'Mga grupo na tumatanggap ng gabay, pagsasanay, o interbensyon ng pamamahala',
                        groupA: 'Grupo A',
                        pleaseSelectGroupAData: 'Mangyaring piliin ang datos ng Group A',
                        thereAreDuplicateUsersInGroupB: 'Duplicate ang mga gumagamit sa grupo B',
                        groupARemarks: 'Mga Pangkat A Remarks',
                        controlGroupGroupComparedWithGroupA: 'Control group, kumpara sa grupo A',
                        groupB: 'Grupo B',
                        pleaseSelectGroupBData: 'Mangyaring piliin ang datos ng grupo B',
                        thereAreDuplicateUsersInGroupA: 'May mga duplicate na gumagamit sa grupo A',
                        groupBRemarks: 'Mga Remark ng grupo B',
                        monitoringPeriod: 'Cycle monitoring',
                        startNode: 'Simula ang Node',
                        monitoringScope: 'Range ng monitoring',
                        pleaseSelectMonitoringConditions: 'Mangyaring piliin ang mga kondisyon sa monitoring',
                        pleaseEnterANumber: 'Mangyaring ipasok ang numero...',
                        pleaseSelectATimePeriod: 'Mangyaring pumili ng panahong',
                        preservation: 'Pag-save',
                        cancel: 'Kansela',
                    },
                },
                list: {
                    template: {
                        deletionSucceeded: 'Matagumpay na natanggala',
                        notStarted: 'Hindi Nagsimula',
                        haveInHand: 'Sa paglaon',
                        closed: 'Endad',
                        newGroupTest: 'Bagong Pagsubok',
                    },
                },
            },
            businessConfiguration: {
                salesStage1: 'Sales Phases',
                communicationStrategy1: 'Stratehiya ng komunikasyon',
                riskAllocation: 'Configuration ng Risk',
                businessConfiguration: 'Konfigurasyon ng negosyon',
                communicationStrategy: {
                    detail: {
                        components: {
                            pushRichText: {
                                index: {
                                    objectionHandlingScript: 'Objection Handling',
                                    productSellingPointScript: 'Mga Punto ng pagbebenta ng produkto',
                                    caseGrouping: 'Pag-grupo ng kaso',
                                    pleaseSelectExcellentCases: 'Mangyaring pumili ng magandang kaso.',
                                    pleaseSelectKnowledgePoints: 'Mangyaring pumili ng punto ng kaalaman',
                                    associativeLinks: 'Mga Associated Links',
                                    jumpTo: 'Jump',
                                    jumpType: 'Jump Type',
                                    knowledgePoints: 'Mga puntos ng kaalaman',
                                    excellentCases: 'Mahusay na Kaso',
                                    excellentScript: 'Mahusay na Speeche',
                                    pleaseSelectASingleKnowledgePoint: 'Mangyaring pumili ng iisang punto ng kaalaman',
                                },
                            },
                        },
                        index: {
                            name: 'Pangang',
                            pushText: 'Pumpa',
                            enableStatus: 'Gaan ang Status',
                            triggerRules: 'Rul ng trigger',
                            communicationStrategy: 'Stratehiya ng komunikasyon',
                        },
                    },
                    list: {
                        index: {
                            communicationStrategyGrouping: 'Grupo ng Stratey ng komunikasyonan',
                            name: 'Pangang',
                            pushText: 'Pumpa',
                            effectiveness: 'Effectiveness',
                            openSuccessfully: 'Bukas nang matagumpayan',
                            closeSuccessfully: 'Nakasara nang matagumpayan',
                            operationFailed: 'Nabigo ang operasyong',
                            operation: 'Operasyong',
                            edit: 'Pag-edita',
                            delete: 'Mangalisa',
                            newlyBuild: 'Bago',
                            communicationStrategy: 'Stratehiya ng komunikasyon',
                            editGroup: 'Pag-edit ng Grupo',
                            groupName: 'Pangalan ng grupon',
                        },
                    },
                },
                riskStatement: {
                    detail: {
                        components: {
                            riskSettingRule: {
                                index: {
                                    allSessions: 'Lahat ng sesyons',
                                    recentDays: 'Kamakailan-lamang',
                                    recentSessions: 'Kamakailan-lamang na sesyons',
                                    scopeOfApplication: 'Scope ng application:',
                                    day: 'Araw',
                                    through: 'Passo',
                                },
                            },
                        },
                        index: {
                            describe: 'Paglalarawan',
                            applicableCustomers: 'Apply sa mga customer',
                            enableStatus: 'Gaan ang Status',
                            triggerRules: 'Rul ng trigger',
                            riskRules: 'Mga Panuntunan sa panganib',
                        },
                    },
                    list: {
                        index: {
                            riskAllocation: 'Configuration ng Risk',
                            keyWord: 'Keywords',
                            newRiskRule: 'Bagong Rula ng Risk',
                            riskRuleName: 'Pangalan ng Rule Rul',
                            describe: 'Paglalarawan',
                            state: 'Status',
                            openSuccessfully: 'Bukas nang matagumpayan',
                            closeSuccessfully: 'Nakasara nang matagumpayan',
                            operationFailed: 'Nabigo ang operasyong',
                            operation: 'Operasyong',
                            edit: 'Pag-edita',
                            delete: 'Mangalisa',
                            deletionSucceeded: 'Matagumpay na natanggala',
                        },
                    },
                },
                salesStage: {
                    detail: {
                        components: {
                            alias: {
                                orderInput: 'Nawala ang Orde',
                            },
                            endReasonList: {
                                addEndReason: 'Dagdag ang End Reason',
                                enterEndReason: 'Isugtan ang end dahilang',
                            },
                            stageList: {
                                keyEvents: 'Mga pangunahing pangyayarin',
                                waysideData: 'Follow-the-road datas',
                                includeAny: 'Naglalaman ng anun',
                                includeAll: 'Isipin ang Lahta',
                                pleaseEnterTheStageName: 'Mangyaring ipasok ang pangalan ng phas',
                                setStageRules: 'Itinakda ang Stage Rules',
                                stageName: 'Pangalan ng Phase',
                                operator: 'Operator',
                                logic: 'Logiko',
                            },
                        },
                        index: {
                            theInputFormatOfTheTimeTypeFieldIs: 'Format ng input ng uri ng oras: 2022-12-31 00:00:00',
                            requestFailedPleaseTryAgainLater: 'Nabigo ang hiling, mangyaring subukan muli mamaya.',
                            salesStage: 'Sales Phases',
                            essentialInformation: 'Pangunahing impormasyong',
                            name: 'Pangang',
                            applicableDepartments: 'Applicable Departmente',
                            applicableToOthers: 'Applicable sa ibal',
                            manualChangePhase: 'Manual Change Phases',
                            enableStatus: 'Gaan ang Status',
                            describe: 'Paglalarawan',
                            opportunityStageSettings: 'Opportunity Phase Settings',
                            stageSettings: 'Mga Setting ng Phase',
                            aliasSettings: 'Alias Settings',
                            closeOpportunity: 'End Opportunity',
                            newSuccessfully: 'Bagong tagumpa',
                            newFailed: 'Bagong bigo',
                            savingSucceeded: 'Ito ang matagumpay',
                            saveFailed: 'Sawi sa pag-save',
                        },
                    },
                    list: {
                        index: {
                            salesStage: 'Sales Phases',
                            keyWord: 'Keywords',
                            newSalesStage: 'Bagong Staga',
                            salesStageName: 'Name Stage Stage',
                            describe: 'Paglalarawan',
                            state: 'Status',
                            openSuccessfully: 'Bukas nang matagumpayan',
                            closeSuccessfully: 'Nakasara nang matagumpayan',
                            operationFailed: 'Nabigo ang operasyong',
                            operation: 'Operasyong',
                            edit: 'Pag-edita',
                            delete: 'Mangalisa',
                            deletionSucceeded: 'Matagumpay na natanggala',
                        },
                    },
                },
                largeModelGeneration: {
                    index: {
                        largeModelGeneration: 'Malaking henerasyon ng modelon',
                        conversationInsights: 'Session Insights',
                    },
                    sessionsInsight: {
                        components: {
                            autoGenerate: {
                                index: {
                                    automaticGeneration: 'Awtomatikong binuo',
                                },
                            },
                            hooks: {
                                conversationSummary: 'Session',
                                conversationProcess: 'Session',
                                opportunityPoints: 'Punto ng pagkakataon',
                            },
                            prompt: {
                                index: {
                                    edit: 'Pag-edita',
                                    restoreDefault: 'Pagbabaliko',
                                    cancel: 'Kansela',
                                    confirm: 'Pagkumpirma',
                                },
                            },
                        },
                        index: {
                            saveSuccessful: 'Ito ang matagumpay',
                            hintLanguage: 'Prompt',
                            preserve: 'Pag-save',
                            cancel: 'Kansela',
                        },
                    },
                },
            },
            salesBusinessConfigurationEntry: {
                largeModelGeneration: 'Malaking henerasyon ng modelon',
                salesStage: 'Sales Phases',
                communicationStrategy: 'Stratehiya ng komunikasyon',
                riskAllocation: 'Configuration ng Risk',
                businessConfiguration: 'Konfigurasyon ng negosyon',
            },
            salesLearningCenter: {
                knowledgeBase: 'Kaalaman Base',
                speechCorpus: 'Speech Librarys',
                learningCenter: 'Learning Center.',
            },
            customerFields: {
                components: {
                    baseFields: {
                        index: {
                            customerInformation: 'Impormasyon sa Customero',
                        },
                    },
                },
                index: {
                    otherInformation: 'Iba pang Impormasyon',
                },
            },
        },
        intelligentAnalysis: {
            ruleTemplate: {
                components: {
                    importButton: {
                        index: {
                            import: 'Importan',
                        },
                    },
                },
                hooks: {
                    index: {
                        questionnaire: 'Questionnaires',
                        eCommerceReview: 'E-Commerce Review',
                        socialMediaComments: 'Mga Komento ng Social MediaName',
                        mixing: 'Paghalo',
                        videoCall: 'Video tawag',
                        all: 'Lahat',
                        intelligentModel: 'Intelligent modele',
                        smartRules: 'Smart Rules',
                        manualScoring: 'Manual scorings',
                        enable: 'Mapangita',
                        notEnabled: 'Hindi nagpagala',
                        voiceCall: 'Tawag ng Voice',
                        textDialogue: 'Teksto dialog',
                        ecommerceTextSession: 'E-commerce Text Session',
                        workOrder: 'Work Order',
                    },
                },
                index: {
                    language: 'Wika',
                    mixing: 'Paghalo',
                    videoCall: 'Video tawag',
                    ruleName: 'Pangalan ng Rule',
                    ruleType: 'Type ng panuntaro',
                    pleaseSelect: 'Pakipilin',
                    ruleStatus: 'Rule Status',
                    dataSourceType: 'Type ng Source ng Data',
                    voiceCall: 'Tawag ng Voice',
                    textDialogue: 'Teksto dialog',
                    ecommerceTextSession: 'E-commerce Text Session',
                    workOrder: 'Work Order',
                    status: 'Status',
                    operation: 'Operasyong',
                    edit: 'Pag-edita',
                    ruleTemplate: 'Rule Template',
                },
            },
            analysisReportTitle: 'Report ng Analysisy',
            ruleTest: 'Rule Test',
            intelligentTags: {
                publicOpinionLabel: 'Lahat ng publiko opinyo',
                businessLabel: 'Business Label',
                userLabel: 'User Label',
                productLabel: 'Product Label',
                labelDisplayQuantity: 'Label',
                unlimited: 'Unlimited',
                ignoringTagLibraries: 'Ipagwalaan ng Tag Librarya',
                automaticallyGenerateLabels: 'Paglikha ng mga labels',
                afterActivationLabelsAreAutomaticallyGeneratedForTheSessionBasedOnTheLargeModelAndTheGeneratedLabelsAreClassifiedAsunclassifiedByDefault: 'Matapos ang paggana ng sesyon, ang mga tag ay awtomatikong ginagawa batay sa malaking modelo, at ang mga nabuo na tag ay klase sa ilalim ng Unclassified sa pamamagitan ng default.',
                defaultValidity: 'Default effectivity',
                supervisionItem: 'Supervision Items',
                customerLabel: 'Customer Label',
                newSupervisionItemRule: 'Bagong Panununga',
                editSupervisionItemRule: 'Edit Supervised Item Rule',
                newCustomerLabel: 'Bagong Customer Label',
                editCustomerLabel: 'Pag-edit ng Customer Tags',
                newSessionLabel: 'Bagong Session Label',
                editSessionLabel: 'Pag-edit ng Session Label',
                newKeyEvent: 'Bagong Key Evento',
                editKeyEvents: 'Pag-edit ng Key Evento',
                detail: {
                    template: {
                        type: 'Type',
                        rules: 'Mga patakan',
                        language: 'Wika',
                        pleaseSelectLanguage: 'Mangyaring pumili ng wika',
                        nameIsARequiredField: 'Ang pangalan ay kinakailangang field',
                    },
                    formItemComponent: {
                        ifTheDialogDoesNotMeetTheFollowingOperatorConditionsTheLargeModelIsUsedToDetermineIfTheDialogDoesNotMeetTheFollowingOperatorConditions: 'Kung hindi natutugunan ng dialog ang mga sumusunod na kondisyon ng operator, ang malaking modelo ay ginagamit upang matukoy kung ang diyalogo ay hindi natutugunan ang mga sumusunod na kondisyon ng operator.',
                        largeModelExtensionLabel: 'Malaking Model Extension Tags',
                        sessionRecordID: 'Session record id',
                        sessionTime: 'Session Times',
                        smartTags: 'Smart Label',
                        viewDetails: 'Pansin Detalyas',
                        afterDeletionTheDataRecordedInThisSessionWillBeClearedAreYouSureYouWantToDeleteIt: 'Matapos ang pagtanggal, ang data ng tala ng session na ito ay malilinis. Sigurado ka bang tatanggalin ito?',
                        tagData: 'Tag Data',
                        batchDeletion: 'Batch Deletet',
                    },
                    component: {
                        pleaseSelectAtLeastOneModel: 'Mangyaring pumili ng hindi bababa sa isang modelon',
                        userLabel: 'User Label',
                        productLabel: 'Product Label',
                        publicOpinionLabel: 'Lahat ng publiko opinyo',
                    },
                },
                template: {
                    labelExtraction: 'Label',
                    presetLabelGroup: 'Preset Label',
                    customLabelGroup: 'Custom Label',
                    generateLabelsAutomatically: 'Paglikha ng mga labels',
                    recordingTime: 'Oras ng pagrekord',
                    youCanSelectUpToOneMonthDaysOfRecordsInTheLastYear: 'Maaari mong piliin hanggang sa isang buwan (31 araw) ng mga talaan sa nakaraang taon.',
                    advancedFiltering: 'Advanced filtering',
                    dataType: 'Type ng data',
                    filterCriteria: 'Filter Condition:',
                    edit: 'Pag-edita',
                    createANewSubcategory: 'Bagong Subcategory',
                    delete: 'Mangalisa',
                    nameLengthCannotExceed: 'Hindi maaaring lumampas sa 40 ang haba ng pangan',
                },
                component: {
                    firstCreationMethod: 'Unang Metodo',
                    createManually: 'Lumikha ng manuki',
                    largeModelCreation: 'Malaking Paglikha ng Modelo',
                    language: 'Wika',
                    modelExpansion: 'Pagpapalawak ng Modelo',
                    enable: 'Mapangita',
                    notEnabled: 'Hindi nagpagala',
                    standardScreening: 'Standard filter',
                    advancedFiltering: 'Advanced filtering',
                },
                components: {
                    autoGenerateTagsModal: {
                        afterOpeningTagsAreAutomaticallyGeneratedForSessionsBasedOnLargeModelsTheGeneratedTagsAreClassifiedUnderLargeModelTagsByDefault: 'Pagkatapos ng pagbubukas, ang mga tag ay awtomatikong ginagawa para sa mga sesyon batay sa malalaking modelo. Ang mga nabuo na tag ay klase sa ilalim ng "Large Model Tags" sa pamamagitan ng default.',
                        labelingRequirements: 'Labeling Kinakailangang',
                        pleaseEnter: 'Mangyaring irekt',
                        tagIgnored: 'Hindi pinapansin ang tag',
                        pleaseEnterTheLabelToBeIgnoredAndEnterTheCarToBeAddedAutomatically: 'Mangyaring ipalagay ang label na hindi pinapansin at ipasok ang kotse na awtomatikong idinagdag.',
                        batchFilterLabel: 'Batch Filter Label',
                    },
                    tagExtractModal: {
                        taskType: 'Type ng task',
                        immediateExecution: 'Agad na pagpapataka',
                        timingExecution: 'Pagpapatupad ng oras',
                        executionFrequency: 'Frequency ng pagpapataka',
                        pleaseSelectAnExecutionFrequency: 'Mangyaring piliin ang frequency ng execution',
                        timeFrameCannotExceedDays: 'Hindi maaaring lumampas sa 30 araw ng oras',
                        scheduledTaskInEffect: 'Ang naka-iskeduled gawain ay may epekto...',
                        pleaseStartUsingAfterDataProcessingIsComplete: 'Mangyaring simulan ang paggamit pagkatapos ng pagproseso ng data',
                        endTask: 'Tapos na gawain',
                        viewTasks: 'Pansin ang mga Tasks',
                        voiceCall: 'Tawag ng Voice',
                        textDialogue: 'Teksto dialog',
                        workOrder: 'Work Order',
                        formValidationFailed: 'Nabigo ang validasyon ng form:',
                        labelExtraction: 'Label',
                        dataSource: 'Source ng Data',
                        pleaseSelectADataSource: 'Mangyaring pumili ng source ng data',
                        dataTimeRange: 'Data Time Range',
                        pleaseSelectATimeRange: 'Mangyaring pumili ng ranggo ng times',
                        selectUpToDaysOfData: 'Pumili hanggang 30 araw ng data',
                        extractionQuantityUpperLimit: 'Paglabas ng dami ng pinakamataas na limite',
                        pleaseEnterTheMaximumExtractionQuantity: 'Mangyaring ipasok ang pinakamataas na dami ng extraction.',
                        addToClassification: 'Dagdag sa Classifications',
                        pleaseSelectALabelClassification: 'Mangyaring piliin ang isang klassifikasyon ng etiba',
                        extractionRequirements: 'Mga kinakailangan sa pag-extraction',
                        pleaseEnterExtractionRequirementsoptional: 'Mangyaring ipasok ang mga kinakailangan sa extraction (optional)',
                        submittedSuccessfullyStartCreatingTags: 'Nagpadala ng matagumpay, nagsimula ang paglikha ng tags',
                        checkLater: 'Sinuri mamaya',
                    },
                    timeRange: {
                        index: {
                            today: 'Ngayon...',
                            yesterday: 'Kahapan',
                            theDayBeforeYesterday: 'Ang araw bago kahangan',
                            thisWeek: 'Sa linggo na ito',
                            lastWeek: 'Nakaraang linggo.',
                            thisMonth: 'Ang Buwan nao',
                            lastMonth: 'Nakaraang busan',
                        },
                    },
                },
            },
            businessAnalysis: {
                detail: {
                    businessAnalysisFiter: {
                        component: {
                            keyWord: 'Keywords',
                            sessionLabel: 'Session Label',
                            keyEvents: 'Mga pangunahing pangyayarin',
                            matchAny: 'Match Arbitrary',
                            matchAll: 'Match Lahat',
                            beEqualTo: 'Katumbas',
                            includeAll: 'Isipin ang Lahta',
                            includeAny: 'Naglalaman ng anun',
                            advancedConditions: 'Advanced Conditions',
                            smartTag: 'Smart Label',
                            smartTagI: 'Smart Label O',
                            smartTagII: 'Smart Label II',
                        },
                        template: {
                            pleaseSelectSmartTag: 'Mangyaring pumili ng matalinong labela',
                            pleaseSelectASessionLabel: 'Mangyaring pumili ng label ng session',
                            pleaseSelectAKeyEvent: 'Mangyaring pumili ng pangyayari sa key',
                            pleaseSelectAdvancedCondition: 'Mangyaring pumili ng isang advanced kondisyon',
                            newAdvancedFilter: 'Bagong Advanced filter',
                            moveUp: 'Paglipat Upa',
                            moveDown: 'Lumang Ibas',
                            moveLeft: 'Lumipat sa kaliwan',
                            shiftRight: 'Lumang kanan',
                        },
                    },
                    component: {
                        businessAnalysispng: 'Business Analysis.png',
                        savedSuccessfully: 'Ito ang matagumpay',
                    },
                    template: {
                        ecommerceSessionQualityInspection: 'E-commerce',
                        questionnaire: 'Questionnaires',
                    },
                },
            },
            supervision: {
                detail: {
                    index: {
                        permanentlyValid: 'Permanently Epektive',
                        permanentlyInvalid: 'Permanenteng hindi ayaw',
                        customValidity: 'Personal na saligan',
                        termOfValidity: 'Peryod ng Validity',
                        name: 'Pangang',
                        explain: 'Paglalarawan',
                        state: 'Status',
                        classification: 'Classifications',
                        smartRecommendation: 'Intelligent rekomend',
                        preconditions: 'Prekondisyong',
                        SetPreconditionsForThisSupervisionItem: '1. Itakda ang mga precondition para sa item ng superbisyon na ito:',
                        whenThePreconditionsAreMetItIsThesupervisionItemToBeImplementedAndThenTheSupervisionItemShallBeTested: 'Kapag ang mga pre-kondisyon ay natutugunan, ito ay isinasaalang-alang bilang "ang item ng superbisyon na ipatupad", at ang item ng superbisyon ay dapat subukan;',
                        ifThePreconditionsAreNotMetTheSupervisionItemWillNotBeDetected: 'Kung ang mga pre-kondisyon ay hindi natutugunan, ang item ng superbisyon ay hindi makikita;',
                        NoPreconditionsAreSetThatIsAllSessionsAreDetectedByDefault: '2. Huwag itakda ang mga precondition, iyon ay, ang lahat ng sesyon ay nakikita sa pamamagitan ng default.',
                        have: 'Mayroong',
                        nothing: 'Walan',
                        preconditionRule: 'Patakaran bago',
                        preconditionLogic: 'Precondition logic',
                    },
                    recommendation: {
                        caseGrouping: 'Pag-grupo ng kaso',
                        whenEmployeesFailToPerformWellTheyCanIntelligentlyRecommendExcellentScriptsAndExcellentCases: 'Kapag ang mga empleyado ay hindi gumaganap sa lugar, maaari silang magrekumenda ng mahusay na kasanayan sa pagsasalita at mahusay na mga kaso.',
                        smartRecommendation: 'Intelligent rekomend',
                        open: 'Buksa',
                        close: 'Saray',
                        whenThisSupervisionItem: 'Kapag ang item ng superbisyo',
                        implement: 'Pagpapataka',
                        unexecuted: 'Hindi pinataka',
                        when: 'Kapag:',
                        recommendedKnowledgePoints: 'Rekumenda ang mga punto ng kaalaman',
                        caseRecommendation: 'Inirekomenda ng kaso',
                    },
                },
                index: {
                    determine: 'Determine',
                    sort: 'Sort',
                    sortSucceeded: 'Magtagumpayan',
                    supervisionItemClassification: 'Classification ng mga items',
                    pressEnterToCreateANew: 'Press Enter News',
                    nameCannotBeEmpty: 'Hindi maaaring walang laman ang pangan',
                    newlyBuild: 'Bago',
                    name: 'Pangang',
                    explain: 'Paglalarawan',
                    validStatus: 'Valid Status',
                    permanentlyValid: 'Permanently Epektive',
                    permanentlyInvalid: 'Permanenteng hindi ayaw',
                    operation: 'Operasyong',
                    edit: 'Pag-edita',
                    batchDelete: 'Batch Deletet',
                    newSupervisionItem: 'Bagong Supervision Item',
                    keyWord: 'Keywords',
                    delete: 'Mangalisa',
                    deleteSucceeded: 'Matagumpay na natanggala',
                },
            },
            analysisReport: {
                components: {
                    list: {
                        index: {
                            theDataCannotBeRecoveredAfterDeletionAreYouSureYouWantToDeleteIt: 'Hindi maaaring ibalik ang data pagkatapos ng pagtanggal. Sigurado ka bang nais mong tanggalin ito?',
                        },
                    },
                    businessAnalysisFiter: {
                        component: {
                            smartTag: 'Smart Label',
                            beEqualTo: 'Katumbas',
                            includeAll: 'Isipin ang Lahta',
                            includeAny: 'Naglalaman ng anun',
                            matchAny: 'Match Arbitrary',
                            matchAll: 'Match Lahat',
                            smartTagI: 'Smart Label O',
                            smartTagII: 'Smart Label II',
                        },
                        template: {
                            pleaseSelectASmartTag: 'Mangyaring pumili ng matalinong labela',
                            pleaseSelectAdvancedConditions: 'Mangyaring pumili ng isang advanced kondisyon',
                            newAdvancedFilter: 'Bagong Advanced filter',
                            rename: 'Pangalawan',
                            moveUp: 'Paglipat Upa',
                            moveDown: 'Lumang Ibas',
                            shiftLeft: 'Lumipat sa kaliwan',
                            shiftRight: 'Lumang kanan',
                        },
                    },
                },
                template: {
                    businessTrendAnalysis: 'Analysis ng trend sa negosyon',
                    percentableSituation: 'Percentable sito',
                    delete: 'Mangalisa',
                    labelFiltering: 'Filtering ng Label:',
                    satisfyAny: 'Matugunan ang arbitrary',
                    meetAll: 'Nakilala ang lahat',
                    theNumberOfConversationsOfSecondaryCategoryLabelsPrimaryCategoryAndASessionMayContainMultipleLabels: 'Bilang ng mga talakayan ng pangalawang klassifikasyon ≥ pangunahing klassifikasyon, maaaring naglalaman ng maraming label ang isang sesyon',
                    calculationLogicOfMonthOnMonthChangeconversationVolumeOfTheSelectedTimePeriodConversationVolumeOfTheImmediatelyPrecedingTimePeriodconversationVolumeOfTheLastTimePeriod: 'Logic para sa kalkulasyon ng pagbabago ng ring:/dialogue volume sa nakaraang panahon ng oras',
                    proportionOfPrimaryClassification: 'Porsyento ng klassifikasyon ng unang anbaw',
                    saveAs: 'Pag-save',
                    cover: 'Cover',
                    preservation: 'Pag-save',
                    qualityInspectionTask: 'Gawain ng pagsusuri:',
                    query: 'Query',
                    changeFromMonthToMonth: 'Ring pagbabago',
                    tagRanking: 'Label Ranking',
                    proportion: 'Percentable sito',
                },
                component: {
                    ecommerceTextSession: 'E-commerce Text Session',
                    questionnaire: 'Questionnaires',
                    noSubordinateClassificationExists: 'Walang subordinate na klasifikasyong',
                    categoryName: 'Kategory',
                    numberOfConversations: 'Bilang ng Pag-uusap',
                    operation: 'Operasyong',
                    businessAnalysispng: 'Business Analysis.png',
                    savingSucceeded: 'Ito ang matagumpay',
                    deletionSucceeded: 'Matagumpay na natanggala',
                    sequence: 'Sequences',
                    firstLevelClassification: 'Antas 1',
                    ringRatioChange: 'Ring pagbabago',
                    classClassification: 'Classification',
                },
            },
            intelligentExtractors: {
                components: {
                    pageLeftTable: {
                        areYouSureToDeleteTheDocumentAndItsExtractedContent: 'Kinumpirma na tanggalin ang dokumento at ang nilalaman nito?',
                        addKnowledgeBase: 'Idagdag ang Kaalaman Base',
                        uploadDocument: 'Upload Document',
                        supportsWordPDFPowerPointExcelAndTxtFormatFiles: 'Suporta sa salita, pdf, ppt, excel, txt format files',
                        taskName: 'Pangalan ng Task',
                        extractConversationDate: 'Extract Date ng Pag-uusap',
                        pleaseSelectAConversationDate: 'Mangyaring pumili ng petsa ng pag-uusap',
                        dataSource: 'Source ng Data',
                        dataType: 'Type ng data',
                    },
                    pageRightTable: {
                        index: {
                            exportSuccessful: 'Nagtagumpay ang pag-exporto',
                            problem: 'Katanungan',
                            answer: 'Sumagot',
                            addToKnowledgeBase: 'Idagdag sa Knowledge Base',
                            pleaseConfirmWhetherToDeleteIt: 'Mangyaring matukoy kung tatanggalin',
                        },
                        pageRightFrom: {
                            addToKnowledgeBase: 'Idagdag sa Knowledge Base',
                            selectClassification: 'Magpili ng kategorya',
                            pleaseSelectAKnowledgeBaseClassification: 'Mangyaring piliin ang klassifikasyon ng kaalaman',
                        },
                    },
                },
                index: {
                    intelligentExtraction: 'Intelligent extractions',
                    documentExtraction: 'Document Extraction',
                    dialogueExtraction: 'Pagkuha ng dayalog',
                },
            },
            ignoreLabel: {
                index: {
                    operationSuccessful: 'Nagtagumpay ang operasyon',
                    labelIgnored: 'Hindi pinapansin ang tag',
                    add: 'Dagdagan',
                    areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                    batchFilterLabels: 'Batch Filter Label',
                },
            },
            dataPreprocess: {
                component: {
                    language: 'Wika',
                },
                detail: {
                    template: {
                        language: 'Wika',
                    },
                },
            },
            intelligentCollection: {
                index: {
                    language: 'Wika',
                },
                detail: {
                    index: {
                        language: 'Wika',
                        pleaseSelectLanguage: 'Mangyaring pumili ng wika',
                    },
                },
            },
            customerPortrait: {
                template: {
                    ticketCount: 'Ticket Count:',
                    numberOfVideoCalls: 'Bilang ng mga tawag ng video:',
                    questionnaire: 'Questionnaires',
                },
            },
            sentimentAnalysis: {
                index: {
                    publicOpinionAnalysis: 'Analysis ng opinyon ng publiko',
                },
            },
        },
        logoSite: {
            index: {
                intelligentQualityInspection: 'Intelligent quality inspeksyo',
                savedSuccessfully: 'Ito ang matagumpay',
                logoSettings: 'Mga Setting ng Logo',
                default: 'Defaulta',
                custom: 'Pasawa',
                title: 'Title',
                theTitleOfTheSystemDisplayShouldBeWithinWords: 'Ang pangalan ng pamagat na ipinapakita ng sistema ay inirerekumenda na nasa loob ng 6 na character.',
                logoImageUpload: 'Logo imahe uploads',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'Mangyaring piliin ang larawan na may sukat na hindi lumampas sa 2048kb',
                inOrderToEnsureTheBrowsingEffectOfLogoUploadPicturesSuggestions: 'Upang matiyak ang logo browsing effect, iminungkahi na i-upload ang mga larawan:',
                Size5050Pixels: '1. Laki: 50*50 pixels;',
                FormatPicturesWithTransparentBackgroundPNGOrJPGLogoGraphicsInWhite: '2. Format: larawan na may transparent background, png o jpg,logo graphic gamit white',
                browserLabelIcon: 'Browser tab icon',
                toEnsureTheBrowsingEffectOfTagsUploadPicturesSuggestions: 'Upang matiyak ang epekto ng tag browsing, inirerekumenda na i-upload ang mga larawan:',
                Size3232Pixels: '1. Laki: 32*32 pixels;',
                FormatPictureWithTransparentBackgroundPNGOrJpg: '2. Format: larawan na may transparent background, png o jpg',
            },
        },
        sdkTest: {
            index: {
                qualityInspectionInProgressPleaseCheckLater: 'Ang inspeksyon ng kalidad ay nagaganap, mangyaring maghintay...',
            },
            componentIndex: {
                atThatTimeInChinasRealEstateReachedACriticalMomentForItsSurvivalALargeNumberOfHousesWereLeftUnattendedAndThePeopleWereUnwillingToBuyThemHangzhouOnceFellBelow8000AndSomeDevelopersFailedToShipAtThatTimeShenzhenWasStillAbout2w3wConsolidationAndTheHousesInTheFirstTierCitiesWereAlsoInDanger: 'Noong 2015, ang real estate ng aking bansa ay umabot sa isang kritikal na sandali ng kaligtasan. Isang malaking bilang ng mga bahay ay hindi nakabantay at ang mga tao ay hindi nais na bumili sa kanila. Ang Hangzhou ay isang beses nahulog sa ibaba ng 8000, at ang ilang mga developer ay nabawasan ang merkado sa barko. Si Shenzhen ay pa rin konsolidting sa paligid ng 2w-3w sa oras na iyon, at ang mga bahay sa mga unang-tier na lungsod ay din sa mapanganib.',
                xiaoAn: 'Ann.',
                storestoreStoreloadTheseMemoryBarriersAreCalledJSRMemoryBarriersTheyAreImplementedAtTheJVMLevelThereAreTwoWaysToImplementThemAtTheBottomOfTheOperatingSystemLockBus2MemoryBarrierMetaLanguageSuchAsSfancewriteBarrierMfencefullScreenBarrierAndIfencereadBarrierTheBottomLayerOfTheHotspotsVirtualMachineUsesAnAssemblyStatementLockADDLLockIsAnEmptyOperationThatIsLockBusThisIsBecauseSomeOperatingSystemsDoNotSupportMemoryBarrierMetaLanguage: 'Storestore storeload ang mga hadlang sa memorya na ito ay tinatawag na mga hadlang sa memorya ng jsr, na nasa antas ng jvm. May dalawang pagpapatupad sa ilalim ng operating system: ang isa ay upang i-lock ang bus, at ang isa ay ang memory barrier primitive, tulad ng sfance (isulat barrier) mfence (buong barrier) ifence (basa labanan). Ang ilalim na layer ng mga hotspots virtual machine ay gumagamit ng isang pahayag ng assembly: lock addl, paglock ng isang walang laman na operasyon, na ang lock bus. Ito ay ginagawa dahil ang ilang mga operating system ay hindi sumusuporta sa memory barrier primitives.',
                xiaobei: 'Xiaobei',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheIngredientsAndWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '1. Subukang marinate ang karne ng ilang beses at pinilit ang mga gulay pagkatapos ng pagdaragdag ng alak. Ang karne ay rancid at amoy ng mabuti! Mula ngayon, wala pang pagluluto ng alak para sa bacon',
                xiaodong: 'Xiaodong',
                xiaoxi: 'Xiao Xi',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '3. Subukang marinate ang karne ng ilang beses, at ang mga gulay na fried pagkatapos ng pagdaragdag ng tubig ay tulad ng nasira na karne, na may matinding amoy! Mula ngayon, wala pang pagluluto ng alak para sa bacon',
            },
        },
        home: {
            index: {
                flyingBookConversation: 'Flying Book Conversation',
                templateManagement: 'Template Management.',
                evaluationOverview: 'Overview ng Evaluation',
                evaluationRecord: 'Rekord ng Evaluation',
                curriculumEvaluation: 'Pagsusuri ng kurkulum',
                videoCallManagement: 'Video call managements',
                planManagement: 'Plan Management.',
                dataIntegration: 'Data Integrations',
                questionnaireManagement: 'Pamamahala ng questionnaires',
                originalSoundManagement: 'Orihinal na Sound Management.',
                productManagement: 'Pamamahala ng produkt',
                productDetails: 'Detalyadong produkto',
                qualityAccompanyList: 'Listahan ng kalidad na kasaman',
                ecommerceReviewManagement: 'E-commerce',
                socialMediaReviewManagement: 'Social Media Review Management.',
                customDataSource: 'Custom Data Source',
                qualityInspectionResults: 'Mga resulta ng inspeksyon sa kalida',
                accountManagement: 'Account Management (Account Management)',
                employeeProfile: 'Portrait ng empleyad',
                intelligentAnalysis: 'Intelligent analysisa',
                customKanban: 'Custom Kanban',
                dataScreening: 'Overview ng Data',
                learningRecord: 'Pag-aaral na talaan',
                dataAnalysis: 'Analysis ng data',
                scoringManagement: 'Scoring Management.',
                businessConfiguration: 'Konfigurasyon ng negosyon',
                manualReview: 'Manual review',
                taskList: 'Listahan ng Task',
                videoAnalysis: 'Video Analysisy',
                overview: 'Overviews',
                personalSignage: 'Personal Kanbans',
                learningCenter: 'Learning Center.',
                wrongQuestionSet: 'Maling itinakda ng probleman',
                abilityImprovement: 'Kakayahang mag-upgrades',
                close: 'Saray',
                switchingSystemApplications: 'Mga Applications ng Sistema',
                moveTheMouseHereToCallUpTheApplicationSwitchingMenuClickTheMenuItemToJumpToDifferentApplications: 'Lumipat dito ang mouse upang tawagan ang menu na switching ng application, at mag-click sa menu item upang tumalon sa iba\'t ibang mga application.',
                teamAnalysis: 'Team Analysis a',
                semanticIntelligence: 'Semantic intelligens',
                permissionManagement: 'Pahintulot na Pamayan',
                dataConnection: 'Docking ng datas',
                courseManagement: 'Course Management',
                labelManagement: 'Label Management (Label Management)',
                curriculum: 'Course Center',
                courseConfiguration: 'Konfigurasyon ng kurso',
                task: 'Misyon ko...',
                historicalLearningData: 'Kasaysayan',
                taskCenter: 'Task Management (Task Management)',
                knowledgeBase: 'Kaalaman Base',
                ecommerceSessionManagement: 'E-commerce',
            },
            components: {
                subAppEntries: {
                    applicationSwitching: 'Paglipat ng application',
                    descriptionOfIntelligentQualityInspectionSystem: 'Paglalarawan ng sistema ng inspeksyon ng intelligent quality',
                },
            },
        },
        eCommerceManage: {
            template: {
                ecommerceSessionFilter: 'E-commerce Session Filter',
                allEcommerceSessions: 'Lahat ng mga sesyon ng e-commerce',
                ecommerceSessionManagement: 'E-commerce',
            },
        },
        analysisEnable: {
            bestPractices: 'Best Practices',
            behaviorAnalysis: 'Analysis ng pag-uugal',
            teamAnalysis: 'Team Analysis a',
            executiveSupervision: 'Pangangasiwa ng puwersa',
            executiveForceAnalysis: 'Execution Analysisy',
        },
        appealCheckingTask: {
            sdk: {
                index: {
                    interfaceRequestExceptionPleaseTryAgainLater: 'Pagbubukod ng interface, mangyari subukan muli mamaya',
                    currentDataCannotBeAppealed: 'Hindi maaaring appealed ang kasalukuyang datas',
                    beforeCanAppeal: 'Bago maaaring appeal',
                    time: 'Oras',
                    uniqueRecordID: 'Unique Record ID',
                    videoSessionID: 'Video Session ID',
                    intelligentInspectionTime: 'Matalinong oras ng inspeksyon ng kalidad',
                    manualInspectionTime: 'Oras ng manu-manong inspeksyon ng kalidad',
                    grade: 'Rating:',
                    startTime: 'Simulan Oras',
                    workOrderNo: 'Numero ng Trabaho',
                    customerServiceHasReadNotRead: 'Agent basa/hindi basat',
                    canYouAppeal: 'Kung tatalakay',
                },
                components: {
                    viewTabs: {
                        index: {
                            caseLibrary: 'Case Librarya',
                        },
                    },
                    caseLibView: {
                        index: {
                            caseLibrary: 'Case library',
                        },
                    },
                    qaResultView: {
                        index: {
                            reviewDetailsNotObtained: 'Hindi makuha ang mga detalye ng pagsusuri.',
                            customerService: 'Serbisyo ng customer',
                            review: 'Review',
                        },
                    },
                },
            },
        },
        clientCenter: {
            wechatClientManage: {
                template: {
                    enterpriseAndMicroNotes: 'Mga pangungusap ng mikrobyo',
                    addFriendTime: 'Dagdag ang oras ng kasapa',
                },
            },
            template: {
                ecommerceCustomers: 'Mga customer ng E-commerce',
            },
        },
        qualityInspectionList: {
            detail: {
                component: {
                    finalSubmission: 'Final Submissions',
                    operationSucceeded: 'Nagtagumpay ang operasyon',
                    operationFailed: 'Nabigo ang operasyong',
                    startPerformingReQualityInspection: 'Simulan muling inspekco',
                    callID: 'Call ID',
                },
                template: {
                    newFeaturesClickThequickSpotCheckButtonAndAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'Mga bagong Features! Ang button ng Click \'Quick Sampling Check\' ay awtomatikong tumalon sa susunod na pahina matapos ang matagumpay na pagsusumit ~ ~ ~ ~ ~',
                },
                components: {
                    finalReview: {
                        index: {
                            confirmedFinal: 'Kinumpirma ang final?',
                            afterTheFinalReviewOnlyTheFinalReviewAndFilingOperationsAreSupported: 'Matapos ang huling pagsusuri, ang huling operasyon lamang ng pagsusuri at pag-file ay suportado.',
                            finalAppeal: 'Final Appeal',
                        },
                    },
                },
            },
            template: {
                sort: 'Sort',
                deleteRecord: 'Paglabas ng Recod',
                areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                confirm: 'Determine',
                reIdentification: 'Re-identificay',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'Ang re-identification ay kumukuha ng oras ng paglipat, mangyaring mag-ingat.',
                determine: 'Determine',
                executionSuccessful: 'Matagumpay na pagpapatupad',
            },
            component: {
                pleaseSelectData: 'Mangyaring pumili ng data',
                operationSuccessful: 'Nagtagumpay ang operasyon',
                startPerformingReQualityInspection: 'Simulan muling inspekco',
            },
        },
        recordUpload: {
            template: {
                workOrderUpload: 'Work Order Uploadd',
                uploadFileName: 'Upload ang pangalan ng files',
                analysisTask: 'Gawain ng analysis',
                analyzeProgress: 'Analyze na pag-unlada',
                analysisSucceeded: 'Analysis ng tagumpay',
                analysisFailed: 'Nabigo ang analisi',
                localDataUpload: 'Mga lokal na data',
                recordingUpload: 'Pag-upload ng audio',
                textUpload: 'Text uploads',
                uploadTime: 'Upload oras',
                taskName: 'Pangalan ng Task',
                operator: 'Operator',
                qualityInspectionProgress: 'Progress ng Inspection ng Quality',
                whole: 'Lahat',
                haveInHand: 'Sa paglaon',
                completed: 'Kumpleto',
                exportAllCompletedDataRecordsUnderTheCurrentFilterCondition: 'I-export ang lahat ng mga nakumpletong tala ng data sa ilalim ng kasalukuyang mga kriter ng filter?',
                upload: 'Uploads',
            },
            detail: {
                info: {
                    template: {
                        uploadTicketFieldData: 'Upload data ng ticket field',
                        workOrderFieldTemplateDownload: 'Pag-download ng Work Order Field Template',
                        uploadWorkOrderMailData: 'Mail data ng order ng trabaho',
                        emailTemplateDownload: 'Email Template Downloade',
                        fillInTheName: 'Mula sa pangan',
                        fillInTheNameSuchAsTheTypesetpurposeOfTheImportedData: 'Maglagay ng pangalan, tulad ng uri/collection/purpos ng mga imported data.',
                        default: 'Defaulta',
                        jDCOM: 'Jingdong',
                        dataType: 'Type ng data',
                        selectAnalysisTask: 'Pumili ng Analysis Task',
                        uploadFiles: 'Upload ang Files',
                        DownloadExcelTemplateAndFillInAccordingToTheFormat: '1. I-download ang mahusay na template at punan ito ayon sa format:',
                        template: 'Template',
                        SupportUpTo10000PiecesOfData: '2. Mas malalaking suporta 10000 piraso ng data',
                        supportTheUploadOfDialogDataExportedByJDLogFileWithAMaximumFileSizeOfM: 'Suporta ang pag-upload ng data ng diyalogo ng Jingdong, file file, maximum na suporta 100M',
                        alongTheWayDataTemplate: 'Follow-the-road data template',
                    },
                },
                result: {
                    template: {
                        workOrderQualityInspection: 'Inspeksyon ng Quality ng Work Orde',
                        workOrderQualityInspectionCompleted: 'Nakumpleto ang Inspection ng Quality ng Work Order',
                        textUnderInspection: 'Mangyaring maghintay nang matiyaga sa panahon ng inspeksyon ng kalidad ng teksto.',
                        textQualityInspectionCompleted: 'Kumpleto ang inspeksyon ng kalidad ng teksto',
                    },
                },
                template: {
                    startAnalysis: 'Simula ang Analysisy',
                    pleaseUploadTheFile: 'Mangyaring upload ang talaksan',
                    localDataUpload: 'Mga lokal na data',
                },
            },
        },
        reviewList: {
            detail: {
                template: {
                    newFeaturesClickThereviewAndSubmitButtonAndThePageWillAutomaticallyJumpToTheNextPageAfterTheSubmissionIsSuccessful: 'Mga bagong Features! Click \'Review Submit\' button, matapos ang tagumpay, ito ay awtomatikong tumalon sa susunod na pahina ~ ~ ~ ~ ~ ~ ~',
                },
            },
            template: {
                sort: 'Sort',
            },
        },
        role: {
            detail: {
                taskPermissions: {
                    template: {
                        qualityInspectionTaskPermission: 'Pahintulot sa gawaing inspekso',
                        edit: 'Pag-edita',
                        iParticipated: 'Ako ay kasangkot sa',
                    },
                },
                dataPermissions: {
                    template: {
                        thisRoleCanSeeDataUnderTheSelectedDepartment: 'Ang papel na ito ay maaaring makita ang data sa ilalim ng piniling departamenton',
                        dataPermissions: 'Mga pahintulot sa data',
                        selectDepartment: 'Pumili ng Departamento',
                        edit: 'Pag-edita',
                    },
                },
            },
        },
        spotCheckList: {
            detail: {
                component: {
                    startPerformingReQualityInspection: 'Simulan muling inspekco',
                    callID: 'Call ID',
                },
                template: {
                    newFeaturesClickThesampleInspectionSubmissionAndquickSampleInspectionButtonsAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'Mga bagong Features! Ang mga pindutan ng sampling submit at \'mabilis na pagsusumit\' ay awtomatikong tumalon sa susunod na pahina matapos ang matagumpay na pagpapadala ~ ~ ~ ~ ~ ~',
                },
            },
            template: {
                sort: 'Sort',
            },
        },
        templateTest: {
            semanticTags: {
                template: {
                    rule: 'Mga patakan',
                },
            },
        },
        ticketManage: {
            detail: {
                template: {
                    workOrderManagement: 'Work Order Management.',
                    workOrderDetails: 'Detalyas ng Work Order',
                },
            },
            template: {
                workOrderFilter: 'Filter ng Work Order',
                allWorkOrders: 'Lahat ng Work Orders',
                workOrderManagement: 'Work Order Management.',
            },
        },
        trainingCenter: {
            topicAnnotation: 'Topic Callout',
            topicList: 'Listahan ng paksan',
            clusteringAnnotation: {
                components: {
                    filter: {
                        index: {
                            roleType: 'Type ng Role',
                            keyWord: 'Keywords',
                            pleaseEnterKeywordSearch: 'Mangyaring ipasok ang keyword search a',
                            query: 'Query',
                        },
                    },
                },
            },
            similarQuestionRecommend: {
                index: {
                    thisFunctionHasNotBeenOpenedYetPleaseContactTheSystemAdministratorIfNecessary: 'Hindi pa binuksan ang function na ito. Mangyaring makipag-ugnay sa administrator ng system kung kinakailangan.',
                    pleaseSelectAQuestion: 'Mangyaring pumili ng tanong!',
                    recommendedSimilarSentencesLargeModel: 'Rekumenda ng mga katulad na pangungusap (malaking modelo)',
                    selectAll: 'Pilit',
                    add: 'Dagdagan',
                    changeBatch: 'Magbago ng batche',
                },
            },
            fastTraining: {
                components: {
                    sentenceTypeTag: {
                        index: {
                            createManually: 'Lumikha ng manuki',
                            largeModelExpansion: 'Malaking pagpapalawak ng modelon',
                            nLPAutomaticExpansion: 'Awtomatikong pagpapalawak ng NLP',
                        },
                    },
                },
            },
        },
        adminEntry: {
            qualityInspectionLanguageSettings: 'Mga setting ng Wika ng Inspection ng kality',
            businessWorkingHours: 'Oras ng trabaho sa negosyon',
            localDataUpload: 'Mga lokal na data',
            assembleMenuListAccordingToCurrentUserPermissions: 'Listahan ng menu ayon sa mga kasalukuyang pribilehiyo ng user',
            sessionSettings: 'Session',
            logoSettings: 'Mga Setting ng Logo',
        },
        login: {
            template: {
                welcomeBackPleaseEnterYourDetails: 'Mula! Mangyaring ipasok ang iyong detalya',
                mailbox: 'E-mail',
                password: 'Password',
                signIn: 'Login',
            },
            components: {
                layout: {
                    theCurrentIPDoesNotAllowLogin: 'Hindi pinapayagan ang kasalukuyang IP ang pag-login',
                    welcomeToLogin: 'Galing sa Login',
                    pursuingExcellenceAndLeadingChange: 'Ang pagpapatuloy ng mahusay, humantong sa pagbabago',
                    intelligentPlatform: 'Intelligent Platforma',
                },
                virtualLogin: {
                    index: {
                        pleaseSelect: 'Pakipilin',
                    },
                },
            },
            oauth: {
                illegalCall: 'Ang ilegal na tawag',
                welcomeBackClickTheButtonBelowToJumpToTheIdentityAuthenticationPlatform: 'Mula! Click ang pindutan sa ibaba upang tumalon sa platform ng pagpapatunay',
                loggingIn: 'Login...',
                unifiedIdentityAuthenticationLogin: 'Unified Identity Authentication Login',
            },
            component: {
                unableToLogIn: 'Hindi maka-log in!',
                unableToLand: 'Hindi makalapag!',
                theAccountDoesNotHaveTheCorrectPhoneInformationAndCannotObtainTheVerificationCodePleaseContactTheAdministratorToFillInTheCorrectPhoneInformationAndTryAgain: 'Ang account ay walang tamang impormasyon sa telepono at hindi makakakuha ng verification code. Mangyaring makipag-ugnay sa administrator upang punan ang tamang impormasyon sa telepono at subukan muli.',
            },
        },
        checkPointTest: {
            index: {
                simulatedWorkOrder: 'Simulated Work Order',
                ruleTestSomeRulesCannotBeTestedUsingRulesSuchAsVoiceSpeedVolumeAndOnTheRoadData: 'Pagsusulit ng panuntunan: Ang ilang mga patakaran ay hindi maaaring subukan gamit ang mga patakaran, tulad ng speech speech speed at volume, data kasama ang paraan, atbp.',
            },
        },
        appEntry: {
            components: {
                subSystemEntryCard: {
                    learnMore: 'Mas maramin',
                    enteringTheSystem: 'Maglagay ng sistema',
                },
            },
            index: {
                cancel: 'Kansela',
                enteringTheSystem: 'Maglagay ng sistema',
                close: 'Saray',
                enterSystemApplication: 'Ipasok ang aplikasyon ng sistema',
                clickEnterSystemToJumpToTheEnabledSystemApplication: 'Click "Enter System" upang jump sa isang naka-abled system app.',
            },
        },
        permissionManagement: {
            employeeManagement: 'Employee Managements',
            roleManagement: 'Role Management (Role Management)',
            permissionManagement: 'Pahintulot na Pamayan',
        },
        generalSetting: {
            docking: {
                components: {
                    ruleList: {
                        beEqualTo: 'Katumbas',
                        contain: 'Naglalando',
                        doesNotContain: 'Hindi naglalaman',
                        applicationSystem: 'Sistema ng aplikasyong',
                        intelligentQualityInspection: 'Ang inteligent quality inspection/intelligent session analysisa',
                        salesEmpowerment: 'Pagbebentas',
                        dataSourceType: 'Type ng Source ng Data',
                        filterCriteria: 'Filter Condition:',
                    },
                },
                index: {
                    dataConnection: 'Docking ng datas',
                    savingSucceeded: 'Ito ang matagumpay',
                    dataIsolation: 'Isolation ng data',
                    afterOpeningYouCanSetTheDataRangeOfEachApplicationSystemAccessCallAndEnterpriseWeChatSessionIfTheSwitchIsNotTurnedOnAllSystemsAreConnectedToFullData: 'Pagkatapos ng pagbubukas, maaari mong itakda ang range ng data ng bawat application system access call at enterprise WeChat session. Kung ang switch ay hindi nakabukas, ang lahat ng mga system ay konektado sa buong data.',
                    accessRules: 'Mga Panunuunang access',
                    preservation: 'Pag-save',
                },
            },
            permissionManagement: {
                role: {
                    index: {
                        applyName: 'Pangalan ng application',
                        accessRights: 'Access',
                        inAppPermissionSettings: 'Mga settings ng pahintulot sa in-app',
                        setUp: 'Pagtatako',
                        applicationAccess: 'Access ng application',
                        newRole: 'Bagong Rol',
                    },
                },
            },
        },
        wechatNotificationAnalysis: {
            conversationalAnalysis: {
                index: {
                    sessionDetails: 'Detalyas',
                },
            },
            messageNotification: {
                index: {
                    sessionDetails: 'Detalyas',
                    caseDetails: 'Detalyas',
                },
            },
        },
        coach: {
            courseManagement: {
                baseInfo: {
                    index: {
                        save: 'Pag-save',
                        cancel: 'Kansela',
                        visibleEmployees: 'Makikita na mga empleyad',
                        newCourse: 'Bagong kurso',
                        editCourse: 'Pag-edit ng kurso',
                        courseName: 'Pangalan ng kurso',
                        courseIntroduction: 'Pagkilala sa kurso',
                        courseType: 'Type ng kurso',
                        courseClassification: 'Classification ng kurso',
                        courseCover: 'Course Cover',
                        learningContent: 'Nilalaman ng pag-aaral',
                        uploadLearningMaterials: 'Mga materyales sa pag-aaral',
                    },
                },
                flow: {
                    components: {
                        configDrawer: {
                            test: 'Testo',
                            preservation: 'Pag-save',
                            cancel: 'Kansela',
                            editNodeName: 'I-edit ang Node',
                            determine: 'Determine',
                            individual: 'Isan',
                            of: ', Kabuuang',
                            branch: 'Punts',
                        },
                        configDrawerComponents: {
                            pPTParsing: 'PPT analysis sa...',
                            uploadSuccessful: 'Tagumpay ang uploads',
                            uploadAttachments: 'Upload Attachment',
                            pPTParsingPleaseWait: 'PPT parsing, mangyaring maghintay',
                        },
                        customerPortraitConfigDrawer: {
                            cancel: 'Kansela',
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisPortrait: 'Hindi ito maaaring ibalik pagkatapos ng pagtanggal. Sigurado ka bang nais mong tanggalin ang larawan na ito?',
                            delete: 'Mangalisa',
                            determine: 'Determine',
                            customerPortrait: 'Customer Portraite',
                            bindSelectedCharacterPortrait: 'Binlaan ang piniling portrait ng characters',
                            customerProfileDetails: 'Detalyas ng Customer Profile',
                            createANewCustomerProfile: 'Bagong Customer Profile',
                        },
                        flow: {
                            sidebar: {
                                node: 'Node',
                            },
                            useControlButtons: {
                                cancellingPleaseWait: 'Undo in, mangyaring mamaya...',
                                redoInProgressPleaseWait: 'Muli, mangyaring mamaya ....',
                                automaticOrganization: 'Awtomatikong Pagtatap',
                                canvasAdaptation: 'Canvas adaptive',
                                delete: 'Mangalisa',
                            },
                            useFlow: {
                                nodeCannotBeConnectedToItself: 'Hindi maaaring koneksyon sa node sa kanyang sarilin',
                            },
                        },
                        globalConfigDrawer: {
                            cancel: 'Kansela',
                            determine: 'Determine',
                            globalConfiguration: 'Global Configuration',
                            sessionDetection: 'Pagtukta ng session',
                            reciprocalRule: 'Mga Panuntunan sa pakikipag-ugnayan',
                            robotVoice: 'Tunog ng Robot',
                        },
                        interactionRuleForm: {
                            studentNodeTimeoutWithoutAnsweringSetting: 'Ang oras ng mag-aaral node ay hindi sagot na setting',
                            maximumAllowedSilenceTimeForStudentsNotAnswerings: 'Pinapayagan ng pinakamataas na oras (s)',
                            promptScriptForFailureToAnswerOverTime: 'Prompt para sa timeout',
                            addScript: 'Dagdag ang mga salat',
                        },
                        robotTimbreForm: {
                            aixianatural: 'Aisha (Nature)',
                            zhishaChat: 'Zhisha (chat)',
                            zhiqiangentle: 'Zhiqian (Gentle)',
                            zhimiEmotion: 'Know rice (emosyon)',
                            aiShuoNatural: 'Aishuo (Nature)',
                            zhishuoChat: 'Zhishuo (chat)',
                            aiHaoAffinity: 'Ai Hao (Affinity)',
                            zhixiangEmotion: 'Zhixiang (Emotion)',
                            robotVoice: 'Tunog ng Robot',
                            schoolboy: 'Boys',
                            girlStudent: 'Mga babae',
                            volume: 'Volumo',
                            tone: 'Tone',
                            speechSpeed: 'Speed of Speeche',
                            test: 'Testo',
                            helloIAmAnIntelligentTrainingCoachAndLookForwardToCommunicatingWithYou: 'Kumusta, ako ay isang matalinong coach ng pagsasanay at umaasa sa pakikipag-usap sa iyo.',
                        },
                        sessionDetectionForm: {
                            expressionDetection: 'Detekta ng ekspresyonan',
                            excessiveDetectionOfModalParticles: 'Labis na modal detection ng salita',
                            theNumberOfRepetitionsIs: 'Ang bilang ng mga paulit-ulit ay',
                            minus: 'Oras, minus',
                            appear: 'Lilitaw',
                            subtract: 'Times, minus',
                            branch: 'Punts',
                            addRules: 'Dagdag ang Rule',
                            includingNegativeAngryComplaining: '(Kasama ang negatibo, galit, reklamo)',
                            scorePointsDisplay: 'Score Points Display',
                            reminderOfSpeakingTooFasttooSlow: 'Speedtoo fast/too mabagal na paalalan',
                            scriptViolationReminder: 'Paalala ng paglabag sa pagsasabit',
                            emotionalReminder: 'Emosyonal na paalalan',
                            speechSpeedDetection: 'Pagkakita ng speech speed',
                            normalSpeechSpeedScore: 'SPEED NORMAL SCORE',
                            speakTooFast: 'Masyadong mabilis ang pagsasalita...',
                            everyMinuteGreaterThan: 'Mas malaki kaysa sa bawat minuto',
                            aWordAppears: 'Salita, lumitaw.',
                            speakTooSlowly: 'Masyadong mabagal',
                            lessThanPerMinute: 'Mas mababa sa bawat minuto',
                            ignoreLessThan: 'Hindi bahala ng mas maa',
                            aSentenceOfWords: 'Ang pangungusap ng salat',
                            emotionalDetection: 'Detekta ng emosyon',
                            emotionalNormalScore: 'Normal na score ng mood',
                            negativeEmotions: 'Negatibong emosyon',
                            illegalWordDetection: 'Ilegal na detection ng salat',
                            scriptViolationConfiguration: 'Konfigurasyon ng Paglabag ng Speeche',
                            realTimePromptOnTheFrontEnd: 'Front-end real-time prompt',
                        },
                        const: {
                            nodeConfigs: {
                                knowledgeNode: {
                                    knowledgeBaseQA: 'Knowledge Base Q & A',
                                    qAMethod: 'Paraan ng tanong at sagot',
                                    numberOfQuestionsAndAnswers: 'Bilang ng mga Katanungan at sagot',
                                    scoringRules: 'Mga Panununga',
                                    ifAnyQuestionAndAnswerIsCorrect: 'Anumang tanong at sagot ay tama, mayroon kan',
                                    branch: 'Punts',
                                    successfullySaved: 'Ito ang matagumpay',
                                },
                                pptNode: {
                                    verificationPassed: 'Ipinasa',
                                    upload: 'Uploads',
                                    supportPptPdfFormatFiles: 'Suporta ang mga file ng format ppt at pdf',
                                    uploadSlide: 'Upload Slides',
                                    assessmentMethod: 'Paraan ng pagsusura',
                                    associateSlide: 'Associate Slides',
                                    standardScript: 'Standard Speeche',
                                    successfullySaved: 'Ito ang matagumpay',
                                },
                                robotNode: {
                                    robotScript: 'Robot Speeche',
                                    randomScript: 'Random Speeche',
                                    chooseAScriptWithSimilarSemanticsAndTheRobotWillRandomlySayOneSentence: 'Pumili ng mga salita na may katulad na semantika, at ang robot ay mananatiling sabihin ng isa sa mga pangunguhan',
                                    customerPortrait: 'Customer Portraite',
                                    whenTheCustomersPortraitIsConsistentTheRobotSaysThisScript: 'Kapag ang portrait ng customer ay pare-pareho, nagsasalita ito ng robot.',
                                    setAsDefaultScript: 'Itinakda bilang defaulta',
                                    yes: 'Oo,',
                                    no: 'Hindin',
                                    useThisScriptWhenTheRobotMissesAnyUserTags: 'Ito ay sinabi kapag nakaligtaan ng robot ang anumang user tag.',
                                    successfullySaved: 'Ito ang matagumpay',
                                    thisBranchNodeAlreadyHasADefaultScriptDoYouWantToReplaceTheDefaultScriptWithTheCurrentScript: 'Ang node ng sangay na ito ay may default na pagsasalita. Gusto mo bang palitan ang default na pagsasalita sa kasalukuyang pagsasalita?',
                                },
                                startNode: {
                                    paragon: 'Voiceover',
                                    successfullySaved: 'Ito ang matagumpay',
                                },
                                userNode: {
                                    verificationPassed: 'Ipinasa',
                                    standardScript: 'Standard Speeche',
                                    successfullySaved: 'Ito ang matagumpay',
                                },
                                aiGenDialogueNode: {
                                    pleaseImproveTheConfiguration: 'Mangyaring perpekto ang pagsasaayos',
                                },
                                aiGenPromptNode: {
                                    pleaseEnterAConversationExample: 'Mangyaring ipasok ang isang sample na pag-uusap',
                                    dialogueExample: 'Halimbawa ng pag-uusal',
                                    generateConversationExamples: 'Bukha ng Dialog',
                                    mattersNeedingAttention: 'Preutions',
                                    pleaseEnterThePromptLanguage: 'Mangyaring ipasok ang prompt',
                                },
                                aiGenSceneNode: {
                                    dialogueScenario: 'Scene dialog',
                                    simulateCharacter: 'Simulated characterName',
                                    accompanyingTrainees: 'Sumasama ang objecto',
                                    selectFromTemplateLibrary: 'Pumili mula sa Template Librarya',
                                    templateLibrary: 'Template Librarya',
                                    role: 'Role',
                                    scene: 'Scene',
                                },
                            },
                        },
                        pPTTestDrawer: {
                            slideTestWindow: 'Slide Test Window α',
                            clearContent: 'Liyas',
                            close: 'Saray',
                        },
                        aiGenFlowDrawer: {
                            index: {
                                aIGenerationProcessScript: 'AI Generation Process',
                                scriptStyle: 'Speech Style',
                                theMostConversationRounds: 'Karamihan sa mga ikot ng dialogo',
                                copyConversation: 'Copy Dialogog',
                                application: 'Aplikation',
                                regenerate: 'Regeneratee',
                                startGenerating: 'Nagsimula ang henerasyong',
                                pleaseGenerateAProcess: 'Mangyaring Bukhain Prosyo',
                                copySuccessful: 'Pagkopya ng tagumpa',
                            },
                        },
                        aiGenPPTDrawer: {
                            components: {
                                tipInput: {
                                    index: {
                                        salesRepresentative: 'Representative ng Sales',
                                        customerServicePersonnel: 'Customer Service Staff',
                                        storeCounter: 'Store Counter',
                                    },
                                },
                            },
                            index: {
                                generateFullTextSpeechScript: 'Bumubuo ang mga kasanayan sa full-text speeh',
                                speaker: 'Speaker',
                                scriptStyle: 'Speech Style',
                                copyConversation: 'Copy Dialogog',
                                application: 'Aplikation',
                                regenerate: 'Regeneratee',
                                startGenerating: 'Nagsimula ang henerasyong',
                                pleaseGenerateAProcess: 'Mangyaring Bukhain Prosyo',
                                operationSuccessful: 'Nagtagumpay ang operasyon',
                                copySuccessful: 'Pagkopya ng tagumpa',
                            },
                        },
                        aiTextArea: {
                            index: {
                                scriptPolishing: 'Speech polish',
                            },
                        },
                        aiWordsTextArea: {
                            theScriptCannotBeEmpty: 'Hindi maaaring walang laman ang mga salita!',
                            copySuccessful: 'Pagkopya ng tagumpa',
                            cancel: 'Kansela',
                            copy: 'Kopyahay',
                            replaceTheOriginalText: 'Papalitan ang orihinala',
                            aiGeneration: 'Henerasyon ng Ai',
                            aiPolishing: 'Ai polish',
                            currentStyle: 'Kasalukuyang Estile',
                            rigorous: 'Mahirap',
                            mild: 'Bantle',
                            lively: 'Lively',
                            simplicity: 'Simplet',
                            pleaseEnterTheSpeakerRole: 'Mangyaring ipasok ang role ng speaker',
                            startGenerating: 'Nagsimula ang henerasyong',
                        },
                        auditionTextArea: {
                            theScriptCannotBeEmpty: 'Hindi maaaring walang laman ang mga salita!',
                            copySuccessful: 'Pagkopya ng tagumpa',
                            aiRewrite: 'Ai Rewrite',
                            cancel: 'Kansela',
                            copy: 'Kopyahay',
                            replaceTheOriginalText: 'Papalitan ang orihinala',
                            currentStyle: 'Kasalukuyang Estile',
                            rigorous: 'Mahirap',
                            mild: 'Bantle',
                            lively: 'Lively',
                            simplicity: 'Simplet',
                            pleaseEnterTheSpeakerRole: 'Mangyaring ipasok ang role ng speaker',
                            startGenerating: 'Nagsimula ang henerasyong',
                        },
                    },
                    index: {
                        verificationPassed: 'Ipinasa',
                        ruleValidation: 'Pag-verifyo',
                        aIGeneration: 'AI henerasyong',
                        generateFullTextSpeechScript: 'Bumubuo ang mga kasanayan sa full-text speeh',
                        editCourse: 'Pag-edit ng kurso',
                        importConversation: 'Pag-uugnayan',
                        uploadExcelToCompleteDialogueImport: 'Upload Excel Complete Dialog Importe',
                        editBasicInformation: 'Pag-edit ng pangunahing impormasyong',
                        test: 'Testo',
                        release: 'Publish',
                    },
                },
            },
            customerTagsManagement: {
                components: {
                    addTag: {
                        index: {
                            newLabel: 'Bagong Label',
                        },
                    },
                    tag: {
                        index: {
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabel: 'Hindi makabawi pagkatapos ng pagtanggal. Sigurado ka bang nais mong tanggalin ang label na ito?',
                            delete: 'Mangalisa',
                            cancel: 'Kansela',
                        },
                    },
                },
                index: {
                    labelManagement: 'Label Management (Label Management)',
                    newGroup: 'Bagong Grupo',
                    edit: 'Pag-edita',
                    afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabelGroup: 'Hindi makabawi pagkatapos ng pagtanggal. Sigurado ka bang nais mong tanggalin ang grupo ng label na ito?',
                    delete: 'Mangalisa',
                    cancel: 'Kansela',
                    editGroup: 'Pag-edit ng Grupo',
                    labelGroupName: 'Name Group ng Label',
                },
            },
            learningCenter: {
                components: {
                    camera: {
                        index: {
                            cameraDisabled: 'Camera ay hindi pinaganang',
                            noCameraDevicesFound: 'Hindi nahanap ang aparato ng cama',
                        },
                    },
                    cue: {
                        index: {
                            regenerate: 'Regeneratee',
                            generate: 'Generated',
                            referenceScript: 'Reference Speecha',
                            mattersNeedingAttention: 'Preutions',
                            examFrequency: 'Bilang ng exams',
                            section: 'Sekson',
                            timestotal: 'Times/Total',
                            second: 'Timess',
                            requirementsForPassingTheExam: 'Mga kinakailangan para sa pagpasa ng exam',
                            examScore: 'Test score ≥',
                            branch: 'Punts',
                        },
                    },
                    customerInfo: {
                        index: {
                            thereIsCurrentlyNoPortraitAvailable: 'Walang larawn',
                            customerBackground: 'Customer Backgrounds',
                            customerLabel: 'Customer Label',
                        },
                    },
                    flow: {
                        index: {
                            processReminder: 'Process Prompt',
                            score: 'Score',
                            TotalScore: '/Total Score',
                        },
                    },
                    index: {
                        taskSource: 'Pinagmulan ng Task',
                        taskName: 'Pangalan ng Task',
                        taskStatus: 'Task Status',
                        whole: 'Lahat',
                        completionStatus: 'Status ng pagkumpleto',
                        courseClassification: 'Classification ng kurso',
                        practiceMode: 'Mode na gaganan',
                        examMode: 'Mode ng pagsusulita',
                        practiceTime: 'Pag-ehersisyo ng oras',
                    },
                    ppt: {
                        index: {
                            nextPage: 'Susunod na Pahinan',
                            tips: 'Prompt',
                            continueWithCurrentPage: 'Patuloy ang Kasalukuyang Pahinan',
                            goToTheNextPage: 'Pumunta sa susunod na pahinan',
                            afterEnteringTheNextPageYouWillNotBeAbleToReturnToThePreviousPagePleaseConfirmThatTheExplanationOnTheCurrentPageIsCompleteBeforeJumpingToTheNextPage: 'Matapos ipasok ang susunod na pahina, hindi ka makakabalik sa nakaraang pahina. Mangyaring kumpleto ang paliwanag ng kasalukuyang pahina bago tumalon.',
                            clickingOnTheNextPageWillNoLongerCauseThisPromptToPopUp: 'Hindi mapapalabas ang prompt na ito sa susunod na pahina...',
                        },
                        list: {
                            index: {
                                slide: 'Slide',
                            },
                        },
                    },
                    record: {
                        index: {
                            unableToRecord: 'Hindi ma-record:',
                            creatingARecorderService: 'Lumikha ng Serbisyo ng Recorder',
                            turnOffTheRecorderService: 'Ipahin ang serbisyo ng Recorder',
                            theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ang kasalukuyang kliyente ay konektado na sa ASR Websocket server',
                            afterProcessingTheLastFrameRestoreTheState: 'Matapos ang pagproseso ng huling frame, ibalik ang estado.',
                            aSRConnectionClosed: 'Sarado ang koneksyon ng ASR...',
                            recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'Ang pag-recorded paused at natapos na proseso, ngunit may data pa rin sa cache',
                            foundASRChannelClosedRecreateWebsocketLink: 'Natagpuan ang ASR channel closed, muling lumikha ng Websocket link',
                            foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'Natagpuan na ang ASR channel ay hindi bukas, likha muli ang Websocket link',
                        },
                        ppt: {
                            hook: {
                                index: {
                                    serverError: 'Error ng server',
                                },
                            },
                        },
                        text: {
                            index: {
                                pleaseEnter: 'Mangyaring irekt',
                                sendOut: 'Dalan',
                                startPracticing: 'Magsimula sa pagsasanay',
                                startTheExam: 'Simulan ang exam',
                            },
                        },
                        util: {
                            recorded: 'Na-recorded',
                            BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Ang 16-bit pcm SendFrameSize ay dapat isang integer multiply of 2',
                            pCMSamplingRateShouldNotOccur: 'Hindi dapat lumitaw ang rate ng sampling ng pcm',
                            andTheRequiredSamplingRate: 'At ang kinakailangang sampling rate',
                            atypism: 'Hindi kompensto',
                            errorsThatShouldNotOccur: 'Mga error na hindi dapat nangyari:',
                            spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span style = "color:red"> Data na wala sa order ay maaaring itapon kung ang mga kinakailangan ay hindi mataas. </Span>',
                            flower: 'Bulaka',
                            TransferStopped: ': Itigil ang paglipat',
                        },
                        video: {
                            index: {
                                camera: 'Camera',
                            },
                        },
                        voice: {
                            hook: {
                                bat: {
                                    index: {
                                        theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ang kasalukuyang kliyente ay konektado na sa ASR Websocket server',
                                        aSRConnectionClosed: 'Sarado ang koneksyon ng ASR...',
                                        foundASRChannelClosedRecreateWebsocketLink: 'Natagpuan ang ASR channel closed, muling lumikha ng Websocket link',
                                        unableToRecord: 'Hindi ma-record:',
                                        aSRChannelClosedReopened: 'Ang ASR channel ay sarado, muling binuksan',
                                        theASRChannelWasNotCreatedStartingNow: 'Hindi nilikha ang ASR channel, nagsisimula ang paglikha ngayon',
                                        useEffectCallbackToClearTheASRChannel: 'Gumagamit ngEffect callback upang maalis ang ASR channel',
                                        creatingARecorderService: 'Lumikha ng Serbisyo ng Recorder',
                                        turnOffTheRecorderService: 'Ipahin ang serbisyo ng Recorder',
                                    },
                                    util: {
                                        recorded: 'Na-recorded',
                                        BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Ang 16-bit pcm SendFrameSize ay dapat isang integer multiply of 2',
                                        pCMSamplingRateShouldNotOccur: 'Hindi dapat lumitaw ang rate ng sampling ng pcm',
                                        andTheRequiredSamplingRate: 'At ang kinakailangang sampling rate',
                                        atypism: 'Hindi kompensto',
                                        errorsThatShouldNotOccur: 'Mga error na hindi dapat nangyari:',
                                        spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span style = "color:red"> Data na wala sa order ay maaaring itapon kung ang mga kinakailangan ay hindi mataas. </Span>',
                                        flower: 'Bulaka',
                                        TransferStopped: ': Itigil ang paglipat',
                                    },
                                },
                                index: {
                                    failInSend: 'Sawi ang pagpadalas',
                                },
                            },
                            index: {
                                startRecording: 'Magsimula sa pagrekord',
                                endRecording: 'End recording',
                                startPracticing: 'Magsimula sa pagsasanay',
                                startTheExam: 'Simulan ang exam',
                            },
                        },
                    },
                    taskMessageModal: {
                        index: {
                            theRemainingNumberOfTimesForTheCurrentExamIs: '(Ang kasalukuyang bilang ng mga natitirang pagsusulit ay',
                            totalScriptScore: 'Kabuuang Score ng Speech:',
                            totalEmotionalScore: 'Kabuuang emosyonal na score:',
                            totalScoreOfExpression: 'Total Expression Score:',
                            theCurrentTaskRatingResultNeedsToBeManuallyReviewedAfterTheReviewIsCompletedYouWillBeNotifiedOfTheFinalScorePleaseBePatientAndWait: 'Ang kasalukuyang mga resulta ng pagmamarka ng gawain ay kailangang suriin ng manu-mano. Matapos ang pagsusuri ay nakumpleto, bibigyan ka ng huling resulta. Mangyaring maghintay nang matiyaga.',
                            areYouSureToSubmit: 'Tikumpirma ang pagsusuri?',
                            theExerciseHasEndedAreYouSureToSubmit: 'Natapos ang ehersisyo. Tikumpirma na ipadala?',
                            theExamHasEndedAreYouSureToSubmit: 'Natapos ang pagsusulit, sigurado ka bang nais mong ipadala ito?',
                            completed: 'Kumpleto',
                            page: 'Pahinang',
                            pageCount: 'Kabuuang Pahinan',
                            topic: 'Paksaan',
                            totalNumberOfQuestions: 'Bilang ng katanungan',
                            totalScore: 'Total score',
                            branch: 'Punts',
                            accumulatedCompletionProgress: 'Pag-unlad ng kumpleto',
                            accumulatedPracticeDuration: 'Paglaan ng Cumulative Practice',
                            lastPauseExerciseResults: 'Mga Resulta ng Huling Oras-Out-Practice',
                            exerciseInstructions: 'Mga Instruksyon ng ehersisyo',
                            examInstructions: 'Paglalarawan ng exam',
                            halfwayPausePracticeResults: 'Halos Pause-Practice Results',
                            tips: 'Prompt',
                            afterExitingThisExerciseWillNotBeCountedTowardsTheGradeAreYouSureToExit: 'Pagkatapos ng paghinto, ang pagsasanay na ito ay hindi kasama sa marka. Sigurado ka bang nais mong umalis?',
                            exitIsNotAllowedMidwayThroughTheExamAreYouSureToSubmit: 'Hindi pinapayagan ang pagtigil sa gitna ng pagsusulit. Tikumpirma ang pagsusuri?',
                            pleaseOperateWithCaution: 'Times, mangyaring gumana nang maingat)',
                            restart: 'Nagsimula ulit',
                            returnToLearning: 'Bumalik sa Pag-aaral',
                            continuePracticing: 'Patuloy sa pagsasanay',
                            continuingTheExam: 'Patuloy na Exam',
                            return: 'Bumalik',
                            notSubmittedTemporarily: 'Huwag ipasa',
                            iGotIt: 'Alam ko.',
                            confirmExit: 'Tikumeriya ang Exit',
                            confirmSubmission: 'Pagtunay',
                            signOut: 'Lumabas',
                        },
                    },
                    taskSubmitButton: {
                        index: {
                            suspend: 'Pahinga',
                            submit: 'Submissions',
                            remainingTimeOfThisQuestion: 'Natitirang Oras',
                            SecondsLeftUntilTheEndTime: '10 segundo hanggang sa wakas',
                            remainingTime: 'Natitirang Oras',
                        },
                    },
                    util: {
                        noUserVoiceContentDetectedPleaseTryAgain: 'Hindi nakita ang nilalaman ng boses ng user, mangyaring subukan mulin',
                    },
                    wave: {
                        index: {
                            continueRecording: 'Patuloy sa pag-recorda',
                            submit: 'Submissions',
                            endRecording: 'End recording',
                            suspendRecording: 'Pause recording',
                            startPracticing: 'Magsimula sa pagsasanay',
                            startTheExam: 'Simulan ang exam',
                        },
                    },
                    deviceModal: {
                        index: {
                            dialogueMode: 'Mode ng dayalog',
                            excessiveNoisePleaseSwitchToAQuietEnvironment: 'Masyadong ingay, mangyaring lumipat sa tahimik na kapaligirang',
                            normalNoiseDetection: 'Normal ang pagkilala sa ingay',
                            theVolumeIsTooLowPleaseIncreaseTheVolume: 'Masyadong mababa ang dami, mangyaring dagdagan ang dami',
                            volumeDetectionIsNormal: 'Normal na detection ng volume nume',
                            noiseDetection: 'Pagkakita ng noise',
                            pleaseRemainQuietAndRecordAsAmbientSound: 'Mangyaring manatiling tahimik at magtala ng tunog ng 3s',
                            endRecording: 'End recording',
                            startRecording: 'Magsimula sa pagrekord',
                            volumeDetection: 'Pagkakita ng volume nume',
                            pleaseReadNowPerformVolumeTestAtNormalVolume: 'Mangyaring basahin ang "volume test ngayon" sa normal na volume"',
                            playLastDetectedAudio: 'Play Last Detection Audio',
                            pleaseReadTheRequirementsCarefullyBeforeStarting: 'Mangyaring basahin nang maingat ang mga kinakailangan bago ka magsimula.',
                            return: 'Bumalik',
                            iGotIt: 'Alam ko.',
                            timeLimitForSingleQuestionAnswering: 'Iisang tanong na sagot na limitasyon sa oras',
                            totalTimeLimit: 'Total Time Limite',
                            unlimitedTime: 'Walang limitasyon na oras',
                            stillNeedToCompleteTheTaskInTotal: 'Ang kabuuang gawain ay kailangan pa rin na kumpleto',
                            practice: 'Ehersisyon',
                            second: 'Timess',
                            taskScore: 'Isang marka ng gawain ≥',
                            branch: 'Punts',
                            or: 'O',
                            examScore: 'Test score ≥',
                            remainingExamTimes: 'Bilang ng natitiran',
                            totalScore: 'Total score',
                            Script: '(Talker)',
                            scoreEmotion: 'Emosyon',
                            fractionExpression: 'Sub- expresso',
                            points: 'Points)',
                            standardScore: 'Standard score',
                            excellentScore: 'Mahusay na markan',
                            exerciseInstructions: 'Mga Instruksyon ng ehersisyo',
                            forASmoothAnswerPleaseCompleteTheEquipmentInspectionFirst: 'Upang masagot nang maayos ang tanong, mangyaring kumpleto muna ang test ng kagamitan:',
                            camera: 'Camera',
                            beingAbleToSeeOneselfInTheVideoMeansThatTheCameraIsFunctioningProperly: 'Ang pagiging makakakita sa iyong sarili sa video ay nangangahulugan na ang camera ay normal.',
                            microphone: 'Microfone',
                            pleaseSpeakIntoTheMicrophoneSeeingTheWaveformPatternIndicatesThatTheMicrophoneIsFunctioningProperly: 'Mangyaring magsalita sa mikropono, tingnan ang pattern ng waveform ay nangangahulugan na ang mikropono ay normal.',
                        },
                    },
                },
                course: {
                    components: {
                        folderTree: {
                            modal: {
                                index: {
                                    empty: 'Walang laman',
                                    copyTo: 'Kopyahay',
                                    classification: 'Classifications',
                                    rename: 'Pangalawan',
                                    newlyBuild: 'Bago',
                                    categoryParent: 'Superior Classifications',
                                    moveTo: 'Lumaw',
                                    name: 'Pangang',
                                },
                            },
                            util: {
                                rename: 'Pangalawan',
                                moveTo: 'Lumaw',
                                copyTo: 'Kopyahay',
                                delete: 'Mangalisa',
                                courseClassification: 'Classification ng kurso',
                                newlyBuild: 'Bago',
                            },
                        },
                        evaluateDrawer: {
                            index: {
                                curriculumEvaluation: 'Pagsusuri ng kurkulum',
                                cancel: 'Kansela',
                                submission: 'Submissions',
                                courseQuality: 'Kalidad sa kurso',
                                higherValuesIndicateBetterCourseQuality: 'Ang mas mataas na halaga ay nagpapahiwatig ng mas mahusay na kalidad ng kurso',
                                learningEffect: 'Epekto sa pag-aaral',
                                theHigherTheValueTheBetterTheLearningEffect: 'Ang mas mataas na halaga, mas mahusay ang epekto ng pag-aaral.',
                                interactiveExperience: 'Interactive Experiens',
                                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'Ang mas mataas na halaga, mas mahusay ang interactive na karanasan ng kurso.',
                                suggestedFeedback: 'Iminungkahi',
                                pleaseEnterAnEvaluationProposalForThisCourse: 'Mangyaring ipalagay ang isang mungkahi sa pagsusuri para sa kurso',
                            },
                        },
                    },
                    edit: {
                        index: {
                            curriculum: 'Kurso',
                        },
                    },
                    index: {
                        courseLabel: 'Course Label',
                        comments: 'Mga komento',
                        submissionOfEvaluation: 'Pagpapadala ng pagsusuri:',
                        evaluationOfSuccess: 'Evaluation ng tagumpay',
                        learn: 'Pag-aaral',
                        practice: 'Praksiya',
                        examination: 'Pagsuboka',
                        curriculum: 'Kurso',
                        courseIntroduction: 'Ipinakilala sa kurso:',
                        createdOn: 'Oras ng paglikha:',
                        published: 'Inilathalan',
                        tasks: 'Gawaing',
                        unpublishedTasks: 'Hindi inilathala ang Gawain',
                        task: 'Gawaing',
                        operation: 'Operasyong',
                        learningMaterials: 'Mga Materials sa Pag-aaral',
                        goPractice: 'Pumunta sa pagsasanay',
                        publishTask: 'Naglathala ng mga Gawain',
                        taskData: 'Task Data',
                        edit: 'Pag-edita',
                        copy: 'Kopyahay',
                        successfullyCopied: 'Pagkopya ng tagumpa',
                        delete: 'Mangalisa',
                        afterDeletionAllTaskDataUnderThisCourseWillBeClearedAreYouSureToDeleteTheCourse: 'Matapos ang pagtanggal, ang lahat ng data ng gawain sa ilalim ng kurso na ito ay malilinis. Sigurado ka bang tatanggalin ang kurso?',
                        courseName: 'Pangalan ng kurso',
                        creationTime: 'Oras ng paglika',
                        releaseStatus: 'Publish Status',
                        whole: 'Lahat',
                    },
                },
                nodeConfigTest: {
                    components: {
                        input: {
                            noSoundDetected: 'Walang nakita na tunog',
                            voice: 'Voice',
                            text: 'Tekstos',
                            referenceScript: 'Reference speech:',
                            clickOnTheRightSideToStartRecording: 'Click sa kanan upang simulan ang pagrekord',
                            sendOut: 'Dalan',
                        },
                        hooks: {
                            input: {
                                theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ang kasalukuyang kliyente ay konektado na sa ASR Websocket server',
                                afterProcessingTheLastFrameRestoreTheState: 'Matapos ang pagproseso ng huling frame, ibalik ang estado.',
                                aSRConnectionClosed: 'Sarado ang koneksyon ng ASR...',
                                recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'Ang pag-recorded paused at natapos na proseso, ngunit may data pa rin sa cache',
                                foundASRChannelClosedRecreateWebsocketLink: 'Natagpuan ang ASR channel closed, muling lumikha ng Websocket link',
                                foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'Natagpuan na ang ASR channel ay hindi bukas, likha muli ang Websocket link',
                                unableToRecord: 'Hindi ma-record:',
                                creatingARecorderService: 'Lumikha ng Serbisyo ng Recorder',
                                turnOffTheRecorderService: 'Ipahin ang serbisyo ng Recorder',
                            },
                            util: {
                                recorded: 'Na-recorded',
                                BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Ang 16-bit pcm SendFrameSize ay dapat isang integer multiply of 2',
                                pCMSamplingRateShouldNotOccur: 'Hindi dapat lumitaw ang rate ng sampling ng pcm',
                                andTheRequiredSamplingRate: 'At ang kinakailangang sampling rate',
                                atypism: 'Hindi kompensto',
                                errorsThatShouldNotOccur: 'Mga error na hindi dapat nangyari:',
                                spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span style = "color:red"> Data na wala sa order ay maaaring itapon kung ang mga kinakailangan ay hindi mataas. </Span>',
                                flower: 'Bulaka',
                                TransferStopped: ': Itigil ang paglipat',
                            },
                        },
                        finishTest: {
                            index: {
                                endTest: 'End teste',
                                testResult: 'Mga Resulta sa pagsubokan',
                                returnToCanvas: 'Bumalik sa Canvas',
                                retest: 'Pagsubok',
                            },
                        },
                    },
                    index: {
                        testFromCurrentNode: 'Subukin mula sa kasalukuyang node',
                        listening: 'Radio sa ...',
                        canvasTesting: 'Canva Test',
                        endOfProcess: 'End of proseso',
                        restart: 'Nagsimula ulit',
                        start: 'Magsimula',
                    },
                },
                record: {
                    detail: {
                        components: {
                            openButton: {
                                index: {
                                    collapseAnalysis: 'Collapse Analysisy',
                                    expandParsing: 'Palawak',
                                },
                            },
                            overView: {
                                index: {
                                    tooManyModalParticles: 'Masyadong maraming modal salat',
                                    second: 'Timess',
                                    ratingOverview: 'Scoring Overviews',
                                    totalScore: 'Total score',
                                    section: 'Sekson',
                                    name: 'Pangang',
                                    of: '(Total',
                                    people: 'Mga tao)',
                                    scriptScore: 'Speech Score',
                                    common: 'Kabuan',
                                    keyPoints: 'Isang pangunahing punto,',
                                    notReached: 'Hindi naabot,',
                                    have: 'Mayroong',
                                    violationOfRegulations: 'Paglabaga',
                                    emotionalScore: 'Emotion Scoree',
                                    appear: 'Lilitaw',
                                    secondaryNegativeEmotions: 'Sekundaryong negatibong emosyon',
                                    expressionScore: 'Score ng expression',
                                    speakTooFast: 'Masyadong mabilis ang pagsasalita...',
                                    times: 'Beses,',
                                    speakTooSlowly: 'Masyadong mabagal',
                                    average: 'Average',
                                    wordminute: 'Salita/minuto',
                                },
                            },
                            score: {
                                index: {
                                    studentNodeName: 'Name node',
                                    keyPointName: 'Pangalan ng Key Point',
                                    slideNodeName: 'Slide node',
                                    dialogue: 'Dialog',
                                    mainPoints: 'Mga Key Points',
                                    slide: 'Slide',
                                    detectionResult: 'Mga Resulta sa pagsubokan',
                                    satisfy: 'Nakilalan',
                                    dissatisfaction: 'Hindi nasiyan',
                                    score: 'Score',
                                    script: 'Mga salat',
                                    semantics: 'Semantic',
                                    scriptViolation: 'Paglabag sa pagsasabit',
                                    emotion: 'Emosyon',
                                    expression: 'Ekresyon',
                                },
                            },
                            taskTitle: {
                                index: {
                                    branch: 'Punts',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    thisTime: 'Ito oras',
                                    lastTime: 'Hulang oras',
                                    comprehensiveEvaluation: 'Kabuuang pagsusuri',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: '<Span style = "margin-left: 8px"> · Standard Speech Cumulative',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'Isang salita, ang bilang ng mga salita na hit ng mag-aaral',
                                    aWordspan: 'Word </span>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Times </span>> <br />span style = "margin-left: 8px"> · Slow bilis',
                                    timesspan: '</Span>',
                                    tooManyModalParticles: '<Span style = "margin-left: 8px"> · Masyadong maraming mga salita sa modal',
                                    complete: 'Kumpletong nilalamang',
                                    keyHit: 'Key Points Hit',
                                    languageNorm: 'Spesyasyon ng wika',
                                    fluentExpression: 'Makinab na ekspresyonan',
                                    emotionallyPositive: 'Emosyonal positibon',
                                    radarChart: 'Radar Chart',
                                    spanStylemarginLeftpxNumberOfCompleteProcesses: '<Span style = "margin-left: 8px"> · Bilang ng kumpletong flows',
                                    spanStylemarginLeftpxNumberOfHitPoints: '<Span style = "margin-left: 8px"> · Key Points for Hit',
                                    spanStylemarginLeftpxYes: '<Span style = "margin-left: 8px"> · Yes',
                                    dealingWithIllegalWordsspan: 'Sa paglabag sa salita </span>',
                                    spanStylemarginLeftpxSpeakTooFast: '<Span style = "margin-left: 8px"> · Masyadong mabilis na pagsasalita.',
                                    spanbrspanStylemarginLeftpxTooManyModalParticles: '</Span><br /><span style = "margin-left: 8px"> masyadong maraming modal na salitan',
                                    spanStylemarginLeftpxNegativeEmotions: '<Span style = "margin-left: 8px"> · Negative emosyon',
                                },
                            },
                            scoreRecord: {
                                index: {
                                    scoringRecords: 'Score Record',
                                    firstRating: 'Unang oras rating',
                                    totalScore: 'Total score',
                                    changeTo: 'Pagbago',
                                },
                            },
                            aiGenScore: {
                                index: {
                                    communicationStage: 'Communication Phases',
                                    communicationObjectives: 'Mga layunin ng komunikasyon',
                                    scoringCriteria: 'Mga criterio ng markas',
                                    suggestionsForImprovement: 'Mga mungkahi ng promosyon',
                                },
                            },
                            onceMore: {
                                index: {
                                    remainingTimes: 'Natitirang:',
                                    second: 'Timess',
                                    doItAgain: 'Isa pang oras.',
                                },
                            },
                            audio: {
                                index: {
                                    theBrowserDoesNotSupportAudioPlayback: 'Hindi suportahan ng browser ang audio playback.',
                                },
                            },
                            evaluationSuggestion: {
                                index: {
                                    scriptCommentsAndSuggestions: 'Mga komento at mungkahi tungkol sa pagsasalita...',
                                    regenerate: 'Regeneratee',
                                    generate: 'Generated',
                                    generationFailed: 'Bigo ang build',
                                },
                            },
                            resultModal: {
                                index: {
                                    return: 'Bumalik',
                                    viewDetails: 'Pansin Detalyas',
                                },
                            },
                        },
                        index: {
                            reRatingSuccessful: 'Re-scoring',
                            reRatingFailed: 'Nabigo ang re-score',
                            downloadRecording: 'Downloading recording',
                            downloadText: 'Download teksto',
                            download: 'Download a',
                            reRating: 'Re-scoring',
                            submitARatingAppeal: 'Ipadala ang Grading Grievance.',
                            reviewSubmission: 'Review Submissions',
                            saveChanges: 'Nakaligtas ang mga pagbabago',
                            previousSentence: 'Ang nakaraang pangungunan',
                            nextSentence: 'Susunod na pangungunan',
                            score: 'Rating',
                            scoringSituation: 'Score',
                            dialogueAnalysis: 'Analysis ng dayalog',
                        },
                    },
                    index: {
                        ratingAppealInProgress: 'Scoring Grievances',
                        operation: 'Operasyong',
                        wrongQuestionSet: 'Maling itinakda ng probleman',
                        ratingUpdate: 'Rating Update',
                        viewDetails: 'Pansin Detalyas',
                        curriculum: 'Kurso',
                        taskName: 'Pangalan ng Task',
                        taskType: 'Type ng task',
                        score: 'Score',
                        scoringResults: 'Mga Resulta ng Score',
                        time: 'Oras',
                        courseClassification: 'Classification ng kurso',
                        whole: 'Lahat',
                        learningTime: 'Oras ng pag-aaral',
                        historicalLearningData: 'Data ng kasaysayan sa pag-aaral',
                    },
                },
                task: {
                    exercise: {
                        index: {
                            intelligentQualityInspection: 'Intelligent quality inspeksyo',
                            practicePause: 'Practice Pause',
                            lastProgress: 'Huling Progress',
                            continuePracticing: 'Patuloy sa pagsasanay',
                            practice: 'Ehersisyon',
                            startPracticing: 'Magsimula sa pagsasanay',
                            historicalData: 'Data ng kasaysayan',
                            courseIntroduction: 'Ipinakilala sa kurso:',
                            exerciseDifficulty: 'Kahirapan ng pagsasanay:',
                            practiceCompletionRequirements: 'Mga pangangailangan sa pagkumpleto:',
                            practiceFrequency: 'Bilang ng mga pagsasanay ≥',
                            second: 'Timess',
                            anyScore: 'Anumang marka ≥',
                            branch: 'Punts',
                            or: 'O',
                            taskList: 'Listahan ng Task',
                            practiceTime: 'Oras ng ehersisyo:',
                            to: 'Tog',
                            unlimitedTime: 'Unlimited times',
                            completionStatus: 'Status ng pagkumpleto',
                            numberOfExercises: 'Bilang ng Exercise',
                            maximumScore: 'Pinakamataas na markan',
                            operation: 'Operasyong',
                            enteringLearning: 'Isugot sa pag-aaral',
                            historicalLearningData: 'Data ng kasaysayan sa pag-aaral',
                            wrongQuestionSet: 'Maling itinakda ng probleman',
                        },
                    },
                    index: {
                        practiceTasks: 'Gawaing',
                        examTasks: 'Gawain sa pagsusulita',
                        task: 'Gawaing',
                    },
                    learn: {
                        index: {
                            courseName: 'Pangalan ng kurso',
                            courseIntroduction: 'Pagkilala sa kurso',
                            learningContent: 'Nilalaman ng pag-aaral',
                            downloadLearningMaterials: 'Pag-aaral na Materials Downloads',
                            startPracticing: 'Magsimula sa pagsasanay',
                        },
                    },
                    test: {
                        index: {
                            taskList: 'Listahan ng Task',
                            courseIntroduction: 'Ipinakilala sa kurso:',
                            examDifficulty: 'Kahirapan ng pagsusulit:',
                            requirementsForPassingTheExam: 'Mga kinakailangan para sa pagpasa ng pagsusulit:',
                            examScore: 'Test score ≥',
                            branch: 'Punts',
                            examTime: 'Oras ng pagsusuri:',
                            to: 'Tog',
                            unlimitedTime: 'Unlimited times',
                            completionStatus: 'Status ng pagkumpleto',
                            completionTimes: 'Bilang ng mga kumpleto',
                            maximumScore: 'Pinakamataas na markan',
                            operation: 'Operasyong',
                            immediateExam: 'Agad na pagsusulita',
                            history: 'Kasaysayan',
                        },
                    },
                },
                wrongQuestionSet: {
                    exercise: {
                        components: {
                            cue: {
                                index: {
                                    referenceScript: 'Reference Speecha',
                                },
                            },
                            flow: {
                                index: {
                                    wrongQuestionItem: 'Maling Item (Malaking Item)',
                                    score: 'Score',
                                    TotalScore: '/Total Score',
                                },
                            },
                            record: {
                                ppt: {
                                    hook: {
                                        index: {
                                            serverError: 'Error ng server',
                                        },
                                    },
                                    index: {
                                        startRecording: 'Magsimula sa pagrekord',
                                        endRecording: 'End recording',
                                        startPracticing: 'Magsimula sa pagsasanay',
                                    },
                                },
                                text: {
                                    index: {
                                        pleaseEnter: 'Mangyaring irekt',
                                        sendOut: 'Dalan',
                                        startPracticing: 'Magsimula sa pagsasanay',
                                    },
                                },
                                voice: {
                                    index: {
                                        startRecording: 'Magsimula sa pagrekord',
                                        endRecording: 'End recording',
                                        startPracticing: 'Magsimula sa pagsasanay',
                                    },
                                    hook: {
                                        index: {
                                            failInSend: 'Sawi ang pagpadalas',
                                        },
                                    },
                                },
                            },
                            taskMessageModal: {
                                index: {
                                    scoreForThisPracticeOfIncorrectQuestions: 'Ang marka ng maling pagsasanay na ito',
                                    tips: 'Prompt',
                                    areYouSureToEnd: 'Tikumerima ang pagtatapos?',
                                    practiceAgainWithoutMasteringTheWrongQuestions: 'Magsanay muli at huwag master ang maling katanungan.',
                                    continue: 'Patuloy',
                                    returnToTheSetOfIncorrectQuestions: 'Bumalik sa maling tanon',
                                    end: 'Endo',
                                    wrongQuestionItem: 'Maling Item',
                                    numberOfExercisesThisTime: 'Ang bilang ng pagsasanay na ito',
                                    masteringTheSituation: 'Pag-uugnay sa sitwasyon',
                                    mastered: 'Mastering',
                                    notMastered: 'Hindi mastered',
                                },
                            },
                            taskSubmitButton: {
                                index: {
                                    practiceThisQuestionAgain: 'Gumagamit muli ang tanong na ito...',
                                    nextQuestion: 'Susunod na tanon',
                                },
                            },
                        },
                        ppt: {
                            index: {
                                mispracticeExercises: 'Maling Exercise',
                                endExercise: 'End ehersisyo',
                            },
                        },
                        text: {
                            index: {
                                mispracticeExercises: 'Maling Exercise',
                                endExercise: 'End ehersisyo',
                            },
                        },
                        voice: {
                            index: {
                                mispracticeExercises: 'Maling Exercise',
                                endExercise: 'End ehersisyo',
                            },
                        },
                    },
                    list: {
                        components: {
                            checkScript: {
                                index: {
                                    checkScript: 'Tingnan Speeche',
                                    section: 'Sekson',
                                    secondaryDiscourseTechnique: 'Sub-speecht',
                                },
                            },
                            tableItem: {
                                count: {
                                    second: 'Timess',
                                },
                                scoreRuleList: {
                                    noRelevantInformationFound: 'Walang kaugnay na impormasyon ay nahanap',
                                    recallWords: 'Itala ang Salit',
                                    branch: 'Punts',
                                    answerIncorrectly: 'Maling sagot',
                                    second: 'Timess',
                                    wrongAnswerRate: 'Maling rate ng sagot',
                                },
                                standardScript: {
                                    standardScript: 'Standard Speeche',
                                    myScript: 'Ang mga salita kos',
                                },
                                status: {
                                    mastered: 'Mastering',
                                    notMastered: 'Hindi mastered',
                                },
                                index: {
                                    totalNumberOfQuestionsAnswered: 'Kabuuang Bilang ng sagot',
                                    numberOfTimesIncorrectQuestionsHaveBeenPracticed: 'Bilang ng mga maling katanungan',
                                },
                            },
                        },
                        index: {
                            wrongQuestionList: 'Listahan ng maling katanungan',
                            wrongQuestionSet: 'Maling itinakda ng probleman',
                            mispracticeExercises: 'Maling Exercise',
                            taskName: 'Pangalan ng Task',
                            staff: 'Employa',
                            masteringTheSituation: 'Pag-uugnay sa sitwasyon',
                            whole: 'Lahat',
                        },
                    },
                },
            },
            taskCenter: {
                components: {
                    completeStandart: {
                        index: {
                            practiceFrequency: 'Bilang ng mga pagsasanay ≥',
                            second: 'Timess',
                            or: 'O',
                            excellentScoreAtAnyOneTime: 'Anumang mahusay na marka (≥',
                            points: 'Points)',
                            examScore: 'Test score ≥',
                            branch: 'Punts',
                        },
                    },
                    manualReviewConfig: {
                        index: {
                            randomAverageDistribution: 'Random average distribution',
                            assignToDesignatedPersonnel: 'Itagal sa mga Tao',
                        },
                    },
                    examTimesInput: {
                        index: {
                            successfullyIncreasedTheNumberOfExams: 'Tagumpay sa pagpapataas ng bilang ng mga pagsusulita',
                            failedToIncreaseTheNumberOfExams: 'Pagpapataas ng bilang ng pagkabigo sa pagsubok',
                            increaseTheNumberOfExams: 'Pagdaragdag ng bilang ng exam',
                            selectObjects: 'Pumili ng Object',
                        },
                    },
                    executionFilter: {
                        index: {
                            participationRate: 'Rata ng bahagi',
                        },
                    },
                    intelligentReview: {
                        index: {
                            overallReview: 'Pangkalahatang pagsusuri',
                            pleaseEnterTheReviewCriterianotMandatory: 'Mangyaring ipasok ang mga criteria ng komento (hindi kinakailangan)',
                            commentaryOnSingleSentenceRhetoric: 'Mga komento sa Single Sentences',
                            realTimeReview: 'Real-time reviews',
                        },
                    },
                },
                detail: {
                    resultAnalysis: {
                        averageScoreOfTheExam: 'Average score ng pagsubok',
                        averageExamDurationmin: 'Average duration ng pagsusulit (min)',
                        accumulatedPracticeDurationmin: 'Cumulative practice duration (min)',
                        accumulatedPracticeTimes: 'Bilang kumulative ng mga pagsasanay',
                        totalScore: 'Total score',
                        average: 'Average',
                        total: 'Kabuan',
                        keyHitCount: 'Key Points Hit Count',
                        practiceAverageScore: 'Practice Average Scoree',
                        averagePracticeDurationmin: 'Average haba ng pagsasanay (min)',
                        topOfTheHighestScore: 'Ang pinakamataas na score Top3',
                        branch: 'Punts',
                        errorProneItemTop: 'Error-prone Top5',
                        hitRate: 'Hit Rate',
                        hitRateOfKeyPointsInScript: 'Speech Key Points Hit Rate',
                        averageScriptScore: 'Average Score ng Speeche',
                        sortByProcess: 'Sort sa pamamagitan ng proseso',
                        sortByScore: 'Sort by Score',
                        averageScoreOfThisPagetotalScoreOfThisPage: 'Average score ng pahina na ito/total na marka ng pahina na ito',
                        averageScoreOfThisItemtotalScoreOfThisItem: 'Ang pamantayang marka ng item na ito/ang kabuuang marka ng item na ito',
                        details: 'Detalyo',
                        viewRules: 'Pansin ang mga Rula',
                        standardScript: 'Standard Speeche',
                    },
                    scoreDetailList: {
                        section: 'Sekson',
                        second: 'Timess',
                        practice: 'Ehersisyon',
                        examination: 'Examinasyon',
                        notMeetingStandards: 'Hindi hanggang sa karaniwang',
                        meetingStandards: 'Standard na',
                        excellent: 'Mahusay',
                        frequency: 'Bilang ng mga beses',
                        fraction: 'Fraction',
                        result: 'Resulta',
                        operation: 'Operasyong',
                        viewDetails: 'Pansin Detalyas',
                    },
                    index: {
                        common: 'Kabuan',
                        people: 'Tao',
                        staff: 'Employa',
                        notMeetingStandards: 'Hindi hanggang sa karaniwang',
                        meetingStandards: 'Standard na',
                        excellent: 'Mahusay',
                        notStarted: 'Hindi Nagsimula',
                        haveInHand: 'Sa paglaon',
                        completed: 'Kumpleto',
                        passed: 'Pasad',
                        hangInTheAir: 'Hindi tapo',
                        failed: 'Hindi lumipasa',
                        unlimitedTime: 'Unlimited times',
                        to: 'Tog',
                        maximumScoringCriteria: 'Pinakamataas na criterio ng scor',
                        completionStatus: 'Status ng pagkumpleto',
                        employeeName: 'Pangalan ng empleyad',
                        frequency: 'Bilang ng mga beses',
                        practice: 'Ehersisyon',
                        examination: 'Examinasyon',
                        average: 'Average',
                        speechCraftAvgScore: 'Average Score ng Speeche',
                        emotionAvgScore: 'Emosyonal Average Scoree',
                        speedAvgScore: 'Average score ng ekspresyon',
                        flowAvgScore: 'Average Process Scoree',
                        practiceCostTime: 'Cumulative Duratione',
                        participateCommitRate: 'Rate ng pagsunod',
                        participateExcellentRate: 'Mahusay na rate',
                        duration: 'Pangulon',
                        score: 'Score',
                        scoringResults: 'Mga Resulta ng Score',
                        flowScore: 'Score ng proseso',
                        craftScore: 'Speech Score',
                        emotionScore: 'Emotion Scoree',
                        speedScore: 'Score ng expression',
                        contentIntegrity: 'Integridad ng content',
                        pointHitRate: 'Key Points Hit Rate',
                        emotionNegativeRate: 'Negatibong proporsyon ng emosyon',
                        paraPhaSiaRate: 'Porsyento ng hindi normal na speeche',
                        toneOvermuchRate: 'Labis na proporsyon ng mga modal salita',
                        maximumScore: 'Pinakamataas na markan',
                        highestScoreResult: 'Pinakamataas na Resulta ng Score',
                        state: 'Status',
                        averageDurationmin: 'Average Duration (min)',
                        lately: 'Kamakain',
                        time: 'Oras',
                        operation: 'Operasyong',
                        viewDetails: 'Pansin Detalyas',
                        wrongQuestionSet: 'Maling itinakda ng probleman',
                        taskName: 'Pangalan ng Task',
                        completeRequirements: 'Kumpletong mga Kinakailangang',
                        publishTo: 'Paglathala ng mga Objects',
                        taskTime: 'Oras ng gayo',
                        fractionalComposition: 'Fraction komposisyong',
                        totalScore: 'Total score',
                        branch: 'Punts',
                        Script: '(Talker)',
                        scoreEmotion: 'Emosyon',
                        fractionExpression: 'Sub- expresso',
                        points: 'Points)',
                        implementationRate: 'Rata ng bahagi',
                        numberOfExecutors: 'Bilang ng mga kalahok',
                        numberOfPeopleNotExecuted: 'Bilang ng mga hindi kalakip',
                        completionRate: 'Rate ng pagkumpleto',
                        numberOfCompletedPersonnel: 'Bilang ng kumpleto',
                        numberOfUnfinishedPersonnel: 'Bilang ng hindi tapo',
                        complianceRate: 'Rate ng pagsunod',
                        numberOfQualifiedPersonnel: 'Bilang ng Attainment',
                        numberOfNonCompliantIndividuals: 'Bilang ng mga tao na hindi nakakatugon sa karaniwang',
                        excellentRate: 'Mahusay na rate',
                        participateCompleteRate: 'Rate ng pagkumpleto ng bahagi',
                        numberOfOutstandingIndividuals: 'Mga natitirang Numbers',
                        numberOfNonOutstandingIndividuals: 'Non-Excellent numero',
                        export: 'Pag-exporto',
                        taskData: 'Task Data',
                        resultAnalysis: 'Pagsusuri ng mga resultat',
                        scoreDetails: 'Detalye ng score -',
                        dataOverview: 'Overview ng Data',
                        taskDetail: 'Detalyas',
                        scriptAnalysis: 'Analysis ng pagsasabit',
                        flowAnalysis: 'Analysis ng proseso',
                        expressionAnalysis: 'Analisiya',
                        emotionAnalysis: 'Sentiment analysisa',
                        byTime: 'Panahon ng Dimension ng Oras',
                        byNumber: 'Degree dimension view',
                        personData: 'Statistics by Personnel',
                        numberData: 'By-Record detail',
                        count: 'Sa pamamagitan ng bilang ng oras',
                        person: 'Sa bilang ng mga tao...',
                        reachTimes: 'Pagbasas',
                        outOfReachTimes: 'Hindi natapos na oras',
                        seeOutOfReach: 'Click upang makita ang hindi nakakab',
                        accumulative: 'Cumulative',
                        script: 'Mga salat',
                        times: 'Timess',
                        sentence: 'Sentensya',
                        expressionAverage: 'Average score ng expressions',
                        modalAnalysis: 'Analysis ng modal salta',
                        total: 'Kabuan',
                        muchModalAnalysis: 'Masyadong maraming modal salat',
                        normal: 'Normale',
                        speedAnalysis: 'Analysis ng speech speed',
                        speedDistribution: 'Distribusyon ng speech rate',
                        speakingSpeed: 'Bilis',
                        normalSpeak: 'Normal na bilis ng pagsasabit',
                        tooFastSpeak: 'Speedy Speedy',
                        tooSlowlySpeak: 'Mabagal na bilis',
                        violationWord: 'Paglabag sa mga salat',
                        violationWordAnalysis: 'Analysis ng mga salitang paglabag',
                        noData: 'Hindin',
                        emotionalScore: 'Emotion Scoree',
                        emotionalDistribution: 'Pamamahagi ng emosyon',
                        negativeEmotion: 'Negatibong emosyon',
                        normalEmotion: 'Normal na emosyon',
                        getDetail: 'Pansin Detalyas',
                        barPattern: 'Bar View',
                        timeDimension: 'Oras Latitude View',
                        timesDimension: 'Degree dimension view',
                    },
                    components: {
                        dataOverview: {
                            hook: {
                                useSummary: {
                                    score: 'Score',
                                    speechScore: 'Speech Score',
                                    emotionScore: 'Emotion Scoree',
                                    expressionScore: 'Score ng expression',
                                    processScore: 'Score ng proseso',
                                    averageScore: 'Average',
                                    averageScoreOfScript: 'Average Score ng Speeche',
                                    averageEmotionalScore: 'Average emosyonal na markan',
                                    expressionAverageScore: 'Average score ng ekspresyon',
                                    processAverageScore: 'Average score ng proseso',
                                    accumulatedDuration: 'Cumulative Duratione',
                                    accumulatedTimes: 'Cumulative Times',
                                    participationComplianceRate: 'Rata ng bahagi',
                                    participationRateForAchievingExcellence: 'Rata ng bahagi',
                                    branch: 'Punts',
                                    numberOfPeople: 'Bilang ng mga tao:',
                                    averageScoreOfExpression: 'Average score ng expressions',
                                    people: 'Tao',
                                },
                            },
                        },
                        emotionAnalysis: {
                            components: {
                                simplePieChart: {
                                    index: {
                                        negativeEmotions: 'Negatibong emosyon',
                                    },
                                },
                            },
                        },
                        scriptAnalysis: {
                            hook: {
                                useSummary: {
                                    averageScoreOfScript: 'Average Score ng Speeche',
                                    branch: 'Punts',
                                },
                                useSummaryDetail: {
                                    keyHitRate: 'Key Points Hit Rate',
                                },
                            },
                        },
                    },
                },
                edit: {
                    index: {
                        intelligentReview: 'Smart reviews',
                        pleaseImproveTheConfiguration: 'Mangyaring perpekto ang pagsasaayos',
                        examResults: 'Mga Resulta ng Exam',
                        showTheResultsAfterEachExam: 'Ipakita ang mga resulta pagkatapos ng bawat pagsusulit.',
                        showTheResultsAfterTheLastExam: 'Ipakita ang mga resulta pagkatapos ng huling pagsusulit.',
                        doNotDisplayResults: 'Huwag ipakita ang mga resultat',
                        resultDisplay: 'Ipakita ng mga resultant',
                        score: 'Score',
                        scoringResults: 'Mga Resulta ng Score',
                        allowViewingScoreDetails: 'Pahintulutan na tingnan ang mga detalye ng score',
                        viewCanvasConfiguration: 'Makita ang pagsasaayos ng canvas',
                        synchronizationFailedProcessNodeHasChanged: 'Nabigo ang synchronization, ang proseso ay gumagawa ng mga pagbabago',
                        successfullySynchronizedPleaseClickOnpublishToUpdateTheCourse: 'Tagumpay ang synchronization, mangyaring mag-click upang i-update ang kurso',
                        retrievedTheLatestCanvasConfiguration: 'Pinakakabagong canvas',
                        synchronizeCanvasConfiguration: 'Pag-synchronize ng canvas',
                        scoringMethod: 'Paraan ng Scoring',
                        pointsProcessPointsScript1PointsEmotion2PointsSpeakingSpeed3Points: 'Points, flow {0} points, kakayahan sa pagsasalita {1} points, emosyon {2} points, bilis {3} points)',
                        excellentStandardsNeedToBeHigherThanStandardStandards: 'Ang pamantayan ng kahusayan ay dapat na mas mataas kaysa sa pamantayan ng pagsunod.',
                        theScoringCriteriaNeedToBeGreaterThanAndLessThanOrEqualTo100: 'Ang mga criteria ng pagmamarka ay dapat na mas malaki kaysa sa 0% at mas mababa sa o katumbas ng 100.',
                        theScoringCriteriaNeedToBeGreaterThanPointsAndLessThanOrEqualTo0Points: 'Ang mga kriterya sa pagmamarka ay dapat na mas malaki sa 0 puntos at mas mababa sa o katumbas ng {0} puntos.',
                        doRatingsRequireManualReview: 'Kung ang pagpunta ay nangangailangan ng manual review',
                        allocationStrategy: 'Patakaran sa pag-allok',
                        pleaseSelectTheAssignedPersonnel: 'Mangyaring pumili ng isang nakatakdang taos',
                        pleaseSelectADesignatedPerson: 'Mangyaring pumili ng isang itinalagang tao...',
                        timeLimitForSingleQuestionAnswering: 'Iisang tanong na sagot na limitasyon sa oras',
                    },
                    autoAddOrganizationList: {
                        publishToNewlyAddedEmployeesByDefault: 'I-publish sa mga bagong karagdagang empleyado sa pamamagitan ng defaulta',
                    },
                },
                list: {
                    index: {
                        reRatingMeansMatchingWillBeDoneAccordingToTheScoringRulesOfTheLatestCanvasThereIsManuallyReviewedScoringDataForTheCurrentTaskDoYouWantToOverwriteTheScores: 'Ang re-scoring ay nagpapahiwatig na ang score ay magkatugma ayon sa mga patakaran sa pagmamarka ng pinakabagong canvas. Ang kasalukuyang gawain ay may manu-manong pagsusuri ng data ng scoring. Gusto mo bang isulat ang marka?',
                        notCovered: 'Hindi sakta',
                        cover: 'Cover',
                        participationSituation: 'Kalakip',
                        numberOfParticipants: 'Bilang ng mga kalahok',
                        sumOfTheNumberOfPracticeSubjectsSelectedForThisTask: 'Sumunod ang bilang ng mga bagay na pinili para sa gawain na ito',
                        sumOfTheNumberOfParticipantsInTheTask: 'Suma sa bilang ng mga tao na lumahok sa gawain',
                        numberOfCompletedPersonnel: 'Bilang ng kumpleto',
                        sumOfTheNumberOfPeopleWhoMeetTheTaskCompletionRequirements: 'Sumapit ang bilang ng mga tao na nakakatugon sa mga kinakailangan sa pagkumpleto ng gawain',
                        numberOfQualifiedPersonnel: 'Bilang ng Attainment',
                        sumUpTheNumberOfPeopleWhoMeetTheTaskScoreRequirements: 'Sumapit ang bilang ng mga tao na nakilala ang marka ng gawain',
                        excellentPersonnel: 'Mga natitirang Numbers',
                        sumUpTheNumberOfPeopleWithExcellentTaskScores: 'Sumapit ang bilang ng mga tao na nakakatugon sa gawain na may mahusay na markan',
                        participationRate: 'Rata ng bahagi',
                        numberOfParticipantsNumberOfParticipants: 'Bilang ng mga kalahok/numbe ng mga kalahok',
                        numberOfCompletedNumberOfParticipants: 'Bilang ng mga taong nakumpleto/bilang ng mga tao na kasangkot',
                        numberOfPeopleWhoMeetTheStandardsnumberOfPeopleWhoShouldParticipate: 'Bilang ng Attainment/Numero ng Mga Kasabay',
                        excellentNumbernumberOfParticipants: 'Natitirang Numero/numbe ng mga Kalakip',
                        participationCompletionRate: 'Rate ng pagkumpleto ng bahagi',
                        numberOfCompletedParticipated: 'Bilang ng mga kumpleto/mga kalakip',
                        participationComplianceRate: 'Rata ng bahagi',
                        numberOfQualifiedPersonnelnumberOfParticipants: 'Bilang ng Attainment/Parisyon',
                        participationRateForAchievingExcellence: 'Rata ng bahagi',
                        accumulatedDuration: 'Cumulative Duratione',
                        sumOfTheDurationOfStudentParticipationInTheTask: 'Magkasali sa tagal at sumo',
                        averageDuration: 'Average Durasyon',
                        sumOfStudentParticipationTimeInTaskstotalNumberOfParticipationTimes: 'Kabuuang tagal ng mga kalahok/kalahatang bilang ng mga kalahok',
                        accumulatedTimes: 'Mga kumulative oras',
                        sumOfTheNumberOfTimesStudentsParticipateInTasks: 'Suma sa bilang ng mga kalahok sa gawain',
                        averageScore: 'Average',
                        theAverageScoreOfThePersonnelParticipatingInThisTask: 'Karaniwang marka ng mga tauhan na kasangkot sa gawain',
                        maximumScore: 'Pinakamataas na markan',
                        theHighestScoreForThePersonnelInvolvedInThisTask: 'Ang pinakamataas na marka ng mga tauhan na kasangkot sa gawain',
                        averageScoreOfScript: 'Average Score ng Speeche',
                        sumOfTraineeScriptScorestotalParticipationTimes: 'Student Speech Score Sum/Total Participation Times.',
                        totalScoreOfScript: 'Kabuuang marka ng pagsasabit',
                        theTotalScoreOfTheScriptSetUnderThisTask: 'Ang kabuuang score ng pagsasalita ay itinakda sa ilalim ng gawain na ito',
                        processAverageScore: 'Average score ng proseso',
                        sumOfStudentProcessScoresTotalParticipationTimes: 'Sum/total na bilang ng mga engagement na proseso ng mag-aaral',
                        totalProcessScore: 'Kabuuang marka ng proseso',
                        theTotalScoreOfTheProcessesSetUnderThisTask: 'Kabuuang marka ng proseso na itinakda sa ilalim ng gawain to',
                        averageEmotionalScore: 'Average emosyonal na markan',
                        sumOfStudentEmotionalScoresTotalParticipationTimes: 'Suma ng score ng emosyon ng trainee/total bilang ng mga engagement',
                        totalEmotionalScore: 'Kabuuang emosyonal na markan',
                        theTotalScoreOfEmotionsSetUnderThisTask: 'Ang kabuuang emosyonal na marka ay itinakda sa ilalim ng gawain na ito',
                        averageScoreOfExpression: 'Average score ng expressions',
                        sumOfStudentExpressionScorestotalParticipationTimes: 'Suma ng score ng expression ng mga nag-aaral/katuu',
                        totalScoreOfExpression: 'Ang kabuuang iskore',
                        theTotalScoreOfExpressionsSetUnderThisTask: 'Ang kabuuang marka ng expression ay itinakda sa ilalim ng gawain na ito',
                        startExecutingReScoringYouCanJumpToTheTaskCenterToViewProgress: 'Magsimula upang gumawa ng re-scoring, maaari kang tumalon sa task center upang tingnan ang pag-unlad.',
                        reRating: 'Re-scoring',
                        reRatingMeansThatMatchingWillBeDoneAccordingToTheLatestScoringRulesOnTheCanvasWhichWillOverwriteTheCurrentScoringResults: 'Ipinapahiwatig ng muling pagmamarka na ang marka ay maitutugma ayon sa mga patakaran sa pagmamarka ng pinakabagong canvas at ang kasalukuyang marka ay mababasan ..',
                        releaseTime: 'Oras ng pagpapalayas',
                    },
                },
                audit: {
                    components: {
                        pageLeftTable: {
                            reviewed: 'Reviewe',
                            pendingReview: 'Upang suriin',
                            enterKeywordSearch: 'Magbigay ng mga keyword upang maghanap',
                        },
                        pageRightTable: {
                            index: {
                                employeeName: 'Pangalan ng empleyad',
                                systemRating: 'Marka ng systema',
                                scoringResults: 'Mga Resulta ng Score',
                                duration: 'Pangulon',
                                time: 'Oras',
                                state: 'Status',
                                whetherToModifyTheRating: 'Ang tamang markan',
                                finalScore: 'Final Score',
                                reviewedBy: 'Reviewer',
                                operation: 'Operasyong',
                                viewScoreDetails: 'Makikita ang mga detalye ng score',
                                viewStatus: 'Pansin ang Status',
                                whole: 'Lahat',
                                correctionStatus: 'Status ng pagwawak',
                                completeReview: 'Kumpleto',
                                tips: 'Prompt',
                                theFinalScoreOfTheStudentIsBasedOnTheCurrentFinalReviewResultPleaseConfirm: 'Ang huling resulta ng mga trainees ay magiging paksa sa kasalukuyang huling resulta ng pagsusuri. Mangyaring kumpirman',
                            },
                        },
                    },
                    index: {
                        manualReview: 'Manual review',
                    },
                },
                review: {
                    index: {
                        employeeName: 'Pangalan ng empleyad',
                        score: 'Score',
                        scoringResults: 'Mga Resulta ng Score',
                        duration: 'Pangulon',
                        taskName: 'Pangalan ng Task',
                        numberOfAppealScripts: 'Bilang ng mga Grievances',
                        appealTime: 'Oras ng Appeal',
                        processStatus: 'Status ng proseso',
                        scoreAfterReview: 'Score matapos ang pagsusuri',
                        reviewedBy: 'Reviewer',
                        operation: 'Operasyong',
                        viewScoreStatus: 'Makikita ang score',
                        whole: 'Lahat',
                        manualReview: 'Manual review',
                    },
                },
                qalist: {
                    index: {
                        participatingEmployees: 'Sumasali sa mga empleyad',
                        traineeNickname: 'Niname ng Trainee',
                        whetherToParticipate: 'Kung magkakalakip',
                        participateInTask: 'Magkasali sa gawain',
                        notInvolved: 'Hindi kalakip',
                        participation: 'Kalakip',
                        finish: 'Taposo',
                        whetherTheRequirementsForTaskCompletionAreMet: 'Kung ang mga kinakailangan sa pagkumpleto ng gawain',
                        unfinished: 'Hindi tapo',
                        complete: 'Taposo',
                        whetherItIsUpToStandard: 'Kung ito ay hanggang sa karaniwang',
                        whetherTheScoreRequirementsOfTheTaskAchievementCriteriaAreMet: 'Kung ang mga pangangailangan sa score ng mga kriterya sa pagkuha ng gawain ay natagpuan',
                        notUpToStandard: 'Hindi hanggang sa karaniwang',
                        standard: 'Standard na',
                        whetherItIsExcellent: 'Kung ito ay mahusay',
                        whetherTheTaskMeetsTheRequirementsForAchievingExcellentScores: 'Kung ang gawain ay nakakatugon sa mga kinakailangan para sa pagkakamit ng mahusay na markan',
                        notExcellent: 'Hindi mahusayan',
                        excellent: 'Mahusay',
                        qualityAccompanyList: 'Listahan ng kalidad na kasaman',
                    },
                },
            },
            dashboard: {
                components: {
                    adminDataCards: {
                        exerciseTaskData: 'Exercise Task Data',
                        implementationRate: 'Rate ng pagpapatupad',
                        numberOfExecutors: 'Bilang ng pagpapatako',
                        numberOfPeopleNotExecuted: 'Bilang ng hindi natupad',
                        completionRate: 'Rate ng pagkumpleto',
                        numberOfCompletedPersonnel: 'Bilang ng kumpleto',
                        numberOfUnfinishedPersonnel: 'Bilang ng hindi tapo',
                        complianceRate: 'Rate ng pagsunod',
                        numberOfQualifiedPersonnel: 'Bilang ng Attainment',
                        numberOfNonCompliantIndividuals: 'Bilang ng mga tao na hindi nakakatugon sa karaniwang',
                        excellentRate: 'Mahusay na rate',
                        numberOfOutstandingIndividuals: 'Mga natitirang Numbers',
                        numberOfNonOutstandingIndividuals: 'Non-Excellent numero',
                        examTaskData: 'Data ng Exam Task',
                        published: 'Inilathalan',
                        courses: 'Isang kurso',
                        courseData: 'Data ng kurso',
                        practiceTasks: 'Gawaing',
                        examTasks: 'Gawain sa pagsusulita',
                    },
                    practiceSummary: {
                        practiceSummary: 'Sumary',
                        numberOfPracticeTasks: 'Bilang ng mga gawain sa pagsasanay',
                        numberOfExercises: 'Bilang ng Exercise',
                        accumulatedPracticeDuration: 'Paglaan ng Cumulative Practice',
                        complianceRate: 'Rate ng pagsunod',
                        excellentRate: 'Mahusay na rate',
                        ranking: 'Ranking',
                    },
                    rankingList: {
                        numberOfExercises: 'Bilang ng Exercise',
                        exerciseDuration: 'Ehersisyo',
                        complianceRate: 'Rate ng pagsunod',
                        excellentRate: 'Mahusay na rate',
                        diligenceChart: 'Listahan',
                        excellentList: 'Mahusay Lista',
                        ranking: 'Rankings',
                        fullName: 'Pangang',
                        i: 'Ako...',
                    },
                    taskCard: {
                        end: 'Deadline:',
                        noDeadline: 'Walang deadlines',
                        second: 'Timess',
                        branch: 'Punts',
                    },
                    taskProgress: {
                        thereAreCurrentlyNoTasksAvailable: 'Walang gawain',
                        completed: 'Kumpleto',
                    },
                    filter: {
                        employeeDepartment: 'Departamento ng empleyas',
                    },
                    exportButton: {
                        index: {
                            exportSuccessfulPleaseGoToTheTaskCenterToView: 'Ang pag-export ay matagumpay, mangyaring pumunta sa task center upang tingnan',
                            export: 'Pag-exporto',
                        },
                    },
                    filterConfig: {
                        dropdown: {
                            custom: 'Pasawa',
                        },
                        modal: {
                            updateSuccessful: 'Nagtagumpay ang pag-update',
                            successfullySaved: 'Ito ang matagumpay',
                            setAsACommonReport: 'Itinakda sa Common Reports',
                            updateCurrentReport: 'Update ang Kasalukuyang Reporto',
                        },
                    },
                    employeeDataCards: {
                        components: {
                            abilityGrowthTrend: {
                                utils: {
                                    averageScore: 'Average',
                                    averageScoreOfScript: 'Average Score ng Speeche',
                                    averageEmotionalScore: 'Emosyonal Average Scoree',
                                    expressionAverageScore: 'Average score ng ekspresyon',
                                    processAverageScore: 'Average Process Scoree',
                                    branch: 'Punts',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    data: 'Data',
                                },
                            },
                            doneStatus: {
                                index: {
                                    practice: 'Ehersisyon',
                                    examination: 'Examinasyon',
                                    executed: 'Pagpatuta',
                                    unexecuted: 'Hindi pinataka',
                                    accumulatedExamDuration: 'Cumulative Test Duration',
                                    examFrequency: 'Bilang ng exams',
                                },
                            },
                            filter: {
                                index: {
                                    practice: 'Ehersisyon',
                                    examination: 'Examinasyon',
                                    pleaseCompleteTheRequiredFields: 'Mangyaring kumpleto ang mga kinakailangang item',
                                    staff: 'Employa',
                                    taskType: 'Type ng task',
                                    pleaseSelect: 'Pakipilin',
                                    taskName: 'Pangalan ng Task',
                                },
                            },
                        },
                        index: {
                            completionStatus: 'Status ng pagkumpleto',
                            comprehensiveEvaluation: 'Kabuuang pagsusuri',
                            abilityGrowthTrend: 'Paglaki ng kapasidad',
                            errorProneAnalysis: 'Error-prone',
                        },
                    },
                },
                hook: {
                    useSummary: {
                        activePopulation: 'Aktibong Numero',
                        accumulatedPracticeDuration: 'Paglaan ng Cumulative Practice',
                        averagePracticeDuration: 'Average Time Exercise',
                        people: 'Tao',
                        numberOfPracticeTasks: 'Bilang ng mga gawain sa pagsasanay',
                        numberOfExercises: 'Bilang ng Exercise',
                        exerciseDuration: 'Ehersisyo',
                        second: 'Timess',
                        avgScore: 'Average',
                        speechCraftAvgScore: 'Average Score ng Speeche',
                        emotionAvgScore: 'Emosyonal Average Scoree',
                        speedAvgScore: 'Average score ng ekspresyon',
                        flowAvgScore: 'Average Process Scoree',
                        practiceCostTime: 'Cumulative Duratione',
                        totalPracticeTimes: 'Cumulative Times',
                        participateCommitRate: 'Rata ng bahagi',
                        participateExcellentRate: 'Rata ng bahagi',
                    },
                },
                index: {
                    employeeProfile: 'Portrait ng empleyad',
                    overview: 'Overviews',
                    personalSignage: 'Personal Kanbans',
                    ongoingExercises: 'Nagsasanay',
                    ongoingExams: 'Ang pagsusuri',
                    practiceTaskProgress: 'Pagsasagawa ng Task Progress',
                    examTaskProgress: 'Test Task Progress',
                },
            },
            businessConfiguration: {
                scoreManagement: {
                    dimensionIndex: {
                        index: {
                            pleaseSelectAConceptWord: 'Mangyaring pumili ng salita ng konsepo',
                            sessionDetectionSettings: 'Session Detection Settings',
                            successfullySaved: 'Ito ang matagumpay',
                            abnormalSpeechSpeed: 'Hindi normal na bilis ng pagsasabit',
                            supportCustomSpeechSpeedDetectionStandardsAndTheResultsWillBeJudgedAsNormalTooFastOrTooSlowWhenThereIsAnAbnormalSpeechSpeedtooFasttooSlowPointsWillBeDeductedAccordingToTheScoringRules: 'Sinusuportahan ang pamantayan ng deteksyon ng speech speech speech. Ang resulta ay normal na bilis ng pagsasalita, masyadong mabilis na bilis ng pagsasalita, at masyadong mabagal na bilis ng pagsasalita. Kapag ang bilis ng pagsasalita ay abnormal (masyadong mabilis/mas mabagal), ang marka ay mababawasan ayon sa mga patakaran sa pagmamarka.',
                            speechSpeedTooFastGreaterThanEveryMinute: 'Masyadong mabilis ang pagsasalita: higit sa isang minuto',
                            oneWordSpeakingTooSlowlyLessThanPerMinute: 'Masyadong mabagal: mas mababa sa bawat minuto',
                            charactersIgnoringLessThan: 'Salita, hindi pinapansin mas maa',
                            aSentenceOfWords: 'Ang pangungusap ng salat',
                            excessiveModalParticles: 'Masyadong maraming modal salat',
                            supportCustomModalParticlesAndSetRulesForExcessiveModalParticlesWhenThereAreTooManyModalParticlesPointsWillBeDeductedAccordingToTheScoringRules: 'Suportahan ang mga salita ng custom tone, at itakda ang mga patakaran ng masyadong maraming mga salita ng tono. Kapag may masyadong maraming mga salita sa modal, ang marka ay mababawasan ayon sa mga patakaran sa pagmamarka.',
                            theNumberOfRepetitionsIs: 'Ang bilang ng mga paulit-ulit ay',
                            inTheSecondTenseItIsDeterminedThatThereAreTooManyModalParticles: 'Sa ikalawang pagkakataon, tinutukoy na mayroong masyadong maraming mga salita sa modal.',
                            definitionOfSensitiveViolations: 'Sensitive na Paglabag',
                            supportCustomWordLibrariesToDetectThePresenceOfIllegalWordsInASentenceWhenIllegalWordsAppearPointsWillBeDeductedAccordingToTheScoringRules: 'Maaari mong ipasadya ang lexicon ng mga ilegal na salita upang makita kung ang anumang mga ilegal na salita ay lumilitaw sa isang pangungusap. Kapag may ilegal na salita, ang marka ay mababawasan ayon sa mga patakaran sa pagmamarka.',
                            violationWords: 'Mga ilegal na salita:',
                            emotionalDetection: 'Detekta ng emosyon',
                            accordingToTheSystemEmotionModelDialogueTechniqueEmotionDetectionWillBeConductedAndTheResultsWillBeJudgedAsNormalEmotionsAndNegativeEmotionsincludingNegativeAngryAndComplainingWhenNegativeEmotionsOccurPointsWillBeDeductedAccordingToTheScoringRules: 'Ayon sa diyalogo ng emosyon ng system, ang pagsusulit sa emosyon ay hahatulan bilang normal na emosyon at negatibong emosyon (kabilang na negatibo, galit at reklamo. Kapag may negatibong emosyon, ang marka ay mababawasan ayon sa mga patakaran sa pagmamarka.',
                            preserve: 'Pag-save',
                        },
                    },
                    scoreDimension: {
                        index: {
                            ratingDimension: 'Ratin dimensions',
                            ratingPoints: 'Punto ng scorings',
                            explain: 'Paglalarawan',
                            type: 'Type',
                        },
                    },
                    scoreModel: {
                        components: {
                            comprehensiveEvaluation: {
                                const: {
                                    randomData: 'Random datas',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: '<Span style = "margin-left: 8px"> · Standard Speech Cumulative',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'Isang salita, ang bilang ng mga salita na hit ng mag-aaral',
                                    aWordspan: 'Word </span>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Times </span>> <br />span style = "margin-left: 8px"> · Slow bilis',
                                    timesspan: '</Span>',
                                    tooManyModalParticles: '<Span style = "margin-left: 8px"> · Masyadong maraming mga salita sa modal',
                                },
                            },
                        },
                        detail: {
                            components: {
                                model: {
                                    group: {
                                        theScoreIs: 'Ang marka ay',
                                    },
                                    item: {
                                        violationOnceReduced: '1 paglabag minus',
                                        abnormalSpeechSpeedincludingTooFastOrTooSlowDecrease: 'Abnormal na bilis (kabilang na masyadong mabilis at masyadong mabagal na bilis) 1 pagbaba',
                                        excessiveNumberOfModalParticlesReducedOnce: 'Masyadong maraming mga salitang modal minus 1 beses',
                                        oneNegativeDecreaseInEmotions: 'Negatibong emosyon minus 1',
                                        branch: 'Punts',
                                    },
                                    wrap: {
                                        name: 'Pangang',
                                        preserve: 'Pag-save',
                                    },
                                },
                            },
                            index: {
                                complete: 'Kumpletong nilalamang',
                                keyHit: 'Key Points Hit',
                                accurateFollowupReading: 'Tumpak na pagbasa',
                                languageNorm: 'Spesyasyon ng wika',
                                speechSpeed: 'Speed of Speeche',
                                modalParticles: 'Modal salita',
                                emotionallyPositive: 'Emosyonal positibon',
                                scoringModel: 'Scoring modele',
                                successfullyModified: 'Nagtagumpay ang pagbabago',
                                newSuccessfullyCreated: 'Bagong tagumpa',
                            },
                        },
                        index: {
                            scoringModel: 'Scoring modele',
                            newModel: 'Bagong Modelo',
                            model: 'Modelo',
                            type: 'Type',
                            operation: 'Operasyong',
                            preview: 'Preview a',
                            edit: 'Pag-edita',
                        },
                    },
                    index: {
                        scoringModel: 'Scoring modele',
                        ratingDimension: 'Ratin dimensions',
                        sessionDetectionSettings: 'Session Detection Settings',
                    },
                },
            },
            dataAnalysis: {
                learningRecord: {
                    components: {
                        keyPointHit: {
                            index: {
                                pleaseSelect: 'Pakipilin',
                                hit: 'Hit',
                                misses: 'Nawalan',
                            },
                        },
                    },
                    index: {
                        duration: 'Pangulon',
                        processScore: 'Score ng proseso',
                        branch: 'Punts',
                        contentCompleteness: 'Integridad ng content',
                        scriptScore: 'Speech Score',
                        keyHitRate: 'Key Points Hit Rate',
                        emotionalScore: 'Emotion Scoree',
                        negativeProportionOfEmotions: 'Negatibong proporsyon ng emosyon',
                        expressionScore: 'Score ng expression',
                        theProportionOfAbnormalSpeechSpeed: 'Porsyento ng hindi normal na speeche',
                        excessiveProportionOfModalParticles: 'Labis na proporsyon ng mga modal salita',
                        learningRecordData: 'Pag-aaral ng record datas',
                        staff: 'Employa',
                        curriculum: 'Kurso',
                        mainPoints: 'Mga Key Points',
                    },
                },
                customKanban: {
                    components: {
                        chart: {
                            components: {
                                header: {
                                    components: {
                                        chartToggle: {
                                            hooks: {
                                                form: 'Tabal',
                                                lineChart: 'Line Chart',
                                                barChart: 'Histograma',
                                                pieChart: 'Pie Chart',
                                            },
                                            index: {
                                                switchingTypes: 'Switch Type',
                                            },
                                        },
                                    },
                                    index: {
                                        saveSuccessful: 'Ito ang matagumpay',
                                        editChart: 'Edit Chart',
                                        chartName: 'Name chart',
                                        deleteSuccessful: 'Matagumpay na natanggala',
                                        refresh: 'Refresh',
                                        export: 'Pag-exporto',
                                        areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                                        delete: 'Mangalisa',
                                        viewFilteringCriteria: 'Pansin ang Filter Criterias',
                                    },
                                },
                            },
                            index: {
                                exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Ang pag-export ay matagumpay, mangyaring pumunta sa task center upang tingnan',
                            },
                        },
                        header: {
                            index: {
                                saveSuccessful: 'Ito ang matagumpay',
                                deleteSuccessful: 'Matagumpay na natanggala',
                                editReport: 'Edit Reporto',
                                reportName: 'Ulat Pangalang',
                                refresh: 'Refresh',
                                areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                                delete: 'Mangalisa',
                                exportToExcel: 'Export Excel',
                                exportSnapshot: 'Export Snapshot',
                                export: 'Pag-exporto',
                                authority: 'Mga pahintulot',
                                permissionSettings: 'Mga Sekreto ng pahinon',
                                reportVisiblePermissions: 'Report ng Mga Paninging permiso',
                                visibleToEveryone: 'Makikita sa lahat',
                                onlyVisibleToOneself: 'Makikita lamang sa sarilin',
                                designatedPersonnelVisible: 'Tinukoy na tao nakikit',
                                pleaseSelect: 'Pakipilin',
                                reportDataPermissions: 'Report Pahintulot sa Data',
                                restrictedByUserPermissions: 'Binigyan ng mga pahintulot ng gumagat',
                                visiblePeopleAreTheSame: 'Parehong makikita ang mga tao.',
                            },
                        },
                        titleFooter: {
                            index: {
                                addReport: 'Bagong Reporto',
                                reportName: 'Ulat Pangalang',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Ang pag-export ay matagumpay, mangyaring pumunta sa task center upang tingnan',
                        dataQueryInProgress: 'Query ng data sa ...',
                        customKanban: 'Custom Kanban',
                    },
                },
                intelligentAnalysis: {
                    components: {
                        header: {
                            hooks: {
                                form: 'Tabal',
                                lineChart: 'Line Chart',
                                barChart: 'Histograma',
                                pieChart: 'Pie Chart',
                            },
                            index: {
                                successfullyAdded: 'Nagdagdag ng matagumpayan',
                                viewSQL: 'View SQL',
                                export: 'Pag-exporto',
                                addToReport: 'Dagdag sa Reporto',
                            },
                        },
                        refer: {
                            hooks: {
                                data: 'Data',
                                interrogativeSentence: 'Mga katanungan',
                                historicalQuery: 'Kasaysayan na Query',
                            },
                            index: {
                                copySuccessful: 'Pagkopya ng tagumpa',
                                copy: 'Kopyahay',
                            },
                        },
                        search: {
                            components: {
                                latitudeModal: {
                                    components: {
                                        selector: {
                                            const: {
                                                notMeetingStandards: 'Hindi hanggang sa karaniwang',
                                                meetingStandards: 'Standard na',
                                                excellent: 'Mahusay',
                                                notStartedYet: 'Hindi Nagsimula',
                                                inProgress: 'Sa paglaon',
                                                completed: 'Kumpleto',
                                                incomplete: 'Hindi tapo',
                                            },
                                        },
                                    },
                                    const: {
                                        taskName: 'Pangalan ng Task',
                                        department: 'Departamento',
                                        studentName: 'Pangalan ng mag-aaral',
                                        scoringResults: 'Mga Resulta ng Score',
                                        taskCompletionStatus: 'Status ng pagkumpleto ng task',
                                    },
                                    index: {
                                        pleaseSelectADimension: 'Mangyaring pumili ng dimensiyo',
                                    },
                                },
                            },
                            index: {
                                enterToOpenThePopupBoxForDimensionSelection: 'Isugin @ upang buksan ang bullet box para sa pagpili ng dimensiw',
                                pleaseEnterAQueryStatementToDirectlyQuery: 'Mangyaring ipalagay ang statement ng query upang direkta',
                                query: 'Query',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Ang pag-export ay matagumpay, mangyaring pumunta sa task center upang tingnan',
                        dataQueryInProgress: 'Query ng data sa ...',
                    },
                },
            },
            templateManage: {
                dialogueManage: {
                    edit: {
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleIfACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyTheSalespersonIntroducesTheInsuranceProductsAndProtectionToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'Ipasok ang angkop na paglalarawan ng tanawin ayon sa iyong sparring layunin. Halimbawa, kung ang isang customer ay nais na bumili ng malubhang seguro sa sakit para sa kanyang pamilya, ang salesperson ay nagpapakilala sa kanya ng mga produkto ng seguro at proteksyon sa pamamagitan ng telepono. Maaari mong magbigay ng mga tiyak na kaganapan na maaaring mangyari sa tanawin sa paglalarawan. Ang mas detalyadong paglalarawan ng tanawin, mas tumpak ang proseso ng dialog o framework at mas mahusay ang epekto.',
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyAndTheSalespersonIntroducesTheInsuranceProductsAndInsuranceToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'Ipasok ang angkop na paglalarawan ng tanawin ayon sa iyong sparring layunin.\nHalimbawa, nais ng isang customer na bumili ng malubhang seguro sa sakit para sa kanyang pamilya, at ipinakilala ng salesperson ang mga produkto ng seguro at insurance sa kanya sa pamamagitan ng telepono.\nMaaari mong magbigay ng mga tiyak na kaganapan na maaaring mangyari sa tanawin sa paglalarawan. Ang mas detalyadong paglalarawan ng tanawin, mas tumpak ang proseso ng dialog o framework at mas mahusay ang epekto.',
                        editSceneSuccessfully: 'Magtagumpay ang eksene',
                        sceneCreatedSuccessfully: 'Matagumpay na nilikha ang Scene',
                        sceneName: 'Pangalan ng Scene',
                        pleaseEnterASceneName: 'Mangyaring ipasok ang pangalan ng eksene',
                        pleaseEnter: 'Mangyaring irekt',
                        scenarioDescription: 'Scenario Description',
                        pleaseEnterASceneDescription: 'Mangyaring ipasok ang isang paglalarawan ng eksene',
                        pleaseEnterASceneDescriptionForTheSceneAndThePurposeOfTheSceneEntryForExampleCustomersWantToHandlePersonnelNeedsBusinessEnterPersonnelInformationPhoneNumberAndOrderProductsAndImprovementsTheMoreDetailedTheSceneDescriptionTheMoreCharacteristicTheDialogueProcessWillBeTheBetterTheEffectWillBe: 'Mangyaring ipasok ang isang paglalarawan ng tanawin para sa tanawin at ang layunin ng entry ng tanawin.\nHalimbawa: nais ng mga customer na hawakan ang negosyo ng mga tauhan, ipasok ang numero ng telepono ng mga tao at mga produkto at pagpapabuti.\nAng mas detalyadong paglalarawan ng tanawin, mas maraming katangian ang proseso ng diyalogo, mas mahusay ang epekto.',
                        panelObjectStudent: 'Panel Object (Student)',
                        pleaseEnterAPanelObject: 'Mangyaring ipasok ang isang panel object a',
                        proposedRolesRobots: 'Proposed Roles (Robots)',
                        pleaseSelectASuggestedRole: 'Mangyaring pumili ng isang iminungkahing role',
                        pleaseEnterARoleName: 'Mangyaring ipasok ang pangalan ng role',
                        remarks: 'Mga pahayaga',
                        cancel: 'Kansela',
                        save: 'Pag-save',
                    },
                    list: {
                        name: 'Pangang',
                        accompanyingTrainingObjectCadet: 'Companying Training Object (Cadet)',
                        proposedRolesRobots: 'Proposed Roles (Robots)',
                        creationTime: 'Oras ng paglika',
                        remarks: 'Mga pahayaga',
                        enabledStatus: 'Nakagana ang Status',
                        operation: 'Operasyong',
                        edit: 'Pag-edita',
                        delete: 'Mangalisa',
                        failedToGetList: 'Hindi makakuha ng listaha',
                        statusUpdateSuccessful: 'Matagumpay ang pag-update ng statuss',
                        statusUpdateFailed: 'Nabigo ang pag-update ng statuss',
                        areYouSureYouWantToDelete: 'Sigurado ka bang nais mong tanggalin?',
                        confirm: 'Pagkumpirma',
                        cancel: 'Kansela',
                        deletedSuccessfully: 'Matagumpay na natanggala',
                        deleteFailed: 'Bigo ang pagtanggal',
                        sceneName: 'Pangalan ng Scene',
                        pleaseEnter: 'Mangyaring irekt',
                        pleaseEnterThePartnerstudent: 'Mangyaring ipasok ang kasama (mag-aaral)',
                        pleaseEnterARoleName: 'Mangyaring ipasok ang pangalan ng role',
                        pleaseEnterComments: 'Mangyaring ipalagay ang mga komento',
                        startDate: 'Date ng simulang',
                        endDate: 'End Date',
                        reset: 'Reseta',
                        filter: 'Filtral',
                        new: 'Bago',
                    },
                },
                roleManage: {
                    edit: {
                        aishaNature: 'Aisha (Nature)',
                        zhishachat: 'Zhisha (chat)',
                        zhiqianGentle: 'Zhiqian (Gentle)',
                        knowRiceemotion: 'Know rice (emosyon)',
                        aishuoNature: 'Aishuo (Nature)',
                        zhishuochat: 'Zhishuo (chat)',
                        aiHaoAffinity: 'Ai Hao (Affinity)',
                        zhixiangEmotion: 'Zhixiang (Emotion)',
                        enterTheCorrespondingDescriptionAccordingToYourPartnersTargetRoleSuchAsTAsPersonalityCharacteristicsCommunicationStylePositionAndWorkUnitPainPointsWhatProductsAreCurrentlyUsedWhatEnvironmentAreCurrentlyInPlaceAndWhatPossibleObjectionsAreThereEtcTheClearerTheDescriptionProvidedTheMoreAccurateAndSpecificTheRoleWillBeBuilt: 'Ipasok ang katumbas na paglalarawan ayon sa target role ng iyong kasamahan, tulad ng katangian ng TA, estilo ng komunikasyon, posisyon at work unit, pain points, kung ano ang mga produkto kasalukuyan Ginagamit, kung anong kapaligiran ang kasalukuyang nasa lugar, at kung ano ang mga posibleng pagtutol doon, atbp. Ang mas malinaw na paglalarawan, mas tumpak at tiyak ang papel ay Binuo',
                        editingRoleSuccessfully: 'Matagumpay sa pag-edit ng Rol',
                        roleCreatedSuccessfully: 'Matagumpay na nilikha ang role',
                        failedToGetSceneDetails: 'Hindi makakuha ng detalye ng eksene',
                        createType: 'Bukha ng Type',
                        accurateCreation: 'Tumpak na paglika',
                        roleName: 'Role Name (Role Name)',
                        pleaseEnter: 'Mangyaring irekt',
                        gender: 'Katok',
                        male: 'Male',
                        female: 'Babae',
                        timbre: 'Timbre',
                        freeDescription: 'Libreng Paglalawa',
                        dialogueSimilarToYourPositionAndRoleSceneIncludingYourCharacterCommunicationStyleCoordinationAndWorkUnitFeelingsWhatProductsAreCurrentlyUsedWhatEnvironmentAreYouInAndWhatExternalCharacteristicsAreYouHavingWhatYouWantToReflectInTheDiscussionWhatYouWantToAchieveInTheDiscussionWhatIsTheSceneInTheContentAndTheCharacteristics: 'Dialogue na katulad ng iyong posisyon at tanawin ng papel, kabilang na ang iyong character, estilo ng komunikasyon, koordinasyon at unit ng trabaho, pakiramdam, kung anong mga produkto ang kasalukuyang ginagamit, kung ano ang kapaligiran mo, at kung ano ang mga panlabas na katangian mo. Ano ang gusto mong ipakita sa talakayan, kung ano ang gusto mong makamit sa talakayan, kung ano ang tanawin sa nilalaman, at ang mga karakteristika',
                        roleTags: 'Role Tags',
                        remarks: 'Mga pahayaga',
                        cancel: 'Kansela',
                        save: 'Pag-save',
                        create: 'Bukhay',
                    },
                    list: {
                        aishaNature: 'Aisha (Nature)',
                        zhishachat: 'Zhisha (chat)',
                        zhiqianGentle: 'Zhiqian (Gentle)',
                        knowRiceemotion: 'Know rice (emosyon)',
                        aishuoNature: 'Aishuo (Nature)',
                        zhishuochat: 'Zhishuo (chat)',
                        aiHaoAffinity: 'Ai Hao (Affinity)',
                        zhixiangEmotion: 'Zhixiang (Emotion)',
                        roleName: 'Role Name (Role Name)',
                        roleGender: 'Role Gendere',
                        male: 'Male',
                        female: 'Babae',
                        creationTime: 'Oras ng paglika',
                        backgroundDescription: 'Description',
                        timbreConfiguration: 'Timbre configuration',
                        remarks: 'Mga pahayaga',
                        status: 'Status',
                        operation: 'Operasyong',
                        edit: 'Pag-edita',
                        delete: 'Mangalisa',
                        failedToGetList: 'Hindi makakuha ng listaha',
                        updateStatusSuccessfully: 'Tagumpay ang statuso',
                        areYouSureYouWantToDelete: 'Sigurado ka bang nais mong tanggalin?',
                        cancel: 'Kansela',
                        deletedSuccessfully: 'Matagumpay na natanggala',
                        pleaseEnterARoleName: 'Mangyaring ipasok ang pangalan ng role',
                        gender: 'Katok',
                        pleaseSelect: 'Pakipilin',
                        pleaseEnterComments: 'Mangyaring ipalagay ang mga komento',
                        reset: 'Reseta',
                        filter: 'Filtral',
                        new: 'Bago',
                    },
                },
                index: {
                    newRole: 'Bagong Rol',
                    editRole: 'Pag-edit ng Role',
                    newScene: 'Bagong Scene',
                    editScene: 'Pag-edit ng Scene',
                    templateManagement: 'Template Management.',
                    roleManagement: 'Role Management (Role Management)',
                    sceneManagement: 'Scene Management (Scene Management)',
                },
            },
            courseEvaluation: {
                components: {
                    scoreRangeSelect: {
                        index: {
                            pleaseSelect: 'Pakipilin',
                            comprehensiveScore: 'Comprehensive score',
                            courseQuality: 'Kalidad sa kurso',
                            learningEffect: 'Epekto sa pag-aaral',
                            interactiveExperience: 'Interactive Experiens',
                            greater: 'Malakin',
                            equal: 'Katumbas',
                            less: 'Mas maa',
                            pleaseEnter: 'Mangyaring irekt',
                        },
                    },
                },
                overview: {
                    components: {
                        scoreTable: {
                            rankings: 'Rankings',
                            courseName: 'Pangalan ng kurso',
                            evaluationQuantity: 'Kwantidad ng pagsusuri',
                            practicePasses: 'Practice Passes',
                        },
                        statisticsCards: {
                            numberOfPublishingTasks: 'Bilang ng mga gawain sa paglalathala',
                            harvestEvaluationNumber: 'Numero ng paghawa',
                            practicePasses: 'Practice Passes',
                            examinations: 'Mga examinas',
                        },
                        trendChart: {
                            comprehensiveScore: 'Comprehensive score',
                            totalQuantityOfEvaluation: 'Kabuuang dami ng pagsusura',
                            addedComprehensiveEvaluationScore: 'Idinagdag ang kabuuang score ng pagsusuri',
                            quantityOfNewEvaluation: 'Dakila ng bagong pagsusuri',
                            score: 'Score',
                        },
                    },
                    index: {
                        failedToLoadDataPleaseTryAgain: 'Sawi sa pag-load ng data, mangyari subukan mulin',
                        evaluationOverview: 'Overview ng Evaluation',
                        courseStatistics: 'Statistics ng kurso',
                        averageCourseScore: 'Average Course Scoree',
                        evaluationTrendChart: 'Evaluation Trend Chart',
                    },
                },
                records: {
                    index: {
                        deletedSuccessfully: 'Matagumpay na natanggala',
                        courseName: 'Pangalan ng kurso',
                        courseType: 'Type ng kurso',
                        evaluationTime: 'Oras ng Evaluation',
                        evaluators: 'Mga Evaluators',
                        operation: 'Operasyong',
                        viewDetails: 'Pansin Detalyas',
                        editCourse: 'Pag-edit ng kurso',
                        confirmDelete: 'Siguraduhin ang Pagalisa',
                        areYouSureYouWantToDeleteThisEvaluationRecord: 'Sigurado ka bang nais mong tanggalin ang rekord ng pagsusuri?',
                        delete: 'Mangalisa',
                        evaluationRecord: 'Rekord ng Evaluation',
                        course: 'Kurso',
                        pleaseSelect: 'Pakipilin',
                        score: 'Score',
                        textFeedback: 'Text Feedback',
                        all: 'Lahat',
                        yes: 'Oo,',
                        no: 'Hindin',
                        reset: 'Reseta',
                        determine: 'Determine',
                    },
                },
            },
        },
        conversationAnalysis: {
            videoAnalysis: {
                detail: {
                    components: {
                        dialogue: {
                            index: {
                                keywordSearch: 'Keyword Search',
                                previous: 'Naunang',
                                next: 'Susunoda',
                                theObjectThatTriggersTheScrollingEventIs: 'Ang bagay na naglalagay ng kaganapan sa scroll ay',
                                userScrolling: 'User Scroll',
                            },
                        },
                        summary: {
                            index: {
                                reminder: 'Paalam:',
                                edit: 'Pag-edita',
                                name: 'Pangang',
                                hintLanguage: 'Prompt',
                            },
                        },
                        viewpoint: {
                            index: {
                                viewpointExtraction: 'Viewpoint extraction',
                            },
                        },
                        outline: {
                            index: {
                                numberOfKeywords: 'Bilang ng mga keywords',
                                speaker: 'Speaker',
                                speechDuration: 'Pangalawan',
                                proportionOfSpeaking: 'Rato ng pagsasalays',
                                maximumSpeechDuration: 'Maximum haba ng pagsasabit',
                                numberOfQuestions: 'Bilang ng mga Katanungan',
                                averageSpeechSpeed: 'Average Speech Speed',
                                conversationalActions: 'Session',
                                contentSummary: 'Sumary',
                                generateSummary: 'Bumuha ng Sumary',
                                keywordCloud: 'Keywords cloud',
                            },
                        },
                    },
                    index: {
                        outline: 'Bumaon',
                        viewpoint: 'Viewpoint',
                        contentSummary: 'Sumary',
                        viewpointExtraction: 'Viewpoint extraction',
                        summaryOfKeyPoints: 'Buod ng mga pangunahing puntos',
                        videoAnalysis: 'Video Analysisy',
                    },
                },
                list: {
                    index: {
                        delete: 'Mangalisa',
                        uploadSuccessful: 'Tagumpay ang uploads',
                        videoList: 'Video Lista',
                        uploadVideo: 'Upload Videos',
                        videoName: 'Video Name a',
                        uploadTime: 'Upload oras',
                        endTime: 'End Oras',
                        analyzeProgress: 'Analyze na pag-unlada',
                        haveInHand: 'Sa paglaon',
                        completed: 'Kumpleto',
                        fail: 'Bigo',
                        toBegin: 'Upang magsimula',
                        operation: 'Operasyong',
                        see: 'Pansing',
                    },
                },
            },
            productManage: {
                components: {
                    acousticData: {
                        components: {
                            template: {
                                index: {
                                    operationSuccessful: 'Nagtagumpay ang operasyon',
                                    operator: 'Operator',
                                    rules: 'Mga patakan',
                                    preserve: 'Pag-save',
                                    cancel: 'Kansela',
                                },
                            },
                        },
                        index: {
                            questionnaire: 'Questionnaires',
                            voiceCall: 'Tawag ng Voice',
                            textDialogue: 'Teksto dialog',
                            workOrder: 'Work Order',
                            videoCall: 'Video tawag',
                            enterpriseMicroData: 'Enterprise micro datas',
                            socialMediaComments: 'Mga Komento ng Social MediaName',
                            applicationComments: 'Mga Komento ng aplikasyong',
                            associatesAcousticData: 'Associates acoustic datas',
                        },
                    },
                    baseInfo: {
                        index: {
                            saveSuccessful: 'Ito ang matagumpay',
                            basicInformation: 'Pangunahing impormasyong',
                            productName: 'Pangalan ng produkto',
                            productDescription: 'Paglalarawan ng produkto',
                            productPicture: 'Larawan ng produkto',
                            preserve: 'Pag-save',
                            nextStep: 'Susunod na hakka',
                        },
                    },
                    subProduct: {
                        components: {
                            unrelatedProducts: {
                                index: {
                                    pleaseSelectProductData: 'Mangyaring piliin ang data ng produkto',
                                },
                            },
                        },
                        index: {
                            associateSubproducts: 'Associate sub-products',
                            associationSuccess: 'Tagumpay ng Associations',
                            operationSuccessful: 'Nagtagumpay ang operasyon',
                            productPicture: 'Larawan ng produkto',
                            productID: 'ID ng produkto',
                            productTitle: 'Pamagat ng produkto',
                            ecommercePlatform: 'E-commerce',
                            price: 'Priso',
                            sales: 'Behes',
                            numberOfComments: 'Bilang ng mga Komento',
                            areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                            remove: 'Alisini',
                            productManagement: 'Pamamahala ng produkt',
                            productData: 'Data ng produkto:',
                        },
                    },
                },
                detail: {
                    index: {
                        productManagement: 'Pamamahala ng produkt',
                        basicInformation: 'Pangunahing impormasyong',
                        associateSubproducts: 'Associate sub-products',
                        associatesAcousticData: 'Associates acoustic datas',
                        newProduct: 'Bagong produkto',
                    },
                },
                list: {
                    components: {
                        checkReportButton: {
                            index: {
                                productStatistics: 'Statistics ng produkt',
                                productInsights: 'Product Insights',
                                userInsights: 'User Insights',
                                viewReport: 'Usot',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAKeyword: 'Mangyaring ipasok ang keyword a',
                        productPicture: 'Larawan ng produkto',
                        productName: 'Pangalan ng produkto',
                        productDescription: 'Paglalarawan ng produkto',
                        creationTime: 'Oras ng paglika',
                        updateTime: 'Pag-update ng oras',
                        ecommercePlatform: 'E-commerce',
                        numberOfSubproducts: 'Bilang ng mga sub-products',
                        edit: 'Pag-edita',
                        areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                        delete: 'Mangalisa',
                        productManagement: 'Pamamahala ng produkt',
                        newProduct: 'Bagong produkto',
                    },
                },
            },
            productDetail: {
                list: {
                    index: {
                        ecommercePlatform: 'E-commerce',
                        productTitle: 'Pamagat ng produkto',
                        productPicture: 'Larawan ng produkto',
                        productID: 'ID ng produkto',
                        price: 'Priso',
                        sales: 'Behes',
                        numberOfComments: 'Bilang ng mga Komento',
                        associationStatus: 'Status ng Associations',
                        associated: 'Associated',
                        notAssociated: 'Hindi kaugnay',
                        associatedMainProduct: 'Associated Main Product',
                        viewDetails: 'Pansin Detalyas',
                        productDetails: 'Detalyadong produkto',
                    },
                },
            },
            dashboard: {
                index: {
                    recentDataTrendStatistics: 'Kamakailan-lamang na statistika ng data',
                    nearlyDays: 'Halos 7 araw...',
                },
                components: {
                    balanceCard: {
                        index: {
                            millionHours: 'Milyong oras.',
                            hours: 'Oras',
                        },
                    },
                },
            },
            dataIntegration: {
                dataIntegration: 'Data Integrations',
            },
            planManage: {
                automaticTriggerMessage: {
                    index: {
                        saveSuccessful: 'Ito ang matagumpay',
                        autoTriggerMessage: 'Auto trigger messages',
                        automaticPush: 'Awtomatiko na push',
                        newPush: 'Bagong Push',
                        push: 'Pumpa',
                        preserve: 'Pag-save',
                    },
                },
                index: {
                    autoTriggerMessage: 'Auto trigger messages',
                    planManagement: 'Plan Management.',
                },
            },
        },
        businessWorkingHours: {
            components: {
                businessWorkingHoursSetting: {
                    index: {
                        addWorkingHours: 'Dagdag ang oras ng trabaho',
                    },
                },
            },
            index: {
                businessWorkingHours: 'Oras ng trabaho sa negosyon',
                newlyBuild: 'Bago',
                name: 'Pangang',
                describe: 'Paglalarawan',
                operation: 'Operasyong',
                edit: 'Pag-edita',
                delete: 'Mangalisa',
                editBusinessWorkingHours: 'Pag-edit ng Trabaho',
                newBusinessWorkingHours: 'Bagong Oras ng Trabaho',
                workingHours: 'Oras ng Trabaho',
            },
        },
        algorithmSemanticIntelligence: {
            intelligentExtraction: 'Intelligent extractions',
        },
        taskCenter: {
            downloadList: {
                component: {
                    areYouSureYouWantToCancelAfterCancellationItCannotBeRestoredAgain: 'Sigurado ka bang nais mong kumansela? Hindi posible ang pagkawalan',
                },
            },
            taskList: {
                template: {
                    plannedAnalysisQuantity: 'Planned Analysis Quantity',
                    actualAnalysisQuantity: 'Aktual Analysis Quantity',
                    numberOfTokensConsumed: 'Bilang ng mga token na konsumo',
                },
            },
        },
        accountManagement: {
            securitySetting: 'Mga Security Security',
            accountManagement: 'Account Management (Account Management)',
        },
        securitySettings: {
            components: {
                iPInput: {
                    index: {
                        to: 'Tog',
                        switchToIPAddressMode: 'Paglipat sa mode ng IP address',
                        switchToIPSegmentMode: 'Paglipat sa IP segment mode',
                    },
                },
                verificationConfig: {
                    index: {
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhosePhoneNumbersAreNotFilledInAndWhosePhoneNumbersAreIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeesAccount: 'Matapos ang pag-verify ng dalawang hakbang ay nag-on, ang mga empleyado na ang mga numero ng telepono ay hindi napuno at ang mga numero ng telepono ay hindi napuno sa pag-log sa system. Sa kaso ng pagkabigo sa pag-log, mangyaring makipag-ugnay sa administrator upang baguhin ang normal na numero ng telepono para sa account ng empleyado.',
                        afterTheTwostepVerificationIsEnabledTheEmployeeAccountWhoseMobilePhoneNumberIsNotFilledInOrWhoseMobilePhoneNumberIsIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeeAccount: 'Matapos ang paggawa ng dalawang hakbang, ang account ng empleyado na ang numero ng mobile phone ay hindi napuno o ang numero ng mobile phone ay hindi napuno login sa system. Sa kaso ng pagkabigo sa pag-log, mangyaring makipag-ugnay sa administrator upang baguhin ang normal na numero ng telepono para sa account ng empleyado.',
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhoDoNotFillInTheMobilePhoneNumberOrFillInTheWrongMobilePhoneNumberWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToCorrectTheNormalPhoneNumberForTheEmployeeAccount: 'Matapos ang pag-verify ng dalawang hakbang ay nag-on, Ang mga empleyado na hindi nagpuno ng numero ng mobile phone o magpuno ng maling numero ng mobile phone ay hindi maaaring mag-log sa sistema. Sa kaso ng pagkabigo sa pag-log, mangyaring makipag-ugnay sa administrator upang maayos ang normal na numero ng telepono para sa account ng empleyado.',
                        login: 'Login',
                        attention: 'Attension',
                        saveSuccessful: 'Ito ang matagumpay',
                        twostepVerification: 'Dalawang hakka',
                        landing: 'Landing',
                        preserve: 'Pag-save',
                    },
                },
            },
            index: {
                employeeLoginIPAddressRestrictions: 'Mga Restrictions ng Login IP Address ng empleyad',
                limitTheIPRangeThatEmployeesCanLogInToLoginIsNotAllowedIfTheIPRangeIsExceededOnlyValidForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'Limitahan ang range ng IP na maaaring mag-log sa mga empleyado. Hindi pinapayagan ang Login kung ang IP address ay lumampas sa range. Ayaw lamang para sa mga website, hindi pinaghihigpitan ang mga mobile apps, at hindi pinaghihigpitan ang mga administrador.',
                iPRangeAllowedForLogin: 'Pinapayagan ang range ng IP para sa pag-login',
                saveSuccessful: 'Ito ang matagumpay',
                pleaseImproveTheConfiguration: 'Mangyaring perpekto ang pagsasaayos',
                securitySetting: 'Mga Security Security',
                employeeLoginIPRestrictions: 'Employee Login IP Restrictions ng IP',
                restrictTheIPRangeThatEmployeesCanLogInToAndProhibitLoggingInBeyondTheRangeOnlyEffectiveForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'Limitahan ang range ng IP na maaaring mag-log sa mga empleyado. Hindi pinapayagan ang Login sa kabila ng range. Ayaw lamang para sa mga website, hindi pinaghihigpitan ang mga mobile apps, at hindi pinaghihigpitan ang mga administrador.',
                whenAddingOrModifyingPleaseFillInTheExternalIPSegmentsameCSegmentOrAFixedExternalIPAddress: 'Kapag nagdaragdag o nagbabago, mangyaring ipasok ang segment ng IP sa panlabas na network (ang parehong C segment) o isang nakapirming panlabas na network IP address.',
                allowLoginIPRange: 'Pinapayagan ang range ng IP na mag-log in',
                preserve: 'Pag-save',
            },
        },
        coachAdminEntry: {
            webPlugin: 'Web Plugin',
            speechRecognition: 'Pagkilala sa pagsasabit',
        },
        billingCenter: {
            template: {
                details: 'Detalyo',
                languageType: 'Type ng wika',
                aSREngine: 'ASR engine:',
                voiceQualityQuota: 'Voice Quality Quota',
                realtimeData: 'Real-time datas',
                calculatedByDay: 'Kalkulado sa araw.',
            },
            component: {
                aSRName: 'ASR',
                language: 'Wika',
                remainingQuota: 'Natitirang quota',
                hours: 'Oras',
                usedQuota: 'Ginamit Quota',
            },
        },
        speechRecognition: {
            component: {
                saveSuccessfully: 'Ito ang matagumpay',
                saveSuccessful: 'Ito ang matagumpay',
                minimumNumberOfSpeakersCannotBeGreaterThanMaximumNumber: 'Ang pinakamababang bilang ng mga nagsasalita ay hindi maaaring maging mas malaki kaysa sa pinakamataas na numero.',
                theNumberOfAgentsCannotBeGreaterThanTheMaximumNumberOfSpeakers: 'Ang bilang ng mga ahente ay hindi maaaring mas malaki kaysa sa pinakamataas na bilang ng mga nagsasalitaan',
                pleaseImproveTheConfiguration: 'Mangyaring perpekto ang pagsasaayos',
                operationSavedSuccessfully: 'Nag-save ang operasyon nang matagumpay!',
                deletedSuccessfully: 'Matagumpay na natanggal!',
                pleaseSelectLanguage: 'Mangyaring pumili ng wika',
                pleaseConfigureRules: 'Mangyaring configure ang mga patakan',
                updateSuccessful: 'Nag-update ng matagumpay!',
                operationSuccessful: 'Matagumpay ang operasyon!',
            },
            template: {
                mixedIdentification: 'Mixed na pagkakakilando',
                whenEnabledMultilingualMixedTranscriptionIsAvailable: 'Kapag nakapaggana, magagamit ang multilingual mixed transcription ay magagamit',
                nonmanualFiltering: 'Non-manual filtering',
                whenEnabledOnlyTranscribeManualCalls: 'Kapag nakapaggana, mag-transcrive lamang ng mga tawag',
                speakerIdentification: 'Pagkilala sa speaker',
                aSRLanguage: 'ASR Language',
                pleaseSelect: 'Pakipilin',
                model: 'Modelo',
                pleaseSelectLanguage: 'Mangyaring pumili ng wika',
                delete: 'Mangalisa',
                newASRModel: 'Bagong ASR Modelo',
            },
            components: {
                aSRFilterMethod: {
                    components: {
                        sampleUpperLimit: {
                            index: {
                                daily: 'Araw-araw',
                                weekly: 'Linggon',
                                pleaseSelectAPeriod: 'Mangyaring pumili ng panahong',
                                byQuantity: 'Sa pamamagitan ng damin',
                                longOnTime: 'Mahaba sa oras',
                                noUpperLimit: 'Walang pinakamataas na limitas',
                                pleaseSelectACalculationDimension: 'Mangyaring pumili ng dimensyon ng kalkulaso',
                                pleaseEnter: 'Mangyaring irekt',
                                hours: 'Oras',
                            },
                        },
                    },
                    index: {
                        filteringMethod: 'Paraan ng filtering:',
                        allEligibleCallsPerformASR: 'Lahat ng mga karapat-dapat na tawag ay gumagawa ng ASR',
                        performASRForEligiblePartialCalls: 'Gumawa ng ASR para sa mga bahagyang tawag',
                        samplingRatio: 'Sampling ratio:',
                        upperSamplingLimit: 'Upper Sampling Limit:',
                    },
                },
                aSRFilterStatus: {
                    index: {
                        drawLimitNotReached: 'Hindi naabot ang limitasyong draw',
                        drawLimitReached: 'Naabot ang limitas',
                    },
                },
                speakerRecognition: {
                    index: {
                        toAccessAThirdpartyCallRecordingThroughAPIItIsNecessaryToIdentifyWhetherTheLeftChannelIsACustomerServiceOrACustomer: 'Upang ma-access ang pagtatala ng tatlong partido sa pamamagitan ng API, ito ay kinakailangan upang makilala kung ang kaliwang channel ay isang serbisyo ng customer o isang customer.',
                        singlechannelRecordingDefinesTheRoleOfTheAgentThroughTextRecognitionAndRoleConfiguration: 'Ang pagrekord ng solong channel ay naglalarawan ng papel ng ahente sa pamamagitan ng pagkilala sa teksto at pagsasaayos ng papel.',
                        aPIIdentifiesTrackRole: 'API Identifies Track Role',
                        textRecognition: 'Pagkilala sa teksto',
                        minimumNumberOfSpeakers: 'Minimum number ng Speakers',
                        maximumNumberOfSpeakers: 'Maximum number ng speakers',
                        numberOfCustomerService: 'Bilang ng Servisyo ng Customero',
                        operator: 'Operator:',
                        rules: 'Mga patakaran:',
                        preserve: 'Pag-save',
                    },
                },
            },
        },
        dataAnalysis: {
            customerServiceResults: 'Mga Resulta ng Servisyo ng Customero',
            qualityInspectionOverviewReport: 'Quality Inspection Overview Report',
            competitiveProductAnalysis: {
                index: {
                    competitionAnalysis: 'Analysis ng kumpetisyong',
                },
            },
            generalInspectionReport: {
                component: {
                    ecommerceTextSession: 'E-commerce Text Session',
                    workOrder: 'Work Order',
                    all: 'Lahat',
                    questionnaire: 'Questionnaires',
                },
                template: {
                    customerService: 'Servisyo ng Customero',
                    totalEcommerceSessions: 'Kabuuang sesyon ng e-commerce',
                    totalWorkOrder: 'Kabuuang Work Order',
                    totalQuestionnaire: 'Kabuuang Katanungan',
                },
            },
            productInsight: {
                index: {
                    productInsights: 'Product Insights',
                },
            },
            productStatistics: {
                index: {
                    productStatistics: 'Statistics ng produkt',
                },
            },
            statisticalProfile: {
                index: {
                    statisticalOverview: 'Statistical Overviews',
                },
            },
            userInsight: {
                index: {
                    userInsights: 'User Insights',
                },
            },
            socialMediaSentiment: {
                index: {
                    socialMediaPublicOpinion: 'Social Media Public Opinion',
                },
            },
            qualityInspectionOverview: {
                index: {
                    qualityInspectionOverviewReport: 'Quality Inspection Overview Report',
                },
            },
            customerServiceScore: {
                index: {
                    customerServiceResults: 'Mga Resulta ng Servisyo ng Customero',
                },
            },
        },
        eCommentManage: {
            template: {
                ecommerceReviewFilter: 'E-commerce Review Filter',
                allComments: 'Lahat ng Komento',
                ecommerceReviewManagement: 'E-commerce',
            },
            detail: {
                template: {
                    ecommerceReviewManagement: 'E-commerce',
                    detailsOfEcommerceComments: 'Detalye ng mga komento ng e-commerce',
                },
            },
        },
        mCommentManage: {
            template: {
                socialMediaReviewFilter: 'Filter ng Social Media Review',
                allComments: 'Lahat ng Komento',
                socialMediaReviewManagement: 'Social Media Review Management.',
            },
            detail: {
                template: {
                    socialMediaReviewManagement: 'Social Media Review Management.',
                    detailsOfSocialMediaComments: 'Detalye ng mga Komento ng Social MediaName',
                },
            },
        },
        conversationAnalysisDataAnalysis: {
            statisticalOverview: 'Statistical Overviews',
            publicOpinionAnalysis: 'Analysis ng opinyon ng publiko',
            userInsights: 'User Insights',
            productInsights: 'Product Insights',
            productStatistics: 'Statistics ng produkt',
            socialMediaPublicOpinion: 'Social Media Public Opinion',
            dataAnalysis: 'Analysis ng data',
            competitionAnalysis: 'Analysis ng kumpetisyong',
        },
        videoCallManage: {
            template: {
                videoCallFilters: 'Mga filter ng tawag',
                videoCallManagement: 'Video call managements',
                videoCallFilter: 'Filter ng Video Call',
            },
        },
        qaLanguageSetting: {
            template: {
                ecommerceTextDialogue: 'E-commerce Text Dialogue',
                flyingBookGroupChat: 'Flying book group chat',
                translation: 'Pagsaling',
                questionnaire: 'Questionnaires',
                voiceCall: 'Tawag ng Voice',
                textDialogue: 'Teksto dialog',
                workOrder: 'Work Order',
                videoCall: 'Video tawag',
                enterpriseWeChatConversation: 'Enterprise micro-session',
                enterpriseMicroVoice: 'Enterprise Micro Voice',
                ecommerceReviewData: 'Data ng E-commerce',
                socialMediaReviewData: 'Data ng Social Media Review',
                qualityInspectionLanguageSettings: 'Mga setting ng Wika ng Inspection ng kality',
                index: {
                    defaultASRModel: 'Default ASR Modelo',
                    pleaseSelectASecondaryLanguage: 'Mangyaring pumili ng pangalawang wika',
                    languageAdaptive: 'Adaptive wika',
                    whenEnabledYouCanSetMultipleTranscriptionLanguagesForAVoiceTheModelAutomaticallyRecognizesAndSelectsALanguageForTranscriptionLanguageAdaptationOnlyTakesEffectWhenUsingGoogleMicrosoftAndAliParaformervOtherASREnginesDoNotTakeEffect: 'Kapag pinagana, maaari kang itakda ng maraming wika ng transcription para sa isang boses. Awtomatikong kinikilala at pinipili ng modelo ang wika para sa transcription. Nagkakabisa lamang ang pagsasagawa ng wika kapag ginagamit ang Google, Microsoft, at Ali paraformer-v2. Ang iba pang mga ASR engine ay hindi nagaganap.',
                    defaultPrimaryLanguage: 'Default na Pangunahing Wika',
                    defaultSublanguage: 'Default sub-language',
                    saveSuccessful: 'Ito ang matagumpay',
                    deleteSuccessful: 'Matagumpay na natanggala',
                    modificationSucceeded: 'Nagtagumpay ang pagbabago',
                    areYouSureToDeleteIt: 'Sigurado ka bang nais mong tanggalin?',
                    defaultLanguage: 'Default Langa',
                    multilanguageSettings: 'Mga settings ng maraming wika',
                    specifyDifferentLanguagesForDifferentData: 'Ang iba\'t ibang wika para sa iba\'t ibang data',
                },
            },
            translate: {
                template: {
                    components: {
                        rules: {
                            components: {
                                item: {
                                    index: {
                                        sourceLanguage: 'Pinagmulan',
                                        targetLanguage: 'Target wika',
                                    },
                                },
                            },
                            index: {
                                setTheCorrespondenceBetweenTheSourceLanguageAndTheTargetLanguagePleaseSetTheTranslationRulesAfterTheQualityInspectionLanguageIsSet: 'Itakda ang koresponsable sa pagitan ng wika ng source at ang target wika. Mangyaring itakda ang mga patakaran sa pagsasalin matapos ang wika ng inspeksyon ng kalidad.',
                                newTranslationRule: 'Bagong Rula',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'Pagsalin ng mga Terms',
                        availableInSemanticIntelligenceSetTheTranslationTermInTheSmartThesaurusWhenEnabledTheSpecifiedWordsInTheTranscriptionResultCanBeTranslatedIntoProfessionalTerms: 'Magagamit sa Semantic Intelligence -\nItakda ang termino ng pagsasalin sa matalinong thesaurus. Kapag pinagana, ang mga tinukoy na salita sa resulta ng transcription ay maaaring isalin sa mga propesyonal na termino.',
                        saveSuccessful: 'Ito ang matagumpay',
                        onState: 'Sa estado...',
                        translateTheSourceLanguageDataIntoTheTargetLanguageAndThenPerformQualityInspectionAndSmartLabel: 'Isinalin ang data ng source wika sa target wika, at pagkatapos ay gumawa ng inspeksyon ng kalidad at matalinong label.',
                        dataSourceType: 'Type ng Source ng Data',
                        translationRules: 'Rules ng pagsasaling',
                        preserve: 'Pag-save',
                    },
                },
            },
        },
        systemIntegration: {
            zendesk: {
                components: {
                    chat: {
                        index: {
                            authorizationSucceeded: 'Nagtagumpay ang awtoridasyon',
                            cancelAuthorizationSuccessfully: 'Mapagtagumpayan ang awtorisado',
                            clientID: 'Client ID',
                            clientKey: 'Client Key',
                            redirectURL: 'Redirect URL',
                        },
                    },
                    ticket: {
                        index: {
                            authorizationSucceeded: 'Nagtagumpay ang awtoridasyon',
                            cancelAuthorizationSuccessfully: 'Mapagtagumpayan ang awtorisado',
                        },
                    },
                },
            },
            kcsDocking: {
                index: {
                    interfaceURL: 'Interface URL',
                    publicKey: 'Public key',
                    privateKey: 'Pribadong Susi',
                },
            },
            feishu: {
                index: {
                    cancel: 'Kansela',
                    preserve: 'Pag-save',
                },
            },
            template: {
                largeModel: 'Malaking modelon',
                jingdong: 'Jingdong',
                flyingBook: 'Flying Libro',
                voiceRobot: 'Voice Robot',
            },
            voiceRobot: {
                index: {
                    domainName: 'Domain',
                    administratorMailbox: 'Administrator Mailbox',
                    tenantAppid: 'Appid tent',
                    tenantSecrect: 'Tenant secrekt',
                },
            },
            integrationLLM: {
                index: {
                    intelligentModel: 'Intelligent modele',
                    smartLabel: 'Smart Label',
                    businessSummary: 'Buktad sa negosyon',
                    problemExtraction: 'Paglabas ng probleman',
                    intelligentExtraction: 'Intelligent extractions',
                    semanticLabel: 'Semantic label a',
                    translation: 'Pagsaling',
                    pictureUnderstanding: 'Pag-unawa ng larawan',
                    audioUnderstanding: 'Audio Understanding',
                    videoUnderstanding: 'Video Understanding',
                    saveSuccessfully: 'Ito ang matagumpay',
                    pleaseSelectAModel: 'Mangyaring pumili ng modelon',
                    save: 'Pag-save',
                    modelLevelChangedTip: 'Nagbago ang antas ng modelo. Kakalkulahin ang mga singil ayon sa bagong modelo.',
                },
            },
            jdShop: {
                components: {
                    configForm: {
                        index: {
                            newStore: 'Bagong tindahan',
                            editBasicInformation: 'Pag-edit ng pangunahing impormasyong',
                            saveSuccessfully: 'Ito ang matagumpay',
                            save: 'Pag-save',
                            shopName: 'Name ng shop',
                            pleaseEnter: 'Mangyaring irekt',
                            merchantID: 'ID ng Merchant',
                            accountNumber: 'Numero ng Acut',
                        },
                    },
                },
                hooks: {
                    index: {
                        authorizationSucceeded: 'Nagtagumpay ang awtoridasyon',
                    },
                },
                index: {
                    accountNumber: 'Numero ng Acut',
                    shopName: 'Name ng shop',
                    merchantID: 'ID ng Merchant',
                    status: 'Status',
                    authorized: 'Pinatutunan',
                    subscriptionExpiration: 'Expiration ng subscriptions',
                    unauthorized: 'Hindi awtorisado',
                    creationTime: 'Oras ng paglika',
                    editBasicInformation: 'Pag-edit ng pangunahing impormasyong',
                    reauthorization: 'Reauthorization',
                    authorization: 'Awtorisasyon',
                    confirmDeletion: 'Patunayan ang pagtanggal?',
                    delete: 'Mangalisa',
                },
            },
        },
        surveyManage: {
            detail: {
                template: {
                    questionnaireManagement: 'Pamamahala ng questionnaires',
                    questionnaireDetails: 'Mga Detalyas',
                },
            },
            template: {
                questionnaireFilter: 'Filter ng questionnaires',
                allQuestionnaires: 'Lahat ng mga Questionnaires',
                questionnaireManagement: 'Pamamahala ng questionnaires',
            },
        },
        soundtrackManage: {
            template: {
                originalSoundManagement: 'Orihinal na Sound Management.',
                allSonic: 'Lahat ng Sonic',
            },
        },
        feishuQa: {
            chatRecord: {
                components: {
                    filter: {
                        index: {
                            loadMore: 'Higit pa ang paglog',
                        },
                    },
                },
            },
            feishuQaEntry: {
                realtimeMessage: 'Real-time message a',
                groupChatSegmentation: 'Segmentasyon ng chat',
                flyingBookConversation: 'Flying Book Conversation',
            },
        },
        customerService: {
            customerInformation: {
                component: {
                    status: 'Status',
                    department: 'Departamento',
                    newEmployee: 'Bagong empleyad',
                    oldStaff: 'Lumang Staff',
                    customerServiceType: 'Type ng Servisyo ng Customero',
                    creationTime: 'Oras ng paglika',
                },
                components: {
                    agentTypeConfig: {
                        index: {
                            saveSuccessfully: 'Ito ang matagumpay',
                            agentTypeConfiguration: 'Agent Type Configuration',
                            newEmployeeCycle: 'Bagong Cycle ng empleyad',
                            pleaseEnterNewEmployeeCycle: 'Mangyaring ipasok ang bagong siklo ng empleyae',
                            day: 'Araw',
                        },
                    },
                },
                template: {
                    pleaseSelectAStatus: 'Mangyaring pumili ng status.',
                    enable: 'Mapangita',
                    disable: 'Disabled',
                    byCustomerServiceGroup: 'Sa pamamagitan ng Customer Service Group',
                    byDepartment: 'Sa pamamagitan ng Departamento',
                    department: 'Departamento',
                },
            },
        },
        caseBase: {
            template: {
                sort: 'Sort',
            },
        },
        testSetList: {
            template: {
                sort: 'Sort',
            },
        },
    },
    columns: {
        admin: {
            user: {
                id: 'ID',
                headPortraitUrl: 'Avatar',
                realname: 'Pangang',
                nickname: 'Niyangal',
                name: 'Pangang',
                email: 'Account Number (Email)',
                mobile: 'Telepono',
                agentId: 'Work No.',
                position: 'Posto',
                role: 'Role',
                actions: 'Operasyong',
                createUser: 'Bagong empleyad',
                editUser: 'Pag-edit ng empleyas',
                account: 'Numero ng Acut',
                originPassword: 'Unang password',
                newPassword: 'Bagong password',
                resumePassword: 'Pagtunay ng Password',
                userGroup: 'Grupo ng empleyas',
                authorizationGroup: 'Pangkat ng pahintulot',
                resetPassword: 'Reset ang Password',
            },
            userGroups: {
                id: 'ID',
                name: 'Pangang',
                userCount: 'Bilang ng mga empleyad',
                actions: 'Operasyong',
                createUserGroup: 'Bagong Grupo ng empleyas',
                editUserGroup: 'Pag-edit ng Employee Groupe',
                member: 'Mga miyel',
            },
            role: {
                id: 'ID',
                name: 'Pangang',
                actions: 'Operasyong',
                all: 'Lahat',
                taskName: 'Gawaing',
                readTask: 'Task View',
                manageTemplate: 'Template Management.',
                manualInspection: 'Manual review',
                readResultAll: 'Mga Resulta',
                readResultPersonal: 'Results View (Individual)',
                readProcess: 'Tingnan Proseso ng Inspection ng Quality',
                readReport: 'Statistics and Reports',
            },
        },
        download: {
            downloadCenter: {
                createTime: 'Petsan',
                taskName: 'Pangang',
                size: 'Lakin',
                status: 'Status',
            },
        },
        tasks: {
            manage: {
                template: {
                    condition: {
                        idCode: 'ID',
                        name: 'Pangang',
                        remark: 'Paglalarawan',
                        actions: 'Operasyong',
                    },
                    checkPoint: {
                        name: 'Pangang',
                        remark: 'Paglalarawan',
                        type: 'Type',
                        gradeType: 'Paraan ng evaluan',
                        conditionLogic: 'Mga patakan',
                        predeterminedScore: 'Score',
                        weight: 'Bigaga',
                        status: 'Status',
                        actions: 'Operasyong',
                        switchOn: 'Mapangita',
                        switchOff: 'Deactivated',
                    },
                },
                workbench: {
                    qualityCheckList: {
                        time: 'Oras',
                        customer: 'Customero',
                        customerPhone: 'Customer Phone',
                        callType: 'Type ng tawag',
                        source: 'Source',
                        voiceRecording: 'Pagrekord ng tawag',
                        graded: 'Rating',
                        openingGreeting: 'Pagbubukas ng Bati',
                    },
                    checkPointList: {
                        name: 'Punto ng inspeksyon ng kalida',
                        type: 'Type',
                        deductScore: 'Fraction',
                        isHit: 'Hit Case',
                        status: 'Review',
                        finalDeductScore: 'Pagtugma ng deduction ng mga points',
                        hit: 'Hit',
                        notHit: 'Nawalan',
                    },
                },
            },
        },
        custom: {
            keywords: 'Mga Salita sa dialogo',
        },
    },
    menu: {
        admin: {
            system: {
                text: 'System Settings',
            },
            systemIntegration: {
                text: 'Integrasyon ng systema',
                subTitle: {
                    udesk: 'Udesk service system ng customer',
                    udeskWhite: 'Sistema ng Servisyo ng Customero',
                    wechat: 'Enterprise WeChat',
                    taobao: 'Taobao Qianniu',
                    weifeng: 'Weifeng',
                },
            },
            columnsManage: {
                text: 'Quality Inspection Field Managements',
            },
            customerField: {
                text: 'Customer Field',
            },
            speechRecognition: {
                text: 'Pagkilala sa pagsasabit',
            },
            user: {
                text: 'Employee Managements',
            },
            userGroups: {
                text: 'Employee Group Managements',
            },
            role: {
                text: 'Role Management (Role Management)',
            },
            dataMigration: {
                text: 'Migrasyon ng Data',
            },
            taskCenter: {
                text: 'Mission Center.',
            },
            recordUpload: {
                text: 'Lokal na pagrekord',
            },
            anomalousData: {
                text: 'Hindi normal na datas',
            },
            systemLog: {
                text: 'Log ng message',
            },
            msgCenter: {
                text: 'Message Center.',
            },
            wechatDocking: {
                text: 'Enterprise micro docking',
            },
        },
        tasks: {
            homePage: {
                text: 'Home Pages',
            },
            workbench: {
                text: 'Workbench',
            },
            semanticIntelligence: {
                text: 'Semantic intelligens',
            },
            intelligentAnalysis: {
                text: 'Intelligent analysisa',
            },
            intelligentLabel: {
                text: 'Smart Label',
            },
            admin: {
                text: 'Pamamahalan',
            },
            callManage: {
                text: 'Call Management.',
            },
            dialogueManage: {
                text: 'Pamamahala ng dayalog',
            },
            ticketManage: {
                text: 'Work Order Management.',
            },
            dataAnalysis: {
                text: 'Analysis ng data',
            },
            customerService: {
                text: 'Customer Service Center',
            },
            clientCenter: {
                text: 'Customer Center',
            },
            insight: {
                text: 'Insight',
            },
            trainingCenter: {
                text: 'Training Center.',
            },
            templates: {
                text: 'Template Management.',
            },
            wechatQaTasks: {
                text: 'Enterprise WeChat Workbench',
            },
            wechatQaSetting: {
                text: 'Enterprise WeChat Analysis Configuration',
            },
            wechatQaChartRecord: {
                text: 'Enterprise WeChat Session',
            },
            wechatStaffCenter: {
                text: 'Enterprise micro empleyado center',
            },
            callAnalysis: {
                text: 'Pag-uusal',
            },
            caseBaseFolder: {
                text: 'Case Librarya',
            },
            coachTask: {
                text: 'Gawain sa coachings',
            },
            teamAnalysis: {
                text: 'Team Analysis a',
            },
            customer: {
                text: 'Customer Center',
            },
            analysisEnable: {
                text: 'Analysis Empowerment',
            },
            analysisHelp: {
                text: 'Pagsusuri ng tup',
            },
            analysisStudy: {
                text: 'Pagsusuri sa pag-aaral',
            },
            analysisReview: {
                text: 'Analysis ng compound disks',
            },
            analysisTags: {
                text: 'Smart Label',
            },
            analysisSentiment: {
                text: 'Analysis ng opinyon ng publiko',
            },
            analysisBusiness: {
                text: 'Analysis ng negosyon',
            },
            groupTest: {
                text: 'Pangkat na Testo',
            },
        },
        navBar: {
            billingCenter: 'Help Center.',
            uploadDownload: 'Upload at Download Center.',
            setting: 'System Settings',
        },
    },
    fix: {
        selectType: 'Magpili ng uri:',
        all: 'Lahat',
        call: 'Tawag',
        text: 'Dialog',
        wechat: 'Enterprise WeChat Session',
        businessTrendAnalysis: 'Analysis ng trend ng negosyo sa antas 1',
        noEchart: 'Walang data para sa chart',
        checkPointisRequired: 'Kinakailangan ang pagsasaayos',
        voiceDownLoad: 'Downloading recording',
        exportTxt: 'Pag-export teksto ng TXT',
        exportWord: 'Pag-export ng teksto ng sala',
        sureReRole: 'Ang kumpirmasyon ba ay nagbabalik sa papel ng nagsasalita?',
        sureRecover: 'Pag-aayos ng re-correction?',
        sureReAsr: 'Patunayan ang re-identification?',
        reRole: 'Reverse speaker',
        recover: 'Re-error pagwak',
        reAsr: 'Re-identificay',
        recordingOperation: 'Operasyon ng pagrekord',
        onlySave30Day: '(30 araw lamang)',
        appealError: 'Mangyaring mag-apela sa punto ng inspeksyon ng kalidad bago ito ipadala.',
        exportToTaskCenter: 'Matagumpay na na-export sa Upload and Download Center.',
        caseBaseLimit: 'Hindi maaaring lumampas sa 50 library',
        unnamed: 'Walang pangalan',
        wordSpeed: 'Word/min)',
        hit: 'Hit',
        checkPoint: 'Punto ng inspeksyon ng kalida',
        realTimeAdditionTip1: 'Idagdag sa totoong oras: nagsisimula kaagad ang inspeksyon ng kalidad kapag ang data ay pumasok sa sistema ng inspeksyon ng kalida',
        realTimeAdditionTip2: 'Pagdagdag ng oras: awtomatikong nagdaragdag ng data para sa inspeksyon ng kalidado',
        null: 'Walan',
        collcetedProps: 'Collection Fields',
        editingNameNow: 'Nag-edit ang pangan',
        upToFourLevels: 'Classification hanggang sa apat na ansan',
        default: 'Defaulta',
        nameCantBeNull: 'Hindi maaaring walang laman ang pangan',
        editingNow: 'Ang aksyon ay nag-edito',
        nameError: 'Maling pangalan',
        nameMaxLength8: 'Ang pinakamataas na haba ng pangalan ay 8',
        callTime: 'Oras ng talk',
        sentimentValue: 'Halaga ng sentimento ng customer',
        agentSentimentValue: 'Halaga ng sentimento ng serbisyo ng customer',
        sentimentAnalysis: 'Sentiment analysisa',
        associatedData: 'Follow-the-road datas',
        notifyTheOwner: 'Binanggit ang may-ari ng grupo.',
        notifyTheEmployee: 'Ipaalam sa kanyang empleyado',
        notifyTheOwnerTip: 'Kapag ang uri ng pag-uusap ay chat ng grupo, bibigyan ng may-ari ng grupo.',
        customNotifyEmployee: 'Personal na empleyado ng notifikas',
        customNotifyEmployeeTip: 'Kung ang nagtataguyod na tao ay isang empleyado, ang empleyado kung saan ang mensahe ay nabibilang.',
        clickToLearnMore: 'Click upang malaman ang higit pa...',
        repeatMarkingTip: 'Ang talaan na ito ay minarkahan ng punto ng inspeksyon ng kalidad na ito, at hindi kailangang ulitin ang marka.',
        successfulEvaluation: 'Evaluation ng tagumpay',
        evaluationFailed: 'Nabigo sa pagwawasay',
        qualityInspectionScore: 'Score ng inspeksyon sa kalida',
        semanticTags: 'Semantic label a',
        smartTags: 'Smart Label',
        collect: 'Palekta ng impormasyong',
        appealRecord: 'Record of Grievance',
        satisfy: 'Nasayan',
        notSatisfy: 'Hindi nasiyan',
        appealPlaceHolder: 'Mangyaring ipasok ang appeal',
        giveUp: 'Abandon',
        rejectReasonPlaceHolder: 'Mangyaring ipalagay ang dahilan para sa pagtanggik',
        reject: 'Tinanggik',
        changeRejectReason: 'Revise Rejection dahilang',
        pass: 'Sa pamamagitan ng',
        revise: 'Pagbago',
        machineEvaluation: 'Pagpapahalaga sa makinaan',
        poor: 'Mahirap',
        excellent: 'Mabuti.',
        moderate: 'Pangkalahatang',
        mustMarked: 'Ang punto ng inspeksyon na ito ay dapat markan',
        pleaseChoose: 'Pakipilin',
        manualEvaluation: 'Manual na pagsusura',
        qualityInspectionTemplate: 'Applicable Quality Inspection Template',
        collectionTemplate: 'Applicable Acquisition Template',
        keywordsWordCloud: 'Keywords cloud',
        editCategoryLabel: 'Pag-edit ng Kategory Labels',
        justCall: 'Tingnan lamang ang tawag',
        justConversation: 'Tingnan lamang ang diyalogo.',
        batchOperation: 'Operasyon ng batch',
        customerServicesGroup: 'Grupo ng Servisyo ng Customero',
        joinGroup: 'Sumalit sa Grupo',
        removeGroup: 'Lumang sa grupo...',
        enterInformationEntity: 'Mangyaring ipasok ang nilalaman ng entity entity',
        enterNotBeNull: 'Hindi maaaring walang laman ang inputs',
        operationGroup: 'Operasyon Groupe',
        customerServiceSelected: 'Piniling serbisyo ng customer',
        callAndConversation: 'Call/Conversasion',
        conversation: 'Dialog',
        system: 'Sistema',
        customize: 'Pasawa',
        effective: 'Epektive',
        invalid: 'Hindi bayad',
        successfulAndToTaskCenter: 'Matagumpay ang pagpapatupad, mangyaring pumunta sa task center upang surian',
        recalculationFailed: 'Sawi sa pagbalik ng kalkulat',
        selectRecalculatedIndicator: 'Mangyaring piliin ang indikator na recalc',
        source: 'Mangyaring pumili ng source ng data',
        placeholder: 'Mangyaring ipasok ang keyword a',
        cumulative: 'Cumulative',
        average: 'Average na uri',
        distribution: 'Batas ng distribusyon',
        originalDataCannotEmpty: 'Hindi maaaring walang laman ang data raw',
        inspection: 'Quality Inspection',
        check: 'Random inspekyon',
        review: 'Review',
        draftSavedSuccessfully: 'Nag-save ang draft',
        optimization: 'Optimization',
        agentName: 'Name ng Servisyo ng Customero',
        allTasks: 'Lahat ng Mga Gawain sa Inspection ng Quality',
        datePickerSelect: 'Piliit ang petsas',
        callSelect: 'Magpili ng Dialog',
        taskSelect: 'Pilit',
        genReport: 'Paglikha ng Reporto',
        dataSource: 'Source ng data',
        callsTotal: 'Kabuuang tawag',
        intelligentQualityInspection: 'Intelligent quality inspeksyo',
        percentage: 'Percentage',
        artificialSampling: 'Manual samplings',
        appealNumber: 'Hala ng mga reklamo',
        totalConversation: 'Kabuuang dami ng diyalogo',
        samplingReviewRate: 'Pumping review rate',
        data: 'Data',
        inspectionResults: 'Mga resulta ng inspeksyon sa kalida',
        inspected: 'Insure ang kalida',
        totalScore: 'Total score',
        learnMore: 'Magpakita ng higit pa...',
        inspectionEffect: 'Efekte sa inspeksyon ng kalida',
        allTotal: 'Kabuan',
        manualInspection: 'Manual review',
        artificialReview: 'Manual review',
        approvalAmountAndRate: 'Naaayos na dami at pag-apruba ng rate',
        customerScore: 'Score ng serbisyo ng Customero',
        inspectionRecommendations: 'Mga mungkahi sa Inspection ng kality',
        saveDraft: 'Pag-save Draft',
        historicalAdvice: 'Makasaysayang payo',
        advicePlaceHolder: 'Mangyaring ipasok ang mungkahi...',
        upload: 'File Uploads',
        customAdd: 'Dagdag ang filt',
        advancedConditions: 'Advanced Conditions',
        keyWord: 'Keywords',
        containsAll: 'Isipin ang Lahta',
        containsAny: 'Naglalaman ng anun',
        matchAny: 'Match Arbitrary',
        matchAll: 'Match Lahat',
        smartTagsOne: 'Smart Label O',
        smartTagsTwo: 'Smart Label II',
        season: 'Season',
        month: 'Buwana',
        week: 'Linggon',
        day: 'Araw',
        hour: 'Noong',
        notMoreThan366: 'Hindi higit sa 366 araw.',
        propsCannotBeNull: 'Ang ilang mga patlang ay hindi puno',
        other: 'Iba',
        correlationCoefficient: 'Coefficient ng korrelasyono',
        repetitionRate: 'Paulit-ulit',
        configurationItemsMoreThan20: 'Idagdag sa 20 items',
        conversionAnalysis: 'Analysis ng pagbabago',
        correlationAnalysis: 'Analysis ng relasyong',
        successfulExportAndToTaskCenter: 'Ang pag-export ay matagumpay, mangyaring pumunta sa task center upang tingnan',
        typeSelect: 'Pilit',
        exportExcel: 'Export Excel',
        exportPng: 'Export png',
        noDataChart: 'Walang data para sa chart',
        placeOperator: 'Mangyaring pumili ng matalinong labela',
        placeAdvancedConditions: 'Mangyaring pumili ng isang advanced kondisyon',
        createAdvancedConditions: 'Bagong Advanced filter',
        moveUp: 'Paglipat Upa',
        moveDown: 'Lumang Ibas',
        moveLeft: 'Lumipat sa kaliwan',
        moveRight: 'Lumang kanan',
        statusChangeSuccess: 'Matagumpay na nabago ang statuss',
        editSuccess: 'Nagtagumpay ang pagbabago',
        saveSuccess: 'Ito ang matagumpay',
        firstPage: 'Home Pages',
        lastPage: 'Tail Page',
        customerInfo: 'Impormasyon sa Customero',
        type: 'Type',
        NumberTypeErrorMessage: 'Ang nilalaman ng impormasyon sa patlang ng uri ng numero ay maaaring maglaman lamang ng mga numero o "."',
        taskStartPrompt: 'Prompt ng pagbubukas ng task',
        startConfirm: 'Mangyaring i-click ang pindutan ng konfirmo upang buksan ang kalidad na gawain ng inspekyon',
        continueToSubmitWithoutEvaluation: 'Patuloy na submission nang walang pagsusura',
        rejectTip: 'Walang mga aksyon na nakita ang pagbabago, sigurado ka bang tumanggi sa lahat ng apela nang direkta?',
        unmarkedSelfLearningTip: 'May mga puntong inspeksyon ng kalidad ng sariling natututun',
        markedSuccessfully: 'Labeling Success',
        markingFailed: 'Nabigo ang Labeling',
        exceedingLength: 'Wala sa haba',
        uncategorized: 'Unclassifid',
        addSuccess: 'Bagong tagumpa',
        deleteSuccess: 'Matagumpay na natanggala',
        featureName: 'Element Name:',
        informationEntity: 'Entity ng impormasyong',
        standardAnswer: 'Standard an sagot',
        keyElementAnswer: 'Mga susi na elemento upang sagot',
        generalStatement: 'Pangkalahatang pahayag (hindi kailangang tanungin)',
        generalQuestionsAndConfirmation: 'Pangkalahatang katanungan at kumpirmasyon',
        specialQuestionsAndAnswers: 'Espesyal na Katanungan at sagot',
        agent: 'Servisyo ng Customero',
        customer: 'Customero',
        semanticTagsAndInformationEntitiesCannotBeEmpty: 'Hindi maaaring walang laman ang elemento ng semantic label at impormasyon entity sa parehong oras',
        standardSentence: 'Karaniwang pangungunan',
        acquaintance: 'Kakilalan',
        smartUePlaceholder: 'Mangyaring ipasok ang matalinong pangalan ng interakso',
        typeSelectPlaceholder: 'Mangyaring pumili ng tipa',
        keyElement: 'Mga susi elemento',
        reQuerySementicTags: 'Pagpili ng mga semantic labels',
        querySementicTags: 'Pumili ng Semantic Label',
        QATestForm: 'Form ng pagtuklas ng tanong at sagot',
        selectNotBeNull: 'Hindi maaaring walang laman ang pagpilin',
        featureDetectionTarget: 'Target ng detection ng elemento',
        categorized: 'Classifications',
        effectiveness: 'Effectiveness',
        hideAdvancedSettings: 'Itog ang mga Advanced Settings',
        showAdvancedSettings: 'Ipakita ang mga Advanced Settings',
        generalStatementOnly: 'GENERAL STATEMENTO',
        generalQuestions: 'Pangkalahatang Pag-aalint',
        affirmativeExpression: 'Propirmative expression',
        negativeIntention: 'Negatibong intensyon',
        searchSementicTags: 'Mga Semantic Labels',
        choiceQuestion: 'Selective interrogative pangungunan',
        selectiveAnswer: 'Sagot ng uri ng pagpipilia',
        sementicTagsPlaceholder: 'Mangyaring ipasok ang semantic label content',
        openSpecialQuestion: 'Buksan ang mga Espesyal na Katanungan',
        openAnswer: 'Buksan ang sagot.',
        customQA: 'Custom Q & A',
        questions: 'Paraan ng pagtatangi',
        dataPlaceholder: 'Mangyaring ipasok ang nilalamang',
        reply: 'Sumagot',
        notFindSuitableLabel: 'Walang natagpuan angkop na label.',
        addSemanticTag: 'Magdagdag ng bagong semantic tag',
        intelligentInteraction: 'Matalinong pakikipag-ugnayan',
        matching: 'Match',
        bout: 'Timess',
        keywordMatch: 'Keyword tugman',
        addFilterConditions: 'Dagdag ang Filter Condition:',
        buttonStartCollectionTask: 'Mangyaring mag-click sa OK-button upang simulan ang gawain ng kolekto',
        buttonStartTask: 'Mangyaring mag-click sa OK-button upang buksan ang kalidad na gawain ng inspekyon',
        ruleConfigurationIsRequired: 'Kinakailangan ang pagsasaayos',
        asrRunning: 'ASR Execution',
        errorCorrectionExecution: 'Pagpapatupad ng erros',
        emotionalVolumeRecognition: 'Emotion Volume Recognition',
        dataPreprocessing: 'Preprocessing ng datas',
        inspectionExecution: 'Pagpapatupad ng inspeksyon ng kality',
        businessId: 'Negos ID',
        businessTime: 'Oras ng negosyon',
        createTime: 'Oras ng paglika',
        abnormalReason: 'Abnormal na dahilang',
        singleChat: 'Single chat',
        groupChat: 'Grupo Chat',
        taskContent: 'Nilalaman ng gawas',
        submissionTime: 'Oras ng Pagpapalagay',
        startTime: 'Simulan Oras',
        endTime: 'End Oras',
        runningTime: 'Operasyon ng pagkuha ng oras',
        totalAmountOfData: 'Kabuuang Volum ng Data',
        resultsOfThe: 'Resulta ng Pagpapatako',
        operator: 'Operator',
        taskDetails: 'Detalyas',
        executiveFunction: 'Executive Functions',
        qualityCheckTasks: 'Gawain sa inspeksyon ng kalida',
        implementationDetails: 'Detalyas',
        conditionalRules: 'Mga Panunungkulan',
        smartCondition: 'Matalinong Kondisyon',
        goThis: 'Ito',
        pleaseMarkClassification: 'Mangyaring marka ang klassiyas',
        advancedScreening: 'Advanced filtering',
        noDataToManipulate: 'Walang datos upang manipulat',
        concept: 'Mga salitang konsepto',
        checkPoint1: 'Rule Configuration',
        requiredFieldsCannotEmpty: 'Hindi maaaring walang laman ang kinakailangang item',
        rule: 'Mga patakan',
        afterFixUnit: 'Salita',
        unmarkedSelfLearningPointsTip: 'May mga puntong inspeksyon ng kalidad ng sariling natututun',
        onlyReservedFor7Days: '(7 araw lamang)',
        downloadError: 'Nabigo ang pag-downloads',
        pause: 'Pahinga',
        continue: 'Patuloy',
        recalcScore: 'Mulilkula ang marka lamang (na may ratings)',
        recalculatePointsAndScores: 'Mulilkula ang mga puntos at marka ng inspeksyon ng kalidado',
        recalculatePointsAndScoresWithEmtry: 'Muling ginamit ang mga puntos at marka ng inspeksyon ng kalidad (ang mga punto ng inspeksyon ng kalidad ay blangko)',
        inProgress: 'Sa paglaon',
        toBeExecuted: 'Upang ipatupad',
        executeImmediately: 'Agad na pagpapataka',
        specialElements: 'Espesyal na elemento',
        logicRule: 'Mga patakaran ng lohiko',
        every: 'Maraming tugman',
        hitRecall: 'Hit Recar Words',
        notHitRecall: 'Na-missed Recall Words',
        hitRecallRegular: 'Hit regular recall',
        notHitRecallRegular: 'Naka-missed Regular',
        hitRule: 'Hit Rules',
        notHitRule: 'Nawawala ang patakas',
        hitSimilarSentence: 'Hit ang mga katulad na pangungunan',
        notHitSimilarSentence: 'Nawawala ang katulad na pangungunan',
        hitExcludeSimilarSentences: 'Pag-iwan upang maiwasan ang mga katulad na pangungunan',
        notHitExcludeSimilarSentences: 'Naliliwanag upang maibukod ang katulad na pangungunan',
        updateSuccess: 'Nagtagumpay ang pag-update',
        qualify: 'Regular,',
        recallKeyWord: 'Itala ang mga Keywords',
        grammar: 'Mga patakaran sa gramatika',
    },
    api: {
        putTypoDatasByIdStatusByStatus: 'Nabigo ang pagbabago ng Validity, mangyaring subukan mulin',
        postAutoMateTasksCaseByTaskId: 'Sawi sa pag-save ng pag-synchronization ng library ng kaso',
        getAutoMateTasksCaseByTaskId: 'Hindi makakuha ng pag-synchronization ng case library',
        postInspectionRemarkModelConfigs: 'Sawi sa pag-save ng template ng komentra',
        putInspectionRemarkModelConfigsById: 'Sawi sa pag-save ng template ng komentra',
        getInspectionRemarkModelConfigsById: 'Hindi makakuha ng datos ng template ng komente',
        postKnowledgeDatas: 'Nabigo ang paglikha ng base ng kaalaman, mangyaring subukan mulin',
        putKnowledgeDatasById: 'Nabigo ang pagbabago ng repository, mangyari subukan mulin',
        getLibraryFiles: 'Hindi makakuha ng listahan ng mga folder ng presyo.',
        getLibraryCalls: 'Hindi makakuha ng talaksan',
        getLibraryFilesSearch: 'Nabigo ang paghahanap',
        putLibraryFilesMoveById: 'Hindi lumipat ang pulutong ng presyo.',
        putLibraryCallsById: 'Nabigo ang pangalan ng talaksan!',
        postLibraryFiles: 'Sawi ang pagdagdag ng folya',
        putLibraryFilesById: 'Hindi nabigo ang pangalan ng FolderName',
        deleteLibraryFilesById: 'Bigo ang pagtanggal',
        deleteLibraryCallsById: 'Bigo ang pagtanggal',
        postLibraryCalls: 'Sawi ang pagdagdag',
        getVoiceUploadResultById: 'Nabigo ng pag-upload ng resulta ng pag-exporto',
    },
};